var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/ev-emitter/ev-emitter.js
var require_ev_emitter = __commonJS({
  "node_modules/ev-emitter/ev-emitter.js"(exports, module) {
    (function(global, factory) {
      if (typeof define == "function" && define.amd) {
        define(factory);
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory();
      } else {
        global.EvEmitter = factory();
      }
    })(typeof window != "undefined" ? window : exports, function() {
      "use strict";
      function EvEmitter() {
      }
      var proto = EvEmitter.prototype;
      proto.on = function(eventName, listener) {
        if (!eventName || !listener) {
          return;
        }
        var events2 = this._events = this._events || {};
        var listeners = events2[eventName] = events2[eventName] || [];
        if (listeners.indexOf(listener) == -1) {
          listeners.push(listener);
        }
        return this;
      };
      proto.once = function(eventName, listener) {
        if (!eventName || !listener) {
          return;
        }
        this.on(eventName, listener);
        var onceEvents = this._onceEvents = this._onceEvents || {};
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        onceListeners[listener] = true;
        return this;
      };
      proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
          return;
        }
        var index = listeners.indexOf(listener);
        if (index != -1) {
          listeners.splice(index, 1);
        }
        return this;
      };
      proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) {
          return;
        }
        listeners = listeners.slice(0);
        args = args || [];
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (var i = 0; i < listeners.length; i++) {
          var listener = listeners[i];
          var isOnce = onceListeners && onceListeners[listener];
          if (isOnce) {
            this.off(eventName, listener);
            delete onceListeners[listener];
          }
          listener.apply(this, args);
        }
        return this;
      };
      proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
      };
      return EvEmitter;
    });
  }
});

// node_modules/get-size/get-size.js
var require_get_size = __commonJS({
  "node_modules/get-size/get-size.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define(factory);
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory();
      } else {
        window2.getSize = factory();
      }
    })(window, function factory() {
      "use strict";
      function getStyleSize(value) {
        var num = parseFloat(value);
        var isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
      }
      function noop() {
      }
      var logError = typeof console == "undefined" ? noop : function(message) {
        console.error(message);
      };
      var measurements = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
      ];
      var measurementsLength = measurements.length;
      function getZeroSize() {
        var size = {
          width: 0,
          height: 0,
          innerWidth: 0,
          innerHeight: 0,
          outerWidth: 0,
          outerHeight: 0
        };
        for (var i = 0; i < measurementsLength; i++) {
          var measurement = measurements[i];
          size[measurement] = 0;
        }
        return size;
      }
      function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) {
          logError("Style returned " + style + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1");
        }
        return style;
      }
      var isSetup = false;
      var isBoxSizeOuter;
      function setup() {
        if (isSetup) {
          return;
        }
        isSetup = true;
        var div = document.createElement("div");
        div.style.width = "200px";
        div.style.padding = "1px 2px 3px 4px";
        div.style.borderStyle = "solid";
        div.style.borderWidth = "1px 2px 3px 4px";
        div.style.boxSizing = "border-box";
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
      }
      function getSize(elem) {
        setup();
        if (typeof elem == "string") {
          elem = document.querySelector(elem);
        }
        if (!elem || typeof elem != "object" || !elem.nodeType) {
          return;
        }
        var style = getStyle(elem);
        if (style.display == "none") {
          return getZeroSize();
        }
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == "border-box";
        for (var i = 0; i < measurementsLength; i++) {
          var measurement = measurements[i];
          var value = style[measurement];
          var num = parseFloat(value);
          size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) {
          size.width = styleWidth + // add padding and border unless it's already including it
          (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        }
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) {
          size.height = styleHeight + // add padding and border unless it's already including it
          (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        }
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
      }
      return getSize;
    });
  }
});

// node_modules/desandro-matches-selector/matches-selector.js
var require_matches_selector = __commonJS({
  "node_modules/desandro-matches-selector/matches-selector.js"(exports, module) {
    (function(window2, factory) {
      "use strict";
      if (typeof define == "function" && define.amd) {
        define(factory);
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory();
      } else {
        window2.matchesSelector = factory();
      }
    })(window, function factory() {
      "use strict";
      var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        if (ElemProto.matches) {
          return "matches";
        }
        if (ElemProto.matchesSelector) {
          return "matchesSelector";
        }
        var prefixes = ["webkit", "moz", "ms", "o"];
        for (var i = 0; i < prefixes.length; i++) {
          var prefix = prefixes[i];
          var method = prefix + "MatchesSelector";
          if (ElemProto[method]) {
            return method;
          }
        }
      }();
      return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
      };
    });
  }
});

// node_modules/fizzy-ui-utils/utils.js
var require_utils = __commonJS({
  "node_modules/fizzy-ui-utils/utils.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "desandro-matches-selector/matches-selector"
        ], function(matchesSelector) {
          return factory(window2, matchesSelector);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_matches_selector()
        );
      } else {
        window2.fizzyUIUtils = factory(
          window2,
          window2.matchesSelector
        );
      }
    })(window, function factory(window2, matchesSelector) {
      "use strict";
      var utils = {};
      utils.extend = function(a, b) {
        for (var prop in b) {
          a[prop] = b[prop];
        }
        return a;
      };
      utils.modulo = function(num, div) {
        return (num % div + div) % div;
      };
      var arraySlice = Array.prototype.slice;
      utils.makeArray = function(obj) {
        if (Array.isArray(obj)) {
          return obj;
        }
        if (obj === null || obj === void 0) {
          return [];
        }
        var isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) {
          return arraySlice.call(obj);
        }
        return [obj];
      };
      utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) {
          ary.splice(index, 1);
        }
      };
      utils.getParent = function(elem, selector) {
        while (elem.parentNode && elem != document.body) {
          elem = elem.parentNode;
          if (matchesSelector(elem, selector)) {
            return elem;
          }
        }
      };
      utils.getQueryElement = function(elem) {
        if (typeof elem == "string") {
          return document.querySelector(elem);
        }
        return elem;
      };
      utils.handleEvent = function(event2) {
        var method = "on" + event2.type;
        if (this[method]) {
          this[method](event2);
        }
      };
      utils.filterFindElements = function(elems, selector) {
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
          if (!(elem instanceof HTMLElement)) {
            return;
          }
          if (!selector) {
            ffElems.push(elem);
            return;
          }
          if (matchesSelector(elem, selector)) {
            ffElems.push(elem);
          }
          var childElems = elem.querySelectorAll(selector);
          for (var i = 0; i < childElems.length; i++) {
            ffElems.push(childElems[i]);
          }
        });
        return ffElems;
      };
      utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        var method = _class.prototype[methodName];
        var timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
          var timeout = this[timeoutName];
          clearTimeout(timeout);
          var args = arguments;
          var _this = this;
          this[timeoutName] = setTimeout(function() {
            method.apply(_this, args);
            delete _this[timeoutName];
          }, threshold);
        };
      };
      utils.docReady = function(callback) {
        var readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") {
          setTimeout(callback);
        } else {
          document.addEventListener("DOMContentLoaded", callback);
        }
      };
      utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
          return $1 + "-" + $2;
        }).toLowerCase();
      };
      var console2 = window2.console;
      utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
          var dashedNamespace = utils.toDashed(namespace);
          var dataAttr = "data-" + dashedNamespace;
          var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
          var jsDashElems = document.querySelectorAll(".js-" + dashedNamespace);
          var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
          var dataOptionsAttr = dataAttr + "-options";
          var jQuery = window2.jQuery;
          elems.forEach(function(elem) {
            var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
            var options;
            try {
              options = attr && JSON.parse(attr);
            } catch (error) {
              if (console2) {
                console2.error("Error parsing " + dataAttr + " on " + elem.className + ": " + error);
              }
              return;
            }
            var instance = new WidgetClass(elem, options);
            if (jQuery) {
              jQuery.data(elem, namespace, instance);
            }
          });
        });
      };
      return utils;
    });
  }
});

// node_modules/flickity/js/cell.js
var require_cell = __commonJS({
  "node_modules/flickity/js/cell.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "get-size/get-size"
        ], function(getSize) {
          return factory(window2, getSize);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_get_size()
        );
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.Cell = factory(
          window2,
          window2.getSize
        );
      }
    })(window, function factory(window2, getSize) {
      "use strict";
      function Cell(elem, parent) {
        this.element = elem;
        this.parent = parent;
        this.create();
      }
      var proto = Cell.prototype;
      proto.create = function() {
        this.element.style.position = "absolute";
        this.element.setAttribute("aria-hidden", "true");
        this.x = 0;
        this.shift = 0;
        this.element.style[this.parent.originSide] = 0;
      };
      proto.destroy = function() {
        this.unselect();
        this.element.style.position = "";
        var side = this.parent.originSide;
        this.element.style[side] = "";
        this.element.style.transform = "";
        this.element.removeAttribute("aria-hidden");
      };
      proto.getSize = function() {
        this.size = getSize(this.element);
      };
      proto.setPosition = function(x) {
        this.x = x;
        this.updateTarget();
        this.renderPosition(x);
      };
      proto.updateTarget = proto.setDefaultTarget = function() {
        var marginProperty = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
      };
      proto.renderPosition = function(x) {
        var sideOffset = this.parent.originSide === "left" ? 1 : -1;
        var adjustedX = this.parent.options.percentPosition ? x * sideOffset * (this.parent.size.innerWidth / this.size.width) : x * sideOffset;
        this.element.style.transform = "translateX(" + this.parent.getPositionValue(adjustedX) + ")";
      };
      proto.select = function() {
        this.element.classList.add("is-selected");
        this.element.removeAttribute("aria-hidden");
      };
      proto.unselect = function() {
        this.element.classList.remove("is-selected");
        this.element.setAttribute("aria-hidden", "true");
      };
      proto.wrapShift = function(shift) {
        this.shift = shift;
        this.renderPosition(this.x + this.parent.slideableWidth * shift);
      };
      proto.remove = function() {
        this.element.parentNode.removeChild(this.element);
      };
      return Cell;
    });
  }
});

// node_modules/flickity/js/slide.js
var require_slide = __commonJS({
  "node_modules/flickity/js/slide.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define(factory);
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory();
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.Slide = factory();
      }
    })(window, function factory() {
      "use strict";
      function Slide(parent) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == "left";
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
      }
      var proto = Slide.prototype;
      proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        if (this.cells.length == 1) {
          this.x = cell.x;
          var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
          this.firstMargin = cell.size[beginMargin];
        }
      };
      proto.updateTarget = function() {
        var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
        var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
      };
      proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
      };
      proto.select = function() {
        this.cells.forEach(function(cell) {
          cell.select();
        });
      };
      proto.unselect = function() {
        this.cells.forEach(function(cell) {
          cell.unselect();
        });
      };
      proto.getCellElements = function() {
        return this.cells.map(function(cell) {
          return cell.element;
        });
      };
      return Slide;
    });
  }
});

// node_modules/flickity/js/animate.js
var require_animate = __commonJS({
  "node_modules/flickity/js/animate.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "fizzy-ui-utils/utils"
        ], function(utils) {
          return factory(window2, utils);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_utils()
        );
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.animatePrototype = factory(
          window2,
          window2.fizzyUIUtils
        );
      }
    })(window, function factory(window2, utils) {
      "use strict";
      var proto = {};
      proto.startAnimation = function() {
        if (this.isAnimating) {
          return;
        }
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
      };
      proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        var previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        if (this.isAnimating) {
          var _this = this;
          requestAnimationFrame(function animateFrame() {
            _this.animate();
          });
        }
      };
      proto.positionSlider = function() {
        var x = this.x;
        if (this.options.wrapAround && this.cells.length > 1) {
          x = utils.modulo(x, this.slideableWidth);
          x -= this.slideableWidth;
          this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
      };
      proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        x = this.options.rightToLeft ? -x : x;
        var translateX = this.getPositionValue(x);
        this.slider.style.transform = is3d ? "translate3d(" + translateX + ",0,0)" : "translateX(" + translateX + ")";
      };
      proto.dispatchScrollEvent = function() {
        var firstSlide = this.slides[0];
        if (!firstSlide) {
          return;
        }
        var positionX = -this.x - firstSlide.target;
        var progress = positionX / this.slidesWidth;
        this.dispatchEvent("scroll", null, [progress, positionX]);
      };
      proto.positionSliderAtSelected = function() {
        if (!this.cells.length) {
          return;
        }
        this.x = -this.selectedSlide.target;
        this.velocity = 0;
        this.positionSlider();
      };
      proto.getPositionValue = function(position) {
        if (this.options.percentPosition) {
          return Math.round(position / this.size.innerWidth * 1e4) * 0.01 + "%";
        } else {
          return Math.round(position) + "px";
        }
      };
      proto.settle = function(previousX) {
        var isResting = !this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100);
        if (isResting) {
          this.restingFrames++;
        }
        if (this.restingFrames > 2) {
          this.isAnimating = false;
          delete this.isFreeScrolling;
          this.positionSlider();
          this.dispatchEvent("settle", null, [this.selectedIndex]);
        }
      };
      proto.shiftWrapCells = function(x) {
        var beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
      };
      proto._shiftCells = function(cells, gap, shift) {
        for (var i = 0; i < cells.length; i++) {
          var cell = cells[i];
          var cellShift = gap > 0 ? shift : 0;
          cell.wrapShift(cellShift);
          gap -= cell.size.outerWidth;
        }
      };
      proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) {
          return;
        }
        for (var i = 0; i < cells.length; i++) {
          cells[i].wrapShift(0);
        }
      };
      proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
      };
      proto.applyForce = function(force) {
        this.velocity += force;
      };
      proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
      };
      proto.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      };
      proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) {
          return;
        }
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
      };
      proto.applySelectedAttraction = function() {
        var dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) {
          return;
        }
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce(force);
      };
      return proto;
    });
  }
});

// node_modules/flickity/js/flickity.js
var require_flickity = __commonJS({
  "node_modules/flickity/js/flickity.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "ev-emitter/ev-emitter",
          "get-size/get-size",
          "fizzy-ui-utils/utils",
          "./cell",
          "./slide",
          "./animate"
        ], function(EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
          return factory(window2, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_ev_emitter(),
          require_get_size(),
          require_utils(),
          require_cell(),
          require_slide(),
          require_animate()
        );
      } else {
        var _Flickity = window2.Flickity;
        window2.Flickity = factory(
          window2,
          window2.EvEmitter,
          window2.getSize,
          window2.fizzyUIUtils,
          _Flickity.Cell,
          _Flickity.Slide,
          _Flickity.animatePrototype
        );
      }
    })(window, function factory(window2, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
      "use strict";
      var jQuery = window2.jQuery;
      var getComputedStyle3 = window2.getComputedStyle;
      var console2 = window2.console;
      function moveElements(elems, toElem) {
        elems = utils.makeArray(elems);
        while (elems.length) {
          toElem.appendChild(elems.shift());
        }
      }
      var GUID = 0;
      var instances = {};
      function Flickity5(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
          if (console2) {
            console2.error("Bad element for Flickity: " + (queryElement || element));
          }
          return;
        }
        this.element = queryElement;
        if (this.element.flickityGUID) {
          var instance = instances[this.element.flickityGUID];
          if (instance)
            instance.option(options);
          return instance;
        }
        if (jQuery) {
          this.$element = jQuery(this.element);
        }
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        this._create();
      }
      Flickity5.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: "center",
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        // friction when free-scrolling
        friction: 0.28,
        // friction when selecting
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
        // watchCSS: false,
        // wrapAround: false
      };
      Flickity5.createMethods = [];
      var proto = Flickity5.prototype;
      utils.extend(proto, EvEmitter.prototype);
      proto._create = function() {
        var id = this.guid = ++GUID;
        this.element.flickityGUID = id;
        instances[id] = this;
        this.selectedIndex = 0;
        this.restingFrames = 0;
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? "right" : "left";
        this.viewport = document.createElement("div");
        this.viewport.className = "flickity-viewport";
        this._createSlider();
        if (this.options.resize || this.options.watchCSS) {
          window2.addEventListener("resize", this);
        }
        for (var eventName in this.options.on) {
          var listener = this.options.on[eventName];
          this.on(eventName, listener);
        }
        Flickity5.createMethods.forEach(function(method) {
          this[method]();
        }, this);
        if (this.options.watchCSS) {
          this.watchCSS();
        } else {
          this.activate();
        }
      };
      proto.option = function(opts) {
        utils.extend(this.options, opts);
      };
      proto.activate = function() {
        if (this.isActive) {
          return;
        }
        this.isActive = true;
        this.element.classList.add("flickity-enabled");
        if (this.options.rightToLeft) {
          this.element.classList.add("flickity-rtl");
        }
        this.getSize();
        var cellElems = this._filterFindCellElements(this.element.children);
        moveElements(cellElems, this.slider);
        this.viewport.appendChild(this.slider);
        this.element.appendChild(this.viewport);
        this.reloadCells();
        if (this.options.accessibility) {
          this.element.tabIndex = 0;
          this.element.addEventListener("keydown", this);
        }
        this.emitEvent("activate");
        this.selectInitialIndex();
        this.isInitActivated = true;
        this.dispatchEvent("ready");
      };
      proto._createSlider = function() {
        var slider = document.createElement("div");
        slider.className = "flickity-slider";
        slider.style[this.originSide] = 0;
        this.slider = slider;
      };
      proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
      };
      proto.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
      };
      proto._makeCells = function(elems) {
        var cellElems = this._filterFindCellElements(elems);
        var cells = cellElems.map(function(cellElem) {
          return new Cell(cellElem, this);
        }, this);
        return cells;
      };
      proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
      };
      proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
      };
      proto.positionCells = function() {
        this._sizeCells(this.cells);
        this._positionCells(0);
      };
      proto._positionCells = function(index) {
        index = index || 0;
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        if (index > 0) {
          var startCell = this.cells[index - 1];
          cellX = startCell.x + startCell.size.outerWidth;
        }
        var len = this.cells.length;
        for (var i = index; i < len; i++) {
          var cell = this.cells[i];
          cell.setPosition(cellX);
          cellX += cell.size.outerWidth;
          this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        }
        this.slideableWidth = cellX;
        this.updateSlides();
        this._containSlides();
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
      };
      proto._sizeCells = function(cells) {
        cells.forEach(function(cell) {
          cell.getSize();
        });
      };
      proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) {
          return;
        }
        var slide2 = new Slide(this);
        this.slides.push(slide2);
        var isOriginLeft = this.originSide == "left";
        var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";
        var canCellFit = this._getCanCellFit();
        this.cells.forEach(function(cell, i) {
          if (!slide2.cells.length) {
            slide2.addCell(cell);
            return;
          }
          var slideWidth = slide2.outerWidth - slide2.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);
          if (canCellFit.call(this, i, slideWidth)) {
            slide2.addCell(cell);
          } else {
            slide2.updateTarget();
            slide2 = new Slide(this);
            this.slides.push(slide2);
            slide2.addCell(cell);
          }
        }, this);
        slide2.updateTarget();
        this.updateSelectedSlide();
      };
      proto._getCanCellFit = function() {
        var groupCells = this.options.groupCells;
        if (!groupCells) {
          return function() {
            return false;
          };
        } else if (typeof groupCells == "number") {
          var number = parseInt(groupCells, 10);
          return function(i) {
            return i % number !== 0;
          };
        }
        var percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
        var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
        return function(i, slideWidth) {
          return slideWidth <= (this.size.innerWidth + 1) * percent;
        };
      };
      proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
      };
      proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
      };
      var cellAlignShorthands = {
        // cell align, then based on origin side
        center: {
          left: 0.5,
          right: 0.5
        },
        left: {
          left: 0,
          right: 1
        },
        right: {
          right: 0,
          left: 1
        }
      };
      proto.setCellAlign = function() {
        var shorthand = cellAlignShorthands[this.options.cellAlign];
        this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
      };
      proto.setGallerySize = function() {
        if (this.options.setGallerySize) {
          var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
          this.viewport.style.height = height + "px";
        }
      };
      proto._getWrapShiftCells = function() {
        if (!this.options.wrapAround) {
          return;
        }
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
        gapX = this.size.innerWidth - this.cursorPosition;
        this.afterShiftCells = this._getGapCells(gapX, 0, 1);
      };
      proto._getGapCells = function(gapX, cellIndex, increment) {
        var cells = [];
        while (gapX > 0) {
          var cell = this.cells[cellIndex];
          if (!cell) {
            break;
          }
          cells.push(cell);
          cellIndex += increment;
          gapX -= cell.size.outerWidth;
        }
        return cells;
      };
      proto._containSlides = function() {
        if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
          return;
        }
        var isRightToLeft = this.options.rightToLeft;
        var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
        var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
        var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
        var isContentSmaller = contentWidth < this.size.innerWidth;
        var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
        var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
        this.slides.forEach(function(slide2) {
          if (isContentSmaller) {
            slide2.target = contentWidth * this.cellAlign;
          } else {
            slide2.target = Math.max(slide2.target, beginBound);
            slide2.target = Math.min(slide2.target, endBound);
          }
        }, this);
      };
      proto.dispatchEvent = function(type, event2, args) {
        var emitArgs = event2 ? [event2].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
          type += this.options.namespaceJQueryEvents ? ".flickity" : "";
          var $event = type;
          if (event2) {
            var jQEvent = new jQuery.Event(event2);
            jQEvent.type = type;
            $event = jQEvent;
          }
          this.$element.trigger($event, args);
        }
      };
      proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) {
          return;
        }
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.options.wrapAround || isWrap) {
          index = utils.modulo(index, this.slides.length);
        }
        if (!this.slides[index]) {
          return;
        }
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) {
          this.positionSliderAtSelected();
        } else {
          this.startAnimation();
        }
        if (this.options.adaptiveHeight) {
          this.setGallerySize();
        }
        this.dispatchEvent("select", null, [index]);
        if (index != prevIndex) {
          this.dispatchEvent("change", null, [index]);
        }
        this.dispatchEvent("cellSelect");
      };
      proto._wrapSelect = function(index) {
        var len = this.slides.length;
        var isWrapping = this.options.wrapAround && len > 1;
        if (!isWrapping) {
          return index;
        }
        var wrapIndex = utils.modulo(index, len);
        var delta = Math.abs(wrapIndex - this.selectedIndex);
        var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
        var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
        if (!this.isDragSelect && backWrapDelta < delta) {
          index += len;
        } else if (!this.isDragSelect && forewardWrapDelta < delta) {
          index -= len;
        }
        if (index < 0) {
          this.x -= this.slideableWidth;
        } else if (index >= len) {
          this.x += this.slideableWidth;
        }
      };
      proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
      };
      proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
      };
      proto.updateSelectedSlide = function() {
        var slide2 = this.slides[this.selectedIndex];
        if (!slide2) {
          return;
        }
        this.unselectSelectedSlide();
        this.selectedSlide = slide2;
        slide2.select();
        this.selectedCells = slide2.cells;
        this.selectedElements = slide2.getCellElements();
        this.selectedCell = slide2.cells[0];
        this.selectedElement = this.selectedElements[0];
      };
      proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) {
          this.selectedSlide.unselect();
        }
      };
      proto.selectInitialIndex = function() {
        var initialIndex = this.options.initialIndex;
        if (this.isInitActivated) {
          this.select(this.selectedIndex, false, true);
          return;
        }
        if (initialIndex && typeof initialIndex == "string") {
          var cell = this.queryCell(initialIndex);
          if (cell) {
            this.selectCell(initialIndex, false, true);
            return;
          }
        }
        var index = 0;
        if (initialIndex && this.slides[initialIndex]) {
          index = initialIndex;
        }
        this.select(index, false, true);
      };
      proto.selectCell = function(value, isWrap, isInstant) {
        var cell = this.queryCell(value);
        if (!cell) {
          return;
        }
        var index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
      };
      proto.getCellSlideIndex = function(cell) {
        for (var i = 0; i < this.slides.length; i++) {
          var slide2 = this.slides[i];
          var index = slide2.cells.indexOf(cell);
          if (index != -1) {
            return i;
          }
        }
      };
      proto.getCell = function(elem) {
        for (var i = 0; i < this.cells.length; i++) {
          var cell = this.cells[i];
          if (cell.element == elem) {
            return cell;
          }
        }
      };
      proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        var cells = [];
        elems.forEach(function(elem) {
          var cell = this.getCell(elem);
          if (cell) {
            cells.push(cell);
          }
        }, this);
        return cells;
      };
      proto.getCellElements = function() {
        return this.cells.map(function(cell) {
          return cell.element;
        });
      };
      proto.getParentCell = function(elem) {
        var cell = this.getCell(elem);
        if (cell) {
          return cell;
        }
        elem = utils.getParent(elem, ".flickity-slider > *");
        return this.getCell(elem);
      };
      proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) {
          return this.selectedSlide.getCellElements();
        }
        index = index === void 0 ? this.selectedIndex : index;
        var len = this.slides.length;
        if (1 + adjCount * 2 >= len) {
          return this.getCellElements();
        }
        var cellElems = [];
        for (var i = index - adjCount; i <= index + adjCount; i++) {
          var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
          var slide2 = this.slides[slideIndex];
          if (slide2) {
            cellElems = cellElems.concat(slide2.getCellElements());
          }
        }
        return cellElems;
      };
      proto.queryCell = function(selector) {
        if (typeof selector == "number") {
          return this.cells[selector];
        }
        if (typeof selector == "string") {
          if (selector.match(/^[#.]?[\d/]/)) {
            return;
          }
          selector = this.element.querySelector(selector);
        }
        return this.getCell(selector);
      };
      proto.uiChange = function() {
        this.emitEvent("uiChange");
      };
      proto.childUIPointerDown = function(event2) {
        if (event2.type != "touchstart") {
          event2.preventDefault();
        }
        this.focus();
      };
      proto.onresize = function() {
        this.watchCSS();
        this.resize();
      };
      utils.debounceMethod(Flickity5, "onresize", 150);
      proto.resize = function() {
        if (!this.isActive || this.isAnimating || this.isDragging) {
          return;
        }
        this.getSize();
        if (this.options.wrapAround) {
          this.x = utils.modulo(this.x, this.slideableWidth);
        }
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent("resize");
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
      };
      proto.watchCSS = function() {
        var watchOption = this.options.watchCSS;
        if (!watchOption) {
          return;
        }
        var afterContent = getComputedStyle3(this.element, ":after").content;
        if (afterContent.indexOf("flickity") != -1) {
          this.activate();
        } else {
          this.deactivate();
        }
      };
      proto.onkeydown = function(event2) {
        var isNotFocused = document.activeElement && document.activeElement != this.element;
        if (!this.options.accessibility || isNotFocused) {
          return;
        }
        var handler = Flickity5.keyboardHandlers[event2.keyCode];
        if (handler) {
          handler.call(this);
        }
      };
      Flickity5.keyboardHandlers = {
        // left arrow
        37: function() {
          var leftMethod = this.options.rightToLeft ? "next" : "previous";
          this.uiChange();
          this[leftMethod]();
        },
        // right arrow
        39: function() {
          var rightMethod = this.options.rightToLeft ? "previous" : "next";
          this.uiChange();
          this[rightMethod]();
        }
      };
      proto.focus = function() {
        var prevScrollY = window2.pageYOffset;
        this.element.focus({ preventScroll: true });
        if (window2.pageYOffset != prevScrollY) {
          window2.scrollTo(window2.pageXOffset, prevScrollY);
        }
      };
      proto.deactivate = function() {
        if (!this.isActive) {
          return;
        }
        this.element.classList.remove("flickity-enabled");
        this.element.classList.remove("flickity-rtl");
        this.unselectSelectedSlide();
        this.cells.forEach(function(cell) {
          cell.destroy();
        });
        this.element.removeChild(this.viewport);
        moveElements(this.slider.children, this.element);
        if (this.options.accessibility) {
          this.element.removeAttribute("tabIndex");
          this.element.removeEventListener("keydown", this);
        }
        this.isActive = false;
        this.emitEvent("deactivate");
      };
      proto.destroy = function() {
        this.deactivate();
        window2.removeEventListener("resize", this);
        this.allOff();
        this.emitEvent("destroy");
        if (jQuery && this.$element) {
          jQuery.removeData(this.element, "flickity");
        }
        delete this.element.flickityGUID;
        delete instances[this.guid];
      };
      utils.extend(proto, animatePrototype);
      Flickity5.data = function(elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.flickityGUID;
        return id && instances[id];
      };
      utils.htmlInit(Flickity5, "flickity");
      if (jQuery && jQuery.bridget) {
        jQuery.bridget("flickity", Flickity5);
      }
      Flickity5.setJQuery = function(jq) {
        jQuery = jq;
      };
      Flickity5.Cell = Cell;
      Flickity5.Slide = Slide;
      return Flickity5;
    });
  }
});

// node_modules/unipointer/unipointer.js
var require_unipointer = __commonJS({
  "node_modules/unipointer/unipointer.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "ev-emitter/ev-emitter"
        ], function(EvEmitter) {
          return factory(window2, EvEmitter);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_ev_emitter()
        );
      } else {
        window2.Unipointer = factory(
          window2,
          window2.EvEmitter
        );
      }
    })(window, function factory(window2, EvEmitter) {
      "use strict";
      function noop() {
      }
      function Unipointer() {
      }
      var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);
      proto.bindStartEvent = function(elem) {
        this._bindStartEvent(elem, true);
      };
      proto.unbindStartEvent = function(elem) {
        this._bindStartEvent(elem, false);
      };
      proto._bindStartEvent = function(elem, isAdd) {
        isAdd = isAdd === void 0 ? true : isAdd;
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        var startEvent = "mousedown";
        if ("ontouchstart" in window2) {
          startEvent = "touchstart";
        } else if (window2.PointerEvent) {
          startEvent = "pointerdown";
        }
        elem[bindMethod](startEvent, this);
      };
      proto.handleEvent = function(event2) {
        var method = "on" + event2.type;
        if (this[method]) {
          this[method](event2);
        }
      };
      proto.getTouch = function(touches) {
        for (var i = 0; i < touches.length; i++) {
          var touch = touches[i];
          if (touch.identifier == this.pointerIdentifier) {
            return touch;
          }
        }
      };
      proto.onmousedown = function(event2) {
        var button = event2.button;
        if (button && (button !== 0 && button !== 1)) {
          return;
        }
        this._pointerDown(event2, event2);
      };
      proto.ontouchstart = function(event2) {
        this._pointerDown(event2, event2.changedTouches[0]);
      };
      proto.onpointerdown = function(event2) {
        this._pointerDown(event2, event2);
      };
      proto._pointerDown = function(event2, pointer) {
        if (event2.button || this.isPointerDown) {
          return;
        }
        this.isPointerDown = true;
        this.pointerIdentifier = pointer.pointerId !== void 0 ? (
          // pointerId for pointer events, touch.indentifier for touch events
          pointer.pointerId
        ) : pointer.identifier;
        this.pointerDown(event2, pointer);
      };
      proto.pointerDown = function(event2, pointer) {
        this._bindPostStartEvents(event2);
        this.emitEvent("pointerDown", [event2, pointer]);
      };
      var postStartEvents = {
        mousedown: ["mousemove", "mouseup"],
        touchstart: ["touchmove", "touchend", "touchcancel"],
        pointerdown: ["pointermove", "pointerup", "pointercancel"]
      };
      proto._bindPostStartEvents = function(event2) {
        if (!event2) {
          return;
        }
        var events2 = postStartEvents[event2.type];
        events2.forEach(function(eventName) {
          window2.addEventListener(eventName, this);
        }, this);
        this._boundPointerEvents = events2;
      };
      proto._unbindPostStartEvents = function() {
        if (!this._boundPointerEvents) {
          return;
        }
        this._boundPointerEvents.forEach(function(eventName) {
          window2.removeEventListener(eventName, this);
        }, this);
        delete this._boundPointerEvents;
      };
      proto.onmousemove = function(event2) {
        this._pointerMove(event2, event2);
      };
      proto.onpointermove = function(event2) {
        if (event2.pointerId == this.pointerIdentifier) {
          this._pointerMove(event2, event2);
        }
      };
      proto.ontouchmove = function(event2) {
        var touch = this.getTouch(event2.changedTouches);
        if (touch) {
          this._pointerMove(event2, touch);
        }
      };
      proto._pointerMove = function(event2, pointer) {
        this.pointerMove(event2, pointer);
      };
      proto.pointerMove = function(event2, pointer) {
        this.emitEvent("pointerMove", [event2, pointer]);
      };
      proto.onmouseup = function(event2) {
        this._pointerUp(event2, event2);
      };
      proto.onpointerup = function(event2) {
        if (event2.pointerId == this.pointerIdentifier) {
          this._pointerUp(event2, event2);
        }
      };
      proto.ontouchend = function(event2) {
        var touch = this.getTouch(event2.changedTouches);
        if (touch) {
          this._pointerUp(event2, touch);
        }
      };
      proto._pointerUp = function(event2, pointer) {
        this._pointerDone();
        this.pointerUp(event2, pointer);
      };
      proto.pointerUp = function(event2, pointer) {
        this.emitEvent("pointerUp", [event2, pointer]);
      };
      proto._pointerDone = function() {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
      };
      proto._pointerReset = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
      };
      proto.pointerDone = noop;
      proto.onpointercancel = function(event2) {
        if (event2.pointerId == this.pointerIdentifier) {
          this._pointerCancel(event2, event2);
        }
      };
      proto.ontouchcancel = function(event2) {
        var touch = this.getTouch(event2.changedTouches);
        if (touch) {
          this._pointerCancel(event2, touch);
        }
      };
      proto._pointerCancel = function(event2, pointer) {
        this._pointerDone();
        this.pointerCancel(event2, pointer);
      };
      proto.pointerCancel = function(event2, pointer) {
        this.emitEvent("pointerCancel", [event2, pointer]);
      };
      Unipointer.getPointerPoint = function(pointer) {
        return {
          x: pointer.pageX,
          y: pointer.pageY
        };
      };
      return Unipointer;
    });
  }
});

// node_modules/unidragger/unidragger.js
var require_unidragger = __commonJS({
  "node_modules/unidragger/unidragger.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "unipointer/unipointer"
        ], function(Unipointer) {
          return factory(window2, Unipointer);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_unipointer()
        );
      } else {
        window2.Unidragger = factory(
          window2,
          window2.Unipointer
        );
      }
    })(window, function factory(window2, Unipointer) {
      "use strict";
      function Unidragger() {
      }
      var proto = Unidragger.prototype = Object.create(Unipointer.prototype);
      proto.bindHandles = function() {
        this._bindHandles(true);
      };
      proto.unbindHandles = function() {
        this._bindHandles(false);
      };
      proto._bindHandles = function(isAdd) {
        isAdd = isAdd === void 0 ? true : isAdd;
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        var touchAction = isAdd ? this._touchActionValue : "";
        for (var i = 0; i < this.handles.length; i++) {
          var handle = this.handles[i];
          this._bindStartEvent(handle, isAdd);
          handle[bindMethod]("click", this);
          if (window2.PointerEvent) {
            handle.style.touchAction = touchAction;
          }
        }
      };
      proto._touchActionValue = "none";
      proto.pointerDown = function(event2, pointer) {
        var isOkay = this.okayPointerDown(event2);
        if (!isOkay) {
          return;
        }
        this.pointerDownPointer = {
          pageX: pointer.pageX,
          pageY: pointer.pageY
        };
        event2.preventDefault();
        this.pointerDownBlur();
        this._bindPostStartEvents(event2);
        this.emitEvent("pointerDown", [event2, pointer]);
      };
      var cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true
      };
      var clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true
      };
      proto.okayPointerDown = function(event2) {
        var isCursorNode = cursorNodes[event2.target.nodeName];
        var isClickType = clickTypes[event2.target.type];
        var isOkay = !isCursorNode || isClickType;
        if (!isOkay) {
          this._pointerReset();
        }
        return isOkay;
      };
      proto.pointerDownBlur = function() {
        var focused = document.activeElement;
        var canBlur = focused && focused.blur && focused != document.body;
        if (canBlur) {
          focused.blur();
        }
      };
      proto.pointerMove = function(event2, pointer) {
        var moveVector = this._dragPointerMove(event2, pointer);
        this.emitEvent("pointerMove", [event2, pointer, moveVector]);
        this._dragMove(event2, pointer, moveVector);
      };
      proto._dragPointerMove = function(event2, pointer) {
        var moveVector = {
          x: pointer.pageX - this.pointerDownPointer.pageX,
          y: pointer.pageY - this.pointerDownPointer.pageY
        };
        if (!this.isDragging && this.hasDragStarted(moveVector)) {
          this._dragStart(event2, pointer);
        }
        return moveVector;
      };
      proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
      };
      proto.pointerUp = function(event2, pointer) {
        this.emitEvent("pointerUp", [event2, pointer]);
        this._dragPointerUp(event2, pointer);
      };
      proto._dragPointerUp = function(event2, pointer) {
        if (this.isDragging) {
          this._dragEnd(event2, pointer);
        } else {
          this._staticClick(event2, pointer);
        }
      };
      proto._dragStart = function(event2, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true;
        this.dragStart(event2, pointer);
      };
      proto.dragStart = function(event2, pointer) {
        this.emitEvent("dragStart", [event2, pointer]);
      };
      proto._dragMove = function(event2, pointer, moveVector) {
        if (!this.isDragging) {
          return;
        }
        this.dragMove(event2, pointer, moveVector);
      };
      proto.dragMove = function(event2, pointer, moveVector) {
        event2.preventDefault();
        this.emitEvent("dragMove", [event2, pointer, moveVector]);
      };
      proto._dragEnd = function(event2, pointer) {
        this.isDragging = false;
        setTimeout(function() {
          delete this.isPreventingClicks;
        }.bind(this));
        this.dragEnd(event2, pointer);
      };
      proto.dragEnd = function(event2, pointer) {
        this.emitEvent("dragEnd", [event2, pointer]);
      };
      proto.onclick = function(event2) {
        if (this.isPreventingClicks) {
          event2.preventDefault();
        }
      };
      proto._staticClick = function(event2, pointer) {
        if (this.isIgnoringMouseUp && event2.type == "mouseup") {
          return;
        }
        this.staticClick(event2, pointer);
        if (event2.type != "mouseup") {
          this.isIgnoringMouseUp = true;
          setTimeout(function() {
            delete this.isIgnoringMouseUp;
          }.bind(this), 400);
        }
      };
      proto.staticClick = function(event2, pointer) {
        this.emitEvent("staticClick", [event2, pointer]);
      };
      Unidragger.getPointerPoint = Unipointer.getPointerPoint;
      return Unidragger;
    });
  }
});

// node_modules/flickity/js/drag.js
var require_drag = __commonJS({
  "node_modules/flickity/js/drag.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "./flickity",
          "unidragger/unidragger",
          "fizzy-ui-utils/utils"
        ], function(Flickity5, Unidragger, utils) {
          return factory(window2, Flickity5, Unidragger, utils);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_flickity(),
          require_unidragger(),
          require_utils()
        );
      } else {
        window2.Flickity = factory(
          window2,
          window2.Flickity,
          window2.Unidragger,
          window2.fizzyUIUtils
        );
      }
    })(window, function factory(window2, Flickity5, Unidragger, utils) {
      "use strict";
      utils.extend(Flickity5.defaults, {
        draggable: ">1",
        dragThreshold: 3
      });
      Flickity5.createMethods.push("_createDrag");
      var proto = Flickity5.prototype;
      utils.extend(proto, Unidragger.prototype);
      proto._touchActionValue = "pan-y";
      proto._createDrag = function() {
        this.on("activate", this.onActivateDrag);
        this.on("uiChange", this._uiChangeDrag);
        this.on("deactivate", this.onDeactivateDrag);
        this.on("cellChange", this.updateDraggable);
      };
      proto.onActivateDrag = function() {
        this.handles = [this.viewport];
        this.bindHandles();
        this.updateDraggable();
      };
      proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove("is-draggable");
      };
      proto.updateDraggable = function() {
        if (this.options.draggable == ">1") {
          this.isDraggable = this.slides.length > 1;
        } else {
          this.isDraggable = this.options.draggable;
        }
        if (this.isDraggable) {
          this.element.classList.add("is-draggable");
        } else {
          this.element.classList.remove("is-draggable");
        }
      };
      proto.bindDrag = function() {
        this.options.draggable = true;
        this.updateDraggable();
      };
      proto.unbindDrag = function() {
        this.options.draggable = false;
        this.updateDraggable();
      };
      proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
      };
      proto.pointerDown = function(event2, pointer) {
        if (!this.isDraggable) {
          this._pointerDownDefault(event2, pointer);
          return;
        }
        var isOkay = this.okayPointerDown(event2);
        if (!isOkay) {
          return;
        }
        this._pointerDownPreventDefault(event2);
        this.pointerDownFocus(event2);
        if (document.activeElement != this.element) {
          this.pointerDownBlur();
        }
        this.dragX = this.x;
        this.viewport.classList.add("is-pointer-down");
        this.pointerDownScroll = getScrollPosition();
        window2.addEventListener("scroll", this);
        this._pointerDownDefault(event2, pointer);
      };
      proto._pointerDownDefault = function(event2, pointer) {
        this.pointerDownPointer = {
          pageX: pointer.pageX,
          pageY: pointer.pageY
        };
        this._bindPostStartEvents(event2);
        this.dispatchEvent("pointerDown", event2, [pointer]);
      };
      var focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true
      };
      proto.pointerDownFocus = function(event2) {
        var isFocusNode = focusNodes[event2.target.nodeName];
        if (!isFocusNode) {
          this.focus();
        }
      };
      proto._pointerDownPreventDefault = function(event2) {
        var isTouchStart = event2.type == "touchstart";
        var isTouchPointer = event2.pointerType == "touch";
        var isFocusNode = focusNodes[event2.target.nodeName];
        if (!isTouchStart && !isTouchPointer && !isFocusNode) {
          event2.preventDefault();
        }
      };
      proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
      };
      proto.pointerUp = function(event2, pointer) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove("is-pointer-down");
        this.dispatchEvent("pointerUp", event2, [pointer]);
        this._dragPointerUp(event2, pointer);
      };
      proto.pointerDone = function() {
        window2.removeEventListener("scroll", this);
        delete this.pointerDownScroll;
      };
      proto.dragStart = function(event2, pointer) {
        if (!this.isDraggable) {
          return;
        }
        this.dragStartPosition = this.x;
        this.startAnimation();
        window2.removeEventListener("scroll", this);
        this.dispatchEvent("dragStart", event2, [pointer]);
      };
      proto.pointerMove = function(event2, pointer) {
        var moveVector = this._dragPointerMove(event2, pointer);
        this.dispatchEvent("pointerMove", event2, [pointer, moveVector]);
        this._dragMove(event2, pointer, moveVector);
      };
      proto.dragMove = function(event2, pointer, moveVector) {
        if (!this.isDraggable) {
          return;
        }
        event2.preventDefault();
        this.previousDragX = this.dragX;
        var direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) {
          moveVector.x %= this.slideableWidth;
        }
        var dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.options.wrapAround && this.slides.length) {
          var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
          dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
          var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
          dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = /* @__PURE__ */ new Date();
        this.dispatchEvent("dragMove", event2, [pointer, moveVector]);
      };
      proto.dragEnd = function(event2, pointer) {
        if (!this.isDraggable) {
          return;
        }
        if (this.options.freeScroll) {
          this.isFreeScrolling = true;
        }
        var index = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
          var restingX = this.getRestingPosition();
          this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!this.options.freeScroll && index == this.selectedIndex) {
          index += this.dragEndBoostSelect();
        }
        delete this.previousDragX;
        this.isDragSelect = this.options.wrapAround;
        this.select(index);
        delete this.isDragSelect;
        this.dispatchEvent("dragEnd", event2, [pointer]);
      };
      proto.dragEndRestingSelect = function() {
        var restingX = this.getRestingPosition();
        var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        var positiveResting = this._getClosestResting(restingX, distance, 1);
        var negativeResting = this._getClosestResting(restingX, distance, -1);
        var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        return index;
      };
      proto._getClosestResting = function(restingX, distance, increment) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition = this.options.contain && !this.options.wrapAround ? (
          // if contain, keep going if distance is equal to minDistance
          function(dist, minDist) {
            return dist <= minDist;
          }
        ) : function(dist, minDist) {
          return dist < minDist;
        };
        while (condition(distance, minDistance)) {
          index += increment;
          minDistance = distance;
          distance = this.getSlideDistance(-restingX, index);
          if (distance === null) {
            break;
          }
          distance = Math.abs(distance);
        }
        return {
          distance: minDistance,
          // selected was previous index
          index: index - increment
        };
      };
      proto.getSlideDistance = function(x, index) {
        var len = this.slides.length;
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        var slide2 = this.slides[slideIndex];
        if (!slide2) {
          return null;
        }
        var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide2.target + wrap);
      };
      proto.dragEndBoostSelect = function() {
        if (this.previousDragX === void 0 || !this.dragMoveTime || // or if drag was held for 100 ms
        /* @__PURE__ */ new Date() - this.dragMoveTime > 100) {
          return 0;
        }
        var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        var delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) {
          return 1;
        } else if (distance < 0 && delta < 0) {
          return -1;
        }
        return 0;
      };
      proto.staticClick = function(event2, pointer) {
        var clickedCell = this.getParentCell(event2.target);
        var cellElem = clickedCell && clickedCell.element;
        var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
        this.dispatchEvent("staticClick", event2, [pointer, cellElem, cellIndex]);
      };
      proto.onscroll = function() {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
          this._pointerDone();
        }
      };
      function getScrollPosition() {
        return {
          x: window2.pageXOffset,
          y: window2.pageYOffset
        };
      }
      return Flickity5;
    });
  }
});

// node_modules/flickity/js/prev-next-button.js
var require_prev_next_button = __commonJS({
  "node_modules/flickity/js/prev-next-button.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "./flickity",
          "unipointer/unipointer",
          "fizzy-ui-utils/utils"
        ], function(Flickity5, Unipointer, utils) {
          return factory(window2, Flickity5, Unipointer, utils);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_flickity(),
          require_unipointer(),
          require_utils()
        );
      } else {
        factory(
          window2,
          window2.Flickity,
          window2.Unipointer,
          window2.fizzyUIUtils
        );
      }
    })(window, function factory(window2, Flickity5, Unipointer, utils) {
      "use strict";
      var svgURI = "http://www.w3.org/2000/svg";
      function PrevNextButton(direction, parent) {
        this.direction = direction;
        this.parent = parent;
        this._create();
      }
      PrevNextButton.prototype = Object.create(Unipointer.prototype);
      PrevNextButton.prototype._create = function() {
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;
        var element = this.element = document.createElement("button");
        element.className = "flickity-button flickity-prev-next-button";
        element.className += this.isPrevious ? " previous" : " next";
        element.setAttribute("type", "button");
        this.disable();
        element.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        var svg = this.createSVG();
        element.appendChild(svg);
        this.parent.on("select", this.update.bind(this));
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
      };
      PrevNextButton.prototype.activate = function() {
        this.bindStartEvent(this.element);
        this.element.addEventListener("click", this);
        this.parent.element.appendChild(this.element);
      };
      PrevNextButton.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element);
        this.unbindStartEvent(this.element);
        this.element.removeEventListener("click", this);
      };
      PrevNextButton.prototype.createSVG = function() {
        var svg = document.createElementNS(svgURI, "svg");
        svg.setAttribute("class", "flickity-button-icon");
        svg.setAttribute("viewBox", "0 0 100 100");
        var path = document.createElementNS(svgURI, "path");
        var pathMovements = getArrowMovements(this.parent.options.arrowShape);
        path.setAttribute("d", pathMovements);
        path.setAttribute("class", "arrow");
        if (!this.isLeft) {
          path.setAttribute("transform", "translate(100, 100) rotate(180) ");
        }
        svg.appendChild(path);
        return svg;
      };
      function getArrowMovements(shape) {
        if (typeof shape == "string") {
          return shape;
        }
        return "M " + shape.x0 + ",50 L " + shape.x1 + "," + (shape.y1 + 50) + " L " + shape.x2 + "," + (shape.y2 + 50) + " L " + shape.x3 + ",50  L " + shape.x2 + "," + (50 - shape.y2) + " L " + shape.x1 + "," + (50 - shape.y1) + " Z";
      }
      PrevNextButton.prototype.handleEvent = utils.handleEvent;
      PrevNextButton.prototype.onclick = function() {
        if (!this.isEnabled) {
          return;
        }
        this.parent.uiChange();
        var method = this.isPrevious ? "previous" : "next";
        this.parent[method]();
      };
      PrevNextButton.prototype.enable = function() {
        if (this.isEnabled) {
          return;
        }
        this.element.disabled = false;
        this.isEnabled = true;
      };
      PrevNextButton.prototype.disable = function() {
        if (!this.isEnabled) {
          return;
        }
        this.element.disabled = true;
        this.isEnabled = false;
      };
      PrevNextButton.prototype.update = function() {
        var slides = this.parent.slides;
        if (this.parent.options.wrapAround && slides.length > 1) {
          this.enable();
          return;
        }
        var lastIndex = slides.length ? slides.length - 1 : 0;
        var boundIndex = this.isPrevious ? 0 : lastIndex;
        var method = this.parent.selectedIndex == boundIndex ? "disable" : "enable";
        this[method]();
      };
      PrevNextButton.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
      };
      utils.extend(Flickity5.defaults, {
        prevNextButtons: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 70,
          y2: 40,
          x3: 30
        }
      });
      Flickity5.createMethods.push("_createPrevNextButtons");
      var proto = Flickity5.prototype;
      proto._createPrevNextButtons = function() {
        if (!this.options.prevNextButtons) {
          return;
        }
        this.prevButton = new PrevNextButton(-1, this);
        this.nextButton = new PrevNextButton(1, this);
        this.on("activate", this.activatePrevNextButtons);
      };
      proto.activatePrevNextButtons = function() {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on("deactivate", this.deactivatePrevNextButtons);
      };
      proto.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off("deactivate", this.deactivatePrevNextButtons);
      };
      Flickity5.PrevNextButton = PrevNextButton;
      return Flickity5;
    });
  }
});

// node_modules/flickity/js/page-dots.js
var require_page_dots = __commonJS({
  "node_modules/flickity/js/page-dots.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "./flickity",
          "unipointer/unipointer",
          "fizzy-ui-utils/utils"
        ], function(Flickity5, Unipointer, utils) {
          return factory(window2, Flickity5, Unipointer, utils);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_flickity(),
          require_unipointer(),
          require_utils()
        );
      } else {
        factory(
          window2,
          window2.Flickity,
          window2.Unipointer,
          window2.fizzyUIUtils
        );
      }
    })(window, function factory(window2, Flickity5, Unipointer, utils) {
      "use strict";
      function PageDots(parent) {
        this.parent = parent;
        this._create();
      }
      PageDots.prototype = Object.create(Unipointer.prototype);
      PageDots.prototype._create = function() {
        this.holder = document.createElement("ol");
        this.holder.className = "flickity-page-dots";
        this.dots = [];
        this.handleClick = this.onClick.bind(this);
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
      };
      PageDots.prototype.activate = function() {
        this.setDots();
        this.holder.addEventListener("click", this.handleClick);
        this.bindStartEvent(this.holder);
        this.parent.element.appendChild(this.holder);
      };
      PageDots.prototype.deactivate = function() {
        this.holder.removeEventListener("click", this.handleClick);
        this.unbindStartEvent(this.holder);
        this.parent.element.removeChild(this.holder);
      };
      PageDots.prototype.setDots = function() {
        var delta = this.parent.slides.length - this.dots.length;
        if (delta > 0) {
          this.addDots(delta);
        } else if (delta < 0) {
          this.removeDots(-delta);
        }
      };
      PageDots.prototype.addDots = function(count) {
        var fragment = document.createDocumentFragment();
        var newDots = [];
        var length = this.dots.length;
        var max = length + count;
        for (var i = length; i < max; i++) {
          var dot = document.createElement("li");
          dot.className = "dot";
          dot.setAttribute("aria-label", "Page dot " + (i + 1));
          fragment.appendChild(dot);
          newDots.push(dot);
        }
        this.holder.appendChild(fragment);
        this.dots = this.dots.concat(newDots);
      };
      PageDots.prototype.removeDots = function(count) {
        var removeDots = this.dots.splice(this.dots.length - count, count);
        removeDots.forEach(function(dot) {
          this.holder.removeChild(dot);
        }, this);
      };
      PageDots.prototype.updateSelected = function() {
        if (this.selectedDot) {
          this.selectedDot.className = "dot";
          this.selectedDot.removeAttribute("aria-current");
        }
        if (!this.dots.length) {
          return;
        }
        this.selectedDot = this.dots[this.parent.selectedIndex];
        this.selectedDot.className = "dot is-selected";
        this.selectedDot.setAttribute("aria-current", "step");
      };
      PageDots.prototype.onTap = // old method name, backwards-compatible
      PageDots.prototype.onClick = function(event2) {
        var target = event2.target;
        if (target.nodeName != "LI") {
          return;
        }
        this.parent.uiChange();
        var index = this.dots.indexOf(target);
        this.parent.select(index);
      };
      PageDots.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
      };
      Flickity5.PageDots = PageDots;
      utils.extend(Flickity5.defaults, {
        pageDots: true
      });
      Flickity5.createMethods.push("_createPageDots");
      var proto = Flickity5.prototype;
      proto._createPageDots = function() {
        if (!this.options.pageDots) {
          return;
        }
        this.pageDots = new PageDots(this);
        this.on("activate", this.activatePageDots);
        this.on("select", this.updateSelectedPageDots);
        this.on("cellChange", this.updatePageDots);
        this.on("resize", this.updatePageDots);
        this.on("deactivate", this.deactivatePageDots);
      };
      proto.activatePageDots = function() {
        this.pageDots.activate();
      };
      proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected();
      };
      proto.updatePageDots = function() {
        this.pageDots.setDots();
      };
      proto.deactivatePageDots = function() {
        this.pageDots.deactivate();
      };
      Flickity5.PageDots = PageDots;
      return Flickity5;
    });
  }
});

// node_modules/flickity/js/player.js
var require_player = __commonJS({
  "node_modules/flickity/js/player.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "ev-emitter/ev-emitter",
          "fizzy-ui-utils/utils",
          "./flickity"
        ], function(EvEmitter, utils, Flickity5) {
          return factory(EvEmitter, utils, Flickity5);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          require_ev_emitter(),
          require_utils(),
          require_flickity()
        );
      } else {
        factory(
          window2.EvEmitter,
          window2.fizzyUIUtils,
          window2.Flickity
        );
      }
    })(window, function factory(EvEmitter, utils, Flickity5) {
      "use strict";
      function Player(parent) {
        this.parent = parent;
        this.state = "stopped";
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
      }
      Player.prototype = Object.create(EvEmitter.prototype);
      Player.prototype.play = function() {
        if (this.state == "playing") {
          return;
        }
        var isPageHidden = document.hidden;
        if (isPageHidden) {
          document.addEventListener("visibilitychange", this.onVisibilityPlay);
          return;
        }
        this.state = "playing";
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        this.tick();
      };
      Player.prototype.tick = function() {
        if (this.state != "playing") {
          return;
        }
        var time = this.parent.options.autoPlay;
        time = typeof time == "number" ? time : 3e3;
        var _this = this;
        this.clear();
        this.timeout = setTimeout(function() {
          _this.parent.next(true);
          _this.tick();
        }, time);
      };
      Player.prototype.stop = function() {
        this.state = "stopped";
        this.clear();
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
      };
      Player.prototype.clear = function() {
        clearTimeout(this.timeout);
      };
      Player.prototype.pause = function() {
        if (this.state == "playing") {
          this.state = "paused";
          this.clear();
        }
      };
      Player.prototype.unpause = function() {
        if (this.state == "paused") {
          this.play();
        }
      };
      Player.prototype.visibilityChange = function() {
        var isPageHidden = document.hidden;
        this[isPageHidden ? "pause" : "unpause"]();
      };
      Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener("visibilitychange", this.onVisibilityPlay);
      };
      utils.extend(Flickity5.defaults, {
        pauseAutoPlayOnHover: true
      });
      Flickity5.createMethods.push("_createPlayer");
      var proto = Flickity5.prototype;
      proto._createPlayer = function() {
        this.player = new Player(this);
        this.on("activate", this.activatePlayer);
        this.on("uiChange", this.stopPlayer);
        this.on("pointerDown", this.stopPlayer);
        this.on("deactivate", this.deactivatePlayer);
      };
      proto.activatePlayer = function() {
        if (!this.options.autoPlay) {
          return;
        }
        this.player.play();
        this.element.addEventListener("mouseenter", this);
      };
      proto.playPlayer = function() {
        this.player.play();
      };
      proto.stopPlayer = function() {
        this.player.stop();
      };
      proto.pausePlayer = function() {
        this.player.pause();
      };
      proto.unpausePlayer = function() {
        this.player.unpause();
      };
      proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener("mouseenter", this);
      };
      proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) {
          return;
        }
        this.player.pause();
        this.element.addEventListener("mouseleave", this);
      };
      proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener("mouseleave", this);
      };
      Flickity5.Player = Player;
      return Flickity5;
    });
  }
});

// node_modules/flickity/js/add-remove-cell.js
var require_add_remove_cell = __commonJS({
  "node_modules/flickity/js/add-remove-cell.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "./flickity",
          "fizzy-ui-utils/utils"
        ], function(Flickity5, utils) {
          return factory(window2, Flickity5, utils);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_flickity(),
          require_utils()
        );
      } else {
        factory(
          window2,
          window2.Flickity,
          window2.fizzyUIUtils
        );
      }
    })(window, function factory(window2, Flickity5, utils) {
      "use strict";
      function getCellsFragment(cells) {
        var fragment = document.createDocumentFragment();
        cells.forEach(function(cell) {
          fragment.appendChild(cell.element);
        });
        return fragment;
      }
      var proto = Flickity5.prototype;
      proto.insert = function(elems, index) {
        var cells = this._makeCells(elems);
        if (!cells || !cells.length) {
          return;
        }
        var len = this.cells.length;
        index = index === void 0 ? len : index;
        var fragment = getCellsFragment(cells);
        var isAppend = index == len;
        if (isAppend) {
          this.slider.appendChild(fragment);
        } else {
          var insertCellElement = this.cells[index].element;
          this.slider.insertBefore(fragment, insertCellElement);
        }
        if (index === 0) {
          this.cells = cells.concat(this.cells);
        } else if (isAppend) {
          this.cells = this.cells.concat(cells);
        } else {
          var endCells = this.cells.splice(index, len - index);
          this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index, true);
      };
      proto.append = function(elems) {
        this.insert(elems, this.cells.length);
      };
      proto.prepend = function(elems) {
        this.insert(elems, 0);
      };
      proto.remove = function(elems) {
        var cells = this.getCells(elems);
        if (!cells || !cells.length) {
          return;
        }
        var minCellIndex = this.cells.length - 1;
        cells.forEach(function(cell) {
          cell.remove();
          var index = this.cells.indexOf(cell);
          minCellIndex = Math.min(index, minCellIndex);
          utils.removeFrom(this.cells, cell);
        }, this);
        this.cellChange(minCellIndex, true);
      };
      proto.cellSizeChange = function(elem) {
        var cell = this.getCell(elem);
        if (!cell) {
          return;
        }
        cell.getSize();
        var index = this.cells.indexOf(cell);
        this.cellChange(index);
      };
      proto.cellChange = function(changedCellIndex, isPositioningSlider) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._getWrapShiftCells();
        this.setGallerySize();
        var cell = this.getCell(prevSelectedElem);
        if (cell) {
          this.selectedIndex = this.getCellSlideIndex(cell);
        }
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent("cellChange", [changedCellIndex]);
        this.select(this.selectedIndex);
        if (isPositioningSlider) {
          this.positionSliderAtSelected();
        }
      };
      return Flickity5;
    });
  }
});

// node_modules/flickity/js/lazyload.js
var require_lazyload = __commonJS({
  "node_modules/flickity/js/lazyload.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "./flickity",
          "fizzy-ui-utils/utils"
        ], function(Flickity5, utils) {
          return factory(window2, Flickity5, utils);
        });
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          window2,
          require_flickity(),
          require_utils()
        );
      } else {
        factory(
          window2,
          window2.Flickity,
          window2.fizzyUIUtils
        );
      }
    })(window, function factory(window2, Flickity5, utils) {
      "use strict";
      Flickity5.createMethods.push("_createLazyload");
      var proto = Flickity5.prototype;
      proto._createLazyload = function() {
        this.on("select", this.lazyLoad);
      };
      proto.lazyLoad = function() {
        var lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) {
          return;
        }
        var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
        var cellElems = this.getAdjacentCellElements(adjCount);
        var lazyImages = [];
        cellElems.forEach(function(cellElem) {
          var lazyCellImages = getCellLazyImages(cellElem);
          lazyImages = lazyImages.concat(lazyCellImages);
        });
        lazyImages.forEach(function(img) {
          new LazyLoader(img, this);
        }, this);
      };
      function getCellLazyImages(cellElem) {
        if (cellElem.nodeName == "IMG") {
          var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
          var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
          var srcsetAttr = cellElem.getAttribute("data-flickity-lazyload-srcset");
          if (lazyloadAttr || srcAttr || srcsetAttr) {
            return [cellElem];
          }
        }
        var lazySelector = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
        var imgs = cellElem.querySelectorAll(lazySelector);
        return utils.makeArray(imgs);
      }
      function LazyLoader(img, flickity) {
        this.img = img;
        this.flickity = flickity;
        this.load();
      }
      LazyLoader.prototype.handleEvent = utils.handleEvent;
      LazyLoader.prototype.load = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        var src = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src");
        var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
        this.img.src = src;
        if (srcset) {
          this.img.setAttribute("srcset", srcset);
        }
        this.img.removeAttribute("data-flickity-lazyload");
        this.img.removeAttribute("data-flickity-lazyload-src");
        this.img.removeAttribute("data-flickity-lazyload-srcset");
      };
      LazyLoader.prototype.onload = function(event2) {
        this.complete(event2, "flickity-lazyloaded");
      };
      LazyLoader.prototype.onerror = function(event2) {
        this.complete(event2, "flickity-lazyerror");
      };
      LazyLoader.prototype.complete = function(event2, className) {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
        var cell = this.flickity.getParentCell(this.img);
        var cellElem = cell && cell.element;
        this.flickity.cellSizeChange(cellElem);
        this.img.classList.add(className);
        this.flickity.dispatchEvent("lazyLoad", event2, cellElem);
      };
      Flickity5.LazyLoader = LazyLoader;
      return Flickity5;
    });
  }
});

// node_modules/flickity/js/index.js
var require_js = __commonJS({
  "node_modules/flickity/js/index.js"(exports, module) {
    (function(window2, factory) {
      if (typeof define == "function" && define.amd) {
        define([
          "./flickity",
          "./drag",
          "./prev-next-button",
          "./page-dots",
          "./player",
          "./add-remove-cell",
          "./lazyload"
        ], factory);
      } else if (typeof module == "object" && module.exports) {
        module.exports = factory(
          require_flickity(),
          require_drag(),
          require_prev_next_button(),
          require_page_dots(),
          require_player(),
          require_add_remove_cell(),
          require_lazyload()
        );
      }
    })(window, function factory(Flickity5) {
      return Flickity5;
    });
  }
});

// node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "node_modules/axios/lib/helpers/bind.js"(exports, module) {
    "use strict";
    module.exports = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// node_modules/axios/lib/utils.js
var require_utils2 = __commonJS({
  "node_modules/axios/lib/utils.js"(exports, module) {
    "use strict";
    var bind = require_bind();
    var toString2 = Object.prototype.toString;
    function isArray2(val) {
      return toString2.call(val) === "[object Array]";
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    function isArrayBuffer(val) {
      return toString2.call(val) === "[object ArrayBuffer]";
    }
    function isFormData(val) {
      return typeof FormData !== "undefined" && val instanceof FormData;
    }
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }
      return result;
    }
    function isString2(val) {
      return typeof val === "string";
    }
    function isNumber2(val) {
      return typeof val === "number";
    }
    function isObject4(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject(val) {
      if (toString2.call(val) !== "[object Object]") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    function isDate(val) {
      return toString2.call(val) === "[object Date]";
    }
    function isFile(val) {
      return toString2.call(val) === "[object File]";
    }
    function isBlob(val) {
      return toString2.call(val) === "[object Blob]";
    }
    function isFunction(val) {
      return toString2.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject4(val) && isFunction(val.pipe);
    }
    function isURLSearchParams(val) {
      return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray2(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject(val)) {
          result[key] = merge({}, val);
        } else if (isArray2(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }
      return result;
    }
    function extend3(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    module.exports = {
      isArray: isArray2,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString: isString2,
      isNumber: isNumber2,
      isObject: isObject4,
      isPlainObject,
      isUndefined,
      isDate,
      isFile,
      isBlob,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend: extend3,
      trim,
      stripBOM
    };
  }
});

// node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "node_modules/axios/lib/helpers/buildURL.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module.exports = function buildURL(url3, params, paramsSerializer) {
      if (!params) {
        return url3;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url3.indexOf("#");
        if (hashmarkIndex !== -1) {
          url3 = url3.slice(0, hashmarkIndex);
        }
        url3 += (url3.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url3;
    };
  }
});

// node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "node_modules/axios/lib/core/InterceptorManager.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module.exports = InterceptorManager;
  }
});

// node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// node_modules/axios/lib/core/enhanceError.js
var require_enhanceError = __commonJS({
  "node_modules/axios/lib/core/enhanceError.js"(exports, module) {
    "use strict";
    module.exports = function enhanceError(error, config, code, request2, response) {
      error.config = config;
      if (code) {
        error.code = code;
      }
      error.request = request2;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code
        };
      };
      return error;
    };
  }
});

// node_modules/axios/lib/core/createError.js
var require_createError = __commonJS({
  "node_modules/axios/lib/core/createError.js"(exports, module) {
    "use strict";
    var enhanceError = require_enhanceError();
    module.exports = function createError(message, config, code, request2, response) {
      var error = new Error(message);
      return enhanceError(error, config, code, request2, response);
    };
  }
});

// node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "node_modules/axios/lib/core/settle.js"(exports, module) {
    "use strict";
    var createError = require_createError();
    module.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError(
          "Request failed with status code " + response.status,
          response.config,
          null,
          response.request,
          response
        ));
      }
    };
  }
});

// node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "node_modules/axios/lib/helpers/cookies.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      /* @__PURE__ */ function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie2 = [];
            cookie2.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) {
              cookie2.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils.isString(path)) {
              cookie2.push("path=" + path);
            }
            if (utils.isString(domain)) {
              cookie2.push("domain=" + domain);
            }
            if (secure === true) {
              cookie2.push("secure");
            }
            document.cookie = cookie2.join("; ");
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      /* @__PURE__ */ function nonStandardBrowserEnv() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove() {
          }
        };
      }()
    );
  }
});

// node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module) {
    "use strict";
    module.exports = function isAbsoluteURL(url3) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url3);
    };
  }
});

// node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "node_modules/axios/lib/helpers/combineURLs.js"(exports, module) {
    "use strict";
    module.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "node_modules/axios/lib/core/buildFullPath.js"(exports, module) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "node_modules/axios/lib/helpers/parseHeaders.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url3) {
          var href = url3;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      /* @__PURE__ */ function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }()
    );
  }
});

// node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "node_modules/axios/lib/adapters/xhr.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var createError = require_createError();
    module.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if (utils.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request2 = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request2.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request2.timeout = config.timeout;
        function onloadend() {
          if (!request2) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request2 ? parseHeaders(request2.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request2.responseText : request2.response;
          var response = {
            data: responseData,
            status: request2.status,
            statusText: request2.statusText,
            headers: responseHeaders,
            config,
            request: request2
          };
          settle(resolve, reject, response);
          request2 = null;
        }
        if ("onloadend" in request2) {
          request2.onloadend = onloadend;
        } else {
          request2.onreadystatechange = function handleLoad() {
            if (!request2 || request2.readyState !== 4) {
              return;
            }
            if (request2.status === 0 && !(request2.responseURL && request2.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request2.onabort = function handleAbort() {
          if (!request2) {
            return;
          }
          reject(createError("Request aborted", config, "ECONNABORTED", request2));
          request2 = null;
        };
        request2.onerror = function handleError() {
          reject(createError("Network Error", config, null, request2));
          request2 = null;
        };
        request2.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(createError(
            timeoutErrorMessage,
            config,
            config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
            request2
          ));
          request2 = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request2) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request2.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request2.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request2.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request2.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request2.upload) {
          request2.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken) {
          config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request2) {
              return;
            }
            request2.abort();
            reject(cancel);
            request2 = null;
          });
        }
        if (!requestData) {
          requestData = null;
        }
        request2.send(requestData);
      });
    };
  }
});

// node_modules/axios/lib/defaults.js
var require_defaults = __commonJS({
  "node_modules/axios/lib/defaults.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var normalizeHeaderName = require_normalizeHeaderName();
    var enhanceError = require_enhanceError();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults2 = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw enhanceError(e, this, "E_JSON_PARSE");
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    };
    defaults2.headers = {
      common: {
        "Accept": "application/json, text/plain, */*"
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults2.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults2.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults2;
  }
});

// node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "node_modules/axios/lib/core/transformData.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var defaults2 = require_defaults();
    module.exports = function transformData(data, headers, fns) {
      var context = this || defaults2;
      utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "node_modules/axios/lib/cancel/isCancel.js"(exports, module) {
    "use strict";
    module.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "node_modules/axios/lib/core/dispatchRequest.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults2 = require_defaults();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
    }
    module.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config.headers[method];
        }
      );
      var adapter = config.adapter || defaults2.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "node_modules/axios/lib/core/mergeConfig.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      var valueFromConfig2Keys = ["url", "method", "data"];
      var mergeDeepPropertiesKeys = ["headers", "auth", "proxy", "params"];
      var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
      ];
      var directMergeKeys = ["validateStatus"];
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          config[prop] = getMergedValue(void 0, config1[prop]);
        }
      }
      utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(void 0, config2[prop]);
        }
      });
      utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
      utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          config[prop] = getMergedValue(void 0, config1[prop]);
        }
      });
      utils.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) {
          config[prop] = getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          config[prop] = getMergedValue(void 0, config1[prop]);
        }
      });
      var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
      var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
      });
      utils.forEach(otherKeys, mergeDeepProperties);
      return config;
    };
  }
});

// node_modules/axios/package.json
var require_package = __commonJS({
  "node_modules/axios/package.json"(exports, module) {
    module.exports = {
      name: "axios",
      version: "0.21.4",
      description: "Promise based HTTP client for the browser and node.js",
      main: "index.js",
      scripts: {
        test: "grunt test",
        start: "node ./sandbox/server.js",
        build: "NODE_ENV=production grunt build",
        preversion: "npm test",
        version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
        postversion: "git push && git push --tags",
        examples: "node ./examples/server.js",
        coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
        fix: "eslint --fix lib/**/*.js"
      },
      repository: {
        type: "git",
        url: "https://github.com/axios/axios.git"
      },
      keywords: [
        "xhr",
        "http",
        "ajax",
        "promise",
        "node"
      ],
      author: "Matt Zabriskie",
      license: "MIT",
      bugs: {
        url: "https://github.com/axios/axios/issues"
      },
      homepage: "https://axios-http.com",
      devDependencies: {
        coveralls: "^3.0.0",
        "es6-promise": "^4.2.4",
        grunt: "^1.3.0",
        "grunt-banner": "^0.6.0",
        "grunt-cli": "^1.2.0",
        "grunt-contrib-clean": "^1.1.0",
        "grunt-contrib-watch": "^1.0.0",
        "grunt-eslint": "^23.0.0",
        "grunt-karma": "^4.0.0",
        "grunt-mocha-test": "^0.13.3",
        "grunt-ts": "^6.0.0-beta.19",
        "grunt-webpack": "^4.0.2",
        "istanbul-instrumenter-loader": "^1.0.0",
        "jasmine-core": "^2.4.1",
        karma: "^6.3.2",
        "karma-chrome-launcher": "^3.1.0",
        "karma-firefox-launcher": "^2.1.0",
        "karma-jasmine": "^1.1.1",
        "karma-jasmine-ajax": "^0.1.13",
        "karma-safari-launcher": "^1.0.0",
        "karma-sauce-launcher": "^4.3.6",
        "karma-sinon": "^1.0.5",
        "karma-sourcemap-loader": "^0.3.8",
        "karma-webpack": "^4.0.2",
        "load-grunt-tasks": "^3.5.2",
        minimist: "^1.2.0",
        mocha: "^8.2.1",
        sinon: "^4.5.0",
        "terser-webpack-plugin": "^4.2.3",
        typescript: "^4.0.5",
        "url-search-params": "^0.10.0",
        webpack: "^4.44.2",
        "webpack-dev-server": "^3.11.0"
      },
      browser: {
        "./lib/adapters/http.js": "./lib/adapters/xhr.js"
      },
      jsdelivr: "dist/axios.min.js",
      unpkg: "dist/axios.min.js",
      typings: "./index.d.ts",
      dependencies: {
        "follow-redirects": "^1.14.0"
      },
      bundlesize: [
        {
          path: "./dist/axios.min.js",
          threshold: "5kB"
        }
      ]
    };
  }
});

// node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "node_modules/axios/lib/helpers/validator.js"(exports, module) {
    "use strict";
    var pkg = require_package();
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    var currentVerArr = pkg.version.split(".");
    function isOlderVersion(version, thanVersion) {
      var pkgVersionArr = thanVersion ? thanVersion.split(".") : currentVerArr;
      var destVer = version.split(".");
      for (var i = 0; i < 3; i++) {
        if (pkgVersionArr[i] > destVer[i]) {
          return true;
        } else if (pkgVersionArr[i] < destVer[i]) {
          return false;
        }
      }
      return false;
    }
    validators.transitional = function transitional(validator, version, message) {
      var isDeprecated = version && isOlderVersion(version);
      function formatMessage(opt, desc) {
        return "[Axios v" + pkg.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, " has been removed in " + version));
        }
        if (isDeprecated && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys = Object.keys(options);
      var i = keys.length;
      while (i-- > 0) {
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new TypeError("option " + opt + " must be " + result);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    module.exports = {
      isOlderVersion,
      assertOptions,
      validators
    };
  }
});

// node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "node_modules/axios/lib/core/Axios.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request2(config) {
      if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
      } else {
        config = config || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
          forcedJSONParsing: validators.transitional(validators.boolean, "1.0.0"),
          clarifyTimeoutError: validators.transitional(validators.boolean, "1.0.0")
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url3, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url: url3,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      Axios.prototype[method] = function(url3, data, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url: url3,
          data
        }));
      };
    });
    module.exports = Axios;
  }
});

// node_modules/axios/lib/cancel/Cancel.js
var require_Cancel = __commonJS({
  "node_modules/axios/lib/cancel/Cancel.js"(exports, module) {
    "use strict";
    function Cancel(message) {
      this.message = message;
    }
    Cancel.prototype.toString = function toString2() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    module.exports = Cancel;
  }
});

// node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "node_modules/axios/lib/cancel/CancelToken.js"(exports, module) {
    "use strict";
    var Cancel = require_Cancel();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    module.exports = CancelToken;
  }
});

// node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "node_modules/axios/lib/helpers/spread.js"(exports, module) {
    "use strict";
    module.exports = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "node_modules/axios/lib/helpers/isAxiosError.js"(exports, module) {
    "use strict";
    module.exports = function isAxiosError(payload) {
      return typeof payload === "object" && payload.isAxiosError === true;
    };
  }
});

// node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "node_modules/axios/lib/axios.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var bind = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults2 = require_defaults();
    function createInstance(defaultConfig) {
      var context = new Axios(defaultConfig);
      var instance = bind(Axios.prototype.request, context);
      utils.extend(instance, Axios.prototype, context);
      utils.extend(instance, context);
      return instance;
    }
    var axios7 = createInstance(defaults2);
    axios7.Axios = Axios;
    axios7.create = function create(instanceConfig) {
      return createInstance(mergeConfig(axios7.defaults, instanceConfig));
    };
    axios7.Cancel = require_Cancel();
    axios7.CancelToken = require_CancelToken();
    axios7.isCancel = require_isCancel();
    axios7.all = function all(promises) {
      return Promise.all(promises);
    };
    axios7.spread = require_spread();
    axios7.isAxiosError = require_isAxiosError();
    module.exports = axios7;
    module.exports.default = axios7;
  }
});

// node_modules/axios/index.js
var require_axios2 = __commonJS({
  "node_modules/axios/index.js"(exports, module) {
    module.exports = require_axios();
  }
});

// node_modules/js-cookie/src/js.cookie.js
var require_js_cookie = __commonJS({
  "node_modules/js-cookie/src/js.cookie.js"(exports, module) {
    ;
    (function(factory) {
      var registeredInModuleLoader;
      if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
      }
      if (typeof exports === "object") {
        module.exports = factory();
        registeredInModuleLoader = true;
      }
      if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
          window.Cookies = OldCookies;
          return api;
        };
      }
    })(function() {
      function extend3() {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
          var attributes = arguments[i];
          for (var key in attributes) {
            result[key] = attributes[key];
          }
        }
        return result;
      }
      function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      function init2(converter) {
        function api() {
        }
        function set(key, value, attributes) {
          if (typeof document === "undefined") {
            return;
          }
          attributes = extend3({
            path: "/"
          }, api.defaults, attributes);
          if (typeof attributes.expires === "number") {
            attributes.expires = new Date(/* @__PURE__ */ new Date() * 1 + attributes.expires * 864e5);
          }
          attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
          try {
            var result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {
          }
          value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
          key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var stringifiedAttributes = "";
          for (var attributeName in attributes) {
            if (!attributes[attributeName]) {
              continue;
            }
            stringifiedAttributes += "; " + attributeName;
            if (attributes[attributeName] === true) {
              continue;
            }
            stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
          }
          return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get2(key, json) {
          if (typeof document === "undefined") {
            return;
          }
          var jar = {};
          var cookies = document.cookie ? document.cookie.split("; ") : [];
          var i = 0;
          for (; i < cookies.length; i++) {
            var parts = cookies[i].split("=");
            var cookie2 = parts.slice(1).join("=");
            if (!json && cookie2.charAt(0) === '"') {
              cookie2 = cookie2.slice(1, -1);
            }
            try {
              var name = decode(parts[0]);
              cookie2 = (converter.read || converter)(cookie2, name) || decode(cookie2);
              if (json) {
                try {
                  cookie2 = JSON.parse(cookie2);
                } catch (e) {
                }
              }
              jar[name] = cookie2;
              if (key === name) {
                break;
              }
            } catch (e) {
            }
          }
          return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
          return get2(
            key,
            false
            /* read as raw */
          );
        };
        api.getJSON = function(key) {
          return get2(
            key,
            true
            /* read as json */
          );
        };
        api.remove = function(key, attributes) {
          set(key, "", extend3(attributes, {
            expires: -1
          }));
        };
        api.defaults = {};
        api.withConverter = init2;
        return api;
      }
      return init2(function() {
      });
    });
  }
});

// src/services/imgURL.js
var imgURL = (src, size) => (
  // remove any current image size then add the new image size
  src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".").replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => `_${size}${match}`)
);

// node_modules/@shopify/theme-currency/currency.js
var moneyFormat = "${{amount}}";
function formatMoney(cents, format2) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format2 || moneyFormat;
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

// src/services/pricing.js
var pricing = (price) => {
  if (price != null) {
    return `${formatMoney(price, window.money_format).replace(",00", "")}`;
  }
};

// src/services/getSections.js
var getCartDrawerSectionsToRender = (productId) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return [
    {
      id: "cart-promo-meter",
      section: (_a = document.getElementById("cart-items")) == null ? void 0 : _a.getAttribute("data-id"),
      selector: "#cart-promo-meter"
    },
    {
      id: "cart-items",
      section: (_b = document.getElementById("cart-items")) == null ? void 0 : _b.getAttribute("data-id"),
      selector: "#cart-items"
    },
    {
      id: "cart-gifting-options",
      section: (_c = document.getElementById("cart-items")) == null ? void 0 : _c.getAttribute("data-id"),
      selector: "#cart-gifting-options"
    },
    {
      id: "cart-note",
      section: (_d = document.getElementById("cart-items")) == null ? void 0 : _d.getAttribute("data-id"),
      selector: "#cart-note"
    },
    {
      id: "cart-influencer-gifts",
      section: (_e = document.getElementById("cart-items")) == null ? void 0 : _e.getAttribute("data-id"),
      selector: "#cart-influencer-gifts"
    },
    {
      id: "cart-gifts",
      section: (_f = document.getElementById("cart-items")) == null ? void 0 : _f.getAttribute("data-id"),
      selector: "#cart-gifts"
    },
    {
      id: "cart-goodie-selector",
      section: (_g = document.getElementById("cart-items")) == null ? void 0 : _g.getAttribute("data-id"),
      selector: "#cart-goodie-selector"
    },
    {
      id: "cart-total",
      section: (_h = document.getElementById("cart-items")) == null ? void 0 : _h.getAttribute("data-id"),
      selector: "#cart-total"
    },
    {
      id: "cart-notification-product",
      section: "cart-notification-product",
      selector: `#cart-notification-product-${productId}`
    },
    {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: "#cart-icon-bubble"
    }
  ];
};

// src/services/sectionInjection.js
var getSectionFromHTML = (html, selector) => {
  var _a;
  if (html && selector) {
    const newSectionElement = new DOMParser().parseFromString(html, "text/html");
    if (newSectionElement) {
      return (_a = newSectionElement.querySelector(selector)) == null ? void 0 : _a.innerHTML;
    }
  }
};

// src/services/dissectForm.js
var dissectForm = (formData) => {
  console.log(formData);
  if (formData.productVariant) {
    const defaultQuantity = 1;
    const variantID = formData.productVariant;
    const quantity = formData.quantity ? formData.quantity : defaultQuantity;
    const fontFrontside = formData.fontFrontside ? formData.fontFrontside : null;
    const textFrontside = formData.textFrontside ? formData.textFrontside : null;
    const fontBackside = formData.fontBackside ? formData.fontBackside : null;
    const textBackside = formData.textBackside ? formData.textBackside : null;
    const itemNote = formData._note ? formData._note : null;
    const singleInitial = formData.initial ? formData.initial : null;
    const singleUntrackedInitial = formData.initial_untracked ? formData.initial_untracked : null;
    const multipleInitials = formData.initials ? formData.initials : null;
    const product1 = formData["properties[_Product 1]"] ? formData["properties[_Product 1]"] : null;
    const product2 = formData["properties[_Product 2]"] ? formData["properties[_Product 2]"] : null;
    const product3 = formData["properties[_Product 3]"] ? formData["properties[_Product 3]"] : null;
    const product4 = formData["properties[_Product 4]"] ? formData["properties[_Product 4]"] : null;
    const product5 = formData["properties[_Product 5]"] ? formData["properties[_Product 5]"] : null;
    const data = {
      id: variantID,
      quantity,
      properties: {}
    };
    if (fontFrontside && textFrontside) {
      data.properties.font_frontside = fontFrontside;
      data.properties.text_frontside = textFrontside;
    }
    if (fontBackside && textBackside) {
      data.properties.font_backside = fontBackside;
      data.properties.text_backside = textBackside;
    }
    if (itemNote) {
      data.properties._note = itemNote;
    }
    if (singleInitial) {
      data.properties.initial = singleInitial.toUpperCase();
    }
    if (singleUntrackedInitial) {
      data.properties.initialUntracked = singleUntrackedInitial.toUpperCase();
    }
    if (multipleInitials) {
      data.properties.initials = multipleInitials.toUpperCase();
    }
    if (product1) {
      data.properties._product1 = product1;
    }
    if (product2) {
      data.properties._product2 = product2;
    }
    if (product3) {
      data.properties._product3 = product3;
    }
    if (product4) {
      data.properties._product4 = product4;
    }
    if (product5) {
      data.properties._product5 = product5;
    }
    return JSON.stringify(data);
  }
  return null;
};

// src/services/cartNotificationState.js
var openNotificationModal = () => {
  const cartNotificationModal = document.querySelector(".cart-notification");
  const iconCartBubbleElement = document.querySelector(".icon-cart");
  cartNotificationModal.classList.add("js-modal-open");
  if (iconCartBubbleElement) {
    iconCartBubbleElement.classList.add("js-active");
  }
  setTimeout(closeNotificationModal, 3e3);
};
var closeNotificationModal = () => {
  const cartNotificationModal = document.querySelector(".cart-notification");
  const iconCartBubbleElement = document.querySelector(".icon-cart");
  cartNotificationModal.classList.remove("js-modal-open");
  if (iconCartBubbleElement) {
    iconCartBubbleElement.classList.remove("js-active");
  }
};

// src/services/cartDrawerStyling.js
var handleAddShadow = (shouldHaveShadow) => {
  const footer2 = document.querySelector(".cart-drawer .footer");
  if (footer2 !== null) {
    if (shouldHaveShadow) {
      footer2.classList.add("has-shadow");
    } else {
      footer2.classList.remove("has-shadow");
    }
  }
};
var cartContentShadow = () => {
  const content = document.querySelector(".cart-drawer .cart-content");
  const contentList = document.querySelector(".cart-drawer .cart-content-list");
  if (content !== null) {
    if (contentList !== null) {
      if (contentList.scrollHeight > contentList.clientHeight) {
        handleAddShadow(true);
      } else {
        handleAddShadow(false);
      }
    }
  }
};
var updateProgressBar = () => {
  const progressElement = document.querySelector(".cart-drawer .progress-bar");
  if (progressElement) {
    const progressBarElement = progressElement.querySelector("span");
    const { progress } = progressElement.dataset;
    let newProgress = Number(progress / 100);
    if (progressBarElement !== null) {
      progressBarElement.dataset.progress = newProgress;
      if (newProgress > 100) {
        newProgress = 100;
      }
      progressBarElement.style.width = `${newProgress}%`;
    }
  }
};

// src/services/body-lock.js
var bodyLock = class {
  /**
   * lock the body to prevent scrolling.
   */
  lock() {
    const bodyElement = document.querySelector("body");
    bodyElement.style.marginRight = `${window.innerWidth - bodyElement.clientWidth}px`;
    bodyElement.classList.add("js-scroll-lock");
  }
  /**
   * unlock the scrolling of the body.
   */
  unlock() {
    const bodyElement = document.querySelector("body");
    bodyElement.classList.remove("js-scroll-lock");
    bodyElement.style.marginRight = 0;
  }
};
var body_lock_default = new bodyLock();

// src/services/cartDrawerState.js
var openCartDrawer = () => {
  const cartDrawer = document.getElementById("cart-drawer");
  const cartDrawerParentElement = cartDrawer.closest(".modal");
  cartDrawerParentElement.classList.add("js-modal-open");
  updateProgressBar();
  cartContentShadow();
  hideOnClickOutside();
  body_lock_default.lock();
};
var closeCartDrawer = () => {
  const cartDrawer = document.getElementById("cart-drawer");
  const cartDrawerParentElement = cartDrawer.closest(".modal");
  cartDrawerParentElement.classList.remove("js-modal-open");
  body_lock_default.unlock();
};
var replaceElement = (responseData) => {
  const productId = responseData.id;
  if (productId) {
    getCartDrawerSectionsToRender(productId).map((section) => {
      if (section.id === "cart-notification-product") {
        const sectionId = section.id;
        const sectionElement = document.getElementById(sectionId);
        if (sectionElement && sectionElement != null) {
          sectionElement.innerHTML = getSectionFromHTML(
            responseData.sections[sectionId],
            section.selector
          );
        }
      } else {
        const elementToReplace = document.querySelectorAll(section.selector) || document.getElementById(section.id).querySelector(section.selector);
        if (elementToReplace !== null) {
          elementToReplace.forEach((element) => {
            element.innerHTML = getSectionFromHTML(
              responseData.sections[section.section],
              section.selector
            );
          });
        }
      }
    });
  } else {
    getCartDrawerSectionsToRender().forEach((section) => {
      const elementToReplace = document.querySelectorAll(section.selector) || document.getElementById(section.id).querySelector(section.selector);
      if (elementToReplace !== null) {
        elementToReplace.forEach((element) => {
          element.innerHTML = getSectionFromHTML(
            responseData.sections[section.section],
            section.selector
          );
        });
      }
    });
  }
};
var shouldOpenCartDrawer = () => matchMedia("screen and (min-width: 768px)").matches;
var handleAddToCartDrawer = (responseData) => {
  replaceElement(responseData);
  if (shouldOpenCartDrawer()) {
    openCartDrawer();
  } else {
    openNotificationModal();
  }
  handleUpdateDrawer();
};
var handleCartDrawerChange = (responseData) => {
  replaceElement(responseData);
  handleUpdateDrawer();
};
var handleRemoveFromCart = (responseData) => {
  replaceElement(responseData);
  handleUpdateDrawer();
};
var handleUpdateDrawer = () => {
  const updateCartEvent = new CustomEvent("updated-cart");
  updateProgressBar();
  window.dispatchEvent(updateCartEvent);
};
var hideOnClickOutside = () => {
  const outsideClickListener = (event2) => {
    const { target } = event2;
    const cartDrawerElement = document.getElementById("cart-drawer");
    const cartDrawerOpener = document.querySelector("#cart-toggle");
    if (target !== cartDrawerElement && target.closest("#cart-drawer") || target.closest("#cart-toggle") === cartDrawerOpener) {
    } else {
      closeCartDrawer();
      removeClickListener();
    }
  };
  const removeClickListener = () => {
    document.removeEventListener("click", outsideClickListener);
  };
  document.addEventListener("click", outsideClickListener);
};

// src/services/sessionStorage.js
var setStoreItem = (itemKey, value) => {
  sessionStorage.setItem(`${itemKey}`, `${value}`);
};
var getStoreItem = (itemKey) => sessionStorage.getItem(`${itemKey}`);
var removeStoreItem = (itemKey) => {
  sessionStorage.removeItem(`${itemKey}`);
};

// src/services/type-check.js
var returnArrayOrNull = (inputValue) => {
  if (Array.isArray(inputValue)) {
    if (inputValue.length > 0) {
      return inputValue;
    }
  }
  return null;
};
var returnStringOrNull = (inputValue) => {
  if (typeof inputValue === "string") {
    if (inputValue.length > 0) {
      return inputValue;
    }
  }
  return null;
};
var returnNumberOrNull = (inputValue) => {
  if (typeof inputValue === "number") {
    return inputValue;
  }
  return null;
};
var returnObjectOrNull = (inputValue) => {
  if (typeof inputValue === "object") {
    if (inputValue !== null) {
      return inputValue;
    }
  }
  return null;
};
var returnBooleanOrNull = (inputValue) => {
  if (typeof inputValue === "boolean") {
    return inputValue;
  }
  return null;
};

// src/templates/variant-image-slide-element.js
var createVariantImageSlideElement = (variant) => {
  const variantTitle = variant.title;
  const variantImage = variant.variant_image;
  if (variantTitle && variantImage && !variantImage.includes("no-image")) {
    const variantImageSlideElement = `
      <div class="slide variant-image">
        <div class="image-holder js-active">
          <img loading="lazy" alt="${variantTitle}" src="${variantImage}" width="{{ final_image.width }}" height="{{ final_image.height }}">
        </div>
        <!-- end .image-holder -->

      </div>
      <!-- end .variant-image -->
    `;
    return returnStringOrNull(variantImageSlideElement);
  }
  return `
      <div class="slide--hidden js-hidden variant-image">
        <div class="image-holder"></div>
      </div>
      <!-- end .variant-image -->
    `;
};

// src/services/productUtils.js
var import_flickity = __toESM(require_js(), 1);
var getAllVariants = () => {
  const variantsDataElement = document.getElementById("variants-data");
  const allVariants = variantsDataElement ? JSON.parse(variantsDataElement.innerHTML).variants : null;
  return returnObjectOrNull(allVariants);
};
var getVariantFromId = (variantId) => {
  const allVariants = getAllVariants();
  const correctVariant = allVariants ? allVariants.find((element) => element.id == variantId) : null;
  return returnObjectOrNull(correctVariant);
};
var getSelectedVariant = () => {
  const variantIdElement = document.querySelector("#productVariant");
  const variantId = variantIdElement ? Number(variantIdElement.value) : null;
  const variant = getVariantFromId(variantId);
  return returnObjectOrNull(variant);
};
var getValueFromVariantSelector = (variantElement, optionName) => {
  const checkedElement = variantElement.querySelector(
    `input[name="${optionName}"]:checked`
  );
  return returnStringOrNull(checkedElement.value);
};
var getCorrectVariantFromOptions = (variantOptions) => {
  const allVariants = getAllVariants();
  if (allVariants != null) {
    let selectedOptions = "";
    variantOptions.forEach((variantElement) => {
      const { optionName } = variantElement.dataset;
      selectedOptions = `${selectedOptions} - ${getValueFromVariantSelector(
        variantElement,
        optionName
      )}`;
    });
    selectedOptions = selectedOptions.slice(3);
    return returnObjectOrNull(
      allVariants.find((element) => element.options === selectedOptions)
    );
  }
  return null;
};
var isVariantAvailable = (variant) => returnBooleanOrNull(variant.available === true);
var handleSetVariant = (variant) => {
  const variantId = variant.id;
  setVariantId(variantId);
  setVariantImage();
};
var setVariantImage = () => {
  const variant = getSelectedVariant();
  if (variant && variant.id) {
    const sliderElement = document.querySelector(".product-media .slider");
    const variantImageElement = createVariantImageSlideElement(variant);
    if (variantImageElement) {
      if (matchMedia("screen and (max-width: 769px)").matches) {
        const flkty = new import_flickity.default(sliderElement);
        const previousVariantImageElement = document.querySelector(
          ".slide.variant-image"
        );
        const selectedSlide = flkty.selectedIndex;
        if (selectedSlide === 0 && previousVariantImageElement && !previousVariantImageElement.classList.contains("js-hidden")) {
          flkty.select(1);
          setTimeout(() => {
            flkty.remove(previousVariantImageElement);
            flkty.prepend(createElementFromHTML(variantImageElement));
            flkty.select(0);
          }, 1e3);
        } else {
          flkty.remove(previousVariantImageElement);
          flkty.prepend(createElementFromHTML(variantImageElement));
          flkty.select(0);
        }
      } else {
        const previousVariantImageElement = document.querySelector(
          ".slide.variant-image"
        );
        if (previousVariantImageElement) {
          previousVariantImageElement.remove();
        }
        sliderElement.insertAdjacentElement(
          "afterbegin",
          createElementFromHTML(variantImageElement)
        );
      }
    }
  }
};
var setVariantId = (variantId) => {
  const variantIdElement = document.querySelector("#variantId");
  variantIdElement.value = variantId;
};

// src/services/element.js
var createElementFromHTML = (htmlString) => {
  const div = document.createElement("div");
  div.innerHTML = htmlString.trim();
  return div.firstChild;
};

// node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
var hasPassiveEvents = false;
if (typeof window !== "undefined") {
  passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return void 0;
    }
  };
  window.addEventListener("testPassive", null, passiveTestOptions);
  window.removeEventListener("testPassive", null, passiveTestOptions);
}
var isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0;
var allowTouchMove = function allowTouchMove2(el) {
  return locks.some(function(lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }
    return false;
  });
};
var preventDefault = function preventDefault2(rawEvent) {
  var e = rawEvent || window.event;
  if (allowTouchMove(e.target)) {
    return true;
  }
  if (e.touches.length > 1)
    return true;
  if (e.preventDefault)
    e.preventDefault();
  return false;
};
var setOverflowHidden = function setOverflowHidden2(options) {
  if (previousBodyPaddingRight === void 0) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + "px";
    }
  }
  if (previousBodyOverflowSetting === void 0) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
};
var restoreOverflowSetting = function restoreOverflowSetting2() {
  if (previousBodyPaddingRight !== void 0) {
    document.body.style.paddingRight = previousBodyPaddingRight;
    previousBodyPaddingRight = void 0;
  }
  if (previousBodyOverflowSetting !== void 0) {
    document.body.style.overflow = previousBodyOverflowSetting;
    previousBodyOverflowSetting = void 0;
  }
};
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled2(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var handleScroll = function handleScroll2(event2, targetElement) {
  var clientY = event2.targetTouches[0].clientY - initialClientY;
  if (allowTouchMove(event2.target)) {
    return false;
  }
  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    return preventDefault(event2);
  }
  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    return preventDefault(event2);
  }
  event2.stopPropagation();
  return true;
};
var disableBodyScroll = function disableBodyScroll2(targetElement, options) {
  if (!targetElement) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (locks.some(function(lock2) {
    return lock2.targetElement === targetElement;
  })) {
    return;
  }
  var lock = {
    targetElement,
    options: options || {}
  };
  locks = [].concat(_toConsumableArray(locks), [lock]);
  if (isIosDevice) {
    targetElement.ontouchstart = function(event2) {
      if (event2.targetTouches.length === 1) {
        initialClientY = event2.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function(event2) {
      if (event2.targetTouches.length === 1) {
        handleScroll(event2, targetElement);
      }
    };
    if (!documentListenerAdded) {
      document.addEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};
var clearAllBodyScrollLocks = function clearAllBodyScrollLocks2() {
  if (isIosDevice) {
    locks.forEach(function(lock) {
      lock.targetElement.ontouchstart = null;
      lock.targetElement.ontouchmove = null;
    });
    if (documentListenerAdded) {
      document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
      documentListenerAdded = false;
    }
    initialClientY = -1;
  } else {
    restoreOverflowSetting();
  }
  locks = [];
};
var enableBodyScroll = function enableBodyScroll2(targetElement) {
  if (!targetElement) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  locks = locks.filter(function(lock) {
    return lock.targetElement !== targetElement;
  });
  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;
    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener("touchmove", preventDefault, hasPassiveEvents ? { passive: false } : void 0);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};
var passiveTestOptions;

// src/services/trustPilot.js
var import_axios = __toESM(require_axios2(), 1);
var fetchReviewsFromTrustPilot = async (language) => {
  const url3 = `https://bynouck-n9okm.ondigitalocean.app/trustpilot/${language}`;
  const config = {
    headers: {
      "Content-Type": "application/json"
    }
  };
  return await import_axios.default.get(url3, config).then((result) => result.data).catch((error) => {
    console.log(error);
  });
};

// src/services/shopifyRecommendedProducts.js
var import_axios2 = __toESM(require_axios2(), 1);
var fetchRelatedProducts = async (productId, limit) => {
  const baseUrl = window.routes.related_product_url;
  const sectionId = "related-products";
  const fullUrl = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;
  const method = "GET";
  const promise = new Promise(async (resolve) => {
    await (0, import_axios2.default)({
      method,
      url: fullUrl,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "X-Requested-With": "xmlhttprequest"
      }
    }).then((response) => {
      const responseData = response.data;
      const elementToReplace = document.getElementById(sectionId);
      if (elementToReplace != null) {
        elementToReplace.innerHTML = responseData;
      }
      resolve(response.data);
    }).catch((error) => {
    });
  });
  return await promise;
};

// src/services/klaviyo.js
var import_axios3 = __toESM(require_axios2(), 1);
var subscribeToNewsletter = async (emailAddress, listId, country) => {
  const url3 = `https://bynouck-n9okm.ondigitalocean.app/klaviyo/lists/${country}/${listId}/subscribe`;
  const data = {
    email: emailAddress
  };
  const config = {
    headers: {
      "Content-Type": "application/json"
    }
  };
  return await import_axios3.default.post(url3, data, config).then((result) => result.data).catch((error) => {
    console.log(error);
  });
};

// src/services/shopifyCart.js
var import_axios4 = __toESM(require_axios2(), 1);
var shopifyCart = {
  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param id {string}
   * @param quantity {number}
   * @returns {Promise<unknown>}
   */
  async quickBuy(id, quantity) {
    const method = "POST";
    const url3 = "/cart/add.js";
    const body = JSON.stringify({
      id,
      quantity,
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleAddToCartDrawer(responseData);
        resolve(response.data);
      }).catch((error) => {
      });
    });
    return await promise;
  },
  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param formData
   * @returns cart object
   */
  async addByo(formData) {
    const method = "POST";
    const url3 = "/cart/add.js";
    const body = JSON.stringify({
      // ...JSON.parse(dissectForm(formData)),
      items: formData.items,
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleAddToCartDrawer(responseData);
        resolve(response.data);
      }).catch((error) => {
      });
    });
    return await promise;
  },
  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param formData
   * @returns cart object
   */
  async add(formData) {
    const method = "POST";
    const url3 = "/cart/add.js";
    const body = JSON.stringify({
      ...JSON.parse(dissectForm(formData)),
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    console.log(body);
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleAddToCartDrawer(responseData);
        resolve(response.data);
      }).catch((error) => {
      });
    });
    return await promise;
  },
  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param formData
   * @returns cart object
   */
  async addBundle(id, quantity, bundleData) {
    const method = "POST";
    const url3 = "/cart/add.js";
    const bodyRaw = {
      items: [
        {
          id,
          quantity,
          properties: {
            _bundleItems: bundleData
          }
        }
      ],
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    bundleData.formatted.forEach((product, index) => {
      const key = parseFloat(index) + 1;
      const value = `${product.sku}${product.product ? ` - ${product.product}` : ""}${product.details ? ` - ${product.details}` : ""}`;
      bodyRaw.items[0].properties[key] = value;
    });
    const body = JSON.stringify(bodyRaw);
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleAddToCartDrawer(responseData);
        resolve(response.data);
      }).catch((error) => {
        console.log(error);
      });
    });
    return await promise;
  },
  /**
   * Remove item from the cart.
   *
   * @param line {string}
   * @returns {Promise<unknown>}
   */
  async remove(line) {
    const method = "POST";
    const url3 = "/cart/change.js";
    const body = JSON.stringify({
      line,
      quantity: 0,
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleRemoveFromCart(responseData);
        resolve(response.data);
      }).catch((error) => {
      });
    });
    return await promise;
  },
  /**
   * Remove item from the cart by Variant ID.
   *
   * @param id {string}
   * @returns {Promise<unknown>}
   */
  async removeById(id) {
    const method = "POST";
    const url3 = "/cart/change.js";
    const body = JSON.stringify({
      id,
      quantity: 0,
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleRemoveFromCart(responseData);
        resolve(response.data);
      }).catch((error) => {
      });
    });
    return await promise;
  },
  /**
   * Update quantity.
   *
   * @param line {string}
   * @param quantity {number}
   *
   * @returns {Promise<unknown>}
   */
  async updateQuantity(line, quantity) {
    const method = "POST";
    const url3 = "/cart/change.js";
    const body = JSON.stringify({
      line,
      quantity,
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleCartDrawerChange(responseData);
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      });
    });
    return await promise;
  },
  /**
   * Update Attributes.
   *
   * @param attributeName {string}
   * @param attributeValue {string}
   *
   * @returns {Promise<unknown>}
   */
  async updateAttributes(attributeName, attributeValue) {
    const method = "POST";
    const url3 = "/cart/update.js";
    const body = JSON.stringify({
      attributes: {
        [attributeName]: attributeValue
      },
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleCartDrawerChange(responseData);
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      });
    });
    return await promise;
  },
  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param id {string}
   * @param quantity {number}
   * @returns {Promise<unknown>}
   */
  async quickBuyWithProperties(id, quantity, properties) {
    const method = "POST";
    const url3 = "/cart/add.js";
    const body = {
      id,
      quantity,
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    if (properties) {
      console.log(properties);
      body.properties = properties;
    }
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: JSON.stringify(body)
      }).then((response) => {
        const responseData = response.data;
        handleAddToCartDrawer(responseData);
        resolve(response.data);
      }).catch((error) => {
      });
    });
    return await promise;
  },
  /**
   * Update quantity.
   *
   * @param line {string}
   * @param properties {object}
   *
   * @returns {Promise<unknown>}
   */
  async updateProduct(line, properties) {
    const method = "POST";
    const url3 = "/cart/change.js";
    const body = JSON.stringify({
      line,
      properties,
      sections: getCartDrawerSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    const promise = new Promise(async (resolve) => {
      await (0, import_axios4.default)({
        method,
        url: url3,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleCartDrawerChange(responseData);
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      });
    });
    return await promise;
  }
};

// src/templates/cartItem.js
var createCartProductElement = async (product, isFree = false) => {
  const title = product.product_title;
  const vartiantTitle = product.variant_title;
  const variantId = product.variant_id;
  const { url: url3 } = product;
  const featuredImageAlt = product.featured_image.alt;
  const featuredImageUrl = product.featured_image.url;
  const linePrice = product.line_price;
  const originalLinePrice = product.original_line_price;
  const { quantity } = product;
  const numberOfQuantitySelect = 11;
  let quantityString;
  let quantitySelectString;
  let discountString = "";
  let frontEngravingText = "";
  let backEngravingText = "";
  let initial = "";
  let initials = "";
  let note = "";
  if (quantity === 1) {
    quantityString = `${quantity} ${text.piece}`;
  } else {
    quantityString = `${quantity} ${text.pieces}`;
  }
  for (let i = 1; i < numberOfQuantitySelect; i++) {
    if (i === quantity && i === 1) {
      quantitySelectString += `<option value="${i}" selected>${i} ${text.piece}</option>`;
    } else if (i === 1) {
      quantitySelectString += `<option value="${i}">${i} ${text.piece}</option>`;
    } else if (i === quantity) {
      quantitySelectString += `<option value="${i}" selected>${i} ${text.pieces}</option>`;
    } else {
      quantitySelectString += `<option value="${i}">${i} ${text.pieces}</option>`;
    }
  }
  const quantityElement = null;
  if (isFree) {
  } else {
  }
  if (product.discounts.length > 0) {
    product.discounts.forEach((discount) => {
      discountString = `<div class="line-level-discount">${discount.title} <br /> -${pricing(discount.amount)}</div>`;
    });
  }
  if (product.properties) {
    if (product.properties.text_frontside) {
      frontEngravingText = product.properties.text_frontside;
    }
    if (product.properties.text_backside) {
      backEngravingText = product.properties.text_backside;
    }
    if (product.properties.initial) {
      initial = product.properties.initial;
    }
    if (product.properties.initials) {
      initials = product.properties.initials;
    }
    if (product.properties.note) {
      note = product.properties._note;
    }
  }
  return `
      <div class="cart-content-list__item" data-variant-id="${variantId}">

        <a class="image-holder" href="${url3}">
          <img alt="${featuredImageAlt}" src="${imgURL(
    featuredImageUrl,
    "400x"
  )}">
        </a>
        <!-- end .image-holder -->

        <div class="text-holder">

          <div class="left-column">

            <div class="title">
              <p><strong>${title}</strong></p>
              ${vartiantTitle ? `<p>${vartiantTitle}</p>` : ""}
              ${frontEngravingText.length > 0 ? `<p>${text.engraving}: ${frontEngravingText}</p>` : ""}
              ${backEngravingText.length > 0 ? `<p>${text.backside}: ${backEngravingText}</p>` : ""}
              ${initial.length > 0 ? `<p>${text.initial}: ${initial}</p>` : ""}
              ${initials.length > 0 ? `<p>${text.initials}: ${initials}</p>` : ""}
              ${note.length > 0 ? `<p class="product-note">${text.note}: ${note}</p>` : ""}
            </div>
            <!-- end .title -->

            <div class="quantity" ${isFree ? 'style="display:none;"' : ""}>
              <div class="placeholder">
                ${quantityString}
              </div>
              <select class="quantity__select">
                ${quantitySelectString}
              </select>
            </div>
            <!-- end .quantity -->

          </div>
          <!-- end .left-column -->

          <div class="right-column">

            <div class="remove">
              <button class="js-remove-item" ${isFree ? 'style="display:none;"' : ""}>${text.remove_item}</button>
            </div>
            <!-- end .remove -->

            <div class="price-container">
              ${originalLinePrice !== linePrice ? `
                <div class="compare-at">
                  <s>
                    ${pricing(originalLinePrice)}
                  </s>
                </div>
                <!-- end .compare-at -->
                
                ${discountString}
              ` : ""}
                            
              <div class="price">
                ${isFree ? "Free" : pricing(linePrice)}
              </div>
              <!-- end .price -->

            </div>
            <!-- end .price-container -->

          </div>
          <!-- end .right-column -->

        </div>
        <!-- end .text-holder -->

      </div>
      <!-- end .cart-content-list__item -->
    `;
};

// src/sections/header.js
var header = () => {
  const init2 = () => {
    bannerScroll();
    mobileMenuToggle();
    mobileMenuDropdown();
    megaMenuHover();
    megaMenuPrimaryDropdown();
    searchFormToggle();
  };
  const mobileMenuToggle = () => {
    const toggle = document.querySelector("header .main-menu .toggle");
    const mobileMenu = document.querySelector("header .mobile-menu");
    if (toggle !== null && mobileMenu !== null) {
      toggle.addEventListener("click", (event2) => {
        event2.preventDefault();
        if (toggle.classList !== null) {
          if (toggle.classList.contains("js-open")) {
            toggle.classList.remove("js-open");
            mobileMenu.classList.remove("js-open");
            enableBodyScroll(mobileMenu);
          } else {
            toggle.classList.add("js-open");
            mobileMenu.classList.add("js-open");
            disableBodyScroll(mobileMenu);
          }
        }
      });
    }
  };
  const bannerScroll = () => {
    const bodyElement = document.querySelector("body");
    const header2 = document.querySelector("header.header");
    let bannerHeight = document.querySelector(".announcement-bar").offsetHeight;
    window.addEventListener("resize", () => {
      bannerHeight = document.querySelector(".announcement-bar").offsetHeight;
    });
    if (!bodyElement.classList.contains("has-banner")) {
      return null;
    }
    function hideBanner() {
      if (header2 !== null) {
        header2.classList.add("header--has-scrolled");
        header2.style.transform = `translateY(-${bannerHeight}px)`;
      }
    }
    function showBanner() {
      if (header2 !== null) {
        header2.classList.remove("header--has-scrolled");
        header2.style.transform = "translateY(0)";
      }
    }
    const offset = bannerHeight * 3;
    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > offset) {
        hideBanner();
      } else {
        showBanner();
      }
    });
  };
  const mobileMenuDropdown = () => {
    const dropdowns = document.querySelectorAll(
      ".navigation .navigation__item--dropdown>a"
    );
    if (dropdowns.length > 0) {
      dropdowns.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          const dropdown = button.nextElementSibling;
          button.classList.toggle("js-open");
          dropdown.classList.toggle("js-open");
        });
      });
    }
  };
  const megaMenuHover = () => {
    const dropdowns = document.querySelectorAll(
      ".main-menu__categories .navigation .navigation__item--mega-menu>a"
    );
    if (dropdowns.length > 0) {
      dropdowns.forEach((button) => {
        const dropdown = button.nextElementSibling;
        button.addEventListener("mouseenter", (e) => {
          e.preventDefault();
          dropdowns.forEach((button2) => button2.classList.remove("js-open"));
          dropdowns.forEach((button2) => button2.classList.remove("js-open"));
          const dropdownsMegaMenu = document.querySelectorAll(".mega-menu.js-open");
          dropdownsMegaMenu.forEach(
            (dropdown2) => dropdown2.classList.remove("js-open")
          );
          button.classList.add("js-open");
          dropdown.classList.add("js-open");
        });
        dropdown.addEventListener("mouseleave", (e) => {
          e.preventDefault();
          button.classList.remove("js-open");
          dropdown.classList.remove("js-open");
        });
      });
    }
    document.addEventListener("click", (e) => {
      const megaMenu = document.querySelector(
        ".main-menu__categories .navigation .navigation__item--mega-menu .mega-menu.js-open"
      );
      let { target } = e;
      do {
        if (target == megaMenu) {
          return;
        }
        target = target.parentNode;
      } while (target);
      closeMegaMenus();
    });
    function closeMegaMenus() {
      if (dropdowns.length > 0) {
        dropdowns.forEach((button) => {
          const dropdown = button.nextElementSibling;
          button.classList.remove("js-open");
          dropdown.classList.remove("js-open");
        });
      }
    }
  };
  const megaMenuPrimaryDropdown = () => {
    const dropdowns = document.querySelectorAll(
      ".mega-menu .primary__item--dropdown>a"
    );
    if (dropdowns.length > 0) {
      dropdowns.forEach((button) => {
        button.addEventListener("mouseover", (e) => {
          e.preventDefault();
          dropdowns.forEach((button2) => button2.classList.remove("js-open"));
          button.classList.add("js-open");
        });
      });
    }
  };
  const searchFormToggle = () => {
    const toggleButton = document.querySelector(
      ".main-menu .item--search form span.icon"
    );
    const form = document.querySelector(".main-menu .item--search form");
    const input = document.querySelector(
      '.main-menu .item--search form input[type="text"]'
    );
    if (toggleButton !== null && form !== null && input !== null) {
      toggleButton.addEventListener("click", (e) => {
        e.preventDefault();
        form.classList.toggle("js-hidden");
        if (form.classList.contains("js-hidden")) {
          input.value = "";
        }
      });
      if (matchMedia("screen and (min-width: 768px)").matches) {
        form.classList.remove("js-hidden");
      }
    }
  };
  init2();
};

// src/sections/addToCart.js
var addToCart = () => {
  const init2 = () => {
    handleAllForms();
  };
  const handleAddToCart = async (event2) => {
    const formData = Object.fromEntries(new FormData(event2.target).entries());
    console.log(formData);
    if (formData) {
      await shopifyCart.add(formData);
    }
  };
  const handleAllForms = () => {
    const allForm = document.querySelectorAll("form.js-add-to-cart");
    if (allForm) {
      allForm.forEach((form) => {
        setVariantImage();
        form.addEventListener("submit", (event2) => {
          event2.preventDefault();
          console.log("handleAddToCart");
          handleAddToCart(event2);
        });
      });
    }
  };
  init2();
};

// src/sections/url.js
var url = new URL(window.location);
var urlFunctions = {
  /**
   * Get current array of filters from the URL.
   *
   * @returns currentFilter {array}
   */
  getCurrentFilters() {
    if (url.searchParams.get("filter")) {
      const currentFilter = url.searchParams.get("filter").split(",");
      return currentFilter;
    }
    return [];
  },
  /**
   * Set buttons active based on the url.
   * Is needed for being able to sent a link that contains filters.
   *
   * @param {*} filters
   */
  setCurrentButtons(filters, buttons) {
    if (!filters)
      return;
    const buttonsArray = Array.from(buttons, (node) => node);
    filters.forEach((filter) => {
      const button = buttonsArray.find((element) => element.dataset.value == filter);
      if (button)
        button.classList.add("js-active");
    });
  },
  /**
   * Create a new filtererable url
   *
   * @param {*} buttons
   */
  changeParams(buttons) {
    const newFilterArray = [];
    buttons.forEach((button) => {
      if (button.classList.contains("js-active")) {
        newFilterArray.push(button.dataset.value);
      }
    });
    const newFilter = newFilterArray.toString();
    url.searchParams.set("filter", newFilter);
    window.history.pushState("", "Filter", url.href.toString());
  }
};

// node_modules/fuse.js/dist/fuse.esm.js
function isArray(value) {
  return !Array.isArray ? getTag(value) === "[object Array]" : Array.isArray(value);
}
var INFINITY = 1 / 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  let result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function toString(value) {
  return value == null ? "" : baseToString(value);
}
function isString(value) {
  return typeof value === "string";
}
function isNumber(value) {
  return typeof value === "number";
}
function isBoolean(value) {
  return value === true || value === false || isObjectLike(value) && getTag(value) == "[object Boolean]";
}
function isObject(value) {
  return typeof value === "object";
}
function isObjectLike(value) {
  return isObject(value) && value !== null;
}
function isDefined(value) {
  return value !== void 0 && value !== null;
}
function isBlank(value) {
  return !value.trim().length;
}
function getTag(value) {
  return value == null ? value === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
var EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
var INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
var LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) => `Invalid value for key ${key}`;
var PATTERN_LENGTH_TOO_LARGE = (max) => `Pattern length exceeds max of ${max}.`;
var MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;
var INVALID_KEY_WEIGHT_VALUE = (key) => `Property 'weight' in key '${key}' must be a positive integer`;
var hasOwn = Object.prototype.hasOwnProperty;
var KeyStore = class {
  constructor(keys) {
    this._keys = [];
    this._keyMap = {};
    let totalWeight = 0;
    keys.forEach((key) => {
      let obj = createKey(key);
      totalWeight += obj.weight;
      this._keys.push(obj);
      this._keyMap[obj.id] = obj;
      totalWeight += obj.weight;
    });
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
};
function createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;
  let getFn = null;
  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, "name")) {
      throw new Error(MISSING_KEY_PROPERTY("name"));
    }
    const name = key.name;
    src = name;
    if (hasOwn.call(key, "weight")) {
      weight = key.weight;
      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
      }
    }
    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }
  return { path, id, weight, src, getFn };
}
function createKeyPath(key) {
  return isArray(key) ? key : key.split(".");
}
function createKeyId(key) {
  return isArray(key) ? key.join(".") : key;
}
function get(obj, path) {
  let list = [];
  let arr = false;
  const deepGet = (obj2, path2, index) => {
    if (!isDefined(obj2)) {
      return;
    }
    if (!path2[index]) {
      list.push(obj2);
    } else {
      let key = path2[index];
      const value = obj2[key];
      if (!isDefined(value)) {
        return;
      }
      if (index === path2.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) {
        list.push(toString(value));
      } else if (isArray(value)) {
        arr = true;
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path2, index + 1);
        }
      } else if (path2.length) {
        deepGet(value, path2, index + 1);
      }
    }
  };
  deepGet(obj, isString(path) ? path.split(".") : path, 0);
  return arr ? list : list[0];
}
var MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};
var BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (a, b) => a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
var FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};
var AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};
var SPACE = /[^ ]+/g;
function norm(weight = 1, mantissa = 3) {
  const cache = /* @__PURE__ */ new Map();
  const m = Math.pow(10, mantissa);
  return {
    get(value) {
      const numTokens = value.match(SPACE).length;
      if (cache.has(numTokens)) {
        return cache.get(numTokens);
      }
      const norm2 = 1 / Math.pow(numTokens, 0.5 * weight);
      const n = parseFloat(Math.round(norm2 * m) / m);
      cache.set(numTokens, n);
      return n;
    },
    clear() {
      cache.clear();
    }
  };
}
var FuseIndex = class {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;
    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys = []) {
    this.keys = keys;
    this._keysMap = {};
    keys.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return;
    }
    this.isCreated = true;
    if (isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }
    this.norm.clear();
  }
  // Adds a doc to the end of the index
  add(doc) {
    const idx = this.size();
    if (isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  // Removes the doc at the specified index of the index
  removeAt(idx) {
    this.records.splice(idx, 1);
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]];
  }
  size() {
    return this.records.length;
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return;
    }
    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };
    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };
    this.keys.forEach((key, keyIndex) => {
      let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
      if (!isDefined(value)) {
        return;
      }
      if (isArray(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];
        while (stack.length) {
          const { nestedArrIndex, value: value2 } = stack.pop();
          if (!isDefined(value2)) {
            continue;
          }
          if (isString(value2) && !isBlank(value2)) {
            let subRecord = {
              v: value2,
              i: nestedArrIndex,
              n: this.norm.get(value2)
            };
            subRecords.push(subRecord);
          } else if (isArray(value2)) {
            value2.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else
            ;
        }
        record.$[keyIndex] = subRecords;
      } else if (isString(value) && !isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };
        record.$[keyIndex] = subRecord;
      }
    });
    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    };
  }
};
function createIndex(keys, docs, { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex;
}
function parseIndex(data, { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}) {
  const { keys, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex;
}
function computeScore$1(pattern, {
  errors = 0,
  currentLocation = 0,
  expectedLocation = 0,
  distance = Config.distance,
  ignoreLocation = Config.ignoreLocation
} = {}) {
  const accuracy = errors / pattern.length;
  if (ignoreLocation) {
    return accuracy;
  }
  const proximity = Math.abs(expectedLocation - currentLocation);
  if (!distance) {
    return proximity ? 1 : accuracy;
  }
  return accuracy + proximity / distance;
}
function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
  let indices = [];
  let start = -1;
  let end = -1;
  let i = 0;
  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }
  return indices;
}
var MAX_BITS = 32;
function search(text2, pattern, patternAlphabet, {
  location: location2 = Config.location,
  distance = Config.distance,
  threshold = Config.threshold,
  findAllMatches = Config.findAllMatches,
  minMatchCharLength = Config.minMatchCharLength,
  includeMatches = Config.includeMatches,
  ignoreLocation = Config.ignoreLocation
} = {}) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
  }
  const patternLen = pattern.length;
  const textLen = text2.length;
  const expectedLocation = Math.max(0, Math.min(location2, textLen));
  let currentThreshold = threshold;
  let bestLocation = expectedLocation;
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  const matchMask = computeMatches ? Array(textLen) : [];
  let index;
  while ((index = text2.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });
    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;
    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }
  bestLocation = -1;
  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;
  const mask = 1 << patternLen - 1;
  for (let i = 0; i < patternLen; i += 1) {
    let binMin = 0;
    let binMid = binMax;
    while (binMin < binMid) {
      const score2 = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });
      if (score2 <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }
      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }
    binMax = binMid;
    let start = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
    let bitArr = Array(finish + 2);
    bitArr[finish + 1] = (1 << i) - 1;
    for (let j = finish; j >= start; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text2.charAt(currentLocation)];
      if (computeMatches) {
        matchMask[currentLocation] = +!!charMatch;
      }
      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
      if (i) {
        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
      }
      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });
        if (finalScore <= currentThreshold) {
          currentThreshold = finalScore;
          bestLocation = currentLocation;
          if (bestLocation <= expectedLocation) {
            break;
          }
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });
    if (score > currentThreshold) {
      break;
    }
    lastBitArr = bitArr;
  }
  const result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(1e-3, finalScore)
  };
  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }
  return result;
}
function createPatternAlphabet(pattern) {
  let mask = {};
  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | 1 << len - i - 1;
  }
  return mask;
}
var BitapSearch = class {
  constructor(pattern, {
    location: location2 = Config.location,
    threshold = Config.threshold,
    distance = Config.distance,
    includeMatches = Config.includeMatches,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    isCaseSensitive = Config.isCaseSensitive,
    ignoreLocation = Config.ignoreLocation
  } = {}) {
    this.options = {
      location: location2,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.chunks = [];
    if (!this.pattern.length) {
      return;
    }
    const addChunk = (pattern2, startIndex) => {
      this.chunks.push({
        pattern: pattern2,
        alphabet: createPatternAlphabet(pattern2),
        startIndex
      });
    };
    const len = this.pattern.length;
    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end = len - remainder;
      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }
      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }
  searchIn(text2) {
    const { isCaseSensitive, includeMatches } = this.options;
    if (!isCaseSensitive) {
      text2 = text2.toLowerCase();
    }
    if (this.pattern === text2) {
      let result2 = {
        isMatch: true,
        score: 0
      };
      if (includeMatches) {
        result2.indices = [[0, text2.length - 1]];
      }
      return result2;
    }
    const {
      location: location2,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;
    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;
    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
      const { isMatch, score, indices } = search(text2, pattern, alphabet, {
        location: location2 + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });
      if (isMatch) {
        hasMatches = true;
      }
      totalScore += score;
      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });
    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };
    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }
    return result;
  }
};
var BaseMatch = class {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex);
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex);
  }
  search() {
  }
};
function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null;
}
var ExactMatch = class extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "exact";
  }
  static get multiRegex() {
    return /^="(.*)"$/;
  }
  static get singleRegex() {
    return /^=(.*)$/;
  }
  search(text2) {
    const isMatch = text2 === this.pattern;
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
};
var InverseExactMatch = class extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "inverse-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"$/;
  }
  static get singleRegex() {
    return /^!(.*)$/;
  }
  search(text2) {
    const index = text2.indexOf(this.pattern);
    const isMatch = index === -1;
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text2.length - 1]
    };
  }
};
var PrefixExactMatch = class extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "prefix-exact";
  }
  static get multiRegex() {
    return /^\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^\^(.*)$/;
  }
  search(text2) {
    const isMatch = text2.startsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
};
var InversePrefixExactMatch = class extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "inverse-prefix-exact";
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^!\^(.*)$/;
  }
  search(text2) {
    const isMatch = !text2.startsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text2.length - 1]
    };
  }
};
var SuffixExactMatch = class extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "suffix-exact";
  }
  static get multiRegex() {
    return /^"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^(.*)\$$/;
  }
  search(text2) {
    const isMatch = text2.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text2.length - this.pattern.length, text2.length - 1]
    };
  }
};
var InverseSuffixExactMatch = class extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "inverse-suffix-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^!(.*)\$$/;
  }
  search(text2) {
    const isMatch = !text2.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text2.length - 1]
    };
  }
};
var FuzzyMatch = class extends BaseMatch {
  constructor(pattern, {
    location: location2 = Config.location,
    threshold = Config.threshold,
    distance = Config.distance,
    includeMatches = Config.includeMatches,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    isCaseSensitive = Config.isCaseSensitive,
    ignoreLocation = Config.ignoreLocation
  } = {}) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location: location2,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    });
  }
  static get type() {
    return "fuzzy";
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(text2) {
    return this._bitapSearch.searchIn(text2);
  }
};
var IncludeMatch = class extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return "include";
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(text2) {
    let location2 = 0;
    let index;
    const indices = [];
    const patternLen = this.pattern.length;
    while ((index = text2.indexOf(this.pattern, location2)) > -1) {
      location2 = index + patternLen;
      indices.push([index, location2 - 1]);
    }
    const isMatch = !!indices.length;
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    };
  }
};
var searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];
var searchersLen = searchers.length;
var SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
var OR_TOKEN = "|";
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query3 = item.trim().split(SPACE_RE).filter((item2) => item2 && !!item2.trim());
    let results = [];
    for (let i = 0, len = query3.length; i < len; i += 1) {
      const queryItem = query3[i];
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }
      if (found) {
        continue;
      }
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break;
        }
      }
    }
    return results;
  });
}
var MultiMatchSet = /* @__PURE__ */ new Set([FuzzyMatch.type, IncludeMatch.type]);
var ExtendedSearch = class {
  constructor(pattern, {
    isCaseSensitive = Config.isCaseSensitive,
    includeMatches = Config.includeMatches,
    minMatchCharLength = Config.minMatchCharLength,
    ignoreLocation = Config.ignoreLocation,
    findAllMatches = Config.findAllMatches,
    location: location2 = Config.location,
    threshold = Config.threshold,
    distance = Config.distance
  } = {}) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location: location2,
      threshold,
      distance
    };
    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }
  static condition(_, options) {
    return options.useExtendedSearch;
  }
  searchIn(text2) {
    const query3 = this.query;
    if (!query3) {
      return {
        isMatch: false,
        score: 1
      };
    }
    const { includeMatches, isCaseSensitive } = this.options;
    text2 = isCaseSensitive ? text2 : text2.toLowerCase();
    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;
    for (let i = 0, qLen = query3.length; i < qLen; i += 1) {
      const searchers2 = query3[i];
      allIndices.length = 0;
      numMatches = 0;
      for (let j = 0, pLen = searchers2.length; j < pLen; j += 1) {
        const searcher = searchers2[j];
        const { isMatch, indices, score } = searcher.search(text2);
        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break;
        }
      }
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };
        if (includeMatches) {
          result.indices = allIndices;
        }
        return result;
      }
    }
    return {
      isMatch: false,
      score: 1
    };
  }
};
var registeredSearchers = [];
function register(...args) {
  registeredSearchers.push(...args);
}
function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options);
    }
  }
  return new BitapSearch(pattern, options);
}
var LogicalOperator = {
  AND: "$and",
  OR: "$or"
};
var KeyType = {
  PATH: "$path",
  PATTERN: "$val"
};
var isExpression = (query3) => !!(query3[LogicalOperator.AND] || query3[LogicalOperator.OR]);
var isPath = (query3) => !!query3[KeyType.PATH];
var isLeaf = (query3) => !isArray(query3) && isObject(query3) && !isExpression(query3);
var convertToExplicit = (query3) => ({
  [LogicalOperator.AND]: Object.keys(query3).map((key) => ({
    [key]: query3[key]
  }))
});
function parse(query3, options, { auto = true } = {}) {
  const next = (query4) => {
    let keys = Object.keys(query4);
    const isQueryPath = isPath(query4);
    if (!isQueryPath && keys.length > 1 && !isExpression(query4)) {
      return next(convertToExplicit(query4));
    }
    if (isLeaf(query4)) {
      const key = isQueryPath ? query4[KeyType.PATH] : keys[0];
      const pattern = isQueryPath ? query4[KeyType.PATTERN] : query4[key];
      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
      }
      const obj = {
        keyId: createKeyId(key),
        pattern
      };
      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }
      return obj;
    }
    let node = {
      children: [],
      operator: keys[0]
    };
    keys.forEach((key) => {
      const value = query4[key];
      if (isArray(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });
    return node;
  };
  if (!isExpression(query3)) {
    query3 = convertToExplicit(query3);
  }
  return next(query3);
}
function computeScore(results, { ignoreFieldNorm = Config.ignoreFieldNorm }) {
  results.forEach((result) => {
    let totalScore = 1;
    result.matches.forEach(({ key, norm: norm2, score }) => {
      const weight = key ? key.weight : null;
      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm2)
      );
    });
    result.score = totalScore;
  });
}
function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];
  if (!isDefined(matches)) {
    return;
  }
  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return;
    }
    const { indices, value } = match;
    let obj = {
      indices,
      value
    };
    if (match.key) {
      obj.key = match.key.src;
    }
    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }
    data.matches.push(obj);
  });
}
function transformScore(result, data) {
  data.score = result.score;
}
function format(results, docs, {
  includeMatches = Config.includeMatches,
  includeScore = Config.includeScore
} = {}) {
  const transformers = [];
  if (includeMatches)
    transformers.push(transformMatches);
  if (includeScore)
    transformers.push(transformScore);
  return results.map((result) => {
    const { idx } = result;
    const data = {
      item: docs[idx],
      refIndex: idx
    };
    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }
    return data;
  });
}
var Fuse = class {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };
    if (this.options.useExtendedSearch && false) {
      throw new Error(EXTENDED_SEARCH_UNAVAILABLE);
    }
    this._keyStore = new KeyStore(this.options.keys);
    this.setCollection(docs, index);
  }
  setCollection(docs, index) {
    this._docs = docs;
    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE);
    }
    this._myIndex = index || createIndex(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    });
  }
  add(doc) {
    if (!isDefined(doc)) {
      return;
    }
    this._docs.push(doc);
    this._myIndex.add(doc);
  }
  remove(predicate = () => false) {
    const results = [];
    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;
        results.push(doc);
      }
    }
    return results;
  }
  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }
  getIndex() {
    return this._myIndex;
  }
  search(query3, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;
    let results = isString(query3) ? isString(this._docs[0]) ? this._searchStringList(query3) : this._searchObjectList(query3) : this._searchLogical(query3);
    computeScore(results, { ignoreFieldNorm });
    if (shouldSort) {
      results.sort(sortFn);
    }
    if (isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }
    return format(results, this._docs, {
      includeMatches,
      includeScore
    });
  }
  _searchStringList(query3) {
    const searcher = createSearcher(query3, this.options);
    const { records } = this._myIndex;
    const results = [];
    records.forEach(({ v: text2, i: idx, n: norm2 }) => {
      if (!isDefined(text2)) {
        return;
      }
      const { isMatch, score, indices } = searcher.searchIn(text2);
      if (isMatch) {
        results.push({
          item: text2,
          idx,
          matches: [{ score, value: text2, norm: norm2, indices }]
        });
      }
    });
    return results;
  }
  _searchLogical(query3) {
    const expression = parse(query3, this.options);
    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;
        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });
        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ];
        }
        return [];
      }
      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return [];
        }
      }
      return res;
    };
    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];
    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);
        if (expResults.length) {
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });
    return results;
  }
  _searchObjectList(query3) {
    const searcher = createSearcher(query3, this.options);
    const { keys, records } = this._myIndex;
    const results = [];
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return;
      }
      let matches = [];
      keys.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });
      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });
    return results;
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return [];
    }
    let matches = [];
    if (isArray(value)) {
      value.forEach(({ v: text2, i: idx, n: norm2 }) => {
        if (!isDefined(text2)) {
          return;
        }
        const { isMatch, score, indices } = searcher.searchIn(text2);
        if (isMatch) {
          matches.push({
            score,
            key,
            value: text2,
            idx,
            norm: norm2,
            indices
          });
        }
      });
    } else {
      const { v: text2, n: norm2 } = value;
      const { isMatch, score, indices } = searcher.searchIn(text2);
      if (isMatch) {
        matches.push({ score, key, value: text2, norm: norm2, indices });
      }
    }
    return matches;
  }
};
Fuse.version = "6.6.2";
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;
{
  Fuse.parseQuery = parse;
}
{
  register(ExtendedSearch);
}

// src/sections/filter.js
var filterProducts = (products, filters = Array) => {
  if (Array.isArray(filters) && filters.length > 0 && filters.length != null) {
    const options = {
      tokenize: false,
      threshold: 0,
      includeScore: false,
      ignoreLocation: true,
      shouldSort: false,
      useExtendedSearch: true,
      keys: ["tags"]
    };
    let productsLocal = products;
    const fuse = new Fuse(productsLocal, options);
    filters.sort();
    const searchPhrasesArray = new Array();
    let currentType;
    let prevType;
    filters.forEach((tag, index) => {
      currentType = tag.split("_")[0];
      if (currentType !== prevType) {
        searchPhrasesArray.push(new Array());
      }
      searchPhrasesArray[searchPhrasesArray.length - 1].push(filters[index]);
      prevType = currentType;
    });
    let results = new Array();
    searchPhrasesArray.forEach((searchPhraseArray) => {
      const searchPhrase = searchPhraseArray.map((tag) => `=${tag}`).join("|");
      results = fuse.search(searchPhrase);
      results = results.concat(results);
    });
    productsLocal = Array.from(new Set(results));
    productsLocal = Array.from(productsLocal, (element) => element.item);
    return productsLocal;
  }
  return products;
};

// src/sections/sort.js
var sortProducts = (select) => {
  const { value } = select;
  if (!value)
    return false;
  let key = "order";
  let order = "asc";
  let type = "default";
  switch (value) {
    case "price-ascending":
      key = "price";
      order = "asc";
      type = "price";
      break;
    case "price-descending":
      key = "price";
      order = "desc";
      type = "price";
      break;
    case "title-ascending":
      key = "title";
      order = "asc";
      type = "default";
      break;
    case "title-descending":
      key = "title";
      order = "desc";
      type = "default";
      break;
    case "date-ascending":
      key = "published_at";
      order = "asc";
      type = "date";
      break;
    case "date-descending":
      key = "published_at";
      order = "desc";
      type = "date";
      break;
    default:
      break;
  }
  return function(a, b) {
    if (!type === "price") {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }
    }
    let varA;
    let varB;
    if (type == "date") {
      varA = new Date(a[key]);
      varB = new Date(b[key]);
    } else if (type == "price") {
      varA = parseFloat(a.variants[0].price);
      varB = parseFloat(b.variants[0].price);
    } else {
      varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
      varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];
    }
    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
};

// src/templates/productButton.js
var url2 = new URL(window.location);
var collectionURL = url2.pathname;
var hasProductEngraving = (tags) => {
  let condition = false;
  if (tags.length > 0) {
    tags.forEach((tag) => {
      if (tag === "show_engrave_input" || tag === "show_initials_input") {
        condition = true;
      }
    });
  }
  return condition;
};
var hasDyoProduct = (tags) => {
  let condition = false;
  if (tags.length > 0) {
    tags.forEach((tag) => {
      if (tag === "dyo_base_product") {
        condition = true;
      }
    });
  }
  return condition;
};
var hasProductMulitpleVariants = (allVariant) => {
  if (allVariant.length > 1) {
    const allPricesOfVariants = allVariant.map((variant) => variant.price);
    const areAllPricesEqual = allPricesOfVariants.every(
      (val, i, arr) => val === arr[0]
    );
    return !areAllPricesEqual;
  }
  return false;
};
var returnLabelAndBanner = (tag) => {
  if (tag !== null) {
    switch (tag) {
      case "label_limited_edition":
        return {
          bannerClass: "include-banner",
          bannerText: text.banner_limited
        };
      case "label_personalize":
        return {
          bannerClass: "include-banner",
          bannerText: text.banner_personalize
        };
      case "label_stainless":
        return {
          bannerClass: "include-banner",
          bannerText: text.stainless_steel
        };
      case "label_waterproof":
        return {
          bannerClass: "include-banner",
          bannerText: text.waterproof
        };
      case "label_stylingparty":
        return {
          bannerClass: "include-banner",
          bannerText: text.banner_stylingparty
        };
      case "label_earparty":
        return {
          bannerClass: "include-banner",
          bannerText: text.banner_earparty
        };
      case "label_layerparty":
        return {
          bannerClass: "include-banner",
          bannerText: text.banner_layerparty
        };
      case "label_sale":
        return {
          labelText: text.label_sale
        };
      case "label_new":
        return {
          labelText: text.label_new
        };
      case "label_back_soon":
        return {
          labelText: text.label_back_soon
        };
      case "label_dyo":
        return {
          bannerClass: "include-banner",
          bannerText: text.label_dyo
        };
      default:
        break;
    }
  }
};
var createProductButtonElement = (product) => {
  const hasEngraving = hasProductEngraving(product.tags);
  const hasMulitpleVariants = hasProductMulitpleVariants(product.variants);
  const hasDyo = hasDyoProduct(product.tags);
  let hasComparedPrice = false;
  let bannerClass = null;
  let bannerText = null;
  let labelText = null;
  product.tags.forEach((tag) => {
    const labelAndBannerObject = returnLabelAndBanner(tag);
    if (labelAndBannerObject) {
      if (labelAndBannerObject.bannerClass) {
        bannerClass = labelAndBannerObject.bannerClass;
      }
      if (labelAndBannerObject.bannerText) {
        bannerText = labelAndBannerObject.bannerText;
      }
      if (labelAndBannerObject.labelText) {
        labelText = labelAndBannerObject.labelText;
      }
    }
  });
  if (product.variants[0].compare_at_price) {
    hasComparedPrice = true;
  }
  const offset = 2;
  let allImageElements = null;
  if (product.images.length > 0) {
    const allImageObjects = product.images;
    allImageElements = allImageObjects.map(
      (imageObject, index) => index <= offset ? `<div class="slide"><img class="link__image${index === 0 ? " first-image" : ""}" onload="fadeIn(this)" alt="Image for ${product.title}" loading="lazy" src="${imgURL(imageObject.src, "800x")}"></div>` : null
    ).join("");
  } else {
    allImageElements = `<div class="slide"><img class="link__imagee first-image" onload="fadeIn(this)" alt="Image for ${product.title}" loading="lazy" src="https://cdn.shopify.com/s/files/1/0108/9883/3489/files/no-image.png?v=1581942672"></div>`;
  }
  const productURL = collectionURL ? `${collectionURL}/products/${product.handle}` : "";
  return `
    <div class="product-button product-button--collection ${bannerClass || ""}">
      <div class="image-holder">
        <a class="image__link" href="${productURL}">
          <surf-scroll class="surf-scroll">
            <div class="surf-scroll__slider">
              ${allImageElements}
            </div>

            <div class="surf-scroll__indicator">
              <div class="dot" data-index="{{ forloop.index0 }}"></div>
            </div>
      
          </surf-scroll>
        </a>
        <!-- end .image__link -->
      
        ${bannerText ? `
          <div class="label--banner">
            <p>${bannerText}</p>
          </div>
          <!-- end .label--round -->
        ` : ""}  
        
        ${labelText ? `
          <div class="label--round">
            <p>${labelText}</p>
          </div>
          <!-- end .label--round -->
        ` : ""}
        
        <product-form class="product-form">
          <form action="${window.routes.cart_add_url}" class="js-add-to-cart">
            <input name="productVariant" value="${product.variants[0].id}" type="hidden">
            
            ${hasEngraving || hasMulitpleVariants || hasDyo ? `
              <a href="${productURL}" class="js-add-to-cart add-container button--round">
              <p>${text.view}</p>

              <svg class="hidden-on-desktop" viewBox="0 0 21 14">
                <path
                d="M11.1923 13.602C9.43568 13.637 7.69071 13.6835 5.93411 13.7068C5.23613 13.7185 4.54977 13.7068 3.85179 13.7068C3.72382 13.7068 3.58423 13.6719 3.47953 13.7068C2.74664 13.9398 2.06029 13.6719 1.37394 13.5089C0.617784 13.3225 0.245524 12.682 0.606151 12.0182C1.05984 11.1797 1.10637 10.2829 1.3274 9.40951C1.62986 8.22163 1.93232 7.03375 2.21152 5.83423C2.37438 5.10054 2.88624 4.85597 3.54933 4.82104C3.94485 4.79774 4.35201 4.82104 4.75917 4.82104C6.21331 4.82104 7.67908 4.82104 9.13322 4.82104C10.7037 4.83268 10.8549 4.9142 11.2272 6.42817C11.5994 7.90719 11.9019 9.39786 12.2276 10.8769C12.3323 11.3311 12.4603 11.7736 12.5533 12.2278C12.7511 13.2876 12.4603 13.637 11.4017 13.6603C11.3435 13.6603 11.2737 13.6603 11.2155 13.6603C11.2039 13.6486 11.1923 13.6253 11.1923 13.602ZM9.28445 2.29388C8.16767 0.570293 6.23657 0.2675 4.6661 1.4088C4.01465 1.88628 3.77036 2.61997 3.71219 3.41189C3.68892 3.71468 4.02628 4.00582 4.32874 3.99418C4.58467 3.98253 4.71264 3.83114 4.71264 3.58657C4.74754 2.58503 5.44552 2.15413 6.23657 1.85134C7.05089 1.5369 7.99317 2.00274 8.30727 2.84124C8.4236 3.15568 8.47013 3.49341 8.53993 3.81949C8.60973 4.15722 8.85402 4.34355 9.23792 4.30862C9.54038 4.28533 9.69161 4.09899 9.77304 3.72632C9.61017 3.2372 9.55201 2.70149 9.28445 2.29388Z"/>
                <path
                d="M20.9999 6.84771H18.6043V4.46667H16.8476V6.84771H14.4665V8.60445H16.8476V11H18.6043V8.60445H20.9999V6.84771Z"/>
              </svg>
              
              <svg class="desktop-only" viewBox="0 0 5 10">
                <path
                d="M3.05478 4.74279C2.1956 3.68242 1.77024 2.64305 0.921663 1.58269C0.751947 1.36221 0.614052 1.11025 0.486765 0.858277C0.370085 0.616807 0.50798 0.406833 0.730732 0.375337C1.01713 0.333342 1.32474 0.280849 1.58992 0.522319C2.49154 1.36221 3.28708 2.2861 3.96595 3.30447C4.19931 3.65093 4.46449 3.97639 4.72967 4.29135C4.89939 4.51182 4.95242 4.83728 4.81453 5.07875C4.7721 5.16274 4.70846 5.23623 4.65542 5.32022C3.65834 6.62206 2.66125 7.93439 1.66417 9.23623C1.58992 9.33072 1.52628 9.41471 1.45203 9.5092C1.29292 9.69817 1.13381 9.74017 0.911056 9.55119C0.497372 9.19423 0.454943 9.09975 0.773161 8.6588C1.13381 8.16536 1.06062 7.68242 1.46369 7.23098C1.96224 6.67455 2.46078 6.12862 2.70474 5.40421C2.779 5.19423 2.90628 5.01576 3.05478 4.74279Z"/>
              </svg>
            </a>
            <!-- end .add-product -->

      
            
            ` : `
            <button type="submit" class="js-add-to-cart add-container button--round">
              <svg viewBox="0 0 21 14">
                <path
                d="M11.1923 13.602C9.43568 13.637 7.69071 13.6835 5.93411 13.7068C5.23613 13.7185 4.54977 13.7068 3.85179 13.7068C3.72382 13.7068 3.58423 13.6719 3.47953 13.7068C2.74664 13.9398 2.06029 13.6719 1.37394 13.5089C0.617784 13.3225 0.245524 12.682 0.606151 12.0182C1.05984 11.1797 1.10637 10.2829 1.3274 9.40951C1.62986 8.22163 1.93232 7.03375 2.21152 5.83423C2.37438 5.10054 2.88624 4.85597 3.54933 4.82104C3.94485 4.79774 4.35201 4.82104 4.75917 4.82104C6.21331 4.82104 7.67908 4.82104 9.13322 4.82104C10.7037 4.83268 10.8549 4.9142 11.2272 6.42817C11.5994 7.90719 11.9019 9.39786 12.2276 10.8769C12.3323 11.3311 12.4603 11.7736 12.5533 12.2278C12.7511 13.2876 12.4603 13.637 11.4017 13.6603C11.3435 13.6603 11.2737 13.6603 11.2155 13.6603C11.2039 13.6486 11.1923 13.6253 11.1923 13.602ZM9.28445 2.29388C8.16767 0.570293 6.23657 0.2675 4.6661 1.4088C4.01465 1.88628 3.77036 2.61997 3.71219 3.41189C3.68892 3.71468 4.02628 4.00582 4.32874 3.99418C4.58467 3.98253 4.71264 3.83114 4.71264 3.58657C4.74754 2.58503 5.44552 2.15413 6.23657 1.85134C7.05089 1.5369 7.99317 2.00274 8.30727 2.84124C8.4236 3.15568 8.47013 3.49341 8.53993 3.81949C8.60973 4.15722 8.85402 4.34355 9.23792 4.30862C9.54038 4.28533 9.69161 4.09899 9.77304 3.72632C9.61017 3.2372 9.55201 2.70149 9.28445 2.29388Z"/>
                <path
                d="M20.9999 6.84771H18.6043V4.46667H16.8476V6.84771H14.4665V8.60445H16.8476V11H18.6043V8.60445H20.9999V6.84771Z"/>
              </svg>
            
            <p>${text.add}</p>
            </button>
            <!-- end .add-product -->`}
          
          </form>
          <!-- end .js-add-to-cart -->

        </product-form>
        
      </div>
      <!-- end .image-holder -->
        
      <div class="text-holder">
        <h5>${product.title}</h5>
        <div class="pricing">
          ${hasMulitpleVariants ? `
            <p>${text.from}</p>
          ` : `
          ${hasComparedPrice ? `
            <s>${pricing(product.variants[0].compare_at_price)}</s>
          ` : ""}
          `}
          
          <span class="${!hasMulitpleVariants && hasComparedPrice ? "compare" : ""}">${pricing(product.price)}</span>
        </div>
        <!-- end .pricing -->
        
      </div>
      <!-- end .text-holder -->
      
    </div>
  `;
};

// src/templates/predictiveSearchTemplates.js
var createProductButtonPredictiveSearchElement = (product) => {
  const { url: url3 } = product;
  const { image } = product;
  const { title } = product;
  return `
    <div class="product-button">
      <div class="image-holder">
        <a class="slide__image" href="${url3}">
          <img alt="" src="${image}">
        </a>
        <!-- end .slide__image -->

      </div>
      <!-- end .image-holder -->
  
      <div class="text-holder">
        <h5>${title}</h5>
      </div>
      <!-- end .text-holder -->
  
    </div>
    <!-- end .product-button -->
  `;
};
var createCollectionButtonPredictiveSearchElement = (collection2) => {
  const collectionUrl = collection2.url;
  const featuredImageUrl = collection2.featured_image.url;
  const { title } = collection2;
  return `
    <a class="collection-button color--accent-light" href="${collectionUrl}">
      <div class="image-holder">
        <img alt="" src="${featuredImageUrl}">
      </div>
      <!-- end .image-holder -->

      <div class="text-holder">
        <h5>${title}</h5>
      </div>
      <!-- end .text-holder -->

    </a>
    <!-- end .collection-button -->
  `;
};

// src/templates/collectionAdTemplate.js
var checkIfImageIsJpg = (image) => /jpg/.test(image);
var createCollectionAdElement = (product) => {
  const productImage = product.image;
  const productType = product.type;
  const productBackgroundColor = product.background_color;
  const productText = product.text;
  let classes2 = "";
  let backgroundColor = "";
  let imgClasses = "";
  let textStars = "";
  let imageStars = "";
  switch (productType) {
    case "type_1":
      classes2 = "";
      textStars = "js-has-stars";
      break;
    case "type_2":
      classes2 = "grid-banner--alternative";
      imageStars = "js-has-stars";
      break;
    case "type_3":
      imgClasses = "image--contain";
      textStars = "js-has-stars";
      break;
    case "type_4":
      classes2 = "grid-banner--alternative";
      imageStars = "js-has-stars";
      imgClasses = "image--contain";
      break;
  }
  switch (productBackgroundColor) {
    case "--color-accent-light":
      backgroundColor = "var(--color-accent-light)";
      break;
    case "--color-button-light":
      backgroundColor = "var(--color-button-light)";
      break;
    case "--color-nude":
      backgroundColor = "var(--color-nude)";
      break;
    case "--color-beige":
      backgroundColor = "var(--color-beige)";
      break;
    default:
      backgroundColor = "var(--color-nude)";
      break;
  }
  if (checkIfImageIsJpg(productImage)) {
    textStars = "js-has-stars";
    imageStars = "";
  }
  return `
      <div class="grid-banner ${classes2}" style="background-color: ${backgroundColor}">
        <div class="grid-banner__inner">

          <div class="text-holder ${textStars}">
            ${productText}
          </div>
          <!-- end .text-holder -->

          <div class="image-holder ${imageStars}">
            <div class="mobile-image ${imgClasses}">
              <img alt="" loading="lazy" src="${productImage}">
            </div>
            <div class="desktop-image ${imgClasses}">
              <img alt="" loading="lazy" src="${productImage}">
            </div>
          </div>
          <!-- end .image-holder -->

        </div>
        <!-- end .grid-banner__inner -->
        
      </div>
      <!-- end .grid-banner -->
  `;
};

// src/sections/template.js
var blocksElement = document.getElementById("collection-data");
var blocks = "";
if (blocksElement) {
  blocks = JSON.parse(blocksElement.innerHTML).blocks;
}
var productsToDom = (container, products) => {
  if (!container)
    return false;
  container.innerHTML = "";
  if (blocks.length > 0) {
    blocks.forEach((block) => {
      if (block.position >= products.length)
        return false;
      products.splice(parseFloat(block.position) - 1, 0, block);
    });
  }
  products.forEach((product) => {
    if (product.id) {
      const productButtonElement = createProductButtonElement(product);
      const productElement = `
        <div class="product-grid__item" id="${product.id}">
           ${productButtonElement}
        </div>
      `;
      container.insertAdjacentHTML("beforeend", productElement);
    } else {
      const collectionAdElement = createCollectionAdElement(product);
      const finalItemElement = `
        <div class="product-grid__item product-grid__item--x2">
           ${collectionAdElement}
        </div>
        <!-- end .product-engraving-grid__item product-engraving-grid__item--x2 -->
      `;
      container.insertAdjacentHTML("beforeend", finalItemElement);
    }
  });
  const productButtons = document.querySelectorAll(".product-grid__item");
  productButtons.forEach((button) => {
    button.addEventListener("click", () => {
      sessionStorage.setItem("lastClickedItem", String(button.id));
    });
  });
};

// src/sections/collection.js
var import_axios5 = __toESM(require_axios2(), 1);
var collection = () => {
  const selectPlaceholder = () => {
    const selectSort = document.querySelector(".collection .collection__filter .sort select");
    const placeholder = document.querySelector(".collection .collection__filter .sort .placeholder");
    if (!selectSort || !placeholder)
      return false;
    selectSort.addEventListener("change", (e) => {
      e.preventDefault();
      placeholder.innerHTML = selectSort.options[selectSort.selectedIndex].text;
    });
  };
  const filterOverlay = () => {
    const filterOpen = document.getElementById("open-filters");
    const overlay = document.querySelector(".filter-overlay");
    const filterContainer = document.querySelector(".filters-container");
    const filterClose = document.querySelector(".filter-overlay #close-overlay");
    const filterApply = document.querySelector(".filter-overlay #apply-filters");
    if (!filterOpen)
      return false;
    countActiveFilters();
    filterOpen.addEventListener("click", (e) => {
      e.preventDefault();
      overlay.classList.add("js-open");
    });
    filterClose.addEventListener("click", (e) => {
      e.preventDefault();
      overlay.classList.remove("js-open");
      countActiveFilters();
    });
    filterApply.addEventListener("click", (e) => {
      e.preventDefault();
      overlay.classList.remove("js-open");
    });
    function countActiveFilters() {
      const numOfFilters = filterContainer.querySelectorAll(".group button.js-active");
      if (numOfFilters) {
        const numElement = filterOpen.querySelector(".toggle__icon");
        numElement.innerHTML = numOfFilters.length;
      }
    }
  };
  const filterMain = () => {
    const globals = {
      productsPerPage: 32,
      // Limit 250 -- TODO: Get from window.theme
      totalProductCountElements: document.querySelectorAll(".collection .numOfProducts"),
      jsonLimit: 250,
      products: [],
      productsFiltered: [],
      productsContainer: document.querySelector(".product-grid"),
      filters: [],
      filterButtons: document.querySelectorAll(".filter-overlay .filters .group button"),
      sortSelect: document.getElementById("sortSelect"),
      loadMoreContainer: document.getElementById("filterLoadMoreContainer"),
      loadMoreButton: document.querySelector("#filterLoadMoreContainer button")
    };
    const addFilterInteraction = () => {
      const interactions = sessionStorage.getItem("filterInteractions");
      sessionStorage.setItem("filterInteractions", parseFloat(interactions) + 1);
    };
    const inFromBack = () => performance && performance.getEntriesByType("navigation").map((nav) => nav.type).includes("back_forward");
    const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1) || "";
    const removeFilter = (button) => {
      button.addEventListener("click", (event2) => {
        event2.preventDefault();
        const { value } = button;
        const buttonsArray = Array.from(globals.filterButtons, (node) => node);
        const filterButton = buttonsArray.find((element) => element.dataset.value == value);
        if (filterButton)
          filterButton.classList.remove("js-active");
        urlFunctions.changeParams(globals.filterButtons);
        load.loadFilter();
      });
    };
    const init2 = async () => {
      globals.filters = urlFunctions.getCurrentFilters();
      if (globals.filters.length === 0 && !inFromBack()) {
        sessionStorage.setItem("filterInteractions", 0);
      }
      if (globals.filters.length > 0 || parseFloat(sessionStorage.getItem("filterInteractions")) > 0) {
        globals.products = await load.getProducts();
        addToCart();
        load.loadFilter();
        globals.loadMoreContainer.remove();
        const lastProductID = sessionStorage.getItem("lastClickedItem");
        if (inFromBack() && lastProductID) {
          document.getElementById(lastProductID).scrollIntoView({ behavior: "smooth" });
        }
      } else {
        sessionStorage.setItem("filterInteractions", 0);
        globals.products = await load.getFirstProducts();
        globals.products = load.addPrices(globals.products.products);
        productsToDom(globals.productsContainer, globals.products);
        globals.products = await load.getProducts();
        addToCart();
        globals.loadMoreButton.classList.remove("disabled");
      }
      load.controls();
    };
    const load = {
      /**
       *
       * @returns {json} Data from first X products.
       */
      async getFirstProducts() {
        const url3 = new URL(window.location);
        const dataUrl = `${url3.origin + url3.pathname}/products.json?limit=${globals.productsPerPage}`;
        const res = await import_axios5.default.get(dataUrl);
        return res.data;
      },
      /**
       * Add price to parent level of the json
       *
       */
      addPrices(array) {
        if (!array)
          return false;
        return Array.from(array, (element) => {
          const prices = [];
          let pricesEqual = false;
          element.variants.forEach((variant) => {
            prices.push(variant.price * 100);
          });
          prices.sort();
          const allEqual = (arr) => arr.every((v) => v === arr[0]);
          pricesEqual = allEqual(prices);
          element.price = prices[0];
          element.prices_equal = pricesEqual;
          return element;
        });
      },
      /**
       * Recursive function to grab all products in chunks of 250
       *
       *
       */
      async getProducts() {
        const collectionDataNode = document.getElementById("collection-data");
        if (collectionDataNode) {
          const collectionData = JSON.parse(collectionDataNode.innerHTML);
          globals.totalProductCount = collectionData.product_count;
        }
        const partials = Math.ceil(globals.totalProductCount / globals.jsonLimit);
        const url3 = new URL(window.location);
        const products = [];
        const promises = [];
        let page = 1;
        for (let index = 0; index < partials; index++) {
          const dataUrl = `${url3.origin + url3.pathname}/products.json?limit=${globals.jsonLimit}&page=${page}`;
          promises.push(import_axios5.default.get(dataUrl).then((response) => products.push(response.data.products)));
          page++;
        }
        const promise = Promise.all(promises).then(() => globals.products = Array.from(new Set(products.flat())));
        return await promise;
      },
      /**
       * Load the filter
       *
       */
      loadFilter() {
        globals.loadMoreContainer.remove();
        globals.filters = urlFunctions.getCurrentFilters();
        urlFunctions.setCurrentButtons(globals.filters, globals.filterButtons);
        globals.productsFiltered = filterProducts(globals.products, globals.filters);
        globals.productsFiltered = load.addPrices(globals.productsFiltered);
        globals.productsFiltered.sort(sortProducts(globals.sortSelect));
        globals.totalProductCountElements.forEach((element) => {
          element.innerHTML = globals.productsFiltered.length;
        });
        productsToDom(globals.productsContainer, globals.productsFiltered);
        const numOfFilters = globals.filters.length;
        const toggleIcon = document.querySelector(".toggle .toggle__icon");
        const desktopActiveFilters = document.querySelector(".collection__filter .active-filters");
        desktopActiveFilters.innerHTML = "";
        toggleIcon.innerHTML = numOfFilters;
        globals.filters.forEach((filter) => {
          const filterName = filter.split("_")[1].replace("-", " ");
          const button = document.createElement("button");
          button.innerHTML = capitalize(filterName);
          button.value = filter;
          desktopActiveFilters.appendChild(button);
          removeFilter(button);
        });
      },
      /**
       * Controls
       *
       * Attach handlers to the buttons and other interactive components of the filter
       */
      controls() {
        const initFilterButtons = () => {
          globals.filterButtons.forEach((button) => {
            button.addEventListener("click", (event2) => {
              event2.preventDefault();
              button.classList.toggle("js-active");
              urlFunctions.changeParams(globals.filterButtons);
              addFilterInteraction();
              load.loadFilter();
            });
          });
        };
        const initSortButton = () => {
          globals.sortSelect.addEventListener("change", (event2) => {
            event2.preventDefault();
            addFilterInteraction();
            load.loadFilter();
          });
        };
        const initLoadMoreButton = () => {
          globals.loadMoreButton.addEventListener("click", (event2) => {
            event2.preventDefault();
            addFilterInteraction();
            load.loadFilter();
          });
        };
        initFilterButtons();
        initSortButton();
        initLoadMoreButton();
      }
    };
    init2();
  };
  selectPlaceholder();
  filterOverlay();
  filterMain();
};

// src/sections/footer.js
var import_flickity2 = __toESM(require_js(), 1);
var footer = () => {
  const footerMenuToggle = () => {
    const buttons = document.querySelectorAll(
      ".footer .footer__menus .item button"
    );
    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        button.classList.toggle("js-open");
      });
    });
  };
  const createReviewElement = (reviewObject) => {
    const { title } = reviewObject;
    const { text: text2 } = reviewObject;
    const createdAt = new Date(reviewObject.createdAt);
    const { author } = reviewObject;
    const { stars } = reviewObject;
    const starIcon = `
      <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
        <rect fill="#00B67A" height="18" width="18" />
        <path
            d="M9 3L10.3471 7.1459H14.7063L11.1796 9.7082L12.5267 13.8541L9 11.2918L5.47329 13.8541L6.82037 9.7082L3.29366 7.1459H7.65292L9 3Z"
            fill="white" />
      </svg>
    `;
    let starElement = "";
    for (let i = 0; i < stars; i++) {
      starElement += starIcon;
    }
    console.log(createdAt.getMonth());
    return `
      <div class="review-slider__item slide">
      
        <div class="score">
          <div class="star-rating">
            ${starElement}
          </div>
          <div class="date">${createdAt.getDate()} - ${createdAt.getMonth() + 1} - ${createdAt.getFullYear()}</div>
        </div>

        <div class="content">
          <h4>${title}</h4>
          <p>${text2}</p>
          <h6 class="author">${author}</h6>
        </div>

      </div>
      <!-- end .review-slider__item -->
    `;
  };
  const setReviewInFooterReviewElement = (review, flkty) => {
    flkty.prepend(createElementFromHTML(createReviewElement(review)));
  };
  const handleFooterReviews = () => {
    const footerReviewElement = document.querySelector(
      ".footer-reviews .review-slider .slider"
    );
    if (footerReviewElement) {
      const language = footerReviewElement.dataset.language ? footerReviewElement.dataset.language : "";
      const flkty = new import_flickity2.default(footerReviewElement);
      fetchReviewsFromTrustPilot(language).then((reviews) => {
        if (reviews) {
          reviews.forEach((review) => {
            setReviewInFooterReviewElement(review, flkty);
          });
        }
      }).then(() => {
        flkty.select(0);
      });
    }
  };
  footerMenuToggle();
  handleFooterReviews();
};

// src/sections/productHelpers.js
var productHelpers = () => {
  const checkStickyDetails = () => {
    const productTextElement = document.querySelector(
      ".product-intro .text-holder"
    );
    if (productTextElement !== null) {
      const onResizing = () => {
        const topOffset = 200;
        const elementHeight = productTextElement.offsetHeight + topOffset;
        const pageHeight = window.innerHeight;
        if (elementHeight > pageHeight) {
          productTextElement.classList.add("non-sticky");
        }
      };
      window.onresize = onResizing;
      window.onload = onResizing;
      window.addEventListener("load", () => {
        onResizing();
      });
    }
  };
  const isAddToBagInView = () => {
    const addToBagElement = document.querySelector("#addToBagButton");
    const mobileOverviewElement = document.querySelector(
      ".mobile-product-overview--small"
    );
    if (addToBagElement !== null && mobileOverviewElement !== null) {
      const pageHeight = window.innerHeight;
      const checkIfButtonIsInView = () => {
        const positionButton = addToBagElement.getBoundingClientRect().top;
        if (positionButton < 0) {
          mobileOverviewElement.classList.remove("hidden");
        } else if (positionButton > pageHeight) {
          mobileOverviewElement.classList.remove("hidden");
        } else if (positionButton < pageHeight && positionButton > 0) {
          mobileOverviewElement.classList.add("hidden");
        }
      };
      window.addEventListener("load", checkIfButtonIsInView, false);
      window.addEventListener("scroll", checkIfButtonIsInView, false);
    }
  };
  const setVariant = (variantID) => {
    const variantSelects = document.querySelectorAll(
      ".product-variants .variant.variant--primary select"
    );
    const currentVariant = getCorrectVariant(variantSelects);
    variantID.value = currentVariant.id;
    setVariantImage();
    checkAvailability(currentVariant);
    setPrice(currentVariant);
  };
  function setPrice(variant) {
    const priceContainer = document.querySelector(".price-holder p");
    const earpartyForm = document.querySelectorAll(".js-earparty");
    if (earpartyForm && earpartyForm.length > 0)
      return false;
    if (variant.compare_at_price) {
      priceContainer.innerHTML = `<s>${pricing(
        variant.compare_at_price
      )}</s> <span>${pricing(variant.price)}</span>`;
    } else {
      priceContainer.innerHTML = `<span>${pricing(variant.price)}</span>`;
    }
  }
  const getCorrectVariant = (variantSelects) => {
    const variantsDataElement = document.getElementById("variants-data");
    let variantsData = "";
    if (variantsDataElement) {
      variantsData = JSON.parse(variantsDataElement.innerHTML).variants;
    }
    let selectedOptions = "";
    variantSelects.forEach((select) => {
      selectedOptions = `${selectedOptions} - ${select.value}`;
    });
    selectedOptions = selectedOptions.slice(3);
    return variantsData.find((element) => element.options === selectedOptions);
  };
  const checkAvailability = (variant) => {
    if (variant.available) {
      setButtonAvailable(true);
      if (variant.quantity > 0) {
        setMaxQuantity(variant.quantity);
      } else {
        setMaxQuantity(50);
      }
    } else {
      setButtonAvailable(false);
    }
  };
  const setButtonAvailable = (state) => {
    const addToCartButtons = document.querySelectorAll(
      "#addToBagButton, #addToBagButtonMobile"
    );
    if (state === true) {
      addToCartButtons.forEach((button) => {
        button.classList.remove("js-unavailable");
        button.innerHTML = button.innerHTML.replace(
          text.sold_out,
          text.add_to_cart
        );
        button.innerHTML = button.innerHTML.replace(text.sold_out, text.add);
      });
    } else {
      addToCartButtons.forEach((button) => {
        button.classList.add("js-unavailable");
        button.innerHTML = button.innerHTML.replace(
          text.add_to_cart,
          text.sold_out
        );
        button.innerHTML = button.innerHTML.replace(text.add, text.sold_out);
      });
    }
  };
  const disableCartButtons = () => {
    const addToCartButton = document.querySelector("#addToBagButton");
    const ctaAddToCartButton = document.querySelector("#ctaAddToBagButton");
    if (addToCartButton) {
      addToCartButton.classList.add("js-disabled");
    }
    if (ctaAddToCartButton) {
      ctaAddToCartButton.classList.add("js-disabled");
    }
  };
  const enableCartButtons = () => {
    const addToCartButton = document.querySelector("#addToBagButton");
    const ctaAddToCartButton = document.querySelector("#ctaAddToBagButton");
    if (addToCartButton) {
      addToCartButton.classList.remove("js-disabled");
    }
    if (ctaAddToCartButton) {
      ctaAddToCartButton.classList.remove("js-disabled");
    }
  };
  const setMaxQuantity = (maxQuantity) => {
    if (maxQuantity < 0)
      maxQuantity = 10;
    const quantityInput = document.querySelector("#quantity");
    Array.from(quantityInput.options).forEach((option) => {
      if (option.value > maxQuantity) {
        option.disabled = true;
      } else {
        option.disabled = false;
      }
    });
  };
  const isOptionValueEmpty = (selectedOptionElement) => {
    const optionValue = selectedOptionElement.value;
    return optionValue.length <= 0;
  };
  const handleSelectValue = (selectElement) => {
    if (selectElement) {
      const selectedOptionElement = selectElement;
      if (isOptionValueEmpty(selectedOptionElement)) {
        disableCartButtons();
      } else {
        enableCartButtons();
      }
    }
  };
  const variantOptions = () => {
    const variantID = document.getElementById("productVariant");
    if (!variantID)
      return;
    if (variantID.classList.contains("multiple-variants")) {
      const variantSelects = document.querySelectorAll(
        ".product-variants .variant select"
      );
      const variantsDataElement = document.getElementById("variants-data");
      if (variantsDataElement) {
        variantSelects.forEach((select, index) => {
          const selectedOption = select.options[select.selectedIndex];
          handleSelectValue(selectedOption);
        });
      }
      variantSelects.forEach((select) => {
        select.addEventListener("change", () => {
          const selectedOption = select.options[select.selectedIndex];
          setVariant(variantID);
          handleSelectValue(selectedOption);
        });
      });
      const backsideCheckbox = document.getElementById("backsideEngraving");
      const backsideVariantSelect = document.getElementById(
        "variant-backside-engraved"
      );
      const backsideEngravingFields = document.querySelectorAll(
        ".product-variants .variant.variant--backside"
      );
      const backsideEngravingImage = document.querySelector(
        ".slide--hero-image.slide--engraving-backside"
      );
      if (backsideCheckbox && backsideVariantSelect) {
        backsideVariantSelect.value = "no";
        setVariant(variantID);
        backsideEngravingFields.forEach(
          (element) => element.classList.add("variant--hidden")
        );
        if (backsideEngravingImage)
          backsideEngravingImage.classList.add("slide--hidden");
        backsideCheckbox.addEventListener("change", (event2) => {
          event2.preventDefault();
          if (backsideCheckbox.checked === true) {
            backsideVariantSelect.value = "yes";
            setVariant(variantID);
            backsideEngravingFields.forEach(
              (element) => element.classList.remove("variant--hidden")
            );
            if (backsideEngravingImage)
              backsideEngravingImage.classList.remove("slide--hidden");
          } else {
            backsideVariantSelect.value = "no";
            setVariant(variantID);
            backsideEngravingFields.forEach(
              (element) => element.classList.add("variant--hidden")
            );
            if (backsideEngravingImage)
              backsideEngravingImage.classList.add("slide--hidden");
          }
        });
      }
    }
  };
  const multipleInitials = () => {
    const initialsInput = document.querySelector("#multipleInitials");
    if (!initialsInput)
      return false;
    const variantInput = document.querySelector(
      ".product-variants .variant.variant--hidden select"
    );
    initialsInput.addEventListener("input", (event2) => {
      event2.preventDefault();
      handleSelectValue(initialsInput);
      let size = parseFloat(initialsInput.value.length);
      if (size === 0)
        size = 1;
      variantInput.value = size;
      variantInput.dispatchEvent(new Event("change"));
    });
  };
  const calcEarpartySaving = () => {
    const earpartyElement = document.getElementById("earparty-data");
    if (window.earparty && window.earparty.length > 0) {
      const earpartyData = JSON.parse(earpartyElement.innerHTML);
      const savingsElement = document.querySelector(".js-set-savings span");
      let productsTotalPrice = 0;
      window.earparty.forEach((product) => {
        productsTotalPrice += product.price;
      });
      const savings = productsTotalPrice - earpartyData.set_price;
      savingsElement.innerHTML = pricing(savings);
    }
  };
  const engravingCheckbox = () => {
    const checkbox = document.querySelector("#acceptEngraving");
    if (checkbox) {
      if (checkbox.checked === false) {
        disableCartButtons();
      }
      checkbox.addEventListener("change", () => {
        if (checkbox.checked === false) {
          disableCartButtons();
        } else {
          enableCartButtons();
        }
      });
    }
  };
  checkStickyDetails();
  isAddToBagInView();
  variantOptions();
  multipleInitials();
  calcEarpartySaving();
  engravingCheckbox();
};

// src/sections/relatedProducts.js
var relatedProducts = () => {
  const handleRelatedProducts = () => {
    const relatedProductsElement = document.querySelector(".related-products");
    if (!relatedProductsElement)
      return false;
    const productId = relatedProductsElement.dataset.productId ? relatedProductsElement.dataset.productId : null;
    const limit = relatedProductsElement ? relatedProductsElement.dataset.limit : 3;
    if (productId) {
      fetchRelatedProducts(productId, limit);
    }
  };
  handleRelatedProducts();
};

// src/sections/productEngraving.js
var productEngraving = () => {
  const resetFontClass = (element) => {
    element.classList.remove("font--gilroy");
    element.classList.remove("font--avenir");
    element.classList.remove("font--bentham");
    element.classList.remove("font--cutivemono");
    element.classList.remove("font--moonflower");
  };
  const getCurrentImage = (form) => {
    let frontside = true;
    if (form.classList.contains("engraving--backside"))
      frontside = false;
    let image = false;
    if (frontside) {
      image = document.querySelector(
        ".slide--hero-image.slide--engraving-frontside"
      );
    } else {
      image = document.querySelector(
        ".slide--hero-image.slide--engraving-backside"
      );
    }
    return image;
  };
  const handleFontInput = (form, inputFonts, inputText) => {
    inputFonts.forEach((input) => {
      input.addEventListener("change", (event2) => {
        event2.preventDefault();
        resetFontClass(inputText);
        inputText.classList.add(input.dataset.font);
        const image = getCurrentImage(form);
        if (image) {
          const imageTextelement = image.querySelector(".engrave-text p");
          resetFontClass(imageTextelement);
          imageTextelement.classList.add(input.dataset.font);
        }
      });
    });
  };
  const updateImage = (image, text2) => {
    const textElement = image.querySelector(".engrave-text p");
    if (textElement)
      textElement.innerHTML = text2;
  };
  const handleTextInput = (form, input) => {
    const image = getCurrentImage(form);
    input.addEventListener("input", () => {
      if (image)
        updateImage(image, input.value);
    });
  };
  const addIcon = (input, icon) => {
    const maxLength = input.maxLength ? input.maxLength : 1;
    if (input.value.length >= maxLength) {
      alert("Max length of engraving reached");
    } else {
      input.value += icon;
      const inputEvent = new Event("input", {
        bubbles: true,
        cancelable: true
      });
      input.dispatchEvent(inputEvent);
    }
  };
  const handleIconInput = (form, iconContainer, input) => {
    if (!iconContainer)
      return false;
    const buttons = iconContainer.querySelectorAll("button");
    buttons.forEach((button) => {
      console.log(button);
      button.addEventListener("click", (event2) => {
        event2.preventDefault();
        console.log("click");
        const type = button.dataset.icon;
        let icon = "";
        switch (type) {
          case "star-icon":
            icon = "\u2605";
            break;
          case "heart-icon":
            icon = "\u2665";
            break;
          default:
            icon = "";
        }
        addIcon(input, icon);
      });
    });
  };
  const initForm = (form) => {
    const inputFonts = form.querySelectorAll('input[type="radio"]');
    const inputSelector = form.querySelector("#engraving-text");
    const inputText = inputSelector || form.querySelector("#engraving-text-backside");
    const iconContainer = form.querySelector(".engraving-icon-selector") ? form.querySelector(".engraving-icon-selector") : "";
    handleFontInput(form, inputFonts, inputText);
    handleTextInput(form, inputText);
    handleIconInput(form, iconContainer, inputText);
  };
  const productEngraving2 = () => {
    const forms = document.querySelectorAll(".variant.engraving");
    if (forms.length > 0) {
      forms.forEach((form) => initForm(form));
    }
  };
  productEngraving2();
};

// src/sections/cookie.js
var import_js_cookie = __toESM(require_js_cookie(), 1);
var cookie = () => {
  const checkIfCookiesAreSet = () => {
    const isCookieAllowed = import_js_cookie.default.get("cookieAllowed");
    if (isCookieAllowed !== void 0) {
      return isCookieAllowed;
    }
    return false;
  };
  const handleDeclineCookie = () => {
    import_js_cookie.default.set("cookieAllowed", "false", { expires: 31 });
  };
  const handleAcceptCookie = () => {
    import_js_cookie.default.set("cookieAllowed", "true", { expires: 31 });
  };
  const setAllCookie = () => {
  };
  const initializeCookieBanner = () => {
    const cookieBannerElement = document.querySelector(".cookie-banner");
    if (cookieBannerElement !== null) {
      const cookieButtonComply = cookieBannerElement.querySelector(
        "#cookieButtonComply"
      );
      const cookieButtonCloseBanner = cookieBannerElement.querySelector(".close-button");
      const openCookieBanner = () => {
        cookieBannerElement.classList.add("visible");
      };
      const closeCookieBanner = () => {
        cookieBannerElement.classList.remove("visible");
      };
      if (checkIfCookiesAreSet() === false) {
        openCookieBanner();
      }
      if (cookieButtonComply) {
        cookieButtonComply.addEventListener("click", () => {
          closeCookieBanner();
          handleAcceptCookie();
          setAllCookie();
        });
      }
      if (cookieButtonCloseBanner) {
        cookieButtonCloseBanner.addEventListener("click", () => {
          closeCookieBanner();
          handleDeclineCookie();
        });
      }
    }
  };
  initializeCookieBanner();
};

// src/sections/search.js
var search2 = () => {
  const init2 = () => {
    selectPlaceholder();
  };
  const selectPlaceholder = () => {
    const selectSort = document.querySelector(
      ".search-page .search-page__filter .sort select"
    );
    const placeholder = document.querySelector(
      ".search-page .search-page__filter .sort .placeholder"
    );
    if (!selectSort || !placeholder)
      return false;
    selectSort.addEventListener("change", (e) => {
      e.preventDefault();
      placeholder.innerHTML = selectSort.options[selectSort.selectedIndex].text;
    });
  };
  return {
    init: init2
  };
};

// src/sections/breadcrumbs.js
var breadcrumbs = () => {
  const init2 = () => {
    scrollBreadcrumbs();
  };
  const scrollBreadcrumbs = () => {
    const allBreadcrumbElement = document.querySelectorAll(".breadcrumbs");
    if (allBreadcrumbElement.length > 0) {
      allBreadcrumbElement.forEach((breadcrumbElement) => {
        const highNumber = 1e4;
        const listElement = breadcrumbElement.querySelector(".breadcrumbs__list");
        if (listElement !== null) {
          listElement.scrollLeft = highNumber;
        }
      });
    }
  };
  return {
    init: init2
  };
};

// src/sections/forgotPassword.js
var forgotPassword = () => {
  const init2 = () => {
    handleForgotPassword();
  };
  const handleForgotPassword = () => {
    const forgotPasswordButton = document.querySelector("#forgotPassword");
    const closeModalButton = document.querySelector("#closeModal");
    const forgotPasswordModal = document.querySelector(
      ".forgot-password-modal"
    );
    if (forgotPasswordButton !== null && forgotPasswordModal !== null && closeModalButton !== null) {
      const openModal = () => {
        forgotPasswordModal.classList.add("visible");
      };
      const closeModal = () => {
        forgotPasswordModal.classList.remove("visible");
      };
      forgotPasswordButton.addEventListener("click", (event2) => {
        event2.preventDefault();
        openModal();
      });
      closeModalButton.addEventListener("click", (event2) => {
        event2.preventDefault();
        closeModal();
      });
    }
  };
  return {
    init: init2
  };
};

// node_modules/@shopify/theme-predictive-search/src/validate.js
function validateQuery(query3) {
  var error;
  if (query3 === null || query3 === void 0) {
    error = new TypeError("'query' is missing");
    error.type = "argument";
    throw error;
  }
  if (typeof query3 !== "string") {
    error = new TypeError("'query' is not a string");
    error.type = "argument";
    throw error;
  }
}

// node_modules/@shopify/theme-predictive-search/src/utilities/CustomError.js
function GenericError() {
  var error = Error.call(this);
  error.name = "Server error";
  error.message = "Something went wrong on the server";
  error.status = 500;
  return error;
}
function NotFoundError(status) {
  var error = Error.call(this);
  error.name = "Not found";
  error.message = "Not found";
  error.status = status;
  return error;
}
function ServerError() {
  var error = Error.call(this);
  error.name = "Server error";
  error.message = "Something went wrong on the server";
  error.status = 500;
  return error;
}
function ContentTypeError(status) {
  var error = Error.call(this);
  error.name = "Content-Type error";
  error.message = "Content-Type was not provided or is of wrong type";
  error.status = status;
  return error;
}
function JsonParseError(status) {
  var error = Error.call(this);
  error.name = "JSON parse error";
  error.message = "JSON syntax error";
  error.status = status;
  return error;
}
function ThrottledError(status, name, message, retryAfter) {
  var error = Error.call(this);
  error.name = name;
  error.message = message;
  error.status = status;
  error.retryAfter = retryAfter;
  return error;
}
function InvalidParameterError(status, name, message) {
  var error = Error.call(this);
  error.name = name;
  error.message = message;
  error.status = status;
  return error;
}
function ExpectationFailedError(status, name, message) {
  var error = Error.call(this);
  error.name = name;
  error.message = message;
  error.status = status;
  return error;
}

// node_modules/@shopify/theme-predictive-search/src/request.js
function request(searchPath, configParams, query3, onSuccess, onError) {
  var xhr = new XMLHttpRequest();
  var route = searchPath + "/suggest.json";
  xhr.onreadystatechange = function() {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      var contentType = xhr.getResponseHeader("Content-Type");
      if (xhr.status >= 500) {
        onError(new ServerError());
        return;
      }
      if (xhr.status === 404) {
        onError(new NotFoundError(xhr.status));
        return;
      }
      if (typeof contentType !== "string" || contentType.toLowerCase().match("application/json") === null) {
        onError(new ContentTypeError(xhr.status));
        return;
      }
      if (xhr.status === 417) {
        try {
          var invalidParameterJson = JSON.parse(xhr.responseText);
          onError(
            new InvalidParameterError(
              xhr.status,
              invalidParameterJson.message,
              invalidParameterJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }
        return;
      }
      if (xhr.status === 422) {
        try {
          var expectationFailedJson = JSON.parse(xhr.responseText);
          onError(
            new ExpectationFailedError(
              xhr.status,
              expectationFailedJson.message,
              expectationFailedJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }
        return;
      }
      if (xhr.status === 429) {
        try {
          var throttledJson = JSON.parse(xhr.responseText);
          onError(
            new ThrottledError(
              xhr.status,
              throttledJson.message,
              throttledJson.description,
              xhr.getResponseHeader("Retry-After")
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }
        return;
      }
      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          res.query = query3;
          onSuccess(res);
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }
        return;
      }
      try {
        var genericErrorJson = JSON.parse(xhr.responseText);
        onError(
          new GenericError(
            xhr.status,
            genericErrorJson.message,
            genericErrorJson.description
          )
        );
      } catch (error) {
        onError(new JsonParseError(xhr.status));
      }
      return;
    }
  };
  xhr.open(
    "get",
    route + "?q=" + encodeURIComponent(query3) + "&" + configParams
  );
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send();
}

// node_modules/@shopify/theme-predictive-search/src/utilities/Cache.js
function Cache(config) {
  this._store = {};
  this._keys = [];
  if (config && config.bucketSize) {
    this.bucketSize = config.bucketSize;
  } else {
    this.bucketSize = 20;
  }
}
Cache.prototype.set = function(key, value) {
  if (this.count() >= this.bucketSize) {
    var deleteKey = this._keys.splice(0, 1);
    this.delete(deleteKey);
  }
  this._keys.push(key);
  this._store[key] = value;
  return this._store;
};
Cache.prototype.get = function(key) {
  return this._store[key];
};
Cache.prototype.has = function(key) {
  return Boolean(this._store[key]);
};
Cache.prototype.count = function() {
  return Object.keys(this._store).length;
};
Cache.prototype.delete = function(key) {
  var exists = Boolean(this._store[key]);
  delete this._store[key];
  return exists && !this._store[key];
};

// node_modules/@shopify/theme-predictive-search/src/utilities/Dispatcher.js
function Dispatcher() {
  this.events = {};
}
Dispatcher.prototype.on = function(eventName, callback) {
  var event2 = this.events[eventName];
  if (!event2) {
    event2 = new DispatcherEvent(eventName);
    this.events[eventName] = event2;
  }
  event2.registerCallback(callback);
};
Dispatcher.prototype.off = function(eventName, callback) {
  var event2 = this.events[eventName];
  if (event2 && event2.callbacks.indexOf(callback) > -1) {
    event2.unregisterCallback(callback);
    if (event2.callbacks.length === 0) {
      delete this.events[eventName];
    }
  }
};
Dispatcher.prototype.dispatch = function(eventName, payload) {
  var event2 = this.events[eventName];
  if (event2) {
    event2.fire(payload);
  }
};
function DispatcherEvent(eventName) {
  this.eventName = eventName;
  this.callbacks = [];
}
DispatcherEvent.prototype.registerCallback = function(callback) {
  this.callbacks.push(callback);
};
DispatcherEvent.prototype.unregisterCallback = function(callback) {
  var index = this.callbacks.indexOf(callback);
  if (index > -1) {
    this.callbacks.splice(index, 1);
  }
};
DispatcherEvent.prototype.fire = function(payload) {
  var callbacks = this.callbacks.slice(0);
  callbacks.forEach(function(callback) {
    callback(payload);
  });
};

// node_modules/@shopify/theme-predictive-search/src/utilities/debounce.js
function debounce(func, wait) {
  var timeout = null;
  return function() {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      func.apply(context, args);
    }, wait || 0);
  };
}

// node_modules/@shopify/theme-predictive-search/src/utilities/objectToQueryParams.js
function objectToQueryParams(obj, parentKey) {
  var output = "";
  parentKey = parentKey || null;
  Object.keys(obj).forEach(function(key) {
    var outputKey = key + "=";
    if (parentKey) {
      outputKey = parentKey + "[" + key + "]";
    }
    switch (trueTypeOf(obj[key])) {
      case "object":
        output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
        break;
      case "array":
        output += outputKey + "=" + obj[key].join(",") + "&";
        break;
      default:
        if (parentKey) {
          outputKey += "=";
        }
        output += outputKey + encodeURIComponent(obj[key]) + "&";
        break;
    }
  });
  return output;
}
function trueTypeOf(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}

// node_modules/@shopify/theme-predictive-search/src/theme-predictive-search.js
var DEBOUNCE_RATE = 10;
var requestDebounced = debounce(request, DEBOUNCE_RATE);
function PredictiveSearch(config) {
  if (!config) {
    throw new TypeError("No config object was specified");
  }
  var configParameters = config;
  this._retryAfter = null;
  this._currentQuery = null;
  this.dispatcher = new Dispatcher();
  this.cache = new Cache({ bucketSize: 40 });
  this.searchPath = configParameters.search_path || "/search";
  if (configParameters.search_path) {
    delete configParameters["search_path"];
  }
  this.configParams = objectToQueryParams(configParameters);
}
PredictiveSearch.SEARCH_PATH = "/search";
PredictiveSearch.TYPES = {
  PRODUCT: "product",
  PAGE: "page",
  ARTICLE: "article",
  COLLECTION: "collection"
};
PredictiveSearch.FIELDS = {
  AUTHOR: "author",
  BODY: "body",
  PRODUCT_TYPE: "product_type",
  TAG: "tag",
  TITLE: "title",
  VARIANTS_BARCODE: "variants.barcode",
  VARIANTS_SKU: "variants.sku",
  VARIANTS_TITLE: "variants.title",
  VENDOR: "vendor"
};
PredictiveSearch.UNAVAILABLE_PRODUCTS = {
  SHOW: "show",
  HIDE: "hide",
  LAST: "last"
};
PredictiveSearch.prototype.query = function query(query) {
  try {
    validateQuery(query);
  } catch (error) {
    this.dispatcher.dispatch("error", error);
    return;
  }
  if (query === "") {
    return this;
  }
  this._currentQuery = normalizeQuery(query);
  var cacheResult = this.cache.get(this._currentQuery);
  if (cacheResult) {
    this.dispatcher.dispatch("success", cacheResult);
    return this;
  }
  requestDebounced(
    this.searchPath,
    this.configParams,
    query,
    function(result) {
      this.cache.set(normalizeQuery(result.query), result);
      if (normalizeQuery(result.query) === this._currentQuery) {
        this._retryAfter = null;
        this.dispatcher.dispatch("success", result);
      }
    }.bind(this),
    function(error) {
      if (error.retryAfter) {
        this._retryAfter = error.retryAfter;
      }
      this.dispatcher.dispatch("error", error);
    }.bind(this)
  );
  return this;
};
PredictiveSearch.prototype.on = function on(eventName, callback) {
  this.dispatcher.on(eventName, callback);
  return this;
};
PredictiveSearch.prototype.off = function on2(eventName, callback) {
  this.dispatcher.off(eventName, callback);
  return this;
};
function normalizeQuery(query3) {
  if (typeof query3 !== "string") {
    return null;
  }
  return query3.trim().replace(" ", "-").toLowerCase();
}

// src/sections/predictiveSearch.js
var predictiveSearch = () => {
  const locale = () => {
    const windowPublishedLocale = window.published_locales;
    const allPublishedLocales = windowPublishedLocale ? JSON.parse(window.published_locales) : null;
    let primaryLocale = null;
    if (allPublishedLocales !== null) {
      allPublishedLocales.forEach((locale2) => {
        if (locale2.shop_locale ? locale2.shop_locale.primary : false) {
          primaryLocale = locale2.shop_locale.locale;
        }
      });
    }
    if (primaryLocale === Shopify.locale) {
      return "";
    }
    return Shopify.locale;
  };
  const predictiveSearchProduct = new PredictiveSearch({
    search_path: `${locale()}/search`,
    resources: {
      type: ["product", "collection"],
      limit: 8,
      options: {
        unavailable_products: "hide"
      }
    }
  });
  const clearItemsFromProductResults = () => {
    const listElement = document.querySelector(
      ".main-menu .product__results .items"
    );
    const mobileListElement = document.querySelector(
      ".mobile-menu .search__results .items"
    );
    listElement.innerHTML = "";
    mobileListElement.innerHTML = "";
  };
  const clearItemsFromCollectionResults = () => {
    const listElement = document.querySelector(
      ".main-menu .collection__results .items"
    );
    const mobileListElement = document.querySelector(
      ".mobile-menu .collection__results .items"
    );
    listElement.innerHTML = "";
    mobileListElement.innerHTML = "";
  };
  const insertProductInSearchResultElement = (product) => {
    const mobileListElement = document.querySelector(
      ".mobile-menu .search__results .items"
    );
    const listElement = document.querySelector(".product__results .items");
    const productElement = createProductButtonPredictiveSearchElement(product);
    if (mobileListElement !== null) {
      mobileListElement.insertAdjacentHTML("beforeend", productElement);
    }
    if (listElement !== null) {
      listElement.insertAdjacentHTML("beforeend", productElement);
    }
  };
  const insertCollectionInSearchResultElement = (collection2) => {
    const mobileListElement = document.querySelector(
      ".mobile-menu .collection__results .items"
    );
    const listElement = document.querySelector(".collection__results .items");
    const isCollectionHidden = collection2.title ? collection2.title.includes(" | hidden") : false;
    if (isCollectionHidden) {
    } else {
      const collectionElement = createCollectionButtonPredictiveSearchElement(collection2);
      if (mobileListElement !== null) {
        mobileListElement.insertAdjacentHTML("beforeend", collectionElement);
      }
      if (listElement !== null) {
        listElement.insertAdjacentHTML("beforeend", collectionElement);
      }
    }
  };
  const showElement = (element) => {
    if (element !== null) {
      element.classList.remove("js-hidden");
      hideOnClickOutside2();
    }
  };
  const hideOnClickOutside2 = () => {
    const outsideClickListener = (event2) => {
      const { target } = event2;
      const cartDrawerElement = document.querySelector(".search__results");
      const cartDrawerOpener = document.querySelector(".item--search");
      if (target !== cartDrawerElement && target.closest(".search__results") || target.closest(".item--search") === cartDrawerOpener) {
      } else {
        const productResultsElement = document.querySelector(".product__results");
        const mobileProductResultsElement = document.querySelector(".product__results");
        const collectionResultsElement = document.querySelector(
          ".collection__results"
        );
        const mobileCollectionResultsElement = document.querySelector(
          ".collection__results"
        );
        hideElement(productResultsElement);
        hideElement(mobileProductResultsElement);
        hideElement(collectionResultsElement);
        hideElement(mobileCollectionResultsElement);
        removeClickListener();
      }
    };
    const removeClickListener = () => {
      document.removeEventListener("click", outsideClickListener);
    };
    document.addEventListener("click", outsideClickListener);
  };
  const hideElement = (element) => {
    if (element !== null) {
      element.classList.add("js-hidden");
    }
  };
  const updateAllProductLink = (inputValue) => {
    const allProductLinkElement = document.querySelector(
      ".main-menu .all-product-link"
    );
    const mobileAllProductLinkElement = document.querySelector(
      ".mobile-menu .all-product-link"
    );
    if (allProductLinkElement !== null && mobileAllProductLinkElement !== null) {
      const { baseUrl } = allProductLinkElement.dataset;
      allProductLinkElement.href = baseUrl + encodeURIComponent(inputValue);
      mobileAllProductLinkElement.href = baseUrl + encodeURIComponent(inputValue);
    }
  };
  const handlePredictiveSearch = () => {
    const menuElement = document.querySelector(".main-menu");
    const searchItemElement = menuElement ? menuElement.querySelector(".item--search") : null;
    const productResultsElement = menuElement ? menuElement.querySelector(".product__results") : null;
    const collectionResultsElement = menuElement ? menuElement.querySelector(".collection__results") : null;
    const searchInputElement = searchItemElement ? searchItemElement.querySelector("#search") : null;
    const mobileMenuElement = document.querySelector(".mobile-menu");
    const mobileProductResultsElement = mobileMenuElement ? mobileMenuElement.querySelector(".product__results") : null;
    const mobileCollectionResultsElement = mobileMenuElement ? mobileMenuElement.querySelector(".collection__results") : null;
    const mobileSearchInputElement = mobileMenuElement ? mobileMenuElement.querySelector("#mobileSearch") : null;
    if (searchInputElement !== null && mobileSearchInputElement !== null) {
      const handleInputChange = () => {
        const desktopInputValue = searchInputElement ? searchInputElement.value : null;
        const mobileInputValue = mobileSearchInputElement ? mobileSearchInputElement.value : null;
        let inputValue = null;
        if (desktopInputValue.length > 0) {
          inputValue = desktopInputValue;
        }
        if (mobileInputValue.length > 0) {
          inputValue = mobileInputValue;
        }
        if (inputValue !== null) {
          updateAllProductLink(inputValue);
          if (inputValue.length > 2) {
            predictiveSearchProduct.query(inputValue);
            predictiveSearchProduct.on("success", (suggestions) => {
              const productSuggestions = suggestions.resources.results.products;
              const collectionSuggestions = suggestions.resources.results.collections;
              clearItemsFromProductResults();
              clearItemsFromCollectionResults();
              if (productSuggestions.length > 0) {
                showElement(productResultsElement);
                showElement(mobileProductResultsElement);
                productSuggestions.forEach((product) => {
                  const tagToSearch = "product_hidden";
                  const isTagFound = product.tags.includes(tagToSearch);
                  if (!isTagFound) {
                    insertProductInSearchResultElement(product);
                  }
                });
              } else {
                hideElement(productResultsElement);
                hideElement(mobileProductResultsElement);
              }
              if (collectionSuggestions.length > 0) {
                let collectionCounter = 0;
                showElement(collectionResultsElement);
                showElement(mobileCollectionResultsElement);
                collectionSuggestions.forEach((collection2) => {
                  collectionCounter += 1;
                  insertCollectionInSearchResultElement(collection2);
                });
              } else {
                hideElement(collectionResultsElement);
                hideElement(mobileCollectionResultsElement);
              }
            });
          }
        } else {
          hideElement(productResultsElement);
          hideElement(mobileProductResultsElement);
          hideElement(collectionResultsElement);
          hideElement(mobileCollectionResultsElement);
        }
      };
      searchInputElement.addEventListener("input", handleInputChange);
      searchInputElement.addEventListener("click", handleInputChange);
      mobileSearchInputElement.addEventListener("input", handleInputChange);
    }
  };
  handlePredictiveSearch();
};

// node_modules/@shopify/theme-addresses/loader.js
var query2 = "query countries($locale: SupportedLocale!) {  countries(locale: $locale) {    name    code    labels {      address1      address2      city      company      country      firstName      lastName      phone      postalCode      zone    }    formatting {      edit    }    zones {      name      code    }  }}";
var GRAPHQL_ENDPOINT = "https://country-service.shopifycloud.com/graphql";
function loadCountries(locale) {
  var response = fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    },
    body: JSON.stringify({
      query: query2,
      operationName: "countries",
      variables: {
        locale: toSupportedLocale(locale)
      }
    })
  });
  return response.then(function(res) {
    return res.json();
  }).then(function(countries) {
    return countries.data.countries;
  });
}
var DEFAULT_LOCALE = "EN";
var SUPPORTED_LOCALES = [
  "DA",
  "DE",
  "EN",
  "ES",
  "FR",
  "IT",
  "JA",
  "NL",
  "PT",
  "PT_BR"
];
function toSupportedLocale(locale) {
  var supportedLocale = locale.replace(/-/, "_").toUpperCase();
  if (SUPPORTED_LOCALES.indexOf(supportedLocale) !== -1) {
    return supportedLocale;
  } else if (SUPPORTED_LOCALES.indexOf(supportedLocale.substring(0, 2)) !== -1) {
    return supportedLocale.substring(0, 2);
  } else {
    return DEFAULT_LOCALE;
  }
}

// node_modules/@shopify/theme-addresses/helpers.js
function mergeObjects() {
  var to = Object({});
  for (var index = 0; index < arguments.length; index++) {
    var nextSource = arguments[index];
    if (nextSource) {
      for (var nextKey in nextSource) {
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey];
        }
      }
    }
  }
  return to;
}

// node_modules/@shopify/theme-addresses/addressForm.js
var FIELD_REGEXP = /({\w+})/g;
var LINE_DELIMITER = "_";
var INPUT_SELECTORS = {
  lastName: '[name="address[last_name]"]',
  firstName: '[name="address[first_name]"]',
  company: '[name="address[company]"]',
  address1: '[name="address[address1]"]',
  address2: '[name="address[address2]"]',
  country: '[name="address[country]"]',
  zone: '[name="address[province]"]',
  postalCode: '[name="address[zip]"]',
  city: '[name="address[city]"]',
  phone: '[name="address[phone]"]'
};
function AddressForm(rootEl, locale, options) {
  locale = locale || "en";
  options = options || { inputSelectors: {} };
  var formElements = loadFormElements(
    rootEl,
    mergeObjects(INPUT_SELECTORS, options.inputSelectors)
  );
  validateElements(formElements);
  return loadShippingCountries(options.shippingCountriesOnly).then(function(shippingCountryCodes) {
    return loadCountries(locale).then(function(countries) {
      init(
        rootEl,
        formElements,
        filterCountries(countries, shippingCountryCodes)
      );
    });
  });
}
function init(rootEl, formElements, countries) {
  populateCountries(formElements, countries);
  var selectedCountry = formElements.country.input ? formElements.country.input.value : null;
  setEventListeners(rootEl, formElements, countries);
  handleCountryChange(rootEl, formElements, selectedCountry, countries);
}
function handleCountryChange(rootEl, formElements, countryCode, countries) {
  var country = getCountry(countryCode, countries);
  setLabels(formElements, country);
  reorderFields(rootEl, formElements, country);
  populateZones(formElements, country);
}
function setEventListeners(rootEl, formElements, countries) {
  formElements.country.input.addEventListener("change", function(event2) {
    handleCountryChange(rootEl, formElements, event2.target.value, countries);
  });
}
function reorderFields(rootEl, formElements, country) {
  var formFormat = country.formatting.edit;
  var countryWrapper = formElements.country.wrapper;
  var afterCountry = false;
  getOrderedField(formFormat).forEach(function(row) {
    row.forEach(function(line) {
      formElements[line].wrapper.dataset.lineCount = row.length;
      if (!formElements[line].wrapper) {
        return;
      }
      if (line === "country") {
        afterCountry = true;
        return;
      }
      if (afterCountry) {
        rootEl.append(formElements[line].wrapper);
      } else {
        rootEl.insertBefore(formElements[line].wrapper, countryWrapper);
      }
    });
  });
}
function setLabels(formElements, country) {
  Object.keys(formElements).forEach(function(formElementName) {
    formElements[formElementName].labels.forEach(function(label) {
      label.textContent = country.labels[formElementName];
    });
  });
}
function populateCountries(formElements, countries) {
  var countrySelect = formElements.country.input;
  var duplicatedCountrySelect = countrySelect.cloneNode(true);
  countries.forEach(function(country) {
    var optionElement = document.createElement("option");
    optionElement.value = country.code;
    optionElement.textContent = country.name;
    duplicatedCountrySelect.appendChild(optionElement);
  });
  countrySelect.innerHTML = duplicatedCountrySelect.innerHTML;
  if (countrySelect.dataset.default) {
    countrySelect.value = countrySelect.dataset.default;
  }
}
function populateZones(formElements, country) {
  var zoneEl = formElements.zone;
  if (!zoneEl) {
    return;
  }
  if (country.zones.length === 0) {
    zoneEl.wrapper.dataset.ariaHidden = "true";
    zoneEl.input.innerHTML = "";
    return;
  }
  zoneEl.wrapper.dataset.ariaHidden = "false";
  var zoneSelect = zoneEl.input;
  var duplicatedZoneSelect = zoneSelect.cloneNode(true);
  duplicatedZoneSelect.innerHTML = "";
  country.zones.forEach(function(zone) {
    var optionElement = document.createElement("option");
    optionElement.value = zone.code;
    optionElement.textContent = zone.name;
    duplicatedZoneSelect.appendChild(optionElement);
  });
  zoneSelect.innerHTML = duplicatedZoneSelect.innerHTML;
  if (zoneSelect.dataset.default) {
    zoneSelect.value = zoneSelect.dataset.default;
  }
}
function validateElements(formElements) {
  Object.keys(formElements).forEach(function(elementKey) {
    var element = formElements[elementKey].input;
    var labels = formElements[elementKey].labels;
    if (!element) {
      return;
    }
    if (typeof element !== "object") {
      throw new TypeError(
        formElements[elementKey] + " is missing an input or select."
      );
    } else if (typeof labels !== "object") {
      throw new TypeError(formElements[elementKey] + " is missing a label.");
    }
  });
}
function getCountry(countryCode, countries) {
  countryCode = countryCode || "CA";
  return countries.filter(function(country) {
    return country.code === countryCode;
  })[0];
}
function getOrderedField(format2) {
  return format2.split(LINE_DELIMITER).map(function(fields) {
    var result = fields.match(FIELD_REGEXP);
    if (!result) {
      return [];
    }
    return result.map(function(fieldName) {
      var newFieldName = fieldName.replace(/[{}]/g, "");
      switch (newFieldName) {
        case "zip":
          return "postalCode";
        case "province":
          return "zone";
        default:
          return newFieldName;
      }
    });
  });
}
function loadFormElements(rootEl, inputSelectors) {
  var elements = {};
  Object.keys(INPUT_SELECTORS).forEach(function(inputKey) {
    var input = rootEl.querySelector(inputSelectors[inputKey]);
    elements[inputKey] = input ? {
      wrapper: input.parentElement,
      input,
      labels: document.querySelectorAll('[for="' + input.id + '"]')
    } : {};
  });
  return elements;
}
function loadShippingCountries(shippingCountriesOnly) {
  if (!shippingCountriesOnly) {
    return Promise.resolve(null);
  }
  var response = fetch(location.origin + "/meta.json");
  return response.then(function(res) {
    return res.json();
  }).then(function(meta) {
    return meta.ships_to_countries.indexOf("*") !== -1 ? null : meta.ships_to_countries;
  }).catch(function() {
    return null;
  });
}
function filterCountries(countries, includedCountryCodes) {
  if (!includedCountryCodes) {
    return countries;
  }
  return countries.filter(function(country) {
    return includedCountryCodes.indexOf(country.code) !== -1;
  });
}

// src/sections/address.js
var address = () => {
  const init2 = () => {
    addressCountryProvince();
    handleChangeAddressModal();
    handleAddAddressModal();
  };
  const addressCountryProvince = () => {
    const locale = window.currentLocale ? window.currentLocale : "en";
    const allAddressFormElement = document.querySelectorAll(".address-form");
    if (allAddressFormElement.length > 0) {
      allAddressFormElement.forEach((addressForm) => {
        AddressForm(addressForm, locale);
      });
    }
  };
  const handleAddShadow2 = (element) => {
    if (element !== null) {
      const screenHeight = window.innerHeight;
      const modalTextHolderElementHeight = element.offsetHeight;
      if (screenHeight > modalTextHolderElementHeight) {
        element.classList.add("has-shadow");
      }
    }
  };
  const handleChangeAddressModal = () => {
    const allChangeAddressButton = document.querySelectorAll(
      ".change-address-button"
    );
    const allCloseModalButton = document.querySelectorAll("#closeModal");
    const changeAddressModal = document.querySelector(".change-address");
    if (allChangeAddressButton.length > 0 && changeAddressModal !== null && allCloseModalButton !== null) {
      const bodyElement = document.querySelector("body");
      const openModal = (event2) => {
        const eventFiredElement = event2.currentTarget;
        const formId = eventFiredElement ? eventFiredElement.dataset.formId : null;
        if (formId) {
          const modalElement = document.getElementById(formId);
          const modalTextHolderElement = modalElement.querySelector(".text-holder");
          handleAddShadow2(modalTextHolderElement);
          modalElement.classList.add("visible");
        }
      };
      const closeModal = (event2) => {
        const eventFiredElement = event2.currentTarget;
        const formId = eventFiredElement ? eventFiredElement.dataset.formId : null;
        if (formId) {
          const modalElement = document.getElementById(formId);
          modalElement.classList.remove("visible");
        }
      };
      allChangeAddressButton.forEach((button) => {
        button.addEventListener("click", (event2) => {
          event2.preventDefault();
          openModal(event2);
        });
      });
      allCloseModalButton.forEach((closeButton) => {
        closeButton.addEventListener("click", (event2) => {
          event2.preventDefault();
          closeModal(event2);
        });
      });
    }
  };
  const handleAddAddressModal = () => {
    const allChangeAddressButton = document.querySelector("#addAddressButton");
    const closeModalButton = document.querySelector("#closeAddModal");
    const changeAddressModal = document.querySelector(".add-address");
    if (allChangeAddressButton !== null && changeAddressModal !== null && closeModalButton !== null) {
      const openModal = () => {
        const modalTextHolderElement = document.querySelector(
          ".add-address .text-holder"
        );
        handleAddShadow2(modalTextHolderElement);
        changeAddressModal.classList.add("visible");
      };
      const closeModal = () => {
        changeAddressModal.classList.remove("visible");
      };
      allChangeAddressButton.addEventListener("click", (event2) => {
        event2.preventDefault();
        openModal();
      });
      closeModalButton.addEventListener("click", (event2) => {
        event2.preventDefault();
        closeModal();
      });
    }
  };
  return {
    init: init2
  };
};

// src/sections/faq.js
var faq = () => {
  const getCategoryParamaterFromUrl = (url3) => {
    const urlSearchParams = new URLSearchParams(url3.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return returnStringOrNull(params.category);
  };
  const hideAllCategoryContent = () => {
    const allFaqItems = document.querySelectorAll(".details-container");
    allFaqItems.forEach((item) => {
      item.classList.add("hidden");
      item.classList.replace("visible", "hidden");
    });
  };
  const setCategoryButtonChecked = (id) => {
    const buttonElement = document.querySelector(`#${id}`);
    buttonElement.checked = true;
  };
  const setCategoryContentVisible = (id) => {
    const visibleFaqItems = document.querySelectorAll(`.${id}`);
    visibleFaqItems.forEach((item) => {
      item.classList.add("visible");
      item.classList.replace("hidden", "visible");
    });
  };
  const setCategoryInUrl = (id, url3) => {
    const params = new URLSearchParams(url3);
    params.set("category", id);
    history.replaceState(null, null, `?${params.toString()}`);
  };
  const setCategoryActive = (id, url3) => {
    hideAllCategoryContent();
    setCategoryButtonChecked(id);
    setCategoryContentVisible(id);
    setCategoryInUrl(id, url3);
  };
  const handleSetFaq = () => {
    const url3 = new URL(window.location);
    const categoryQuery = getCategoryParamaterFromUrl(url3);
    const allCategoriesElement = document.querySelectorAll(".tag");
    if (allCategoriesElement.length <= 0) {
      return null;
    }
    if (categoryQuery) {
      setCategoryActive(categoryQuery, url3);
    } else {
      const firstCategory = allCategoriesElement[0].id;
      setCategoryActive(firstCategory, url3);
    }
    allCategoriesElement.forEach((categoryElement) => {
      categoryElement.addEventListener("click", () => {
        const category = categoryElement.id;
        setCategoryActive(category, url3);
      });
    });
  };
  handleSetFaq();
};

// src/sections/cart.js
var mainCart = () => {
  const handleRemoveCartItemButton = () => {
    const allRemoveCartItemButton = document.querySelectorAll(".js-remove-item");
    if (allRemoveCartItemButton) {
      allRemoveCartItemButton.forEach((removeButtonElement) => {
        removeButtonElement.addEventListener("click", async (event2) => {
          event2.preventDefault();
          const line = event2.target.dataset.index;
          await shopifyCart.remove(line);
        });
      });
    }
  };
  const handleCartDrawerState = () => {
    const toggle = document.getElementById("cart-toggle");
    const closeButton = document.querySelector(
      "#cart-drawer .close-cart-drawer"
    );
    const cartDrawer = document.getElementById("cart-drawer");
    const cartNotificationElement = document.querySelector(
      ".cart-notification-product"
    );
    if (toggle && closeButton && cartDrawer) {
      toggle.addEventListener("click", (event2) => {
        event2.preventDefault();
        openCartDrawer();
      });
      closeButton.addEventListener("click", (event2) => {
        event2.preventDefault();
        closeCartDrawer();
      });
      if (cartNotificationElement) {
        cartNotificationElement.addEventListener("click", (event2) => {
          event2.preventDefault();
          openCartDrawer();
        });
      }
    }
  };
  const cartTooltip = () => {
    const tooltips = document.querySelectorAll("#cart-drawer .tooltip");
    if (tooltips.length > 0) {
      tooltips.forEach((tooltip) => {
        tooltip.addEventListener("click", (event2) => {
          event2.preventDefault();
          if (tooltip.classList.contains("js-open")) {
            tooltip.classList.remove("js-open");
          } else {
            closeTooltips();
            tooltip.classList.add("js-open");
          }
        });
      });
      const closeTooltips = () => {
        tooltips.forEach((tooltip) => tooltip.classList.remove("js-open"));
      };
    }
  };
  const handleNoteListener = () => {
    const checkoutButtonElement = document.querySelector("#checkoutButton");
    const noteElement = document.querySelector(
      ".cart-drawer .order-note textarea"
    );
    if (checkoutButtonElement !== null && noteElement !== null) {
      noteElement.addEventListener("input", () => {
        if (noteElement.value.length === 0) {
          removeStoreItem("note");
        }
        setStoreItem("note", noteElement.value);
      });
    }
  };
  const handleShadow = () => {
    window.addEventListener("resize", cartContentShadow);
  };
  handleCartDrawerState();
  cartTooltip();
  handleNoteListener();
  handleShadow();
  handleRemoveCartItemButton();
};

// src/sections/earparty.js
var earparty = () => {
  const handleProductToggle = () => {
    const toggleButtons = document.querySelectorAll(
      ".js-earparty .earparty_product__button--toggle"
    );
    const closeToggles = (buttons) => {
      buttons.forEach((button) => button.classList.remove("js-open"));
    };
    if (toggleButtons.length > 0) {
      toggleButtons.forEach((button) => {
        button.addEventListener("click", (event2) => {
          event2.preventDefault();
          if (button.classList.contains("js-open")) {
            closeToggles(toggleButtons);
          } else {
            closeToggles(toggleButtons);
            button.classList.toggle("js-open");
          }
        });
      });
    }
  };
  const handleVariant = (product) => {
    const select = product.querySelector('select[name="productVariant"]');
    const variantsDataElement = product.querySelector("#variants-data");
    if (variantsDataElement) {
      select.addEventListener("change", () => {
        const selectedOption = select.options[select.selectedIndex].value;
        const button = product.querySelector(".earparty_product__button");
        if (selectedOption !== void 0 && selectedOption !== "*" && selectedOption !== "") {
          button.classList.remove("js-invalid");
          product.querySelector(".text-holder p").innerHTML = selectedOption;
        } else {
          product.querySelector(".text-holder p").innerHTML = text.choose_variant;
          button.classList.add("js-invalid");
        }
        earpartyHasErrors();
      });
    }
  };
  const handleEngraving = (product) => {
    const input = product.querySelector('input[name="textFrontside"]');
    const button = product.querySelector(".earparty_product__button");
    if (!input)
      return false;
    input.addEventListener("input", (event2) => {
      event2.preventDefault();
      if (input.value.length > 0) {
        button.classList.remove("js-invalid");
        product.querySelector(
          ".text-holder p"
        ).innerHTML = `Engraving: ${input.value}`;
      } else {
        button.classList.add("js-invalid");
        product.querySelector(".text-holder p").innerHTML = text.choose_engraving;
      }
      earpartyHasErrors();
    });
  };
  const handleSingleInput = (product) => {
    const select = product.querySelector('select[name="initial"]');
    if (select) {
      select.addEventListener("change", () => {
        const selectedOption = select.options[select.selectedIndex].value;
        const button = product.querySelector(".earparty_product__button");
        if (selectedOption !== void 0 && selectedOption !== "*" && selectedOption !== "") {
          button.classList.remove("js-invalid");
          product.querySelector(
            ".text-holder p"
          ).innerHTML = `Initial: ${selectedOption}`;
        } else {
          product.querySelector(".text-holder p").innerHTML = text.choose_variant;
          button.classList.add("js-invalid");
        }
        earpartyHasErrors();
      });
    }
  };
  const handleMultipleInitial = (product) => {
    const input = product.querySelector("input#multipleInitials");
    const button = product.querySelector(".earparty_product__button");
    if (!input)
      return false;
    input.addEventListener("input", (event2) => {
      event2.preventDefault();
      if (input.value.length > 0) {
        button.classList.remove("js-invalid");
        product.querySelector(
          ".text-holder p"
        ).innerHTML = `Initials: ${input.value}`;
      } else {
        button.classList.add("js-invalid");
        product.querySelector(".text-holder p").innerHTML = text.choose_initials;
      }
      earpartyHasErrors();
    });
  };
  const earpartyHasErrors = () => {
    const blocks2 = document.querySelectorAll(".js-earparty .earparty_product");
    const button = document.querySelector(
      "form.js-earparty .js-add-to-cart-button"
    );
    let hasErrors = false;
    if (blocks2.length > 0) {
      blocks2.forEach((block) => {
        const button2 = block.querySelector(".earparty_product__button");
        if (button2.classList.contains("js-invalid")) {
          hasErrors = true;
        }
      });
    }
    if (hasErrors) {
      button.classList.add("js-disabled");
    } else {
      button.classList.remove("js-disabled");
    }
  };
  const setTotalSavings = () => {
  };
  const addOrderPickerData = (product, sku, font = false) => {
    const title = String(product.querySelector(".text-holder h6").innerHTML);
    let details = String(product.querySelector(".text-holder p").innerHTML);
    if (font) {
      details = `${details} / Font: ${font}`;
    }
    const formattedObject = {
      product: title,
      sku,
      details
    };
    window.earparty.formatted.push(formattedObject);
  };
  const setEarpartyProducts = () => {
    const form = document.querySelector("form.js-earparty");
    const setProducts = form.querySelectorAll(".earparty_product");
    const quantityElement = form.querySelector("#quantity");
    let quantity = 0;
    if (quantityElement) {
      quantity = parseFloat(
        quantityElement.options[quantityElement.selectedIndex].value
      );
    } else {
      quantity = 1;
    }
    window.earparty = [];
    window.earparty.formatted = [];
    setProducts.forEach((product) => {
      if (product.querySelector("input.multiple-variants") && !product.querySelector('select[name="initial"]') && !product.querySelector('input[name="initials"]')) {
        const variantsDataElement = product.querySelector("#variants-data");
        if (variantsDataElement) {
          const variantsData = JSON.parse(
            variantsDataElement.innerHTML
          ).variants;
          const selectValue = product.querySelector(
            'select[name="productVariant"]'
          ).value;
          const variant = variantsData.find(
            (element) => element.options === selectValue
          );
          const object = {
            id: variant.id,
            quantity
          };
          window.earparty.push(object);
          addOrderPickerData(product, variant.sku);
        }
      }
      if (product.querySelector(".variant.engraving.engraving--frontside")) {
        const variantElement = product.querySelector("input#productVariant");
        const engravingElement = product.querySelector("input#engraving-text");
        if (variantElement && engravingElement) {
          const variantID = variantElement.value;
          const { sku } = variantElement.dataset;
          const engraving = engravingElement.value;
          const radioButtons = product.querySelectorAll(
            '.radio--primary input[type="radio"]'
          );
          let font = "font--avenir";
          if (radioButtons) {
            const selectedRadio = Array.from(radioButtons).find(
              (radio) => radio.checked
            );
            font = selectedRadio.dataset.font;
          }
          font = String(font).replace("font--", "");
          const object = {
            id: parseFloat(variantID),
            quantity,
            properties: {
              Engraving: String(engraving),
              _font: font
            }
          };
          window.earparty.push(object);
          addOrderPickerData(product, sku, font);
        }
      }
      if (product.querySelector('select[name="initial"]')) {
        const variantsDataElement = product.querySelector("#variants-data");
        if (variantsDataElement) {
          const variantsData = JSON.parse(
            variantsDataElement.innerHTML
          ).variants;
          const variantID = variantsData[0].id;
          const { sku } = variantsData[0];
          const selectValue = product.querySelector(
            'select[name="initial"]'
          ).value;
          const object = {
            id: parseFloat(variantID),
            quantity,
            properties: {
              Initial: String(selectValue)
            }
          };
          window.earparty.push(object);
          addOrderPickerData(product, sku);
        } else {
          const variant = product.querySelector(
            'input[name="productVariant"][type="hidden"]'
          );
          const selectValue = product.querySelector(
            'select[name="initial"]'
          ).value;
          const object = {
            id: parseFloat(variant.value),
            quantity,
            properties: {
              Initial: String(selectValue)
            }
          };
          window.earparty.push(object);
          addOrderPickerData(product, variant.dataset.sku);
        }
      }
      if (product.querySelector('input[name="initials"]')) {
        const variantsDataElement = product.querySelector("#variants-data");
        if (variantsDataElement) {
          const variantsData = JSON.parse(
            variantsDataElement.innerHTML
          ).variants;
          const inputElement = product.querySelector(
            'input[name="initials"]'
          ).value;
          const variant = variantsData.find(
            (element) => element.options === String(inputElement.length)
          );
          const object = {
            id: variant.id,
            quantity,
            properties: {
              Initials: String(inputElement)
            }
          };
          window.earparty.push(object);
          addOrderPickerData(product);
        }
      }
      if (product.querySelector('input[type="hidden"]') && !product.querySelector(".variant.engraving.engraving--frontside") && !product.querySelector("input.multiple-variants") && !product.querySelector('select[name="initial"]') && !product.querySelector('input[name="initials"]')) {
        const variant = product.querySelector(
          'input[name="productVariant"][type="hidden"]'
        );
        const object = {
          id: parseFloat(variant.value),
          quantity
        };
        window.earparty.push(object);
        addOrderPickerData(product, variant.dataset.sku);
      }
    });
  };
  const initEarparty = () => {
    const form = document.querySelector("form.js-earparty");
    const button = document.querySelector(
      "form.js-earparty .js-add-to-cart-button"
    );
    if (!form && !button)
      return false;
    const setProducts = form.querySelectorAll(".earparty_product");
    setProducts.forEach((product) => {
      if (product.querySelector("input.multiple-variants") && !product.querySelector('select[name="initial"]') && !product.querySelector('input[name="initials"]')) {
        handleVariant(product);
      }
      if (product.querySelector(".variant.engraving.engraving--frontside")) {
        handleEngraving(product);
      }
      if (product.querySelector('select[name="initial"]')) {
        handleSingleInput(product);
      }
      if (product.querySelector('input[name="initials"]')) {
        handleMultipleInitial(product);
      }
    });
    setTotalSavings();
    earpartyHasErrors();
    button.addEventListener("click", (event2) => {
      event2.preventDefault();
      if (earpartyHasErrors())
        return;
      setEarpartyProducts();
      const id = parseFloat(button.dataset.id);
      const { quantity } = window.earparty[0];
      shopifyCart.addBundle(id, quantity, window.earparty);
    });
  };
  handleProductToggle();
  initEarparty();
};

// src/utils/bfcache.js
var import_axios6 = __toESM(require_axios2(), 1);
var enableBFCacheSupport = () => {
  window.addEventListener(
    "pageshow",
    (event2) => {
      console.log("pageshow");
      if (event2.persisted) {
        const url3 = new URL(window.location.href);
        url3.searchParams.append(
          "sections",
          getCartDrawerSectionsToRender().map((section) => section.id).join(",")
        );
        import_axios6.default.get(url3.href).then((response) => {
          const newRenderedSectionsObject = response.data;
          const sectionObjects = Object.keys(newRenderedSectionsObject).map(
            (key) => ({
              name: key,
              html: newRenderedSectionsObject[key]
            })
          );
          console.log(url3);
          sectionObjects.forEach((renderedSection) => {
            var _a;
            const parser = new DOMParser();
            const destinationSelector = (_a = getCartDrawerSectionsToRender().find(
              (sectionInfo) => sectionInfo.id == renderedSection.name
            )) == null ? void 0 : _a.selector;
            const destinationElement = document.querySelector(destinationSelector);
            const rawSectionData = parser.parseFromString(
              renderedSection.html,
              "text/html"
            );
            const newSectionElement = rawSectionData.querySelector(destinationSelector);
            if (destinationElement) {
              console.log(destinationElement);
              console.log(newSectionElement);
              destinationElement.innerHTML = newSectionElement.innerHTML;
            }
          });
        });
      }
    },
    false,
    { passive: true }
  );
};

// src/extenders/product-form.js
var ProductForm = class extends HTMLElement {
  constructor() {
    super();
    const handleSubmit = (event2) => {
      const variantIdElement = event2.target.querySelector(
        '[name="productVariant"]'
      );
      const variantId = variantIdElement ? variantIdElement.value : null;
      const defaultQuantity = 1;
      if (variantId) {
        shopifyCart.quickBuy(variantId, defaultQuantity);
      }
    };
    const form = this.querySelector("form");
    if (form) {
      form.addEventListener("submit", (event2) => {
        event2.preventDefault();
        handleSubmit(event2);
      });
    }
  }
};
customElements.define("product-form", ProductForm);

// src/extenders/quantity-selector.js
var QuantitySelector = class extends HTMLElement {
  constructor() {
    super();
    const selectElement = this.querySelector("select");
    selectElement.addEventListener("change", (event2) => {
      const line = selectElement.dataset.index;
      const selectedOption = selectElement.options[selectElement.selectedIndex];
      const newQuantity = selectedOption ? selectedOption.value : null;
      if (line && newQuantity) {
        this.handleUpdateQuantity(line, newQuantity);
      }
    });
  }
  /**
   * Handle update quantity
   * @param line
   * @param quantity
   * @returns {Promise<void>}
   */
  async handleUpdateQuantity(line, quantity) {
    await shopifyCart.updateQuantity(line, quantity);
  }
};
customElements.define("quantity-selector", QuantitySelector);

// src/extenders/cart-remove-button.js
var CartRemoveButton = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event2) => {
      event2.preventDefault();
      const line = this.dataset.index;
      this.handleRemoveCartItem(line);
    });
  }
  /**
   * Handle remove cart item.
   * @param line
   * @returns {Promise<void>}
   */
  async handleRemoveCartItem(line) {
    await shopifyCart.remove(line);
  }
};
customElements.define("cart-remove-button", CartRemoveButton);

// src/extenders/checkout-button.js
var CheckoutButton = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event2) => {
      event2.preventDefault();
      const checkoutButtonElement = event2.target.closest(".checkout-button");
      const forwardLocationBase = checkoutButtonElement.dataset.forwardLocation;
      if (getStoreItem("note")) {
        location.href = `${forwardLocationBase}?note='${encodeURIComponent(
          getStoreItem("note")
        )}'`;
      } else {
        location.href = forwardLocationBase;
      }
    });
  }
  /**
   * Handle remove free product.
   *
   * @param freeProductVariantId
   * @returns {Promise<void>}
   */
  async removeAddFreeProduct(freeProductVariantId) {
    const defaultQuantity = 0;
    await shopifyCart.updateFreeProduct(freeProductVariantId, defaultQuantity);
  }
};
customElements.define("checkout-button", CheckoutButton);

// src/extenders/handle-conditional-gift.js
var HandleConditionalGift = class extends HTMLElement {
  constructor() {
    super();
    const conditialGiftValue = this.dataset.value;
    const { totalPrice, threshold, isInCart } = this.dataset;
    if (this.isFreeProductCandidate(totalPrice, threshold) && isInCart === "false") {
      this.addAttribute(conditialGiftValue);
    } else if (this.isFreeProductCandidate(totalPrice, threshold) && isInCart === "true") {
    } else if (!this.isFreeProductCandidate(totalPrice, threshold) && isInCart === "true") {
      this.removeAttribute();
    } else {
    }
  }
  /**
   * Is free product available for client.
   *
   * @param totalPrice
   * @returns {boolean}
   */
  isFreeProductCandidate(totalPrice, threshold) {
    return Number(totalPrice) >= Number(threshold);
  }
  /**
   * Handle add free product.
   *
   * @param conditialGiftValue
   * @returns {Promise<void>}
   */
  async addAttribute(conditialGiftValue) {
    shopifyCart.updateAttributes("conditial_gift", conditialGiftValue);
  }
  /**
   * Handle remove cart item.
   *
   * @param conditialGiftValue
   *
   * @returns {Promise<void>}
   */
  async removeAttribute() {
    shopifyCart.updateAttributes("conditial_gift", null);
  }
};
customElements.define("handle-conditional-gift", HandleConditionalGift);

// src/extenders/handle-gift.js
var HandleFreePouch = class extends HTMLElement {
  constructor() {
    super();
    const giftValue = this.dataset.value;
    const { isInCart } = this.dataset;
    if (isInCart === "false") {
      this.handleAddProduct(giftValue);
    }
  }
  /**
   * Handle add free product.
   *
   * @param freeProductVariantId
   * @returns {Promise<void>}
   */
  async handleAddProduct(giftValue) {
    shopifyCart.updateAttributes("gift", giftValue);
  }
};
customElements.define("handle-gift", HandleFreePouch);

// src/extenders/cart-giftbox-button.js
var CartGiftboxButton = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event2) => {
      const noteElement = document.querySelector(
        ".cart-drawer .order-note textarea"
      );
      event2.preventDefault();
      this.classList.toggle("js-open");
      cartContentShadow();
      if (noteElement) {
        noteElement.value = getStoreItem("note");
      }
    });
  }
};
customElements.define("cart-giftbox-button", CartGiftboxButton);

// src/extenders/subscribe-newsletter.js
var SubscribeNewsletter = class extends HTMLElement {
  constructor() {
    super();
    const handleFormSuccess = (result) => {
      const formInputElement = this.querySelector("input");
      const formButton = this.querySelector("button");
      if (formInputElement !== null) {
        if (result.status > 200 && result.status < 300) {
          formInputElement.value = formInputElement.dataset.success;
          formButton.classList.add("js-disabled");
        } else {
          formInputElement.value = formInputElement.dataset.error;
        }
      }
    };
    const handleSubmit = async (form2, event2) => {
      const emailElement = form2.querySelector('[type="email"]');
      const emailAddress = emailElement.value;
      const { listId, klaviyoCountry } = this.dataset;
      if (emailAddress.length > 0) {
        await subscribeToNewsletter(emailAddress, listId, klaviyoCountry).then(
          (result) => {
            if (result !== null) {
              handleFormSuccess(result);
            }
          }
        );
      }
    };
    const form = this.querySelector("form");
    if (form) {
      form.addEventListener("submit", (event2) => {
        event2.preventDefault();
        handleSubmit(form, event2);
      });
    }
  }
};
customElements.define("subscribe-newsletter", SubscribeNewsletter);

// src/templates/byo-render-price.js
var byoRenderPrice = (productList) => {
  const subTotalElement = document.querySelector(".js-subtotal");
  const defaultPrice = document.querySelector(".js-default-price");
  const addonPriceElement = document.querySelector(".js-addon-price");
  const claspPriceElement = document.querySelector(".js-clasp-price");
  const fyb = document.querySelector("[data-fyb]");
  const subTotal = [];
  const addonTotal = [];
  const claspTotal = [];
  subTotal.push(Number(defaultPrice.dataset.price));
  productList.forEach((element) => {
    var _a;
    const name = (_a = element.dataset.name) == null ? void 0 : _a.toLowerCase();
    subTotal.push(Number(element.dataset.price));
    if (name.includes("clasp")) {
      claspTotal.push(Number(element.dataset.price));
    } else {
      addonTotal.push(Number(element.dataset.price));
    }
  });
  const totalPrice = subTotal.reduce((a, b) => {
    return a + b;
  });
  let totalClaspPrice = 0;
  let totalAddonPrice = 0;
  if (claspTotal.length > 0) {
    totalClaspPrice = claspTotal.reduce((a, b) => {
      return a + b;
    });
  }
  if (addonTotal.length > 0) {
    totalAddonPrice = addonTotal.reduce((a, b) => {
      return a + b;
    });
  }
  let subTotalPrice = `
    <p>${text.subtotal}</p>
    <p data-price=${totalPrice} class="js-subtotal-price-element">&nbsp;${pricing(Number(defaultPrice.dataset.price) + totalAddonPrice + totalClaspPrice)}</p>
  `;
  if (addonTotal.length > 9) {
    subTotalPrice = `
    <p>${text.subtotal}</p>
    <p data-price=${totalPrice} class="js-subtotal-price-element">&nbsp;${pricing(Number(defaultPrice.dataset.price) + Number(totalAddonPrice / 2) + totalClaspPrice)}</p>
  `;
  }
  subTotalElement.innerHTML = subTotalPrice;
  let addonPrice = `
      <p data-price=${totalAddonPrice} class="js-adsdon-price-element">${pricing(totalAddonPrice)}</p>
    `;
  if (addonTotal.length > 9) {
    addonPrice = `
      <p data-price=${totalAddonPrice} class="js-addon-price-element">
      <s>${pricing(totalAddonPrice)}</s>
    <strong>${pricing(totalAddonPrice / 2)}<strong></p>
    `;
  }
  if (addonPriceElement)
    addonPriceElement.innerHTML = addonPrice;
  const claspPrice = `
      <p data-price=${totalClaspPrice} class="js-clasp-price-element">${pricing(totalClaspPrice)}</p>
    `;
  if (claspPriceElement)
    claspPriceElement.innerHTML = claspPrice;
};
var byo_render_price_default = byoRenderPrice;

// src/services/byo-product-limiter.js
var byoProductLimiter = () => {
  const productList = document.querySelector(".js-byo-product-list");
  const listLength = productList.children.length;
  const maxItems = document.querySelector(".js-addon-limit").dataset.limit - 1;
  const fyb = document.querySelector("[data-fyb]");
  if (fyb) {
    const fybItems = document.querySelectorAll(".byo-product");
    fybItems.forEach((element, index) => {
      let title = element.querySelector(".text-holder__title");
      title.dataset.index = index + 1;
    });
  }
  if (listLength <= maxItems) {
    return true;
  } else {
    return false;
  }
};
var byo_product_limiter_default = byoProductLimiter;

// src/templates/byo-price-deletion.js
var byoPriceDeletion = (reduceValue, isClasp) => {
  const reducedPriceElement = document.querySelector(".js-addon-price");
  const reducedClaspPriceElement = document.querySelector(".js-clasp-price");
  const reducedSubTotalElement = document.querySelector(
    ".js-subtotal-price-element"
  );
  const addonPriceElement = document.querySelector(".js-addon-price-element");
  const claspPriceElement = document.querySelector(".js-clasp-price-element");
  const reducedAddonPrice = Number(addonPriceElement == null ? void 0 : addonPriceElement.dataset.price) - reduceValue;
  const reducedClaspPrice = Number(claspPriceElement == null ? void 0 : claspPriceElement.dataset.price) - reduceValue;
  const reducedSubtotalPrice = Number(reducedSubTotalElement == null ? void 0 : reducedSubTotalElement.dataset.price) - reduceValue;
  reducedSubTotalElement.dataset.price = Number(reducedSubTotalElement == null ? void 0 : reducedSubTotalElement.dataset.price) - reduceValue;
  const reducedSubtotalPriceTemplate = `
    <p data-price=${reducedSubtotalPrice} class="js-subtotal-price-element">${pricing(
    reducedSubtotalPrice
  )}</p>
  `;
  reducedSubTotalElement.innerHTML = reducedSubtotalPriceTemplate;
  if (isClasp) {
    const reducedClaspPriceTemplate = `
      <p data-price=${reducedClaspPrice} class="js-addon-price-element">${pricing(
      reducedClaspPrice
    )}</p>
    `;
    reducedClaspPriceElement.innerHTML = reducedClaspPriceTemplate;
  } else {
    const reducedPriceTemplate = `
      <p data-price=${reducedAddonPrice} class="js-addon-price-element">${pricing(
      reducedAddonPrice
    )}</p>
    `;
    reducedPriceElement.innerHTML = reducedPriceTemplate;
  }
};
var byo_price_deletion_default = byoPriceDeletion;

// src/services/byo-handle-add-to-cart-button.js
var handleAddToCartButton = () => {
  const productList = document.querySelector(".js-byo-product-list");
  const addToCartButton = document.querySelector(".js-byo-add-to-cart-button");
  if (productList.children.length >= 1) {
    addToCartButton.innerHTML = `
      <svg class="left-icon shoping-bag--large" fill="none" height="16" viewBox="0 0 25 16" width="25"
      xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.8225 15.7643C10.7313 15.8059 8.65393 15.8614 6.56274 15.8891C5.73181 15.903 4.91472 15.8891 4.08378 15.8891C3.93145 15.8891 3.76526 15.8475 3.64062 15.8891C2.76814 16.1664 1.95105 15.8475 1.13396 15.6534C0.23378 15.4316 -0.209386 14.669 0.219931 13.8788C0.76004 12.8806 0.815435 11.813 1.07857 10.7732C1.43864 9.35908 1.79871 7.94494 2.13108 6.51694C2.32497 5.6435 2.93432 5.35235 3.72371 5.31076C4.19458 5.28303 4.67929 5.31076 5.164 5.31076C6.89512 5.31076 8.64009 5.31076 10.3712 5.31076C12.2408 5.32462 12.4208 5.42167 12.864 7.22401C13.3072 8.98475 13.6672 10.7594 14.055 12.5201C14.1797 13.0608 14.332 13.5876 14.4428 14.1283C14.6782 15.39 14.332 15.8059 13.0717 15.8336C13.0025 15.8336 12.9194 15.8336 12.8502 15.8336C12.8363 15.8198 12.8225 15.792 12.8225 15.7643ZM10.5512 2.30224C9.22174 0.250349 6.92282 -0.110118 5.05321 1.24857C4.27767 1.817 3.98684 2.69044 3.9176 3.6332C3.8899 3.99366 4.29152 4.34027 4.65159 4.3264C4.95627 4.31254 5.10861 4.13231 5.10861 3.84116C5.15015 2.64884 5.98109 2.13587 6.92282 1.7754C7.89224 1.40107 9.01401 1.95564 9.38793 2.95385C9.52642 3.32819 9.58181 3.73025 9.66491 4.11844C9.748 4.5205 10.0388 4.74233 10.4958 4.70074C10.8559 4.67301 11.036 4.45118 11.1329 4.00753C10.939 3.42524 10.8698 2.78749 10.5512 2.30224Z"
          fill="white" />
        <path
          d="M24.4982 7.72346H21.6463V4.88889H19.555V7.72346H16.7204V9.81482H19.555V12.6667H21.6463V9.81482H24.4982V7.72346Z"
          fill="white" />
      </svg>
      ${text.add_to_bag}`;
  } else {
  }
};
var byo_handle_add_to_cart_button_default = handleAddToCartButton;

// src/services/byo-size-limiter.js
var byoSizeLimiter = () => {
  var _a;
  const productList = document.querySelector(".js-size-list");
  const listLength = (_a = productList == null ? void 0 : productList.children) == null ? void 0 : _a.length;
  const maxItems = 1;
  if (listLength < maxItems) {
    return true;
  } else {
    return false;
  }
};
var byo_size_limiter_default = byoSizeLimiter;

// src/templates/byo-remove-product.js
var byoRemoveProduct = (selector) => {
  const productList = document.querySelector(".js-byo-product-list");
  const updateMaxProduct = document.querySelector(".js-addon-limit");
  const addCharmButton = document.querySelectorAll(".js-open-modal");
  const addedProduct = document.querySelector(`.${selector}`);
  let isClasp = false;
  addedProduct.addEventListener("click", (e) => {
    var _a, _b;
    const byoProduct = e.target.closest(".byo-product");
    const priceDeletion = byoProduct == null ? void 0 : byoProduct.dataset.price;
    byoProduct == null ? void 0 : byoProduct.remove();
    (_a = e.target.closest(".byo-product-size")) == null ? void 0 : _a.remove();
    updateMaxProduct.innerHTML = ` ${updateMaxProduct.dataset.limit - productList.children.length}`;
    if (byoProduct) {
      if (byoProduct.dataset.type === "clasp") {
        isClasp = true;
      }
      byo_price_deletion_default(Number(priceDeletion), isClasp);
    }
    byo_handle_add_to_cart_button_default();
    if (byo_product_limiter_default()) {
      if (((_b = addCharmButton[1]) == null ? void 0 : _b.length) > 1) {
        if (addCharmButton[1].classList.contains("disabled")) {
          addCharmButton[1].classList.remove("disabled");
        } else {
          addCharmButton[1].classList.add("disabled");
        }
      }
    }
    if (byo_size_limiter_default()) {
      if (addCharmButton[0].length) {
        if (addCharmButton[0].classList.contains("disabled")) {
          addCharmButton[0].classList.remove("disabled");
        } else {
          addCharmButton[0].classList.add("disabled");
        }
      }
    }
  });
};
var byo_remove_product_default = byoRemoveProduct;

// src/templates/byo-add-product.js
var handleAddButton = () => {
  const addCharmButton = document.querySelectorAll(".add-charm__button");
  if (byo_product_limiter_default()) {
    for (let i = 0; i < addCharmButton.length; i++) {
      if (addCharmButton[i].classList.contains("disabled")) {
        addCharmButton[i].classList.remove("disabled");
      }
    }
  }
};
var byoAddProduct = (product) => {
  const sizeList = document.querySelector(".js-size-list");
  const productList = document.querySelector(".js-byo-product-list");
  const updateMaxProduct = document.querySelector(".js-addon-limit");
  const remaining = document.querySelector(".js-remaining");
  const fyb = document.querySelector("[data-fyb]");
  let description = "";
  let descriptionBack = "";
  let descriptionHTML = "";
  if (product.dataset.variant === "engrave_editor") {
    description = text.byo_engraving;
    descriptionHTML = `<p class="text-holder__description">${description}: ${product.dataset.textfront} - ${pricing(product.dataset.price)}</p>`;
  }
  if (product.dataset.variant === "engrave_backside") {
    descriptionHTML = `
    <p class="text-holder__description">${text.byo_engraving_front}: ${product.dataset.textfront} ${product.dataset.textback !== void 0 ? `- ${text.byo_engraving_back}: ${product.dataset.textback}` : ""} - ${pricing(product.dataset.price)}</p>
    `;
  }
  if (product.dataset.variant === "engrave_editor_icons") {
    description = text.byo_engraving;
    descriptionHTML = `<p class="text-holder__description">${description}: ${product.dataset.textfront} - ${pricing(product.dataset.price)}</p>`;
  }
  if (product.dataset.variant === "initial_select_picker") {
    description = text.byo_initial;
    descriptionHTML = `<p class="text-holder__description">${description}: ${product.dataset.initial} - ${pricing(product.dataset.price)}</p>`;
  }
  if (product.dataset.variant === "initial_text_input") {
    description = text.byo_initials;
    descriptionHTML = `<p class="text-holder__description">${description}: ${product.dataset.initials} - ${pricing(product.dataset.price)}</p>`;
  }
  if (product.dataset.variant === "initial_select_picker_default") {
    description = text.byo_initial;
    descriptionHTML = `<p class="text-holder__description">${description}: ${product.dataset.initial} - ${pricing(product.dataset.price)}</p>`;
  }
  if (product.dataset.variant === "birthstone_select_picker") {
    description = text.birthstone;
    descriptionHTML = `<p class="text-holder__description">${description}: ${product.dataset.initial} - ${pricing(product.dataset.price)}</p>`;
  }
  if (product.dataset.variant === "engrave_editor_all_options") {
    description = text.byo_engraving;
    descriptionBack = `${text.byo_engraving} ${text.backside}`;
    descriptionHTML = `
      <p class="text-holder__description">${description}: ${product.dataset.textfront} - ${pricing(product.dataset.price)}</p>
      ${product.dataset.textback !== void 0 ? `<p class="text-holder__description">${descriptionBack}: ${product.dataset.textback}</p>` : ""}
    `;
  }
  if (product.dataset.variant === "no_variant") {
    descriptionHTML = `<p class="text-holder__description">${pricing(
      product.dataset.price
    )}</p>`;
  }
  const uniqueByDate = Date.now();
  const productHtml = `
    <div class="byo-product${product.dataset.variant === "base_product" ? "-size" : ""}"
      data-id=${product.dataset.variantId ? product.dataset.variantId : product.dataset.id}
      data-name="${product.dataset.name}"
      data-initial=${product.dataset.initial}
      data-initials=${product.dataset.initials}
      data-price=${product.dataset.price}
      data-fontfront=${product.dataset.fontfront}
      data-textfront=${product.dataset.textfront}
      data-fontback=${product.dataset.fontback}
      data-textback=${product.dataset.textback}
      data-type=${product.dataset.type}
    >
      <div class="image-holder">
        <img src=${product.dataset.img} alt="build your own product image"/>
      </div>
      <div class="text-holder">
        <p class="text-holder__title">${product.dataset.name}</p>
        ${descriptionHTML}
      </div>
      <div class="delete js-delete js-product-event-${uniqueByDate}">
      <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.69207 10.5155C8.99409 10.2134 9.2332 9.97432 9.52264 9.68488C12.8334 12.0644 15.5907 14.9475 18.3858 17.7678C18.2847 17.9687 18.2717 18.0815 18.2087 18.1445C17.3402 19.0629 17.3027 19.0505 16.3915 18.1897C15.2557 17.1043 14.0947 16.0691 12.9715 14.9711C11.6112 13.636 10.2636 12.2632 8.92853 10.9029C8.86624 10.8155 8.80406 10.7029 8.69207 10.5155Z" fill="#231F20"/>
        <path d="M17.4259 9.61958C17.6272 9.82093 17.7781 9.94688 17.8915 10.0852C18.3073 10.6258 18.333 10.7763 17.909 11.2507C17.0607 12.1744 16.1872 13.0479 15.3012 13.9339C14.1282 15.1069 12.9175 16.2422 11.7445 17.4152C11.3577 17.802 11.0336 18.2267 10.6468 18.6135C10.1727 19.1128 9.89702 19.1116 9.4315 18.6711C8.9534 18.2179 8.92707 17.917 9.38878 17.4553C10.2748 16.5694 11.1734 15.721 12.0594 14.835C13.4696 13.45 14.8546 12.0398 16.2648 10.6548C16.6018 10.3179 16.964 10.0312 17.4259 9.61958Z" fill="#231F20"/>
      </svg>
      </div>
    </div>
  `;
  if (product.dataset.variant === "base_product") {
    if (byo_size_limiter_default()) {
      sizeList.insertAdjacentHTML("beforeend", productHtml);
      byo_remove_product_default(`js-product-event-${uniqueByDate}`);
      const addCharmButton = document.querySelectorAll(".add-charm__button");
      addCharmButton[0].classList.remove("add-charm__button--error");
      addCharmButton[0].classList.add("disabled");
      addCharmButton[1].classList.remove("disabled");
    }
  }
  if (byo_product_limiter_default() && product.dataset.variant !== "base_product") {
    if (product.dataset.type === "clasp") {
      const claspProductList = document.querySelector(
        ".js-byo-product-list--clasp"
      );
      const addClaspButton = document.querySelector(".add-clasp__button");
      claspProductList.innerHTML = "";
      claspProductList.insertAdjacentHTML("beforeend", productHtml);
      addClaspButton.classList.add("disabled");
    } else {
      productList.insertAdjacentHTML("beforeend", productHtml);
    }
    const updatedProductList = document.querySelectorAll(".byo-product");
    updateMaxProduct.innerHTML = ` ${updateMaxProduct.dataset.limit - productList.children.length}`;
    const discountElement = document.querySelector(".discount-element");
    if (discountElement) {
      if (productList.children.length >= 9) {
        discountElement.setAttribute("data-discount", "true");
      } else {
        discountElement.setAttribute("data-discount", "false");
      }
    }
    byo_render_price_default(updatedProductList);
    handleAddButton();
    byo_remove_product_default(`js-product-event-${uniqueByDate}`);
    byo_handle_add_to_cart_button_default();
  }
};
var byo_add_product_default = byoAddProduct;

// src/templates/byo-variants.js
var ByoVariants = (product) => {
  var _a;
  const variantData = product.querySelector("#variants-data").innerHTML;
  const parsedData = JSON.parse(variantData);
  const fallBackAlphabet = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
  ];
  let productType = "";
  if (product.dataset.type === "charm") {
    productType = text.charm;
  } else if (product.dataset.type === "clasp") {
    productType = text.clasp;
  } else {
    productType = text.pendant;
  }
  if (product.dataset.variant === "initial_text_input") {
    product.dataset.variantId = (_a = parsedData.variants[0]) == null ? void 0 : _a.id;
    return `
    <div class="variant-holder">
      <div class="img-holder">
        <img src="${product.dataset.img}">
      </div>
      <div class="variant-content">
        <div class="variant-info">
          <h5 class="variant-info__title">${product.dataset.name}</h5>
          <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>${text.byo_per_piece}</span></p>
        </div>
        <div class="initials">
          <label>${text.type_your_character_max} ${product.dataset.inputlength} ${text.characters}</label>
          <input type="text" class="js-initial-text" maxLength="${product.dataset.inputlength}" pattern="[a-zA-Z0-9\xC0-\xD6\xD8-\xF6\xF8-\xFF!@#$%^&*()_+-=[]{};':\\|,.<>/?~ \u2000-\u3300]+"/>
          <button class="button button--primary variant-button variant-button--disabled js-choose-variant-button">${text.byo_choose_variant}</button>
        </div>
      </div>
    </div>
    `;
  }
  if (product.dataset.variant === "birthstone_select_picker") {
    product.dataset.variantId = parsedData.variants[0].id;
    return `
    <div class="variant-holder">
      <div class="img-holder">
        <img src="${product.dataset.img}" loading="lazy">
      </div>
      <div class="variant-content">
        <div class="variant-info">
          <h5 class="variant-info__title">${product.dataset.name}</h5>
          <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>${text.byo_per_piece}</span></p>
        </div>
        <div class="initials">
          <label>${text.choose_variant}</label>
          <select class="js-initial-select select--primary">
            <option selected disabled></option>
            ${parsedData.variants.map((variant, i) => {
      return `<option key=${i} value=${variant.id}>${variant.options}</option>`;
    })}
          </select>
          <button class="button button--primary variant-button variant-button--disabled js-choose-variant-button">${text.byo_choose_variant}</button>
        </div>
      </div>
    </div>
    `;
  }
  if (product.dataset.variant === "initial_select_picker") {
    product.dataset.variantId = parsedData.variants[0].id;
    return `
    <div class="variant-holder">
      <div class="img-holder">
        <img src="${product.dataset.img}" loading="lazy">
      </div>
      <div class="variant-content">
        <div class="variant-info">
          <h5 class="variant-info__title">${product.dataset.name}</h5>
          <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>${text.byo_per_piece}</span></p>
        </div>
        <div class="initials">
          <label>${text.byo_select_your_characters}</label>
          <select class="js-initial-select select--primary">
            <option selected disabled></option>
            ${parsedData.variants.map((variant, i) => {
      return `<option key=${i} value=${variant.id}>${variant.options}</option>`;
    })}
          </select>
          <button class="button button--primary variant-button variant-button--disabled js-choose-variant-button">${text.byo_choose_variant}</button>
        </div>
      </div>
    </div>
    `;
  }
  if (product.dataset.variant === "initial_select_picker_default") {
    product.dataset.variantId = parsedData.variants[0].id;
    return `
    <div class="variant-holder">
      <div class="img-holder">
        <img src="${product.dataset.img}" loading="lazy">
      </div>
      <div class="variant-content">
        <div class="variant-info">
          <h5 class="variant-info__title">${product.dataset.name}</h5>
          <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>${text.byo_per_piece}</span></p>
        </div>
        <div class="initials">
          <label>${text.byo_select_your_characters}</label>
          <select class="js-initial-select-default select--primary">
            <option selected disabled></option>
            ${fallBackAlphabet.map((variant, i) => {
      return `<option key=${i} value=${variant}>${variant}</option>`;
    })}
          </select>
          <button class="button button--primary variant-button variant-button--disabled js-choose-variant-button">${text.byo_choose_variant}</button>
        </div>
      </div>
    </div>
    `;
  }
  if (product.dataset.variant === "no_variant") {
    product.dataset.variantId = parsedData.variants[0].id;
    return `
    <div class="variant-holder">
      <div class="img-holder">
        <img src="${product.dataset.img}" loading="lazy">
      </div>
      <div class="variant-content">
        <div class="variant-info">
          <h5 class="variant-info__title">${product.dataset.name}</h5>
          <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>${text.byo_per_piece}</span></p>
        </div>
        <div class="initials">
          <button class="button button--primary variant-button js-choose-variant-button-default">${text.byo_add + " " + productType}</button>
        </div>
      </div>
    </div>
    `;
  }
  if (product.dataset.variant === "engrave_editor") {
    product.dataset.variantId = parsedData.variants[0].id;
    return `
    <div class="variant-holder">
      <div class="img-holder">
        <img src="${product.dataset.img}" loading="lazy">
      </div>
      <div class="variant-content">
        <div class="variant-info">
          <h5 class="variant-info__title">${product.dataset.name}</h5>
          <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>${text.byo_per_piece}</span></p>
        </div>
        <div class="initials style-engraving">
          <div class="variant">
            <h6>${text.choose_your_font}</h6>
            <div class="variant__options-container">
      
              <div class="radio--primary">
                <label class="font--avenir" for="font--avenir">Aa</label>
                <input checked id="font--avenir" data-font="font--avenir" name="fontFrontside" type="radio" value="avenir" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--bentham" for="font--bentham">Aa</label>
                <input id="font--bentham" data-font="font--bentham" name="fontFrontside" type="radio" value="bentham" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--cutivemono" for="font--cutivemono">Aa</label>
                <input id="font--cutivemono" data-font="font--cutivemono" name="fontFrontside" type="radio" value="cutivemono" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--moonflower" for="font--moonflower">Aa</label>
                <input id="font--moonflower" data-font="font--moonflower" name="fontFrontside" type="radio" value="moonflower" class="js-input-font-radio">
              </div>
            </div>
            <!-- end .font__options-container -->
      
          </div>
          <!-- end .variant -->
      
          <div class="variant">
            <div class="variant__text" id="engravingText">
              <label for="text">Type your text - Max ${product.dataset.inputlength} characters</label>
              <input autocomplete="off" class="font--gilroy input--primary js-engraving-input" id="engraving-text" maxlength="${product.dataset.inputlength}" name="_textFrontside"
                      placeholder="BN" type="text" pattern="[a-zA-Z0-9\xC0-\xD6\xD8-\xF6\xF8-\xFF!@#$%^&*()_+-=[]{};':\\|,.<>/?~ \u2000-\u3300]+" >
            </div>
            <!-- end .form__text -->
      
        </div>
        <!-- end .variant -->
          <button class="button button--primary variant-button variant-button--disabled js-choose-variant-button">${text.byo_choose_variant}</button>
        </div>
      </div>
    </div>
    `;
  }
  if (product.dataset.variant === "engrave_editor_icons") {
    return `
    <div class="variant-holder">
    <div class="img-holder">
      <img src="${product.dataset.img}" loading="lazy">
    </div>
    <div class="variant-content">
      <div class="variant-info">
        <h5 class="variant-info__title">${product.dataset.name}</h5>
        <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>per piece</span></p>
      </div>
      <div class="initials style-engraving">
        <div class="variant">
          <h6>${text.choose_your_font}</h6>
          <div class="variant__options-container">
    
            <div class="radio--primary">
              <label class="font--avenir" for="font--avenir">Aa</label>
              <input checked id="font--avenir" data-font="font--avenir" name="fontFrontside" type="radio" value="avenir" class="js-input-font-radio">
            </div>
    
            <div class="radio--primary">
              <label class="font--bentham" for="font--bentham">Aa</label>
              <input id="font--bentham" data-font="font--bentham" name="fontFrontside" type="radio" value="bentham" class="js-input-font-radio">
            </div>
    
            <div class="radio--primary">
              <label class="font--cutivemono" for="font--cutivemono">Aa</label>
              <input id="font--cutivemono" data-font="font--cutivemono" name="fontFrontside" type="radio" value="cutivemono" class="js-input-font-radio">
            </div>
    
            <div class="radio--primary">
              <label class="font--moonflower" for="font--moonflower">Aa</label>
              <input id="font--moonflower" data-font="font--moonflower" name="fontFrontside" type="radio" value="moonflower" class="js-input-font-radio">
            </div>
          </div>
          <!-- end .font__options-container -->
    
        </div>
        <!-- end .variant -->
    
        <div class="variant">
          <div class="variant__text" id="engravingText">
            <label for="text">Type your text - Max ${product.dataset.inputlength} ${text.characters}</label>
            <input autocomplete="off" class="font--gilroy input--primary js-engraving-input" id="engraving-text" maxlength="${product.dataset.inputlength}" name="_textFrontside"
                    placeholder="BN" type="text" pattern="[a-zA-Z0-9\xC0-\xD6\xD8-\xF6\xF8-\xFF!@#$%^&*()_+-=[]{};':\\|,.<>/?~ \u2000-\u3300]+" >
          </div>
          <!-- end .form__text -->

          <div class="variant">
            <h6>${text.add_an_icon}</h6>
            <div class="variant__options-container engraving-icon-selector">
              <button class="button--round js-icon-selector" data-icon="star-icon" type="button">
                <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.99978 0.895996C10.5 0.895996 12.5137 7.896 12.5137 7.896C12.5137 7.896 15 7.896 16 7.896C17 7.896 19.9717 7.90664 19.9859 8.15132C20 8.396 13.8278 12.3747 14.0137 12.6354C14.1996 12.896 16.843 19.8854 16.1715 19.8907C15.5 19.896 10.0137 15.896 10.0137 15.896C10.0137 15.896 4.01369 20.3907 3.82804 19.8907C3.64239 19.3907 6.01367 13.396 5.81043 12.6354C5.6072 11.8747 4.70437 11.4466 4.01367 10.8907C3.32297 10.3348 0.00476192 8.3111 0.0136899 8.15132C0.0232642 7.97997 4.51367 7.896 4.51367 7.896H7.51367C7.51367 7.896 9.49955 0.895996 9.99978 0.895996Z"
                    fill="#231F20" />
                </svg>
              </button>

              <button class="button--round js-icon-selector" data-icon="heart-icon" type="button">
                <svg fill="none" height="20" viewBox="0 0 14 20" width="14" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.37765 1.40951C4.67221 0.987655 5.86109 2.46131 6.83861 4.12956C7.07639 3.91863 6.83861 2.85112 7.45947 2.23405C7.95788 1.73867 8.7144 1.42869 9.37488 1.10271C11.3696 0.124768 13.5888 2.79013 13.8398 5.45549C14.0511 7.64147 13.5492 9.52064 12.6113 11.1314C11.5413 12.953 10.3788 14.6788 9.256 16.4429C8.70119 17.3058 8.13317 18.1687 7.55194 18.9932C7.07639 19.6835 6.81219 19.6644 6.32343 19.0316C5.97998 18.5905 5.62331 18.1687 5.27986 17.7468C3.28518 15.2924 1.44903 12.6846 0.392246 9.11796C-0.162563 7.27714 0.128051 4.6693 1.07915 3.19281C1.72643 2.1957 2.4926 1.69714 3.37765 1.40951Z"
                    fill="#231F20" />
                </svg>
              </button>
            </div>
            <!-- end .variant__options-container -->
    
      </div>
      <!-- end .variant -->
      <button class="button button--primary variant-button variant-button--disabled js-choose-variant-button">${text.byo_choose_variant}</button>
      </div>
    </div>
  </div>
    `;
  }
  if (product.dataset.variant === "engrave_backside") {
    return `
    <div class="variant-holder">
      <div class="img-holder">
        <img src="${product.dataset.img}" loading="lazy">
      </div>
      <div class="variant-content">
        <div class="variant-info">
          <h5 class="variant-info__title">${product.dataset.name}</h5>
          <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>${text.byo_per_piece}</span></p>
        </div>
        <div class="initials style-engraving">
          <div class="variant">
            <h6>${text.choose_your_font}</h6>
            <div class="variant__options-container">
      
              <div class="radio--primary">
                <label class="font--avenir" for="font--avenir">Aa</label>
                <input checked id="font--avenir" data-font="font--avenir" name="fontFrontside" type="radio" value="avenir" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--bentham" for="font--bentham">Aa</label>
                <input id="font--bentham" data-font="font--bentham" name="fontFrontside" type="radio" value="bentham" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--cutivemono" for="font--cutivemono">Aa</label>
                <input id="font--cutivemono" data-font="font--cutivemono" name="fontFrontside" type="radio" value="cutivemono" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--moonflower" for="font--moonflower">Aa</label>
                <input id="font--moonflower" data-font="font--moonflower" name="fontFrontside" type="radio" value="moonflower" class="js-input-font-radio">
              </div>
            </div>
            <!-- end .font__options-container -->
      
          </div>
          <!-- end .variant -->
      
          <div class="variant">
            <div class="variant__text" id="engravingText">
              <label for="text">${text.type_your_character_max} ${product.dataset.inputlength} ${text.characters}</label>
              <input autocomplete="off" class="font--gilroy input--primary js-engraving-input" id="engraving-text" maxlength="${product.dataset.inputlength}" name="_textFrontside"
                      placeholder="BN" type="text" pattern="[a-zA-Z0-9\xC0-\xD6\xD8-\xF6\xF8-\xFF!@#$%^&*()_+-=[]{};':\\|,.<>/?~ \u2000-\u3300]+" >
            </div>
            <!-- end .form__text -->

            <div class="checkbox--primary">
              <input id="backsideEngraving" name="backsideEngraving" type="checkbox">
              <label for="backsideEngraving">${text.byo_backside_engraving}</label>
            </div>
            <!-- end .checkbox--primary -->

            <div class="variant js-backside-engraving-inputs backside-hidden">
            <h6>${text.choose_your_font}</h6>
            <div class="variant__options-container">
      
              <div class="radio--primary">
                <label class="font--avenir" for="font--avenir-back">Aa</label>
                <input checked id="font--avenir-back" data-font="font--avenir" name="fontBackside" type="radio" value="back-avenir" class="js-input-font-backside">
              </div>
      
              <div class="radio--primary">
                <label class="font--bentham" for="font--bentham-back">Aa</label>
                <input id="font--bentham-back" data-font="font--bentham" name="fontBackside" type="radio" value="back-bentham" class="js-input-font-backside">
              </div>
      
              <div class="radio--primary">
                <label class="font--cutivemono" for="font--cutivemono-back">Aa</label>
                <input id="font--cutivemono-back" data-font="font--cutivemono" name="fontBackside" type="radio" value="back-cutivemono" class="js-input-font-backside">
              </div>
      
              <div class="radio--primary">
                <label class="font--moonflower" for="font--moonflower-back">Aa</label>
                <input id="font--moonflower-back" data-font="font--moonflower" name="fontBackside" type="radio" value="back-moonflower" class="js-input-font-backside">
              </div>
            </div>
            <!-- end .font__options-container -->

            <div class="variant__text" id="engravingText">
              <label for="text">${text.type_your_character_max} ${product.dataset.inputlength} ${text.characters}</label>
              <input autocomplete="off" class="font--gilroy input--primary js-engraving-input-backside" id="engraving-text" maxlength="${product.dataset.inputlength}" name="_textFrontside"
                      placeholder="BN" type="text" pattern="[a-zA-Z0-9\xC0-\xD6\xD8-\xF6\xF8-\xFF!@#$%^&*()_+-=[]{};':\\|,.<>/?~ \u2000-\u3300]+" >
            </div>
            <!-- end .form__text -->
      
          </div>
          <!-- end .variant -->
      
        </div>
        <!-- end .variant -->
          <button class="button button--primary variant-button variant-button--disabled js-choose-variant-button">${text.byo_choose_variant}</button>
        </div>
      </div>
    </div>
    `;
  }
  if (product.dataset.variant === "engrave_editor_all_options") {
    return `
    <div class="variant-holder">
      <div class="img-holder">
        <img src="${product.dataset.img}" loading="lazy">
      </div>
      <div class="variant-content">
        <div class="variant-info">
          <h5 class="variant-info__title">${product.dataset.name}</h5>
          <p class="variant-info__price">${pricing(
      product.dataset.price
    )} <span>per piece</span></p>
        </div>
        <div class="initials style-engraving">
          <div class="variant">
            <h6>${text.choose_your_font}</h6>
            <div class="variant__options-container">
      
              <div class="radio--primary">
                <label class="font--avenir" for="font--avenir">Aa</label>
                <input checked id="font--avenir" data-font="font--avenir" name="fontFrontside" type="radio" value="avenir" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--bentham" for="font--bentham">Aa</label>
                <input id="font--bentham" data-font="font--bentham" name="fontFrontside" type="radio" value="bentham" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--cutivemono" for="font--cutivemono">Aa</label>
                <input id="font--cutivemono" data-font="font--cutivemono" name="fontFrontside" type="radio" value="cutivemono" class="js-input-font-radio">
              </div>
      
              <div class="radio--primary">
                <label class="font--moonflower" for="font--moonflower">Aa</label>
                <input id="font--moonflower" data-font="font--moonflower" name="fontFrontside" type="radio" value="moonflower" class="js-input-font-radio">
              </div>
            </div>
            <!-- end .font__options-container -->
      
          </div>
          <!-- end .variant -->
      
          <div class="variant">
            <div class="variant__text" id="engravingText">
              <label for="text">${text.type_your_character_max} ${product.dataset.inputlength} ${text.characters}</label>
              <input autocomplete="off" class="font--gilroy input--primary js-engraving-input" id="engraving-text" maxlength="${product.dataset.inputlength}" name="_textFrontside"
                      placeholder="BN" type="text" pattern="[a-zA-Z0-9\xC0-\xD6\xD8-\xF6\xF8-\xFF!@#$%^&*()_+-=[]{};':\\|,.<>/?~ \u2000-\u3300]+" >
            </div>
            <!-- end .form__text -->

            <div class="variant">
              <h6>${text.add_an_icon}</h6>
              <div class="variant__options-container engraving-icon-selector">
                <button class="button--round js-icon-selector" data-icon="star-icon" type="button">
                  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.99978 0.895996C10.5 0.895996 12.5137 7.896 12.5137 7.896C12.5137 7.896 15 7.896 16 7.896C17 7.896 19.9717 7.90664 19.9859 8.15132C20 8.396 13.8278 12.3747 14.0137 12.6354C14.1996 12.896 16.843 19.8854 16.1715 19.8907C15.5 19.896 10.0137 15.896 10.0137 15.896C10.0137 15.896 4.01369 20.3907 3.82804 19.8907C3.64239 19.3907 6.01367 13.396 5.81043 12.6354C5.6072 11.8747 4.70437 11.4466 4.01367 10.8907C3.32297 10.3348 0.00476192 8.3111 0.0136899 8.15132C0.0232642 7.97997 4.51367 7.896 4.51367 7.896H7.51367C7.51367 7.896 9.49955 0.895996 9.99978 0.895996Z"
                      fill="#231F20" />
                  </svg>
                </button>

                <button class="button--round js-icon-selector" data-icon="heart-icon" type="button">
                  <svg fill="none" height="20" viewBox="0 0 14 20" width="14" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.37765 1.40951C4.67221 0.987655 5.86109 2.46131 6.83861 4.12956C7.07639 3.91863 6.83861 2.85112 7.45947 2.23405C7.95788 1.73867 8.7144 1.42869 9.37488 1.10271C11.3696 0.124768 13.5888 2.79013 13.8398 5.45549C14.0511 7.64147 13.5492 9.52064 12.6113 11.1314C11.5413 12.953 10.3788 14.6788 9.256 16.4429C8.70119 17.3058 8.13317 18.1687 7.55194 18.9932C7.07639 19.6835 6.81219 19.6644 6.32343 19.0316C5.97998 18.5905 5.62331 18.1687 5.27986 17.7468C3.28518 15.2924 1.44903 12.6846 0.392246 9.11796C-0.162563 7.27714 0.128051 4.6693 1.07915 3.19281C1.72643 2.1957 2.4926 1.69714 3.37765 1.40951Z"
                      fill="#231F20" />
                  </svg>
                </button>
              </div>
              <!-- end .variant__options-container -->

            <div class="checkbox--primary">
              <input id="backsideEngraving" name="backsideEngraving" type="checkbox">
              <label for="backsideEngraving">${text.byo_backside_engraving}</label>
            </div>
            <!-- end .checkbox--primary -->

            <div class="variant js-backside-engraving-inputs backside-hidden">
            <h6>${text.choose_your_font}</h6>
            <div class="variant__options-container">
      
              <div class="radio--primary">
                <label class="font--avenir" for="font--avenir-back">Aa</label>
                <input checked id="font--avenir-back" data-font="font--avenir" name="fontBackside" type="radio" value="back-avenir" class="js-input-font-backside">
              </div>
      
              <div class="radio--primary">
                <label class="font--bentham" for="font--bentham-back">Aa</label>
                <input id="font--bentham-back" data-font="font--bentham" name="fontBackside" type="radio" value="back-bentham" class="js-input-font-backside">
              </div>
      
              <div class="radio--primary">
                <label class="font--cutivemono" for="font--cutivemono-back">Aa</label>
                <input id="font--cutivemono-back" data-font="font--cutivemono" name="fontBackside" type="radio" value="back-cutivemono" class="js-input-font-backside">
              </div>
      
              <div class="radio--primary">
                <label class="font--moonflower" for="font--moonflower-back">Aa</label>
                <input id="font--moonflower-back" data-font="font--moonflower" name="fontBackside" type="radio" value="back-moonflower" class="js-input-font-backside">
              </div>
            </div>
            <!-- end .font__options-container -->

            <div class="variant__text" id="engravingText">
              <label for="text">Type your text - Max ${product.dataset.inputlength} ${text.characters}</label>
              <input autocomplete="off" class="font--gilroy input--primary js-engraving-input-backside" id="engraving-text" maxlength="${product.dataset.inputlength}" name="_textFrontside"
                      placeholder="BN" type="text" pattern="[a-zA-Z0-9\xC0-\xD6\xD8-\xF6\xF8-\xFF!@#$%^&*()_+-=[]{};':\\|,.<>/?~ \u2000-\u3300]+" >
            </div>
            <!-- end .form__text -->
      
          </div>
          <!-- end .variant -->
      
        </div>
        <!-- end .variant -->
          <button class="button button--primary variant-button variant-button--disabled js-choose-variant-button">${text.byo_choose_variant}</button>
        </div>
      </div>
    </div>
    `;
  }
};
var byo_variants_default = ByoVariants;

// src/services/byo-variant-handleInitialtext.js
var handleInitialText = (product, variantTextInput, defaultPriceElement, variantButton, parsedData) => {
  variantTextInput.addEventListener("input", () => {
    if (variantTextInput.value !== "") {
      product.dataset.initials = variantTextInput.value;
      product.dataset.variantId = parsedData.variants[variantTextInput.value.length - 1].id;
      product.dataset.price = parsedData.variants[variantTextInput.value.length - 1].price;
      defaultPriceElement.innerHTML = `<p>${pricing(parsedData.variants[variantTextInput.value.length - 1].price)} <span>${text.byo_per_piece}</span></p>`;
      if (variantTextInput.value.match(/^[^a-z0-9]+$/i)) {
        variantButton.classList.add("variant-button--disabled");
        variantButton.disabled = true;
      } else {
        variantButton.classList.remove("variant-button--disabled");
        variantButton.disabled = false;
      }
    } else {
      variantButton.classList.add("variant-button--disabled");
    }
  });
};
var byo_variant_handleInitialtext_default = handleInitialText;

// src/services/byo-variant-handleInitialSelect.js
var handleInitialSelect = (product, variantSelectInput, variantButton) => {
  variantSelectInput.addEventListener("change", () => {
    const variantsDataElement = product.querySelector("#variants-data");
    const variantData = variantsDataElement ? JSON.parse(variantsDataElement.innerHTML).variants : null;
    const variantId = variantSelectInput.value;
    const selectedVariant = variantData.find((variant) => Number(variant.id) === Number(variantId));
    const currentVariantImageElement = document.querySelector(".byo-modal .variant-holder .img-holder img");
    const variantImageElement = new Image();
    if (selectedVariant.variant_image && selectedVariant.variant_image !== "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_1000x.gif") {
      variantImageElement.src = selectedVariant.variant_image;
      variantImageElement.alt = selectedVariant.title;
      variantImageElement.onload = () => {
        currentVariantImageElement.replaceWith(variantImageElement);
      };
    }
    product.dataset.initial = variantSelectInput.options[variantSelectInput.selectedIndex].text;
    product.dataset.variantId = variantId;
    variantButton.classList.remove("variant-button--disabled");
    variantButton.disabled = false;
  });
};
var byo_variant_handleInitialSelect_default = handleInitialSelect;

// src/services/byo-variant-handleVariantEngraving.js
var handleVariantEngraving = (product, variantFontInput, variantEngravingInput, variantButton) => {
  variantFontInput.forEach((element) => {
    if (element.checked) {
      product.dataset.fontfront = element.id;
    }
    element.addEventListener("click", () => {
      product.dataset.fontfront = element.id;
      variantEngravingInput.classList.remove("font--gilroy", "font--bentham", "font--avenir", "font--cutivemono", "font--moonflower");
      variantEngravingInput.classList.add(element.id);
    });
  });
  const handleInput = () => {
    if (variantEngravingInput.value !== "" && variantEngravingInput.value.match(/^[a-zA-Z0-9À-ÖØ-öø-ÿ!@#$%^&*()_+\-=\[\]{};':\\|,.<>\/?~ \u2000-\u3300]+$/i) !== null) {
      variantButton.classList.remove("variant-button--disabled");
      variantButton.disabled = false;
    } else {
      variantButton.classList.add("variant-button--disabled");
      variantButton.disabled = true;
    }
  };
  variantEngravingInput.addEventListener("input", () => {
    handleInput();
  });
  variantEngravingInput.addEventListener("change", () => {
    handleInput();
  });
  variantButton.addEventListener("click", () => {
    product.dataset.textfront = JSON.stringify(variantEngravingInput.value);
  });
};
var byo_variant_handleVariantEngraving_default = handleVariantEngraving;

// src/services/byo-variant-handleVariantBacksideEngraving.js
var handleBackSideEngraving = (product, backsideEngravingCheck, backsideInputs, defaultPriceElement, variantFontBacksideInput, variantEngravingInputBackside, parsedData) => {
  const basePrice = product.dataset.price;
  product.dataset.variantId = parsedData.variants[0].id;
  backsideEngravingCheck.addEventListener("change", () => {
    if (backsideEngravingCheck.checked) {
      backsideInputs.classList.remove("backside-hidden");
      const backsideVariant = parsedData.variants.filter((el) => el.options === "yes");
      product.dataset.variantId = backsideVariant[0].id;
      defaultPriceElement.innerHTML = `<p>${pricing(backsideVariant[0].price)} <span>${text.byo_per_piece}</span></p>`;
      product.dataset.price = backsideVariant[0].price;
    } else {
      backsideInputs.classList.add("backside-hidden");
      const backsideVariant = parsedData.variants.filter((el) => el.options === "no");
      product.dataset.variantId = backsideVariant[0].id;
      defaultPriceElement.innerHTML = `<p>${pricing(basePrice)} <span>${text.byo_per_piece}</span></p>`;
    }
  });
  variantFontBacksideInput.forEach((element) => {
    element.addEventListener("click", () => {
      product.dataset.fontback = element.dataset.font;
      variantEngravingInputBackside.classList.remove("font--gilroy", "font--bentham", "font--avenir", "font--cutivemono", "font--moonflower");
      variantEngravingInputBackside.classList.add(element.dataset.font);
    });
  });
  variantEngravingInputBackside.addEventListener("input", () => {
    if (variantEngravingInputBackside.value !== "" && variantEngravingInputBackside.value.match(/^[a-zA-Z0-9À-ÖØ-öø-ÿ!@#$%^&*()_+\-=\[\]{};':\\|,.<>\/?~ \u2000-\u3300]+$/i) == null) {
      product.dataset.textback = variantEngravingInputBackside.value;
    }
  });
};
var byo_variant_handleVariantBacksideEngraving_default = handleBackSideEngraving;

// src/services/byo-variant-handleIcon.js
var handleIcon = (product, iconButtons, variantEngravingInput, variantButton) => {
  iconButtons.forEach((button) => {
    button.addEventListener("click", () => {
      switch (button.dataset.icon) {
        case "star-icon":
          if (variantEngravingInput.value !== void 0 && variantEngravingInput.value.length <= variantEngravingInput.maxLength) {
            variantEngravingInput.value += "\u2605";
            if (product.dataset.textfront === void 0) {
              product.dataset.textfront = "";
              product.dataset.textfront += "\u2605";
              variantButton.disabled = false;
              variantButton.classList.remove("variant-button--disabled");
            } else {
              product.dataset.textfront += "\u2605";
              variantButton.disabled = false;
              variantButton.classList.remove("variant-button--disabled");
            }
          }
          break;
        case "heart-icon":
          if (variantEngravingInput.value !== void 0 && variantEngravingInput.value.length <= variantEngravingInput.maxLength) {
            variantEngravingInput.value += "\u2665";
            if (product.dataset.textfront === void 0) {
              product.dataset.textfront = "";
              product.dataset.textfront += "\u2665";
              variantButton.disabled = false;
              variantButton.classList.remove("variant-button--disabled");
            } else {
              product.dataset.textfront += "\u2665";
              variantButton.disabled = false;
              variantButton.classList.remove("variant-button--disabled");
            }
          }
          break;
        default:
          break;
      }
    });
  });
};
var byo_variant_handleIcon_default = handleIcon;

// src/services/byo-variant-handleInitialDefault.js
var handleInitialSelectDefault = (product, variantSelectInput, variantButton) => {
  variantSelectInput.addEventListener("change", () => {
    product.dataset.initial = variantSelectInput.options[variantSelectInput.selectedIndex].text;
    variantButton.classList.remove("variant-button--disabled");
    variantButton.disabled = false;
  });
};
var byo_variant_handleInitialDefault_default = handleInitialSelectDefault;

// src/services/byo-default-price.js
var handleDefaultPrice = (price) => {
  const defaultPriceElement = document.querySelector(".js-default-price");
  const subTotal = document.querySelector(".js-subtotal");
  defaultPriceElement.outerHTML = `<p class="js-default-price" data-price="${price}"><span class="money">${pricing(price)}</span></p>`;
  subTotal.outerHTML = `
    <div class="js-subtotal subtotal">
      <p>${text.subtotal}</p>
      <p><span class="money">${pricing(price)}</span></p>
    </div>
  `;
};
var byo_default_price_default = handleDefaultPrice;

// src/extenders/byo-modal.js
var ByoModal = class extends HTMLElement {
  constructor() {
    super();
    const addCharmButton = this.querySelector(".js-open-modal");
    const byoModalClose = this.querySelector(".js-close");
    const byoModal = this.querySelector(".js-byo-modal");
    const byoModalBackground = this.querySelector(".byo-modal-background");
    const modalContent = this.querySelector(".byo-modal__inner");
    const defaultModalContent = this.querySelector(".byo-modal__inner").innerHTML;
    const addToCartButton = document.querySelector(".js-byo-add-to-cart-button");
    addToCartButton.disabled = true;
    if (addCharmButton && byoModal) {
      const renderProductDetailsModal = (product) => {
        modalContent.innerHTML = byo_variants_default(product);
        const variantButton = this.querySelector(".js-choose-variant-button");
        const variantButtonDefault = this.querySelector(".js-choose-variant-button-default");
        const variantTextInput = this.querySelector(".js-initial-text");
        const variantSelectInput = this.querySelector(".js-initial-select");
        const variantSelectInputDefault = this.querySelector(".js-initial-select-default");
        const variantEngravingInput = this.querySelector(".js-engraving-input");
        const variantFontInput = this.querySelectorAll(".js-input-font-radio");
        const backsideEngravingCheck = this.querySelector("#backsideEngraving");
        const variantFontBacksideInput = this.querySelectorAll(".js-input-font-backside");
        const backsideInputs = this.querySelector(".js-backside-engraving-inputs");
        const variantEngravingInputBackside = this.querySelector(".js-engraving-input-backside");
        const defaultPriceElement = this.querySelector(".variant-info__price");
        const iconButtons = this.querySelectorAll(".js-icon-selector");
        const variantData = product.querySelector("#variants-data").innerHTML;
        const parsedData = JSON.parse(variantData);
        if (variantButton) {
          variantButton.disabled = true;
        }
        if (variantTextInput) {
          byo_variant_handleInitialtext_default(product, variantTextInput, defaultPriceElement, variantButton, parsedData);
        }
        if (variantSelectInput) {
          byo_variant_handleInitialSelect_default(product, variantSelectInput, variantButton);
        }
        if (variantSelectInputDefault) {
          byo_variant_handleInitialDefault_default(product, variantSelectInputDefault, variantButton);
        }
        if (variantEngravingInput && variantFontInput) {
          byo_variant_handleVariantEngraving_default(product, variantFontInput, variantEngravingInput, variantButton);
        }
        if (backsideInputs && backsideEngravingCheck && variantFontBacksideInput) {
          byo_variant_handleVariantBacksideEngraving_default(
            product,
            backsideEngravingCheck,
            backsideInputs,
            defaultPriceElement,
            variantFontBacksideInput,
            variantEngravingInputBackside,
            parsedData
          );
        }
        if (iconButtons) {
          byo_variant_handleIcon_default(product, iconButtons, variantEngravingInput, variantButton);
        }
        if (variantButtonDefault) {
          variantButtonDefault.addEventListener("click", () => {
            byo_add_product_default(product);
            handleModalState();
          });
        }
        if (variantButton) {
          variantButton.addEventListener("click", () => {
            byo_add_product_default(product);
            handleModalState();
          });
        }
      };
      const handleSizeButton = (e, product) => {
        const updatedProductList = document.querySelectorAll(".byo-product");
        e.preventDefault();
        byo_add_product_default(product);
        byo_default_price_default(product.dataset.price);
        byo_render_price_default(updatedProductList);
        handleModalState();
      };
      const handleClaspButton = (product) => {
        byo_add_product_default(product);
        handleModalState();
      };
      const handleModalButton = (product) => {
        const chooseCharmButton = this.querySelector(".js-choose-charm-button");
        const addSizeButton = this.querySelector(".js-size-button");
        const addClaspButton = this.querySelector(".js-clasp-button");
        const title = this.querySelector(".title");
        if (chooseCharmButton == null ? void 0 : chooseCharmButton.classList.contains("add-button--disabled")) {
          chooseCharmButton.classList.remove("add-button--disabled");
          chooseCharmButton.innerHTML = `${text.byo_choose_this} ${title.innerHTML}`;
          chooseCharmButton.disabled = false;
        }
        if (addSizeButton == null ? void 0 : addSizeButton.classList.contains("add-button--disabled")) {
          addSizeButton.classList.remove("add-button--disabled");
          addSizeButton.innerHTML = `${title.innerHTML}`;
          addSizeButton.disabled = false;
        }
        if (addClaspButton == null ? void 0 : addClaspButton.classList.contains("add-button--disabled")) {
          addClaspButton.classList.remove("add-button--disabled");
          addClaspButton.innerHTML = `${text.byo_choose_this} ${title.innerHTML}`;
          addClaspButton.disabled = false;
        }
        if (addSizeButton) {
          addSizeButton.addEventListener("click", (e) => {
            handleSizeButton(e, product);
          });
        } else if (addClaspButton) {
          addClaspButton.addEventListener("click", () => {
            handleClaspButton(product);
          });
        } else {
          chooseCharmButton.addEventListener("click", () => {
            renderProductDetailsModal(product);
          });
        }
      };
      const handleProducts = () => {
        const collectionProducts = this.querySelectorAll(".byo-product-button");
        const chooseCharmButton = this.querySelector(".js-choose-charm-button");
        const chooseSizeButton = this.querySelector(".js-size-button");
        if (chooseSizeButton) {
          chooseSizeButton.disabled = true;
        }
        if (chooseCharmButton) {
          chooseCharmButton.disabled = true;
        }
        collectionProducts.forEach((product) => {
          product.addEventListener("click", (e) => {
            if (e.target.classList.contains("js-checkbox")) {
              handleModalButton(product);
              e.stopImmediatePropagation();
            }
          });
        });
      };
      const handleModalState = () => {
        if (byoModal.classList.contains("hidden")) {
          byoModal.classList.remove("hidden");
          byoModalBackground.classList.remove("hidden");
          body_lock_default.lock();
        } else {
          byoModal.classList.add("hidden");
          byoModalBackground.classList.add("hidden");
          modalContent.innerHTML = defaultModalContent;
          handleProducts();
          body_lock_default.unlock();
        }
      };
      const handleCharmButton = () => {
        addCharmButton.addEventListener("click", (e) => {
          console.log("clicked");
          e.preventDefault();
          if (byo_product_limiter_default() || byo_size_limiter_default()) {
            if (addCharmButton.classList.contains("disabled")) {
              addCharmButton.classList.remove("disabled");
            }
            handleModalState();
            handleProducts();
          } else {
            addCharmButton.classList.add("disabled");
          }
        });
      };
      const handleCloseButton = () => {
        byoModalClose.addEventListener("click", (e) => {
          e.preventDefault();
          handleModalState();
        });
      };
      handleCharmButton();
      handleCloseButton();
    }
  }
};
customElements.define("byo-modal", ByoModal);

// src/services/byo-get-products.js
var byoGetProducts = () => {
  const products = document.querySelectorAll(".byo-product");
  const productSize = document.querySelectorAll(".byo-product-size");
  const defaultProduct = document.querySelector(".js-byo-add-to-cart-button");
  const byoProducts = {
    items: []
  };
  const addDefaultProduct = () => {
    if (defaultProduct.dataset.id) {
      const data = {
        id: defaultProduct.dataset.id,
        quantity: 1
      };
      byoProducts.items.push(data);
    }
  };
  const structureProduct = (product) => {
    const fontFrontside = product.dataset.fontfront !== "undefined" ? product.dataset.fontfront : null;
    const textFrontside = product.dataset.textfront !== "undefined" ? product.dataset.textfront : null;
    const fontBackside = product.dataset.fontback !== "undefined" ? product.dataset.fontback : null;
    const textBackside = product.dataset.textback !== "undefined" ? product.dataset.textback : null;
    const initial = product.dataset.initial !== "undefined" ? product.dataset.initial : null;
    const multipleInitials = product.dataset.initials !== "undefined" ? product.dataset.initials : null;
    const data = {
      id: product.dataset.id,
      quantity: 1,
      properties: {}
    };
    if (fontFrontside) {
      data.properties.font_frontside = fontFrontside;
    }
    if (textFrontside) {
      data.properties.text_frontside = textFrontside;
    }
    if (fontBackside) {
      data.properties.font_backside = fontBackside;
    }
    if (textBackside) {
      data.properties.text_backside = textBackside;
    }
    if (initial) {
      data.properties.initial = initial.toUpperCase();
    }
    if (multipleInitials) {
      data.properties.initials = multipleInitials.toUpperCase();
    }
    byoProducts.items.push(data);
  };
  products.forEach((product) => {
    structureProduct(product);
  });
  productSize.forEach((product) => {
    structureProduct(product);
  });
  addDefaultProduct();
  return byoProducts;
};
var byo_get_products_default = byoGetProducts;

// src/services/byo-handle-error.js
var byoHandleError = (type) => {
  const fyb = document.querySelector("[data-fyb]");
  if (fyb) {
    return;
  } else {
    if (type === "no_selection") {
      const sizeButton = document.querySelector(".button-required");
      sizeButton.classList.add("add-charm__button--error");
      const title = sizeButton.querySelector("p");
      title.innerHTML = `<p>${text.byo_step_1} - ${text.byo_select_size} <span>- ${text.required}</span></p>`;
    }
  }
};
var byo_handle_error_default = byoHandleError;

// src/extenders/byo-add-to-cart.js
var ByoAddToCart = class extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector(".js-byo-add-to-cart-button");
    const acceptEngraving = this.querySelector("#acceptEngraving");
    const sizeList = document.querySelector(".js-size-list");
    const productList = document.querySelector(".fyb-product-list");
    if (acceptEngraving) {
      console.log("acceptEngraving");
      acceptEngraving.addEventListener("change", () => {
        console.log("acceptEngraving");
        if (productList) {
          if (sizeList && sizeList.children.length === 0 || productList.children.length <= 9) {
            acceptEngraving.checked = false;
            acceptEngraving.disabled = true;
            button.classList.add("disabled--add-to-cart");
            byo_handle_error_default("no_selection");
          }
        }
        if (acceptEngraving.checked) {
          button.disabled = false;
          button.classList.remove("disabled--add-to-cart");
        } else {
          button.disabled = true;
          button.classList.add("disabled--add-to-cart");
        }
      });
    } else {
      button.disabled = false;
      button.classList.remove("disabled--add-to-cart");
    }
    button.addEventListener("click", (event2) => {
      if ((productList == null ? void 0 : productList.children.length) < 1) {
        alert("Please select a product");
        return;
      }
      event2.preventDefault();
      shopifyCart.addByo(byo_get_products_default());
    });
  }
};
customElements.define("byo-add-to-cart", ByoAddToCart);

// src/extenders/surf-slider.js
var import_flickity3 = __toESM(require_js(), 1);
var SurfSlider = class extends HTMLElement {
  constructor() {
    super();
    const sliderElement = this.querySelector(".slider");
    const arrowPath = "M20.2481 52.2971C29.7113 63.5434 34.3962 74.567 43.7426 85.8133C45.6119 88.1517 47.1307 90.8241 48.5327 93.4965C49.8178 96.0575 48.299 98.2845 45.8456 98.6185C42.6912 99.0639 39.3031 99.6207 36.3823 97.0596C26.4518 88.1517 17.6895 78.3529 10.2123 67.552C7.64208 63.8774 4.72133 60.4256 1.80057 57.0851C-0.0687147 54.7468 -0.652866 51.2949 0.865928 48.7339C1.33325 47.8431 2.03423 47.0636 2.61838 46.1729C13.6004 32.3655 24.5825 18.4468 35.5645 4.63942C36.3823 3.63727 37.0833 2.74648 37.9011 1.74433C39.6536 -0.25996 41.406 -0.705351 43.8595 1.29894C48.4159 5.08483 48.8832 6.08698 45.3783 10.7637C41.406 15.9971 42.2122 21.1192 37.7726 25.9072C32.2816 31.8087 26.7906 37.5989 24.1035 45.2821C23.2857 47.509 21.8837 49.402 20.2481 52.2971Z";
    const returnSetValueOrDefault = (setValue, fallback) => setValue || fallback;
    if (sliderElement) {
      const prevNextButtonsSetting = this.dataset.prevNextButtons;
      const pageDotsSetting = this.dataset.pageDots;
      const wrapAroundSetting = this.dataset.wrapAround;
      const imagesLoadedSetting = this.dataset.imagesLoaded;
      const groupCellsSetting = this.dataset.groupCells;
      const containSetting = this.dataset.contain;
      const freeScrollSetting = this.dataset.freeScroll;
      const adaptiveHeightSetting = this.dataset.adaptiveHeight;
      const cellAlignSetting = this.dataset.cellAlign;
      const watchCssSetting = this.dataset.watchCss;
      const flkty = new import_flickity3.default(sliderElement, {
        prevNextButtons: returnSetValueOrDefault(prevNextButtonsSetting, false),
        pageDots: returnSetValueOrDefault(pageDotsSetting, false),
        wrapAround: returnSetValueOrDefault(wrapAroundSetting, false),
        imagesLoaded: returnSetValueOrDefault(imagesLoadedSetting, true),
        groupCells: returnSetValueOrDefault(groupCellsSetting, true),
        contain: returnSetValueOrDefault(containSetting, true),
        freeScroll: returnSetValueOrDefault(freeScrollSetting, false),
        adaptiveHeight: returnSetValueOrDefault(adaptiveHeightSetting, false),
        watchCSS: returnSetValueOrDefault(watchCssSetting, false),
        cellAlign: returnSetValueOrDefault(cellAlignSetting, "center"),
        arrowShape: arrowPath
      });
      const cellElements = flkty.cells ? flkty.cells.length : null;
      if (cellElements && cellElements <= 4) {
        sliderElement.querySelector(
          ".flickity-prev-next-button.next"
        ).style.display = "none";
      }
      console.log("cellElements");
      flkty.on("dragStart", () => {
        document.ontouchmove = () => false;
      });
      flkty.on("dragEnd", () => {
        document.ontouchmove = () => true;
      });
      document.body.addEventListener("touchstart", () => {
        document.ontouchmove = () => true;
      });
      window.addEventListener("resize", () => {
        flkty.resize();
      });
      document.addEventListener("shopify:section:load", () => {
        flkty.resize();
      });
    }
  }
};
if (customElements.get("surf-slider") === void 0) {
  customElements.define("surf-slider", SurfSlider);
}

// src/extenders/usp-slider.js
var import_flickity4 = __toESM(require_js(), 1);
var SurfSlider2 = class extends HTMLElement {
  constructor() {
    super();
    const sliderElement = this.querySelector(".slider");
    const returnSetValueOrDefault = (setValue, fallback) => setValue || fallback;
    const setSliderHeightToMax = (sliderElement2) => {
      if (sliderElement2.cells === 0)
        return false;
      sliderElement2.cells.forEach((cell) => cell.element.style.height = "");
      const heights = sliderElement2.cells.map((cell) => cell.element.offsetHeight);
      const max = Math.max.apply(Math, heights);
      sliderElement2.cells.forEach((cell) => cell.element.style.height = `${max}px`);
    };
    if (sliderElement) {
      const screenWidth = screen.width;
      if (screenWidth < 450) {
        new import_flickity4.default(sliderElement, {
          wrapAround: false,
          prevNextButtons: false,
          pageDots: true,
          imagesLoaded: true,
          contain: false,
          freeScroll: true,
          adaptiveHeight: true,
          cellAlign: "center",
          dragThreshold: 10,
          watchCSS: true,
          on: {
            ready() {
              setSliderHeightToMax(this);
            }
          }
        });
      } else {
        new import_flickity4.default(sliderElement, {
          wrapAround: false,
          prevNextButtons: false,
          pageDots: true,
          imagesLoaded: true,
          contain: true,
          freeScroll: true,
          adaptiveHeight: true,
          cellAlign: "center",
          dragThreshold: 10,
          watchCSS: true,
          on: {
            ready() {
              setSliderHeightToMax(this);
            }
          }
        });
      }
      window.addEventListener("resize", () => {
        const flkty = new import_flickity4.default(sliderElement);
        flkty.resize();
      });
      document.addEventListener("shopify:section:load", () => {
        const flkty = new import_flickity4.default(sliderElement);
        flkty.resize();
      });
    }
  }
};
if (customElements.get("usp-slider") === void 0) {
  customElements.define("usp-slider", SurfSlider2);
}

// src/extenders/estimated-days.js
var estimatedDays = class extends HTMLElement {
  constructor() {
    super();
    const daysElement = this.querySelector(".delivery-button");
    const dateElement = this.querySelector("#date");
    const days = daysElement.dataset.estimated;
    const currentDate = /* @__PURE__ */ new Date();
    const futureDate = currentDate.setDate(currentDate.getDate() + parseInt(days, 10));
    const parsed = new Date(futureDate);
    const day = parsed.getDate();
    const month = parsed.toLocaleString("default", { month: "long" });
    const hours = parsed.getDate();
    if (hours < 23) {
      dateElement.innerHTML = day >= 2 ? `${day - 1} ${month}` : `${day} ${month}`;
    } else {
      dateElement.innerHTML = `${day} ${month}`;
    }
  }
};
customElements.define("estimated-days", estimatedDays);

// src/utils/debounce.js
var debounce2 = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(void 0, args);
    }, timeout);
  };
};

// src/extenders/surf-scroll.js
var SurfScroll = class extends HTMLElement {
  constructor() {
    super();
    const surfScrollElement = this;
    const sliderElement = surfScrollElement.querySelector(
      ".surf-scroll__slider"
    );
    const firstSlideElement = sliderElement.querySelectorAll(
      ".slide:not(.js-hidden)"
    ) ? sliderElement.querySelectorAll(".slide:not(.js-hidden)")[0] : null;
    const grabOverlayElement = surfScrollElement.querySelector(
      ".surf-scroll__grab-overlay"
    );
    const thumbsString = surfScrollElement.dataset.thumbs;
    const thumbsParentElement = thumbsString ? document.querySelector(".is-thumbs-element") : null;
    const indicatorElement = surfScrollElement.querySelector(
      ".surf-scroll__indicator"
    );
    const arrowsElement = surfScrollElement.querySelector(
      ".surf-scroll__arrows"
    );
    let intervalPaused = false;
    let isDown = false;
    let startX;
    let showOverlay;
    const config = {
      attributes: false,
      childList: true,
      subtree: false
    };
    const sliderConfig = {
      devMode: surfScrollElement.dataset.devMode ? surfScrollElement.dataset.devMode === "true" : false,
      grabVelocity: surfScrollElement.dataset.grabVelocity || 100,
      autoScrollDuration: surfScrollElement.dataset.autoScroll,
      enableThumbs: surfScrollElement.dataset.thumbs ? true : false,
      snapAlignStyle: firstSlideElement ? getComputedStyle(firstSlideElement)["scroll-snap-align"] : null
    };
    const updateSliderConfig = () => {
      const refreshedFirstSlideElement = sliderElement.querySelectorAll(
        ".slide:not(.js-hidden)"
      ) ? sliderElement.querySelectorAll(".slide:not(.js-hidden)")[0] : null;
      sliderConfig.snapAlignStyle = refreshedFirstSlideElement ? getComputedStyle(refreshedFirstSlideElement)["scroll-snap-align"] : null;
      if (sliderConfig.devMode) {
        setDevMode();
      }
    };
    const setDevMode = () => {
      var _a, _b;
      let sliderElementPaddingLeft = null;
      let sliderElementPaddingRight = null;
      if (sliderConfig.snapAlignStyle === "start") {
        sliderElementPaddingLeft = getComputedStyle(sliderElement)["paddingLeft"];
        sliderElementPaddingRight = getComputedStyle(sliderElement)["paddingRight"];
      } else if (sliderConfig.snapAlignStyle === "center") {
        sliderElementPaddingLeft = "50%";
        sliderElementPaddingRight = getComputedStyle(sliderElement)["paddingRight"];
      }
      surfScrollElement.classList.add("js-dev-mode");
      (_a = surfScrollElement.querySelector(".js-dev-start-line")) == null ? void 0 : _a.remove();
      (_b = surfScrollElement.querySelector(".js-dev-end-line")) == null ? void 0 : _b.remove();
      surfScrollElement.insertAdjacentHTML(
        "afterBegin",
        `<div style="position:absolute;z-index:50;left:${sliderElementPaddingLeft};width:3px;height:100px;background-color:blue" class="js-dev-start-line"></div><div style="position:absolute;z-index:50;right:${sliderElementPaddingRight};width:3px;height:100px;background-color:red" class="js-dev-end-line"></div>`
      );
    };
    if (sliderConfig.devMode) {
      if (sliderConfig.snapAlignStyle === "end") {
        console.warn(
          "Snap align style is set to end. This is currently not supported."
        );
      }
      window.addEventListener("resize", setDevMode);
      setDevMode();
    }
    const createDotElement = (index) => `<div class="dot" data-index="${index}"></div>`;
    const setActiveThumb = debounce2((activeSlidePostion) => {
      if (thumbsParentElement) {
        const allThumbsElement = thumbsParentElement.querySelectorAll(".slide");
        allThumbsElement.forEach((thumbElement) => {
          if (thumbElement.getAttribute("id") == activeSlidePostion) {
            thumbElement.classList.add("js-active");
          } else {
            thumbElement.classList.remove("js-active");
          }
        });
      }
    }, 100);
    const setActiveIndicator = (activeSlidePostion) => {
      if (indicatorElement) {
        const allIndicatorDots = indicatorElement.querySelectorAll(".dot");
        allIndicatorDots.forEach((dotElement) => {
          dotElement.classList.remove("js-active");
          if (Number(dotElement.dataset.index) === Number(activeSlidePostion)) {
            dotElement.classList.add("js-active");
          }
        });
      }
    };
    const setScrollPosition = debounce2((activeSlidePostion) => {
      const allSlidePositions = getCurrentSlideInView().allSlideWidths;
      if (activeSlidePostion >= 0) {
        const allSlideWidthsBeforeActiveSlide = allSlidePositions.map((slideWidth, index) => {
          if (index <= activeSlidePostion - 1) {
            return slideWidth;
          }
        }).filter((slideWidth) => slideWidth);
        const startingPosition = 0;
        const activeSlidePosition = allSlideWidthsBeforeActiveSlide == null ? void 0 : allSlideWidthsBeforeActiveSlide.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          startingPosition
        );
        sliderElement.scrollTo({
          top: 0,
          left: activeSlidePosition,
          behavior: "smooth"
        });
      }
    }, 10);
    const setStylingArrows = () => {
      const previousArrow = arrowsElement == null ? void 0 : arrowsElement.querySelector(".previous");
      const nextArrow = arrowsElement == null ? void 0 : arrowsElement.querySelector(".next");
      const currentSlide = getCurrentSlideInView();
      if (previousArrow) {
        if (currentSlide.activeSlide == 0) {
          previousArrow.classList.add("js-disabled");
        } else {
          previousArrow.classList.remove("js-disabled");
        }
        previousArrow.addEventListener("click", handlePreviousSlide);
      }
      if (nextArrow) {
        if (currentSlide.isSlideTheLastSlide === true) {
          nextArrow.classList.add("js-disabled");
        } else {
          nextArrow.classList.remove("js-disabled");
        }
        nextArrow.addEventListener("click", handleNextSlide);
      }
    };
    const getPositionOfSlideById = (slideId) => {
      const allSlideElements = sliderElement.querySelectorAll(
        ".slide:not(.js-hidden)"
      );
      const arrayOfAllSlideElements = [...allSlideElements];
      const indexOfNewSlide = arrayOfAllSlideElements.findIndex(
        (slideElement) => slideElement.getAttribute("id") == slideId
      );
      return indexOfNewSlide;
    };
    const setNewDots = debounce2(() => {
      if (indicatorElement) {
        sliderElement.classList.add("js-updating-slides");
        const allSlidesInScroll = sliderElement.querySelectorAll(
          ".slide:not(.js-hidden)"
        );
        const arrayAllSlidesInScroll = [...allSlidesInScroll];
        const startPositionId = surfScrollElement.dataset.startPositionId || 0;
        indicatorElement.innerHTML = "";
        arrayAllSlidesInScroll.map((slide2, index) => {
          indicatorElement.insertAdjacentHTML(
            "beforeEnd",
            createDotElement(index)
          );
        });
        const startPosition = getPositionOfSlideById(startPositionId);
        handleSetNewSlide();
        setScrollPosition(startPosition);
        setStylingArrows(startPosition);
        sliderElement.classList.remove("js-updating-slides");
      }
    }, 10);
    const handleClickNewActiveSlide = (event2) => {
      const thumbElement = event2.target.closest(".slide");
      const dotElement = event2.target.closest(".dot");
      let newActiveSlideIndex = 0;
      if (thumbElement) {
        const newActiveSlideId = thumbElement.getAttribute("id");
        newActiveSlideIndex = getPositionOfSlideById(newActiveSlideId);
        setActiveThumb(newActiveSlideId);
      }
      if (dotElement) {
        newActiveSlideIndex = dotElement.dataset.index;
      }
      setActiveIndicator(newActiveSlideIndex);
      setScrollPosition(newActiveSlideIndex);
      setStylingArrows(newActiveSlideIndex);
    };
    const getSlideIdByPosition = (position) => {
      var _a;
      const allSlidesInScroll = sliderElement.querySelectorAll(
        ".slide:not(.js-hidden)"
      );
      const arrayAllSlidesInScroll = [...allSlidesInScroll];
      return (_a = arrayAllSlidesInScroll[position]) == null ? void 0 : _a.getAttribute("id");
    };
    const handleSetNewSlide = debounce2(() => {
      const activeSlide = getCurrentSlideInView();
      if (thumbsParentElement) {
        const newActiveSlideId = getSlideIdByPosition(activeSlide.activeSlide);
        setActiveThumb(newActiveSlideId);
      }
      if (indicatorElement) {
        setActiveIndicator(activeSlide.activeSlide);
      }
    }, 100);
    const handleScroll3 = debounce2(() => {
      const activeSlide = getCurrentSlideInView();
      intervalPaused = true;
      if (thumbsParentElement) {
        const newActiveSlideId = getSlideIdByPosition(activeSlide.activeSlide);
        setActiveThumb(newActiveSlideId);
      }
      if (indicatorElement) {
        setActiveIndicator(activeSlide.activeSlide);
      }
      if (arrowsElement) {
        setStylingArrows(activeSlide.activeSlide);
      }
    }, 100);
    const getTotalSlidesInView = () => {
      const allSlideElements = sliderElement.querySelectorAll(
        ".slide:not(.js-hidden)"
      );
      const arrayOfAllSlideElements = allSlideElements ? [...allSlideElements] : null;
      const viewportWidth = window.innerWidth;
      const scrollPositionLeft = sliderElement.scrollLeft;
      const sliderElementPaddingLeft = getComputedStyle(sliderElement)["paddingLeft"];
      const paddingLeftValue = sliderElementPaddingLeft.replace("px", "");
      const sliderElementGap = getComputedStyle(sliderElement)["gap"];
      const sliderGapValue = sliderElementGap.replace("px", "");
      const scrollAbleWindow = viewportWidth - (scrollPositionLeft >= paddingLeftValue ? 0 : paddingLeftValue);
      let totalSlidesInView = 0;
      arrayOfAllSlideElements.reduce((previousValue, currentValue) => {
        const halfOfSlide = currentValue.clientWidth / 2;
        if (previousValue - halfOfSlide >= 0) {
          totalSlidesInView++;
          return previousValue - currentValue.clientWidth - sliderGapValue;
        }
        return previousValue;
      }, scrollAbleWindow);
      return totalSlidesInView;
    };
    const getCurrentSlideInView = () => {
      const allSlideElements = sliderElement.querySelectorAll(
        ".slide:not(.js-hidden)"
      );
      const arrayOfAllSlideElements = allSlideElements ? [...allSlideElements] : null;
      const sliderElementPaddingLeft = getComputedStyle(sliderElement)["paddingLeft"];
      const paddingLeftValue = sliderElementPaddingLeft.replace("px", "");
      const sliderElementGap = getComputedStyle(sliderElement)["gap"];
      const sliderGapValue = (sliderElementGap == null ? void 0 : sliderElementGap.split(" ")) ? sliderElementGap == null ? void 0 : sliderElementGap.split(" ")[0].replace("px", "") : sliderElementGap == null ? void 0 : sliderElementGap.replace("px", "");
      const widthOfSliderElement = sliderElement.getBoundingClientRect().width;
      const totalSlidesNumber = arrayOfAllSlideElements.length;
      const activePosition = Number(sliderElement.getBoundingClientRect().left) + Number(paddingLeftValue);
      const currentSlidePositions = arrayOfAllSlideElements.map(
        (slideElement) => {
          const offsetLeft = slideElement.getBoundingClientRect().x;
          const widthImage = slideElement.getBoundingClientRect().width;
          switch (sliderConfig.snapAlignStyle) {
            case "start":
              return Number(offsetLeft) - Number(activePosition);
            case "center":
              return Number(offsetLeft) - Number(activePosition) + Number(widthImage / 2);
            default:
              return offsetLeft;
          }
        }
      );
      const slidePositionsWithWidth = arrayOfAllSlideElements.map(
        (slideElement) => {
          const offsetLeft = slideElement.getBoundingClientRect().x;
          const widthImage = slideElement.getBoundingClientRect().width;
          return Number(offsetLeft) + Number(widthImage);
        }
      );
      const originalSlidePositions = arrayOfAllSlideElements.map(
        (slideElement, index) => {
          const widthImage = slideElement.getBoundingClientRect().width;
          if (index === totalSlidesNumber) {
            return Number(widthImage);
          }
          return Number(widthImage) + Number(sliderGapValue.match(/^[0-9]+$/) ? sliderGapValue : 0);
        }
      );
      if (currentSlidePositions.length > 0) {
        const closestActiveSlide = currentSlidePositions == null ? void 0 : currentSlidePositions.reduce(
          (prev, curr) => Math.abs(curr - 0) < Math.abs(prev - 0) ? curr : prev
        );
        const indexOfClosestActiveSlide = currentSlidePositions == null ? void 0 : currentSlidePositions.findIndex(
          (slidePosition) => slidePosition === closestActiveSlide
        );
        const sliderElementPaddingLeft2 = getComputedStyle(sliderElement)["paddingRight"];
        const paddingRightValue = sliderElementPaddingLeft2.replace("px", "");
        const lastSlidePosition = Math.ceil(
          slidePositionsWithWidth[totalSlidesNumber - 1]
        );
        let isLastSlide = null;
        switch (sliderConfig.snapAlignStyle) {
          case "start":
            isLastSlide = Number(lastSlidePosition) + Number(paddingRightValue) <= Number(widthOfSliderElement) + 10 && Number(lastSlidePosition) + Number(paddingRightValue) >= Number(widthOfSliderElement) - 10;
            break;
          case "center":
            isLastSlide = lastSlidePosition - paddingRightValue === widthOfSliderElement / 2;
            break;
          default:
            isLastSlide = lastSlidePosition === widthOfSliderElement;
            break;
        }
        const returnObject = {
          // activePosition: activePosition,
          allSlideWidths: originalSlidePositions,
          // Including gap.
          currentSlidePositions,
          // totalSlidesInView: totalSlidesInView,
          activeSlide: indexOfClosestActiveSlide,
          isSlideTheLastSlide: isLastSlide
        };
        if (sliderConfig.devMode) {
          console.log(returnObject);
        }
        return returnObject;
      }
      return 0;
    };
    const callback = (mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          setNewDots();
          updateSliderConfig();
        }
      }
    };
    const handlePreviousSlide = () => {
      const currentSlide = getCurrentSlideInView();
      let newSlide = currentSlide.activeSlide;
      if (currentSlide === 0) {
        newSlide = 0;
      } else {
        newSlide -= 1;
      }
      setActiveThumb(newSlide);
      setActiveIndicator(newSlide);
      setScrollPosition(newSlide);
      setStylingArrows(newSlide);
    };
    const handleNextSlide = () => {
      const currentSlide = getCurrentSlideInView();
      const totalSlides = sliderElement.querySelectorAll(
        ".slide:not(.js-hidden)"
      );
      let newSlide = currentSlide.activeSlide;
      if (currentSlide.isSlideTheLastSlide) {
        if (sliderConfig.autoScrollDuration) {
          newSlide = 0;
        } else {
          newSlide = totalSlides.length - 1;
        }
      } else {
        newSlide += 1;
      }
      setActiveThumb(newSlide);
      setActiveIndicator(newSlide);
      setScrollPosition(newSlide);
      setStylingArrows(newSlide);
    };
    const setEventListeners2 = () => {
      if (thumbsParentElement) {
        const allThumbsElement = thumbsParentElement.querySelectorAll(".slide");
        allThumbsElement.forEach((thumbElement) => {
          thumbElement.addEventListener("click", handleClickNewActiveSlide);
        });
      }
      if (indicatorElement) {
        const allIndicatorDots = indicatorElement.querySelectorAll(".dot");
        allIndicatorDots.forEach((dotElement) => {
          dotElement.addEventListener("click", handleClickNewActiveSlide);
        });
      }
      if (arrowsElement) {
        const previousArrow = arrowsElement.querySelector(".previous");
        const nextArrow = arrowsElement.querySelector(".next");
        if (previousArrow) {
          previousArrow.addEventListener("click", handlePreviousSlide);
        }
        if (nextArrow) {
          nextArrow.addEventListener("click", handleNextSlide);
        }
      }
    };
    handleSetNewSlide();
    sliderElement.addEventListener("scroll", handleScroll3);
    sliderElement.addEventListener("mousedown", () => {
      showOverlay = true;
    });
    sliderElement.addEventListener("mousemove", (event2) => {
      if (showOverlay) {
        grabOverlayElement == null ? void 0 : grabOverlayElement.classList.add("js-active");
        const mouseEvent = new MouseEvent("mousedown", event2);
        grabOverlayElement == null ? void 0 : grabOverlayElement.dispatchEvent(mouseEvent);
      }
    });
    sliderElement.addEventListener("mouseup", () => {
      const mouseEvent = new MouseEvent("mouseup");
      grabOverlayElement == null ? void 0 : grabOverlayElement.classList.remove("js-active");
      grabOverlayElement == null ? void 0 : grabOverlayElement.dispatchEvent(mouseEvent);
      showOverlay = false;
    });
    if (grabOverlayElement) {
      grabOverlayElement.addEventListener("mousedown", (event2) => {
        const allSlidesInScroll = sliderElement.querySelectorAll(
          ".slide:not(.js-hidden)"
        );
        const arrayAllSlidesInScroll = [...allSlidesInScroll];
        isDown = true;
        sliderElement.classList.add("js-active");
        startX = event2.pageX - sliderElement.offsetLeft;
        arrayAllSlidesInScroll.map((slideElement) => {
          slideElement.ondragstart = function() {
            return false;
          };
        });
      });
      const handleMouseUpAndOut = () => {
        isDown = false;
        grabOverlayElement.classList.remove("js-active");
        showOverlay = false;
        setTimeout(() => {
          sliderElement.classList.remove("js-active");
        }, 1e3);
      };
      grabOverlayElement.addEventListener(
        "mouseup",
        (event2) => handleMouseUpAndOut(event2)
      );
      grabOverlayElement.addEventListener("mousemove", (event2) => {
        if (!isDown)
          return;
        event2.preventDefault();
        const currentSlide = getCurrentSlideInView();
        const x = event2.pageX - sliderElement.offsetLeft;
        const walk = x - startX;
        if (walk >= -sliderConfig.grabVelocity && walk <= 0) {
          setScrollPosition(currentSlide.activeSlide + 1);
        }
        if (walk >= sliderConfig.grabVelocity && walk >= 0) {
          setScrollPosition(currentSlide.activeSlide - 1);
        }
      });
    }
    sliderElement.addEventListener("touchstart", handleScroll3);
    setTimeout(() => {
      setEventListeners2();
      setNewDots();
    }, 300);
    if (sliderConfig.autoScrollDuration) {
      setInterval(() => {
        if (intervalPaused) {
          intervalPaused = false;
        } else {
          handleNextSlide();
          intervalPaused = false;
        }
      }, Number(sliderConfig.autoScrollDuration));
    }
    const observer = new MutationObserver(callback);
    observer.observe(sliderElement, config);
  }
};
if (customElements.get("surf-scroll") === void 0) {
  customElements.define("surf-scroll", SurfScroll);
}

// src/extenders/surf-expand.js
var SurfExpand = class extends HTMLElement {
  constructor() {
    super();
    const surfExpandElement = this;
    const ariaControls = surfExpandElement.getAttribute("aria-controls");
    const summaryElement = surfExpandElement.querySelector(".surf-expand__summary");
    const contentElement = surfExpandElement.querySelector(`[aria-label="${ariaControls}"]`);
    const iconChevronElement = surfExpandElement.querySelector(".icon-chevron");
    const iconPlusElement = surfExpandElement.querySelector(".icon-plus");
    const currentState = surfExpandElement.getAttribute("aria-expanded");
    const handleExpandElement = (surfExpandElement2, contentElement2) => {
      const currentState2 = surfExpandElement2.getAttribute("aria-expanded");
      if (currentState2 === "true") {
        surfExpandElement2.setAttribute("aria-expanded", "false");
        iconChevronElement == null ? void 0 : iconChevronElement.classList.add("js-closed");
        iconChevronElement == null ? void 0 : iconChevronElement.classList.remove("js-open");
        contentElement2.hidden = true;
      } else {
        surfExpandElement2.setAttribute("aria-expanded", "true");
        iconChevronElement == null ? void 0 : iconChevronElement.classList.remove("js-closed");
        iconChevronElement == null ? void 0 : iconChevronElement.classList.add("js-open");
        contentElement2.hidden = false;
      }
    };
    summaryElement == null ? void 0 : summaryElement.addEventListener("click", () => {
      handleExpandElement(surfExpandElement, contentElement);
    }, true, { passive: true });
    if (currentState === "false") {
      contentElement.hidden = true;
      iconChevronElement == null ? void 0 : iconChevronElement.classList.add("js-closed");
      iconChevronElement == null ? void 0 : iconChevronElement.classList.remove("js-open");
    }
    if (currentState === "true") {
      iconChevronElement == null ? void 0 : iconChevronElement.classList.remove("js-closed");
      iconChevronElement == null ? void 0 : iconChevronElement.classList.add("js-open");
      contentElement.hidden = false;
    }
  }
};
if (customElements.get("surf-expand") === void 0) {
  customElements.define("surf-expand", SurfExpand);
}

// node_modules/swiper/shared/ssr-window.esm.mjs
function isObject2(obj) {
  return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function extend(target, src) {
  if (target === void 0) {
    target = {};
  }
  if (src === void 0) {
    src = {};
  }
  Object.keys(src).forEach((key) => {
    if (typeof target[key] === "undefined")
      target[key] = src[key];
    else if (isObject2(src[key]) && isObject2(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}
var ssrDocument = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function getDocument() {
  const doc = typeof document !== "undefined" ? document : {};
  extend(doc, ssrDocument);
  return doc;
}
var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function CustomEvent2() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === "undefined") {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === "undefined") {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== "undefined" ? window : {};
  extend(win, ssrWindow);
  return win;
}

// node_modules/swiper/shared/utils.mjs
function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach((key) => {
    try {
      object[key] = null;
    } catch (e) {
    }
    try {
      delete object[key];
    } catch (e) {
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle2(el) {
  const window2 = getWindow();
  let style;
  if (window2.getComputedStyle) {
    style = window2.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = "x";
  }
  const window2 = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle2(el);
  if (window2.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(",").length > 6) {
      curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ");
    }
    transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
    matrix = transformMatrix.toString().split(",");
  }
  if (axis === "x") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m41;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[12]);
    else
      curTransform = parseFloat(matrix[4]);
  }
  if (axis === "y") {
    if (window2.WebKitCSSMatrix)
      curTransform = transformMatrix.m42;
    else if (matrix.length === 16)
      curTransform = parseFloat(matrix[13]);
    else
      curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject3(o) {
  return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function isNode(node) {
  if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend2() {
  const to = Object(arguments.length <= 0 ? void 0 : arguments[0]);
  const noExtend = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const nextSource = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== void 0 && desc.enumerable) {
          if (isObject3(to[nextKey]) && isObject3(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend2(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject3(to[nextKey]) && isObject3(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend2(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
  let {
    swiper,
    targetPosition,
    side
  } = _ref;
  const window2 = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = "none";
  window2.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? "next" : "prev";
  const isOutOfBound = (current, target) => {
    return dir === "next" && current >= target || dir === "prev" && current <= target;
  };
  const animate = () => {
    time = (/* @__PURE__ */ new Date()).getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = "hidden";
      swiper.wrapperEl.style.scrollSnapType = "";
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = "";
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window2.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
  };
  animate();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function elementChildren(element, selector) {
  if (selector === void 0) {
    selector = "";
  }
  return [...element.children].filter((el) => el.matches(selector));
}
function createElement(tag, classes2) {
  if (classes2 === void 0) {
    classes2 = [];
  }
  const el = document.createElement(tag);
  el.classList.add(...Array.isArray(classes2) ? classes2 : [classes2]);
  return el;
}
function elementOffset(el) {
  const window2 = getWindow();
  const document2 = getDocument();
  const box = el.getBoundingClientRect();
  const body = document2.body;
  const clientTop = el.clientTop || body.clientTop || 0;
  const clientLeft = el.clientLeft || body.clientLeft || 0;
  const scrollTop = el === window2 ? window2.scrollY : el.scrollTop;
  const scrollLeft = el === window2 ? window2.scrollX : el.scrollLeft;
  return {
    top: box.top + scrollTop - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling;
    if (selector) {
      if (prev.matches(selector))
        prevEls.push(prev);
    } else
      prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling;
    if (selector) {
      if (next.matches(selector))
        nextEls.push(next);
    } else
      nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window2 = getWindow();
  return window2.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1)
        i += 1;
    }
    return i;
  }
  return void 0;
}
function elementParents(el, selector) {
  const parents = [];
  let parent = el.parentElement;
  while (parent) {
    if (selector) {
      if (parent.matches(selector))
        parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el)
      return;
    callback.call(el, e);
    el.removeEventListener("transitionend", fireCallBack);
  }
  if (callback) {
    el.addEventListener("transitionend", fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  const window2 = getWindow();
  if (includeMargins) {
    return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
  }
  return el.offsetWidth;
}

// node_modules/swiper/modules/virtual.mjs
function Virtual(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit
  } = _ref;
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  const document2 = getDocument();
  swiper.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const tempDOM = document2.createElement("div");
  function renderSlide(slide2, index) {
    const params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }
    let slideEl;
    if (params.renderSlide) {
      slideEl = params.renderSlide.call(swiper, slide2, index);
      if (typeof slideEl === "string") {
        tempDOM.innerHTML = slideEl;
        slideEl = tempDOM.children[0];
      }
    } else if (swiper.isElement) {
      slideEl = createElement("swiper-slide");
    } else {
      slideEl = createElement("div", swiper.params.slideClass);
    }
    slideEl.setAttribute("data-swiper-slide-index", index);
    if (!params.renderSlide) {
      slideEl.innerHTML = slide2;
    }
    if (params.cache) {
      swiper.virtual.cache[index] = slideEl;
    }
    return slideEl;
  }
  function update2(force) {
    const {
      slidesPerView,
      slidesPerGroup,
      centeredSlides,
      loop: isLoop
    } = swiper.params;
    const {
      addSlidesBefore,
      addSlidesAfter
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;
    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }
    const activeIndex = swiper.activeIndex || 0;
    let offsetProp;
    if (swiper.rtlTranslate)
      offsetProp = "right";
    else
      offsetProp = swiper.isHorizontal() ? "left" : "top";
    let slidesAfter;
    let slidesBefore;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
    }
    let from = activeIndex - slidesBefore;
    let to = activeIndex + slidesAfter;
    if (!isLoop) {
      from = Math.max(from, 0);
      to = Math.min(to, slides.length - 1);
    }
    let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    if (isLoop && activeIndex >= slidesBefore) {
      from -= slidesBefore;
      if (!centeredSlides)
        offset += swiper.slidesGrid[0];
    } else if (isLoop && activeIndex < slidesBefore) {
      from = -slidesBefore;
      if (centeredSlides)
        offset += swiper.slidesGrid[0];
    }
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid,
      slidesBefore,
      slidesAfter
    });
    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      emit("virtualUpdate");
    }
    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.forEach((slideEl) => {
          slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
      }
      swiper.updateProgress();
      emit("virtualUpdate");
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];
          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()
      });
      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit("virtualUpdate");
      }
      return;
    }
    const prependIndexes = [];
    const appendIndexes = [];
    const getSlideIndex = (index) => {
      let slideIndex = index;
      if (index < 0) {
        slideIndex = slides.length + index;
      } else if (slideIndex >= slides.length) {
        slideIndex = slideIndex - slides.length;
      }
      return slideIndex;
    };
    if (force) {
      swiper.slides.filter((el) => el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl) => {
        slideEl.remove();
      });
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          const slideIndex = getSlideIndex(i);
          swiper.slides.filter((el) => el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl) => {
            slideEl.remove();
          });
        }
      }
    }
    const loopFrom = isLoop ? -slides.length : 0;
    const loopTo = isLoop ? slides.length * 2 : slides.length;
    for (let i = loopFrom; i < loopTo; i += 1) {
      if (i >= from && i <= to) {
        const slideIndex = getSlideIndex(i);
        if (typeof previousTo === "undefined" || force) {
          appendIndexes.push(slideIndex);
        } else {
          if (i > previousTo)
            appendIndexes.push(slideIndex);
          if (i < previousFrom)
            prependIndexes.push(slideIndex);
        }
      }
    }
    appendIndexes.forEach((index) => {
      swiper.slidesEl.append(renderSlide(slides[index], index));
    });
    if (isLoop) {
      for (let i = prependIndexes.length - 1; i >= 0; i -= 1) {
        const index = prependIndexes[i];
        swiper.slidesEl.prepend(renderSlide(slides[index], index));
      }
    } else {
      prependIndexes.sort((a, b) => b - a);
      prependIndexes.forEach((index) => {
        swiper.slidesEl.prepend(renderSlide(slides[index], index));
      });
    }
    elementChildren(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl) => {
      slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
    });
    onRendered();
  }
  function appendSlide(slides) {
    if (typeof slides === "object" && "length" in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i])
          swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }
    update2(true);
  }
  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;
    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i])
          swiper.virtual.slides.unshift(slides[i]);
      }
      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }
    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach((cachedIndex) => {
        const cachedEl = cache[cachedIndex];
        const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
        if (cachedElIndex) {
          cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }
        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
      });
      swiper.virtual.cache = newCache;
    }
    update2(true);
    swiper.slideTo(newActiveIndex, 0);
  }
  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === "undefined" || slidesIndexes === null)
      return;
    let activeIndex = swiper.activeIndex;
    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
          Object.keys(swiper.virtual.cache).forEach((key) => {
            if (key > slidesIndexes) {
              swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
              swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
              delete swiper.virtual.cache[key];
            }
          });
        }
        swiper.virtual.slides.splice(slidesIndexes[i], 1);
        if (slidesIndexes[i] < activeIndex)
          activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
        Object.keys(swiper.virtual.cache).forEach((key) => {
          if (key > slidesIndexes) {
            swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
            swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
            delete swiper.virtual.cache[key];
          }
        });
      }
      swiper.virtual.slides.splice(slidesIndexes, 1);
      if (slidesIndexes < activeIndex)
        activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }
    update2(true);
    swiper.slideTo(activeIndex, 0);
  }
  function removeAllSlides() {
    swiper.virtual.slides = [];
    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }
    update2(true);
    swiper.slideTo(0, 0);
  }
  on3("beforeInit", () => {
    if (!swiper.params.virtual.enabled)
      return;
    let domSlidesAssigned;
    if (typeof swiper.passedParams.virtual.slides === "undefined") {
      const slides = [...swiper.slidesEl.children].filter((el) => el.matches(`.${swiper.params.slideClass}, swiper-slide`));
      if (slides && slides.length) {
        swiper.virtual.slides = [...slides];
        domSlidesAssigned = true;
        slides.forEach((slideEl, slideIndex) => {
          slideEl.setAttribute("data-swiper-slide-index", slideIndex);
          swiper.virtual.cache[slideIndex] = slideEl;
          slideEl.remove();
        });
      }
    }
    if (!domSlidesAssigned) {
      swiper.virtual.slides = swiper.params.virtual.slides;
    }
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
    update2();
  });
  on3("setTranslate", () => {
    if (!swiper.params.virtual.enabled)
      return;
    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update2();
      }, 100);
    } else {
      update2();
    }
  });
  on3("init update resize", () => {
    if (!swiper.params.virtual.enabled)
      return;
    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update: update2
  });
}

// node_modules/swiper/modules/keyboard.mjs
function Keyboard(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit
  } = _ref;
  const document2 = getDocument();
  const window2 = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });
  function handle(event2) {
    if (!swiper.enabled)
      return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event2;
    if (e.originalEvent)
      e = e.originalEvent;
    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40;
    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }
    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return void 0;
    }
    if (document2.activeElement && document2.activeElement.nodeName && (document2.activeElement.nodeName.toLowerCase() === "input" || document2.activeElement.nodeName.toLowerCase() === "textarea")) {
      return void 0;
    }
    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false;
      if (elementParents(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && elementParents(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) {
        return void 0;
      }
      const el = swiper.el;
      const swiperWidth = el.clientWidth;
      const swiperHeight = el.clientHeight;
      const windowWidth = window2.innerWidth;
      const windowHeight = window2.innerHeight;
      const swiperOffset = elementOffset(el);
      if (rtl)
        swiperOffset.left -= el.scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];
      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];
        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0)
            continue;
          inView = true;
        }
      }
      if (!inView)
        return void 0;
    }
    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault)
          e.preventDefault();
        else
          e.returnValue = false;
      }
      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl)
        swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl)
        swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault)
          e.preventDefault();
        else
          e.returnValue = false;
      }
      if (isPageDown || isArrowDown)
        swiper.slideNext();
      if (isPageUp || isArrowUp)
        swiper.slidePrev();
    }
    emit("keyPress", kc);
    return void 0;
  }
  function enable() {
    if (swiper.keyboard.enabled)
      return;
    document2.addEventListener("keydown", handle);
    swiper.keyboard.enabled = true;
  }
  function disable() {
    if (!swiper.keyboard.enabled)
      return;
    document2.removeEventListener("keydown", handle);
    swiper.keyboard.enabled = false;
  }
  on3("init", () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on3("destroy", () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}

// node_modules/swiper/modules/mousewheel.mjs
function Mousewheel(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit
  } = _ref;
  const window2 = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];
  function normalize(e) {
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0;
    let pX = 0;
    let pY = 0;
    if ("detail" in e) {
      sY = e.detail;
    }
    if ("wheelDelta" in e) {
      sY = -e.wheelDelta / 120;
    }
    if ("wheelDeltaY" in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ("wheelDeltaX" in e) {
      sX = -e.wheelDeltaX / 120;
    }
    if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }
    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;
    if ("deltaY" in e) {
      pY = e.deltaY;
    }
    if ("deltaX" in e) {
      pX = e.deltaX;
    }
    if (e.shiftKey && !pX) {
      pX = pY;
      pY = 0;
    }
    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }
    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }
  function handleMouseEnter() {
    if (!swiper.enabled)
      return;
    swiper.mouseEntered = true;
  }
  function handleMouseLeave() {
    if (!swiper.enabled)
      return;
    swiper.mouseEntered = false;
  }
  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      return false;
    }
    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      return false;
    }
    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      return true;
    }
    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit("scroll", newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit("scroll", newEvent.raw);
    }
    lastScrollTime = new window2.Date().getTime();
    return false;
  }
  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;
    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      return true;
    }
    return false;
  }
  function handle(event2) {
    let e = event2;
    let disableParentSwiper = true;
    if (!swiper.enabled)
      return;
    if (event2.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`))
      return;
    const params = swiper.params.mousewheel;
    if (swiper.params.cssMode) {
      e.preventDefault();
    }
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== "container") {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    const targetElContainsTarget = targetEl && targetEl.contains(e.target);
    if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges)
      return true;
    if (e.originalEvent)
      e = e.originalEvent;
    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);
    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY))
          delta = -data.pixelX * rtlFactor;
        else
          return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX))
        delta = -data.pixelY;
      else
        return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }
    if (delta === 0)
      return true;
    if (params.invert)
      delta = -delta;
    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate())
      positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate())
      positions = swiper.maxTranslate();
    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested)
      e.stopPropagation();
    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event2
      };
      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift();
      }
      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : void 0;
      recentWheelEvents.push(newEvent);
      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      }
      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = void 0;
        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate())
          position = swiper.minTranslate();
        if (position <= swiper.maxTranslate())
          position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }
        if (swiper.params.loop) {
          swiper.loopFix({
            direction: newEvent.direction < 0 ? "next" : "prev",
            byMousewheel: true
          });
        }
        if (swiper.params.freeMode.sticky) {
          clearTimeout(timeout);
          timeout = void 0;
          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift();
          }
          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : void 0;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);
          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, void 0, snapToThreshold);
            }, 0);
          }
          if (!timeout) {
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, void 0, snapToThreshold);
            }, 500);
          }
        }
        if (!ignoreWheelEvents)
          emit("scroll", e);
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction)
          swiper.autoplay.stop();
        if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) {
          return true;
        }
      }
    }
    if (e.preventDefault)
      e.preventDefault();
    else
      e.returnValue = false;
    return false;
  }
  function events2(method) {
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== "container") {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    targetEl[method]("mouseenter", handleMouseEnter);
    targetEl[method]("mouseleave", handleMouseLeave);
    targetEl[method]("wheel", handle);
  }
  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener("wheel", handle);
      return true;
    }
    if (swiper.mousewheel.enabled)
      return false;
    events2("addEventListener");
    swiper.mousewheel.enabled = true;
    return true;
  }
  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }
    if (!swiper.mousewheel.enabled)
      return false;
    events2("removeEventListener");
    swiper.mousewheel.enabled = false;
    return true;
  }
  on3("init", () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }
    if (swiper.params.mousewheel.enabled)
      enable();
  });
  on3("destroy", () => {
    if (swiper.params.cssMode) {
      enable();
    }
    if (swiper.mousewheel.enabled)
      disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}

// node_modules/swiper/shared/create-element-if-not-defined.mjs
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach((key) => {
      if (!params[key] && params.auto === true) {
        let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = createElement("div", checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}

// node_modules/swiper/modules/navigation.mjs
function Navigation(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit
  } = _ref;
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  });
  swiper.navigation = {
    nextEl: null,
    prevEl: null
  };
  const makeElementsArray = (el) => (Array.isArray(el) ? el : [el]).filter((e) => !!e);
  function getEl(el) {
    let res;
    if (el && typeof el === "string" && swiper.isElement) {
      res = swiper.el.querySelector(el);
      if (res)
        return res;
    }
    if (el) {
      if (typeof el === "string")
        res = [...document.querySelectorAll(el)];
      if (swiper.params.uniqueNavElements && typeof el === "string" && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
        res = swiper.el.querySelector(el);
      }
    }
    if (el && !res)
      return el;
    return res;
  }
  function toggleEl(el, disabled) {
    const params = swiper.params.navigation;
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      if (subEl) {
        subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
        if (subEl.tagName === "BUTTON")
          subEl.disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        }
      }
    });
  }
  function update2() {
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (swiper.params.loop) {
      toggleEl(prevEl, false);
      toggleEl(nextEl, false);
      return;
    }
    toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind)
      return;
    swiper.slidePrev();
    emit("navigationPrev");
  }
  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind)
      return;
    swiper.slideNext();
    emit("navigationNext");
  }
  function init2() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    });
    if (!(params.nextEl || params.prevEl))
      return;
    let nextEl = getEl(params.nextEl);
    let prevEl = getEl(params.prevEl);
    Object.assign(swiper.navigation, {
      nextEl,
      prevEl
    });
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const initButton = (el, dir) => {
      if (el) {
        el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
      }
      if (!swiper.enabled && el) {
        el.classList.add(...params.lockClass.split(" "));
      }
    };
    nextEl.forEach((el) => initButton(el, "next"));
    prevEl.forEach((el) => initButton(el, "prev"));
  }
  function destroy() {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const destroyButton = (el, dir) => {
      el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
      el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
    };
    nextEl.forEach((el) => destroyButton(el, "next"));
    prevEl.forEach((el) => destroyButton(el, "prev"));
  }
  on3("init", () => {
    if (swiper.params.navigation.enabled === false) {
      disable();
    } else {
      init2();
      update2();
    }
  });
  on3("toEdge fromEdge lock unlock", () => {
    update2();
  });
  on3("destroy", () => {
    destroy();
  });
  on3("enable disable", () => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (swiper.enabled) {
      update2();
      return;
    }
    [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.add(swiper.params.navigation.lockClass));
  });
  on3("click", (_s, e) => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    const targetEl = e.target;
    if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl)))
        return;
      let isHidden;
      if (nextEl.length) {
        isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      } else if (prevEl.length) {
        isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit("navigationShow");
      } else {
        emit("navigationHide");
      }
      [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.toggle(swiper.params.navigation.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
    init2();
    update2();
  };
  const disable = () => {
    swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update: update2,
    init: init2,
    destroy
  });
}

// node_modules/swiper/shared/classes-to-selector.mjs
function classesToSelector(classes2) {
  if (classes2 === void 0) {
    classes2 = "";
  }
  return `.${classes2.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}

// node_modules/swiper/modules/pagination.mjs
function Pagination(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit
  } = _ref;
  const pfx = "swiper-pagination";
  extendParams({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: (number) => number,
      formatFractionTotal: (number) => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  const makeElementsArray = (el) => (Array.isArray(el) ? el : [el]).filter((e) => !!e);
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl)
      return;
    bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function onBulletClick(e) {
    const bulletEl = e.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e.preventDefault();
    const index = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index)
        return;
      const realIndex = swiper.realIndex;
      const newSlideIndex = swiper.getSlideIndexByData(index);
      const currentSlideIndex = swiper.getSlideIndexByData(swiper.realIndex);
      const loopFix2 = (dir) => {
        const indexBeforeLoopFix = swiper.activeIndex;
        swiper.loopFix({
          direction: dir,
          activeSlideIndex: newSlideIndex,
          slideTo: false
        });
        const indexAfterFix = swiper.activeIndex;
        if (indexBeforeLoopFix === indexAfterFix) {
          swiper.slideToLoop(realIndex, 0, false, true);
        }
      };
      if (newSlideIndex > swiper.slides.length - swiper.loopedSlides) {
        loopFix2(newSlideIndex > currentSlideIndex ? "next" : "prev");
      } else if (swiper.params.centeredSlides) {
        const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (newSlideIndex < Math.floor(slidesPerView / 2)) {
          loopFix2("prev");
        }
      }
      swiper.slideToLoop(index);
    } else {
      swiper.slideTo(index);
    }
  }
  function update2() {
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled())
      return;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== "undefined") {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
        el.forEach((subEl) => {
          subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== void 0) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach((bulletEl) => {
        const classesToRemove = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`)].map((s) => typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach((bullet) => {
          const bulletIndex = elementIndex(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(" "));
          } else if (swiper.isElement) {
            bullet.setAttribute("part", "bullet");
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, "prev");
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, "next");
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(" "));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            if (bullets[i]) {
              bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
            }
          }
          setSideBullets(firstDisplayedBullet, "prev");
          setSideBullets(lastDisplayedBullet, "next");
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? "right" : "left";
        bullets.forEach((bullet) => {
          bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === "fraction") {
        subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach((fractionEl) => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach((totalEl) => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === "progressbar") {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
        } else {
          progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === "horizontal") {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach((progressEl) => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === "custom" && params.renderCustom) {
        subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
        if (subElIndex === 0)
          emit("paginationRender", subEl);
      } else {
        if (subElIndex === 0)
          emit("paginationRender", subEl);
        emit("paginationUpdate", subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
      }
    });
  }
  function render() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled())
      return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let paginationHTML = "";
    if (params.type === "bullets") {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === "fraction") {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === "progressbar") {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach((subEl) => {
      if (params.type !== "custom") {
        subEl.innerHTML = paginationHTML || "";
      }
      if (params.type === "bullets") {
        swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
      }
    });
    if (params.type !== "custom") {
      emit("paginationRender", el[0]);
    }
  }
  function init2() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: "swiper-pagination"
    });
    const params = swiper.params.pagination;
    if (!params.el)
      return;
    let el;
    if (typeof params.el === "string" && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === "string") {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0)
      return;
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      if (el.length > 1) {
        el = el.filter((subEl) => {
          if (elementParents(subEl, ".swiper")[0] !== swiper.el)
            return false;
          return true;
        })[0];
      }
    }
    if (Array.isArray(el) && el.length === 1)
      el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      if (params.type === "bullets" && params.clickable) {
        subEl.classList.add(...(params.clickableClass || "").split(" "));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === "bullets" && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === "progressbar" && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener("click", onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled())
      return;
    let el = swiper.pagination.el;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || "").split(" "));
          subEl.removeEventListener("click", onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets)
      swiper.pagination.bullets.forEach((subEl) => subEl.classList.remove(...params.bulletActiveClass.split(" ")));
  }
  on3("changeDirection", () => {
    if (!swiper.pagination || !swiper.pagination.el)
      return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on3("init", () => {
    if (swiper.params.pagination.enabled === false) {
      disable();
    } else {
      init2();
      render();
      update2();
    }
  });
  on3("activeIndexChange", () => {
    if (typeof swiper.snapIndex === "undefined") {
      update2();
    }
  });
  on3("snapIndexChange", () => {
    update2();
  });
  on3("snapGridLengthChange", () => {
    render();
    update2();
  });
  on3("destroy", () => {
    destroy();
  });
  on3("enable disable", () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
    }
  });
  on3("lock unlock", () => {
    update2();
  });
  on3("click", (_s, e) => {
    const targetEl = e.target;
    const el = makeElementsArray(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl))
        return;
      const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit("paginationShow");
      } else {
        emit("paginationHide");
      }
      el.forEach((subEl) => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init2();
    render();
    update2();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach((subEl) => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update: update2,
    init: init2,
    destroy
  });
}

// node_modules/swiper/modules/scrollbar.mjs
function Scrollbar(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit
  } = _ref;
  const document2 = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null
  };
  function setTranslate2() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
      dragEl.style.width = `${newSize}px`;
    } else {
      dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
      dragEl.style.height = `${newSize}px`;
    }
    if (params.hide) {
      clearTimeout(timeout);
      el.style.opacity = 1;
      timeout = setTimeout(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = "400ms";
      }, 1e3);
    }
  }
  function setTransition2(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
  }
  function updateSize2() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    const {
      scrollbar
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    dragEl.style.width = "";
    dragEl.style.height = "";
    trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
    if (swiper.params.scrollbar.dragSize === "auto") {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }
    if (swiper.isHorizontal()) {
      dragEl.style.width = `${dragSize}px`;
    } else {
      dragEl.style.height = `${dragSize}px`;
    }
    if (divider >= 1) {
      el.style.display = "none";
    } else {
      el.style.display = "";
    }
    if (swiper.params.scrollbar.hide) {
      el.style.opacity = 0;
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
  }
  function getPointerPosition(e) {
    return swiper.isHorizontal() ? e.clientX : e.clientY;
  }
  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - elementOffset(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }
    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
    e.preventDefault();
    e.stopPropagation();
    wrapperEl.style.transitionDuration = "100ms";
    dragEl.style.transitionDuration = "100ms";
    setDragPosition(e);
    clearTimeout(dragTimeout);
    el.style.transitionDuration = "0ms";
    if (params.hide) {
      el.style.opacity = 1;
    }
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style["scroll-snap-type"] = "none";
    }
    emit("scrollbarDragStart", e);
  }
  function onDragMove(e) {
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    if (!isTouched)
      return;
    if (e.preventDefault)
      e.preventDefault();
    else
      e.returnValue = false;
    setDragPosition(e);
    wrapperEl.style.transitionDuration = "0ms";
    el.style.transitionDuration = "0ms";
    dragEl.style.transitionDuration = "0ms";
    emit("scrollbarDragMove", e);
  }
  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el
    } = scrollbar;
    if (!isTouched)
      return;
    isTouched = false;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style["scroll-snap-type"] = "";
      wrapperEl.style.transitionDuration = "";
    }
    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = "400ms";
      }, 1e3);
    }
    emit("scrollbarDragEnd", e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }
  function events2(method) {
    const {
      scrollbar,
      params
    } = swiper;
    const el = scrollbar.el;
    if (!el)
      return;
    const target = el;
    const activeListener = params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target)
      return;
    const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
    target[eventMethod]("pointerdown", onDragStart, activeListener);
    document2[eventMethod]("pointermove", onDragMove, activeListener);
    document2[eventMethod]("pointerup", onDragEnd, passiveListener);
  }
  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    events2("on");
  }
  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el)
      return;
    events2("off");
  }
  function init2() {
    const {
      scrollbar,
      el: swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const params = swiper.params.scrollbar;
    if (!params.el)
      return;
    let el;
    if (typeof params.el === "string" && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === "string") {
      el = document2.querySelectorAll(params.el);
    } else if (!el) {
      el = params.el;
    }
    if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) {
      el = swiperEl.querySelector(params.el);
    }
    if (el.length > 0)
      el = el[0];
    el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let dragEl;
    if (el) {
      dragEl = el.querySelector(`.${swiper.params.scrollbar.dragClass}`);
      if (!dragEl) {
        dragEl = createElement("div", swiper.params.scrollbar.dragClass);
        el.append(dragEl);
      }
    }
    Object.assign(scrollbar, {
      el,
      dragEl
    });
    if (params.draggable) {
      enableDraggable();
    }
    if (el) {
      el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    }
  }
  function destroy() {
    const params = swiper.params.scrollbar;
    const el = swiper.scrollbar.el;
    if (el) {
      el.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }
    disableDraggable();
  }
  on3("init", () => {
    if (swiper.params.scrollbar.enabled === false) {
      disable();
    } else {
      init2();
      updateSize2();
      setTranslate2();
    }
  });
  on3("update resize observerUpdate lock unlock", () => {
    updateSize2();
  });
  on3("setTranslate", () => {
    setTranslate2();
  });
  on3("setTransition", (_s, duration) => {
    setTransition2(duration);
  });
  on3("enable disable", () => {
    const {
      el
    } = swiper.scrollbar;
    if (el) {
      el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    }
  });
  on3("destroy", () => {
    destroy();
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
    }
    init2();
    updateSize2();
    setTranslate2();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
    }
    destroy();
  };
  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize: updateSize2,
    setTranslate: setTranslate2,
    init: init2,
    destroy
  });
}

// node_modules/swiper/modules/parallax.mjs
function Parallax(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    parallax: {
      enabled: false
    }
  });
  const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const rtlFactor = rtl ? -1 : 1;
    const p = el.getAttribute("data-swiper-parallax") || "0";
    let x = el.getAttribute("data-swiper-parallax-x");
    let y = el.getAttribute("data-swiper-parallax-y");
    const scale = el.getAttribute("data-swiper-parallax-scale");
    const opacity = el.getAttribute("data-swiper-parallax-opacity");
    const rotate = el.getAttribute("data-swiper-parallax-rotate");
    if (x || y) {
      x = x || "0";
      y = y || "0";
    } else if (swiper.isHorizontal()) {
      x = p;
      y = "0";
    } else {
      y = p;
      x = "0";
    }
    if (x.indexOf("%") >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }
    if (y.indexOf("%") >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }
    if (typeof opacity !== "undefined" && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      el.style.opacity = currentOpacity;
    }
    let transform = `translate3d(${x}, ${y}, 0px)`;
    if (typeof scale !== "undefined" && scale !== null) {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      transform += ` scale(${currentScale})`;
    }
    if (rotate && typeof rotate !== "undefined" && rotate !== null) {
      const currentRotate = rotate * progress * -1;
      transform += ` rotate(${currentRotate}deg)`;
    }
    el.style.transform = transform;
  };
  const setTranslate2 = () => {
    const {
      el,
      slides,
      progress,
      snapGrid,
      isElement
    } = swiper;
    const elements = elementChildren(el, elementsSelector);
    if (swiper.isElement) {
      elements.push(...elementChildren(swiper.hostEl, elementsSelector));
    }
    elements.forEach((subEl) => {
      setTransform(subEl, progress);
    });
    slides.forEach((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl) => {
        setTransform(subEl, slideProgress);
      });
    });
  };
  const setTransition2 = function(duration) {
    if (duration === void 0) {
      duration = swiper.params.speed;
    }
    const {
      el,
      hostEl
    } = swiper;
    const elements = [...el.querySelectorAll(elementsSelector)];
    if (swiper.isElement) {
      elements.push(...hostEl.querySelectorAll(elementsSelector));
    }
    elements.forEach((parallaxEl) => {
      let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
      if (duration === 0)
        parallaxDuration = 0;
      parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
    });
  };
  on3("beforeInit", () => {
    if (!swiper.params.parallax.enabled)
      return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on3("init", () => {
    if (!swiper.params.parallax.enabled)
      return;
    setTranslate2();
  });
  on3("setTranslate", () => {
    if (!swiper.params.parallax.enabled)
      return;
    setTranslate2();
  });
  on3("setTransition", (_swiper, duration) => {
    if (!swiper.params.parallax.enabled)
      return;
    setTransition2(duration);
  });
}

// node_modules/swiper/modules/zoom.mjs
function Zoom(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit
  } = _ref;
  const window2 = getWindow();
  extendParams({
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let fakeGestureTouched;
  let fakeGestureMoved;
  const evCache = [];
  const gesture = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  };
  const image = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, "scale", {
    get() {
      return scale;
    },
    set(value) {
      if (scale !== value) {
        const imageEl = gesture.imageEl;
        const slideEl = gesture.slideEl;
        emit("zoomChange", value, imageEl, slideEl);
      }
      scale = value;
    }
  });
  function getDistanceBetweenTouches() {
    if (evCache.length < 2)
      return 1;
    const x1 = evCache[0].pageX;
    const y1 = evCache[0].pageY;
    const x2 = evCache[1].pageX;
    const y2 = evCache[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  }
  function getScaleOrigin() {
    if (evCache.length < 2)
      return {
        x: null,
        y: null
      };
    const box = gesture.imageEl.getBoundingClientRect();
    return [(evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window2.scrollX) / currentScale, (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window2.scrollY) / currentScale];
  }
  function getSlideSelector() {
    return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  }
  function eventWithinSlide(e) {
    const slideSelector = getSlideSelector();
    if (e.target.matches(slideSelector))
      return true;
    if (swiper.slides.filter((slideEl) => slideEl.contains(e.target)).length > 0)
      return true;
    return false;
  }
  function eventWithinZoomContainer(e) {
    const selector = `.${swiper.params.zoom.containerClass}`;
    if (e.target.matches(selector))
      return true;
    if ([...swiper.hostEl.querySelectorAll(selector)].filter((containerEl) => containerEl.contains(e.target)).length > 0)
      return true;
    return false;
  }
  function onGestureStart(e) {
    if (e.pointerType === "mouse") {
      evCache.splice(0, evCache.length);
    }
    if (!eventWithinSlide(e))
      return;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;
    evCache.push(e);
    if (evCache.length < 2) {
      return;
    }
    fakeGestureTouched = true;
    gesture.scaleStart = getDistanceBetweenTouches();
    if (!gesture.slideEl) {
      gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
      if (!gesture.slideEl)
        gesture.slideEl = swiper.slides[swiper.activeIndex];
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = void 0;
      }
      if (!gesture.imageWrapEl) {
        gesture.imageEl = void 0;
        return;
      }
      gesture.maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
    }
    if (gesture.imageEl) {
      const [originX, originY] = getScaleOrigin();
      gesture.originX = originX;
      gesture.originY = originY;
      gesture.imageEl.style.transitionDuration = "0ms";
    }
    isScaling = true;
  }
  function onGestureChange(e) {
    if (!eventWithinSlide(e))
      return;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const pointerIndex = evCache.findIndex((cachedEv) => cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0)
      evCache[pointerIndex] = e;
    if (evCache.length < 2) {
      return;
    }
    fakeGestureMoved = true;
    gesture.scaleMove = getDistanceBetweenTouches();
    if (!gesture.imageEl) {
      return;
    }
    zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
  }
  function onGestureEnd(e) {
    if (!eventWithinSlide(e))
      return;
    if (e.pointerType === "mouse" && e.type === "pointerout")
      return;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const pointerIndex = evCache.findIndex((cachedEv) => cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0)
      evCache.splice(pointerIndex, 1);
    if (!fakeGestureTouched || !fakeGestureMoved) {
      return;
    }
    fakeGestureTouched = false;
    fakeGestureMoved = false;
    if (!gesture.imageEl)
      return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale > 1 && gesture.slideEl) {
      gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
    } else if (zoom.scale <= 1 && gesture.slideEl) {
      gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
    }
    if (zoom.scale === 1) {
      gesture.originX = 0;
      gesture.originY = 0;
      gesture.slideEl = void 0;
    }
  }
  function onTouchStart2(e) {
    const device = swiper.device;
    if (!gesture.imageEl)
      return;
    if (image.isTouched)
      return;
    if (device.android && e.cancelable)
      e.preventDefault();
    image.isTouched = true;
    const event2 = evCache.length > 0 ? evCache[0] : e;
    image.touchesStart.x = event2.pageX;
    image.touchesStart.y = event2.pageY;
  }
  function onTouchMove2(e) {
    if (!eventWithinSlide(e) || !eventWithinZoomContainer(e))
      return;
    const zoom = swiper.zoom;
    if (!gesture.imageEl)
      return;
    if (!image.isTouched || !gesture.slideEl)
      return;
    if (!image.isMoved) {
      image.width = gesture.imageEl.offsetWidth;
      image.height = gesture.imageEl.offsetHeight;
      image.startX = getTranslate(gesture.imageWrapEl, "x") || 0;
      image.startY = getTranslate(gesture.imageWrapEl, "y") || 0;
      gesture.slideWidth = gesture.slideEl.offsetWidth;
      gesture.slideHeight = gesture.slideEl.offsetHeight;
      gesture.imageWrapEl.style.transitionDuration = "0ms";
    }
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight)
      return;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
    image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
    const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
    if (touchesDiff > 5) {
      swiper.allowClick = false;
    }
    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }
      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    e.stopPropagation();
    image.isMoved = true;
    const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
    const {
      originX,
      originY
    } = gesture;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }
    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }
    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }
    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    }
    if (!velocity.prevPositionX)
      velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY)
      velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime)
      velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2)
      velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2)
      velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
  }
  function onTouchEnd2() {
    const zoom = swiper.zoom;
    if (!gesture.imageEl)
      return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY;
    if (velocity.x !== 0)
      momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0)
      momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY;
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
    gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
  }
  function onTransitionEnd() {
    const zoom = swiper.zoom;
    if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
      if (gesture.imageEl) {
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
      }
      if (gesture.imageWrapEl) {
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
      }
      gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
      zoom.scale = 1;
      currentScale = 1;
      gesture.slideEl = void 0;
      gesture.imageEl = void 0;
      gesture.imageWrapEl = void 0;
      gesture.originX = 0;
      gesture.originY = 0;
    }
  }
  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    if (!gesture.slideEl) {
      if (e && e.target) {
        gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
      }
      if (!gesture.slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.slideEl = elementChildren(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
        } else {
          gesture.slideEl = swiper.slides[swiper.activeIndex];
        }
      }
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = void 0;
      }
    }
    if (!gesture.imageEl || !gesture.imageWrapEl)
      return;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = "hidden";
      swiper.wrapperEl.style.touchAction = "none";
    }
    gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;
    if (typeof image.touchesStart.x === "undefined" && e) {
      touchX = e.pageX;
      touchY = e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }
    const forceZoomRatio = typeof e === "number" ? e : null;
    if (currentScale === 1 && forceZoomRatio) {
      touchX = void 0;
      touchY = void 0;
    }
    zoom.scale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
    currentScale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
    if (e && !(currentScale === 1 && forceZoomRatio)) {
      slideWidth = gesture.slideEl.offsetWidth;
      slideHeight = gesture.slideEl.offsetHeight;
      offsetX = elementOffset(gesture.slideEl).left + window2.scrollX;
      offsetY = elementOffset(gesture.slideEl).top + window2.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.imageEl.offsetWidth;
      imageHeight = gesture.imageEl.offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;
      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }
      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    if (forceZoomRatio && zoom.scale === 1) {
      gesture.originX = 0;
      gesture.originY = 0;
    }
    gesture.imageWrapEl.style.transitionDuration = "300ms";
    gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
    gesture.imageEl.style.transitionDuration = "300ms";
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
  }
  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    if (!gesture.slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.slideEl = elementChildren(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
      } else {
        gesture.slideEl = swiper.slides[swiper.activeIndex];
      }
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = void 0;
      }
    }
    if (!gesture.imageEl || !gesture.imageWrapEl)
      return;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = "";
      swiper.wrapperEl.style.touchAction = "";
    }
    zoom.scale = 1;
    currentScale = 1;
    gesture.imageWrapEl.style.transitionDuration = "300ms";
    gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
    gesture.imageEl.style.transitionDuration = "300ms";
    gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
    gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
    gesture.slideEl = void 0;
    gesture.originX = 0;
    gesture.originY = 0;
  }
  function zoomToggle(e) {
    const zoom = swiper.zoom;
    if (zoom.scale && zoom.scale !== 1) {
      zoomOut();
    } else {
      zoomIn(e);
    }
  }
  function getListeners() {
    const passiveListener = swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = swiper.params.passiveListeners ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }
  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled)
      return;
    zoom.enabled = true;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
    swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
    ["pointerup", "pointercancel", "pointerout"].forEach((eventName) => {
      swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
    });
    swiper.wrapperEl.addEventListener("pointermove", onTouchMove2, activeListenerWithCapture);
  }
  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled)
      return;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();
    swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
    swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
    ["pointerup", "pointercancel", "pointerout"].forEach((eventName) => {
      swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
    });
    swiper.wrapperEl.removeEventListener("pointermove", onTouchMove2, activeListenerWithCapture);
  }
  on3("init", () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on3("destroy", () => {
    disable();
  });
  on3("touchStart", (_s, e) => {
    if (!swiper.zoom.enabled)
      return;
    onTouchStart2(e);
  });
  on3("touchEnd", (_s, e) => {
    if (!swiper.zoom.enabled)
      return;
    onTouchEnd2();
  });
  on3("doubleTap", (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on3("transitionEnd", () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on3("slideChange", () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}

// node_modules/swiper/modules/controller.mjs
function Controller(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    controller: {
      control: void 0,
      inverse: false,
      by: "slide"
      // or 'container'
    }
  });
  swiper.controller = {
    control: void 0
  };
  function LinearSpline(x, y) {
    const binarySearch = /* @__PURE__ */ function search3() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    let i1;
    let i3;
    this.interpolate = function interpolate(x2) {
      if (!x2)
        return 0;
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;
      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  }
  function getInterpolateFunction(c) {
    swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
  }
  function setTranslate2(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper2 = swiper.constructor;
    function setControlledTranslate(c) {
      if (c.destroyed)
        return;
      const translate2 = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === "slide") {
        getInterpolateFunction(c);
        controlledTranslate = -swiper.controller.spline.interpolate(-translate2);
      }
      if (!controlledTranslate || swiper.params.controller.by === "container") {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) {
          multiplier = 1;
        }
        controlledTranslate = (translate2 - swiper.minTranslate()) * multiplier + c.minTranslate();
      }
      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper2) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper2 && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }
  function setTransition2(duration, byController) {
    const Swiper2 = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;
    function setControlledTransition(c) {
      if (c.destroyed)
        return;
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }
        elementTransitionEnd(c.wrapperEl, () => {
          if (!controlled)
            return;
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper2) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper2 && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
  function removeSpline() {
    if (!swiper.controller.control)
      return;
    if (swiper.controller.spline) {
      swiper.controller.spline = void 0;
      delete swiper.controller.spline;
    }
  }
  on3("beforeInit", () => {
    if (typeof window !== "undefined" && // eslint-disable-line
    (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
      const controlElement = document.querySelector(swiper.params.controller.control);
      if (controlElement && controlElement.swiper) {
        swiper.controller.control = controlElement.swiper;
      } else if (controlElement) {
        const onControllerSwiper = (e) => {
          swiper.controller.control = e.detail[0];
          swiper.update();
          controlElement.removeEventListener("init", onControllerSwiper);
        };
        controlElement.addEventListener("init", onControllerSwiper);
      }
      return;
    }
    swiper.controller.control = swiper.params.controller.control;
  });
  on3("update", () => {
    removeSpline();
  });
  on3("resize", () => {
    removeSpline();
  });
  on3("observerUpdate", () => {
    removeSpline();
  });
  on3("setTranslate", (_s, translate2, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed)
      return;
    swiper.controller.setTranslate(translate2, byController);
  });
  on3("setTransition", (_s, duration, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed)
      return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate: setTranslate2,
    setTransition: setTransition2
  });
}

// node_modules/swiper/modules/a11y.mjs
function A11y(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;
  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0)
      return;
    notification.innerHTML = "";
    notification.innerHTML = message;
  }
  const makeElementsArray = (el) => (Array.isArray(el) ? el : [el]).filter((e) => !!e);
  function getRandomNumber(size) {
    if (size === void 0) {
      size = 16;
    }
    const randomChar = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(size).replace(/x/g, randomChar);
  }
  function makeElFocusable(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("tabIndex", "0");
    });
  }
  function makeElNotFocusable(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("tabIndex", "-1");
    });
  }
  function addElRole(el, role) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("role", role);
    });
  }
  function addElRoleDescription(el, description) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-roledescription", description);
    });
  }
  function addElControls(el, controls) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-controls", controls);
    });
  }
  function addElLabel(el, label) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-label", label);
    });
  }
  function addElId(el, id) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("id", id);
    });
  }
  function addElLive(el, live) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-live", live);
    });
  }
  function disableEl(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-disabled", true);
    });
  }
  function enableEl(el) {
    el = makeElementsArray(el);
    el.forEach((subEl) => {
      subEl.setAttribute("aria-disabled", false);
    });
  }
  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32)
      return;
    const params = swiper.params.a11y;
    const targetEl = e.target;
    if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
      if (!e.target.matches(classesToSelector(swiper.params.pagination.bulletClass)))
        return;
    }
    if (swiper.navigation && swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }
      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }
    if (swiper.navigation && swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }
      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }
    if (swiper.pagination && targetEl.matches(classesToSelector(swiper.params.pagination.bulletClass))) {
      targetEl.click();
    }
  }
  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation)
      return;
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (prevEl) {
      if (swiper.isBeginning) {
        disableEl(prevEl);
        makeElNotFocusable(prevEl);
      } else {
        enableEl(prevEl);
        makeElFocusable(prevEl);
      }
    }
    if (nextEl) {
      if (swiper.isEnd) {
        disableEl(nextEl);
        makeElNotFocusable(nextEl);
      } else {
        enableEl(nextEl);
        makeElFocusable(nextEl);
      }
    }
  }
  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }
  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }
  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination())
      return;
    swiper.pagination.bullets.forEach((bulletEl) => {
      if (swiper.params.pagination.clickable) {
        makeElFocusable(bulletEl);
        if (!swiper.params.pagination.renderBullet) {
          addElRole(bulletEl, "button");
          addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, elementIndex(bulletEl) + 1));
        }
      }
      if (bulletEl.matches(classesToSelector(swiper.params.pagination.bulletActiveClass))) {
        bulletEl.setAttribute("aria-current", "true");
      } else {
        bulletEl.removeAttribute("aria-current");
      }
    });
  }
  const initNavEl = (el, wrapperId, message) => {
    makeElFocusable(el);
    if (el.tagName !== "BUTTON") {
      addElRole(el, "button");
      el.addEventListener("keydown", onEnterOrSpaceKey);
    }
    addElLabel(el, message);
    addElControls(el, wrapperId);
  };
  const handlePointerDown = () => {
    swiper.a11y.clicked = true;
  };
  const handlePointerUp = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };
  const handleFocus = (e) => {
    if (swiper.a11y.clicked)
      return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
    if (!slideEl || !swiper.slides.includes(slideEl))
      return;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible)
      return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents)
      return;
    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }
    swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
  };
  const initSlides = () => {
    const params = swiper.params.a11y;
    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
    }
    if (params.slideRole) {
      addElRole(swiper.slides, params.slideRole);
    }
    const slidesLength = swiper.slides.length;
    if (params.slideLabelMessage) {
      swiper.slides.forEach((slideEl, index) => {
        const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel(slideEl, ariaLabelMessage);
      });
    }
  };
  const init2 = () => {
    const params = swiper.params.a11y;
    swiper.el.append(liveRegion);
    const containerEl = swiper.el;
    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
    }
    if (params.containerMessage) {
      addElLabel(containerEl, params.containerMessage);
    }
    const wrapperEl = swiper.wrapperEl;
    const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
    addElId(wrapperEl, wrapperId);
    addElLive(wrapperEl, live);
    initSlides();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach((el) => initNavEl(el, wrapperId, params.nextSlideMessage));
    }
    if (prevEl) {
      prevEl.forEach((el) => initNavEl(el, wrapperId, params.prevSlideMessage));
    }
    if (hasClickablePagination()) {
      const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [swiper.pagination.el];
      paginationEl.forEach((el) => {
        el.addEventListener("keydown", onEnterOrSpaceKey);
      });
    }
    swiper.el.addEventListener("focus", handleFocus, true);
    swiper.el.addEventListener("pointerdown", handlePointerDown, true);
    swiper.el.addEventListener("pointerup", handlePointerUp, true);
  };
  function destroy() {
    if (liveRegion)
      liveRegion.remove();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = makeElementsArray(nextEl);
    prevEl = makeElementsArray(prevEl);
    if (nextEl) {
      nextEl.forEach((el) => el.removeEventListener("keydown", onEnterOrSpaceKey));
    }
    if (prevEl) {
      prevEl.forEach((el) => el.removeEventListener("keydown", onEnterOrSpaceKey));
    }
    if (hasClickablePagination()) {
      const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [swiper.pagination.el];
      paginationEl.forEach((el) => {
        el.removeEventListener("keydown", onEnterOrSpaceKey);
      });
    }
    swiper.el.removeEventListener("focus", handleFocus, true);
    swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
    swiper.el.removeEventListener("pointerup", handlePointerUp, true);
  }
  on3("beforeInit", () => {
    liveRegion = createElement("span", swiper.params.a11y.notificationClass);
    liveRegion.setAttribute("aria-live", "assertive");
    liveRegion.setAttribute("aria-atomic", "true");
  });
  on3("afterInit", () => {
    if (!swiper.params.a11y.enabled)
      return;
    init2();
  });
  on3("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    if (!swiper.params.a11y.enabled)
      return;
    initSlides();
  });
  on3("fromEdge toEdge afterInit lock unlock", () => {
    if (!swiper.params.a11y.enabled)
      return;
    updateNavigation();
  });
  on3("paginationUpdate", () => {
    if (!swiper.params.a11y.enabled)
      return;
    updatePagination();
  });
  on3("destroy", () => {
    if (!swiper.params.a11y.enabled)
      return;
    destroy();
  });
}

// node_modules/swiper/modules/history.mjs
function History(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    history: {
      enabled: false,
      root: "",
      replaceState: false,
      key: "slides",
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};
  const slugify = (text2) => {
    return text2.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
  };
  const getPathValues = (urlOverride) => {
    const window2 = getWindow();
    let location2;
    if (urlOverride) {
      location2 = new URL(urlOverride);
    } else {
      location2 = window2.location;
    }
    const pathArray = location2.pathname.slice(1).split("/").filter((part) => part !== "");
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };
  const setHistory = (key, index) => {
    const window2 = getWindow();
    if (!initialized || !swiper.params.history.enabled)
      return;
    let location2;
    if (swiper.params.url) {
      location2 = new URL(swiper.params.url);
    } else {
      location2 = window2.location;
    }
    const slide2 = swiper.slides[index];
    let value = slugify(slide2.getAttribute("data-history"));
    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === "/")
        root = root.slice(0, root.length - 1);
      value = `${root}/${key ? `${key}/` : ""}${value}`;
    } else if (!location2.pathname.includes(key)) {
      value = `${key ? `${key}/` : ""}${value}`;
    }
    if (swiper.params.history.keepQuery) {
      value += location2.search;
    }
    const currentState = window2.history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      window2.history.replaceState({
        value
      }, null, value);
    } else {
      window2.history.pushState({
        value
      }, null, value);
    }
  };
  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide2 = swiper.slides[i];
        const slideHistory = slugify(slide2.getAttribute("data-history"));
        if (slideHistory === value) {
          const index = swiper.getSlideIndex(slide2);
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };
  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };
  const init2 = () => {
    const window2 = getWindow();
    if (!swiper.params.history)
      return;
    if (!window2.history || !window2.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) {
      if (!swiper.params.history.replaceState) {
        window2.addEventListener("popstate", setHistoryPopState);
      }
      return;
    }
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      window2.addEventListener("popstate", setHistoryPopState);
    }
  };
  const destroy = () => {
    const window2 = getWindow();
    if (!swiper.params.history.replaceState) {
      window2.removeEventListener("popstate", setHistoryPopState);
    }
  };
  on3("init", () => {
    if (swiper.params.history.enabled) {
      init2();
    }
  });
  on3("destroy", () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on3("transitionEnd _freeModeNoMomentumRelease", () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on3("slideChange", () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}

// node_modules/swiper/modules/hash-navigation.mjs
function HashNavigation(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    on: on3
  } = _ref;
  let initialized = false;
  const document2 = getDocument();
  const window2 = getWindow();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false,
      getSlideIndex(_s, hash) {
        if (swiper.virtual && swiper.params.virtual.enabled) {
          const slideWithHash = swiper.slides.filter((slideEl) => slideEl.getAttribute("data-hash") === hash)[0];
          if (!slideWithHash)
            return 0;
          const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
          return index;
        }
        return swiper.getSlideIndex(elementChildren(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
      }
    }
  });
  const onHashChange = () => {
    emit("hashChange");
    const newHash = document2.location.hash.replace("#", "");
    const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
    const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
    if (newHash !== activeSlideHash) {
      const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
      if (typeof newIndex === "undefined" || Number.isNaN(newIndex))
        return;
      swiper.slideTo(newIndex);
    }
  };
  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled)
      return;
    const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
    const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
    if (swiper.params.hashNavigation.replaceState && window2.history && window2.history.replaceState) {
      window2.history.replaceState(null, null, `#${activeSlideHash}` || "");
      emit("hashSet");
    } else {
      document2.location.hash = activeSlideHash || "";
      emit("hashSet");
    }
  };
  const init2 = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled)
      return;
    initialized = true;
    const hash = document2.location.hash.replace("#", "");
    if (hash) {
      const speed = 0;
      const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
      swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
    }
    if (swiper.params.hashNavigation.watchState) {
      window2.addEventListener("hashchange", onHashChange);
    }
  };
  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      window2.removeEventListener("hashchange", onHashChange);
    }
  };
  on3("init", () => {
    if (swiper.params.hashNavigation.enabled) {
      init2();
    }
  });
  on3("destroy", () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on3("transitionEnd _freeModeNoMomentumRelease", () => {
    if (initialized) {
      setHash();
    }
  });
  on3("slideChange", () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}

// node_modules/swiper/modules/autoplay.mjs
function Autoplay(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit,
    params
  } = _ref;
  swiper.autoplay = {
    running: false,
    paused: false,
    timeLeft: 0
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3e3,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });
  let timeout;
  let raf;
  let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3e3;
  let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3e3;
  let autoplayTimeLeft;
  let autoplayStartTime = (/* @__PURE__ */ new Date()).getTime;
  let wasPaused;
  let isTouched;
  let pausedByTouch;
  let touchStartTimeout;
  let slideChanged;
  let pausedByInteraction;
  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.wrapperEl)
      return;
    if (e.target !== swiper.wrapperEl)
      return;
    swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
    resume();
  }
  const calcTimeLeft = () => {
    if (swiper.destroyed || !swiper.autoplay.running)
      return;
    if (swiper.autoplay.paused) {
      wasPaused = true;
    } else if (wasPaused) {
      autoplayDelayCurrent = autoplayTimeLeft;
      wasPaused = false;
    }
    const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - (/* @__PURE__ */ new Date()).getTime();
    swiper.autoplay.timeLeft = timeLeft;
    emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
    raf = requestAnimationFrame(() => {
      calcTimeLeft();
    });
  };
  const getSlideDelay = () => {
    let activeSlideEl;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      activeSlideEl = swiper.slides.filter((slideEl) => slideEl.classList.contains("swiper-slide-active"))[0];
    } else {
      activeSlideEl = swiper.slides[swiper.activeIndex];
    }
    if (!activeSlideEl)
      return void 0;
    const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
    return currentSlideDelay;
  };
  const run = (delayForce) => {
    if (swiper.destroyed || !swiper.autoplay.running)
      return;
    cancelAnimationFrame(raf);
    calcTimeLeft();
    let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
    autoplayDelayTotal = swiper.params.autoplay.delay;
    autoplayDelayCurrent = swiper.params.autoplay.delay;
    const currentSlideDelay = getSlideDelay();
    if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
      delay = currentSlideDelay;
      autoplayDelayTotal = currentSlideDelay;
      autoplayDelayCurrent = currentSlideDelay;
    }
    autoplayTimeLeft = delay;
    const speed = swiper.params.speed;
    const proceed = () => {
      if (!swiper || swiper.destroyed)
        return;
      if (swiper.params.autoplay.reverseDirection) {
        if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
          swiper.slidePrev(speed, true, true);
          emit("autoplay");
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, speed, true, true);
          emit("autoplay");
        }
      } else {
        if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
          swiper.slideNext(speed, true, true);
          emit("autoplay");
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, speed, true, true);
          emit("autoplay");
        }
      }
      if (swiper.params.cssMode) {
        autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
        requestAnimationFrame(() => {
          run();
        });
      }
    };
    if (delay > 0) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        proceed();
      }, delay);
    } else {
      requestAnimationFrame(() => {
        proceed();
      });
    }
    return delay;
  };
  const start = () => {
    swiper.autoplay.running = true;
    run();
    emit("autoplayStart");
  };
  const stop = () => {
    swiper.autoplay.running = false;
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
    emit("autoplayStop");
  };
  const pause = (internal, reset) => {
    if (swiper.destroyed || !swiper.autoplay.running)
      return;
    clearTimeout(timeout);
    if (!internal) {
      pausedByInteraction = true;
    }
    const proceed = () => {
      emit("autoplayPause");
      if (swiper.params.autoplay.waitForTransition) {
        swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
      } else {
        resume();
      }
    };
    swiper.autoplay.paused = true;
    if (reset) {
      if (slideChanged) {
        autoplayTimeLeft = swiper.params.autoplay.delay;
      }
      slideChanged = false;
      proceed();
      return;
    }
    const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
    autoplayTimeLeft = delay - ((/* @__PURE__ */ new Date()).getTime() - autoplayStartTime);
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop)
      return;
    if (autoplayTimeLeft < 0)
      autoplayTimeLeft = 0;
    proceed();
  };
  const resume = () => {
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running)
      return;
    autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
    if (pausedByInteraction) {
      pausedByInteraction = false;
      run(autoplayTimeLeft);
    } else {
      run();
    }
    swiper.autoplay.paused = false;
    emit("autoplayResume");
  };
  const onVisibilityChange = () => {
    if (swiper.destroyed || !swiper.autoplay.running)
      return;
    const document2 = getDocument();
    if (document2.visibilityState === "hidden") {
      pausedByInteraction = true;
      pause(true);
    }
    if (document2.visibilityState === "visible") {
      resume();
    }
  };
  const onPointerEnter = (e) => {
    if (e.pointerType !== "mouse")
      return;
    pausedByInteraction = true;
    if (swiper.animating || swiper.autoplay.paused)
      return;
    pause(true);
  };
  const onPointerLeave = (e) => {
    if (e.pointerType !== "mouse")
      return;
    if (swiper.autoplay.paused) {
      resume();
    }
  };
  const attachMouseEvents = () => {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.el.addEventListener("pointerenter", onPointerEnter);
      swiper.el.addEventListener("pointerleave", onPointerLeave);
    }
  };
  const detachMouseEvents = () => {
    swiper.el.removeEventListener("pointerenter", onPointerEnter);
    swiper.el.removeEventListener("pointerleave", onPointerLeave);
  };
  const attachDocumentEvents = () => {
    const document2 = getDocument();
    document2.addEventListener("visibilitychange", onVisibilityChange);
  };
  const detachDocumentEvents = () => {
    const document2 = getDocument();
    document2.removeEventListener("visibilitychange", onVisibilityChange);
  };
  on3("init", () => {
    if (swiper.params.autoplay.enabled) {
      attachMouseEvents();
      attachDocumentEvents();
      autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
      start();
    }
  });
  on3("destroy", () => {
    detachMouseEvents();
    detachDocumentEvents();
    if (swiper.autoplay.running) {
      stop();
    }
  });
  on3("beforeTransitionStart", (_s, speed, internal) => {
    if (swiper.destroyed || !swiper.autoplay.running)
      return;
    if (internal || !swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on3("sliderFirstMove", () => {
    if (swiper.destroyed || !swiper.autoplay.running)
      return;
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
      return;
    }
    isTouched = true;
    pausedByTouch = false;
    pausedByInteraction = false;
    touchStartTimeout = setTimeout(() => {
      pausedByInteraction = true;
      pausedByTouch = true;
      pause(true);
    }, 200);
  });
  on3("touchEnd", () => {
    if (swiper.destroyed || !swiper.autoplay.running || !isTouched)
      return;
    clearTimeout(touchStartTimeout);
    clearTimeout(timeout);
    if (swiper.params.autoplay.disableOnInteraction) {
      pausedByTouch = false;
      isTouched = false;
      return;
    }
    if (pausedByTouch && swiper.params.cssMode)
      resume();
    pausedByTouch = false;
    isTouched = false;
  });
  on3("slideChange", () => {
    if (swiper.destroyed || !swiper.autoplay.running)
      return;
    slideChanged = true;
  });
  Object.assign(swiper.autoplay, {
    start,
    stop,
    pause,
    resume
  });
}

// node_modules/swiper/modules/thumbs.mjs
function Thumb(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };
  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed)
      return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass))
      return;
    if (typeof clickedIndex === "undefined" || clickedIndex === null)
      return;
    let slideToIndex;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      swiper.slideToLoop(slideToIndex);
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  function init2() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized)
      return false;
    initialized = true;
    const SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper.update();
    } else if (isObject3(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }
    swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on("tap", onThumbClick);
    return true;
  }
  function update2(initial) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed)
      return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }
    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }
    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.forEach((slideEl) => slideEl.classList.remove(thumbActiveClass));
    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        elementChildren(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl) => {
          slideEl.classList.add(thumbActiveClass);
        });
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        if (thumbsSwiper.slides[swiper.realIndex + i]) {
          thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
      }
    }
    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      const currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;
      if (thumbsSwiper.params.loop) {
        const newThumbsSlide = thumbsSwiper.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
        newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
        direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
      }
      if (useOffset) {
        newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
      }
      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1)
          ;
        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : void 0);
      }
    }
  }
  on3("beforeInit", () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper)
      return;
    if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
      const document2 = getDocument();
      const getThumbsElementAndInit = () => {
        const thumbsElement = typeof thumbs.swiper === "string" ? document2.querySelector(thumbs.swiper) : thumbs.swiper;
        if (thumbsElement && thumbsElement.swiper) {
          thumbs.swiper = thumbsElement.swiper;
          init2();
          update2(true);
        } else if (thumbsElement) {
          const onThumbsSwiper = (e) => {
            thumbs.swiper = e.detail[0];
            thumbsElement.removeEventListener("init", onThumbsSwiper);
            init2();
            update2(true);
            thumbs.swiper.update();
            swiper.update();
          };
          thumbsElement.addEventListener("init", onThumbsSwiper);
        }
        return thumbsElement;
      };
      const watchForThumbsToAppear = () => {
        if (swiper.destroyed)
          return;
        const thumbsElement = getThumbsElementAndInit();
        if (!thumbsElement) {
          requestAnimationFrame(watchForThumbsToAppear);
        }
      };
      requestAnimationFrame(watchForThumbsToAppear);
    } else {
      init2();
      update2(true);
    }
  });
  on3("slideChange update resize observerUpdate", () => {
    update2();
  });
  on3("setTransition", (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed)
      return;
    thumbsSwiper.setTransition(duration);
  });
  on3("beforeDestroy", () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed)
      return;
    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init: init2,
    update: update2
  });
}

// node_modules/swiper/modules/free-mode.mjs
function freeMode(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    once
  } = _ref;
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });
  function onTouchStart2() {
    if (swiper.params.cssMode)
      return;
    const translate2 = swiper.getTranslate();
    swiper.setTranslate(translate2);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }
  function onTouchMove2() {
    if (swiper.params.cssMode)
      return;
    const {
      touchEventsData: data,
      touches
    } = swiper;
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? "startX" : "startY"],
        time: data.touchStartTime
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
      time: now()
    });
  }
  function onTouchEnd2(_ref2) {
    let {
      currentPos
    } = _ref2;
    if (swiper.params.cssMode)
      return;
    const {
      params,
      wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper;
    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }
    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        }
        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1e3 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl)
        newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides)
          needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides)
          needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;
        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }
        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        once("transitionEnd", () => {
          swiper.loopFix();
        });
      }
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
        if (params.freeMode.sticky) {
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }
      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        elementTransitionEnd(wrapperEl, () => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce)
            return;
          emit("momentumBounce");
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            elementTransitionEnd(wrapperEl, () => {
              if (!swiper || swiper.destroyed)
                return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit("_freeModeNoMomentumRelease");
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          elementTransitionEnd(wrapperEl, () => {
            if (!swiper || swiper.destroyed)
              return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit("_freeModeNoMomentumRelease");
    }
    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }
  Object.assign(swiper, {
    freeMode: {
      onTouchStart: onTouchStart2,
      onTouchMove: onTouchMove2,
      onTouchEnd: onTouchEnd2
    }
  });
}

// node_modules/swiper/shared/effect-init.mjs
function effectInit(params) {
  const {
    effect,
    swiper,
    on: on3,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on3("beforeInit", () => {
    if (swiper.params.effect !== effect)
      return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on3("setTranslate", () => {
    if (swiper.params.effect !== effect)
      return;
    setTranslate2();
  });
  on3("setTransition", (_s, duration) => {
    if (swiper.params.effect !== effect)
      return;
    setTransition2(duration);
  });
  on3("transitionEnd", () => {
    if (swiper.params.effect !== effect)
      return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows)
        return;
      swiper.slides.forEach((slideEl) => {
        slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl) => shadowEl.remove());
      });
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on3("virtualUpdate", () => {
    if (swiper.params.effect !== effect)
      return;
    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate2();
        requireUpdateOnVirtual = false;
      }
    });
  });
}

// node_modules/swiper/shared/effect-target.mjs
function effectTarget(effectParams, slideEl) {
  const transformEl = getSlideTransformEl(slideEl);
  if (transformEl !== slideEl) {
    transformEl.style.backfaceVisibility = "hidden";
    transformEl.style["-webkit-backface-visibility"] = "hidden";
  }
  return transformEl;
}

// node_modules/swiper/shared/effect-virtual-transition-end.mjs
function effectVirtualTransitionEnd(_ref) {
  let {
    swiper,
    duration,
    transformElements,
    allSlides
  } = _ref;
  const {
    activeIndex
  } = swiper;
  const getSlide = (el) => {
    if (!el.parentElement) {
      const slide2 = swiper.slides.filter((slideEl) => slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
      return slide2;
    }
    return el.parentElement;
  };
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let transitionEndTarget;
    if (allSlides) {
      transitionEndTarget = transformElements;
    } else {
      transitionEndTarget = transformElements.filter((transformEl) => {
        const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
        return swiper.getSlideIndex(el) === activeIndex;
      });
    }
    transitionEndTarget.forEach((el) => {
      elementTransitionEnd(el, () => {
        if (eventTriggered)
          return;
        if (!swiper || swiper.destroyed)
          return;
        eventTriggered = true;
        swiper.animating = false;
        const evt = new window.CustomEvent("transitionend", {
          bubbles: true,
          cancelable: true
        });
        swiper.wrapperEl.dispatchEvent(evt);
      });
    });
  }
}

// node_modules/swiper/modules/effect-fade.mjs
function EffectFade(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    fadeEffect: {
      crossFade: false
    }
  });
  const setTranslate2 = () => {
    const {
      slides
    } = swiper;
    const params = swiper.params.fadeEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = swiper.slides[i];
      const offset = slideEl.swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate)
        tx -= swiper.translate;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.opacity = slideOpacity;
      targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
    }
  };
  const setTransition2 = (duration) => {
    const transformElements = swiper.slides.map((slideEl) => getSlideTransformEl(slideEl));
    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`;
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effectInit({
    effect: "fade",
    swiper,
    on: on3,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

// node_modules/swiper/modules/effect-cube.mjs
function EffectCube(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const createSlideShadows = (slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
    let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
    if (!shadowBefore) {
      shadowBefore = createElement("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
      slideEl.append(shadowBefore);
    }
    if (!shadowAfter) {
      shadowAfter = createElement("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
      slideEl.append(shadowAfter);
    }
    if (shadowBefore)
      shadowBefore.style.opacity = Math.max(-progress, 0);
    if (shadowAfter)
      shadowAfter.style.opacity = Math.max(progress, 0);
  };
  const recreateShadows = () => {
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.forEach((slideEl) => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows(slideEl, progress, isHorizontal);
    });
  };
  const setTranslate2 = () => {
    const {
      el,
      wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser: browser2
    } = swiper;
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let cubeShadowEl;
    if (params.shadow) {
      if (isHorizontal) {
        cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
        if (!cubeShadowEl) {
          cubeShadowEl = createElement("div", "swiper-cube-shadow");
          swiper.wrapperEl.append(cubeShadowEl);
        }
        cubeShadowEl.style.height = `${swiperWidth}px`;
      } else {
        cubeShadowEl = el.querySelector(".swiper-cube-shadow");
        if (!cubeShadowEl) {
          cubeShadowEl = createElement("div", "swiper-cube-shadow");
          el.append(cubeShadowEl);
        }
      }
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      let slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
      }
      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }
      if (rtl) {
        tx = -tx;
      }
      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }
      const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl)
          wrapperRotate = -slideIndex * 90 - progress * 90;
      }
      slideEl.style.transform = transform;
      if (params.slideShadows) {
        createSlideShadows(slideEl, progress, isHorizontal);
      }
    }
    wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
    wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
    if (params.shadow) {
      if (isHorizontal) {
        cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`;
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`;
      }
    }
    const zFactor = (browser2.isSafari || browser2.isWebView) && browser2.needPerspectiveFix ? -swiperSize / 2 : 0;
    wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
    wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
  };
  const setTransition2 = (duration) => {
    const {
      el,
      slides
    } = swiper;
    slides.forEach((slideEl) => {
      slideEl.style.transitionDuration = `${duration}ms`;
      slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl) => {
        subEl.style.transitionDuration = `${duration}ms`;
      });
    });
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      const shadowEl = el.querySelector(".swiper-cube-shadow");
      if (shadowEl)
        shadowEl.style.transitionDuration = `${duration}ms`;
    }
  };
  effectInit({
    effect: "cube",
    swiper,
    on: on3,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}

// node_modules/swiper/shared/create-shadow.mjs
function createShadow(suffix, slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
  const shadowContainer = getSlideTransformEl(slideEl);
  let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
  if (!shadowEl) {
    shadowEl = createElement("div", shadowClass.split(" "));
    shadowContainer.append(shadowEl);
  }
  return shadowEl;
}

// node_modules/swiper/modules/effect-flip.mjs
function EffectFlip(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  });
  const createSlideShadows = (slideEl, progress) => {
    let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
    let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
    if (!shadowBefore) {
      shadowBefore = createShadow("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
    }
    if (!shadowAfter) {
      shadowAfter = createShadow("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
    }
    if (shadowBefore)
      shadowBefore.style.opacity = Math.max(-progress, 0);
    if (shadowAfter)
      shadowAfter.style.opacity = Math.max(progress, 0);
  };
  const recreateShadows = () => {
    swiper.params.flipEffect;
    swiper.slides.forEach((slideEl) => {
      let progress = slideEl.progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }
      createSlideShadows(slideEl, progress);
    });
  };
  const setTranslate2 = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      let progress = slideEl.progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }
      const offset = slideEl.swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }
      slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
      if (params.slideShadows) {
        createSlideShadows(slideEl, progress);
      }
      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
    }
  };
  const setTransition2 = (duration) => {
    const transformElements = swiper.slides.map((slideEl) => getSlideTransformEl(slideEl));
    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl) => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements
    });
  };
  effectInit({
    effect: "flip",
    swiper,
    on: on3,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

// node_modules/swiper/modules/effect-coverflow.mjs
function EffectCoverflow(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true
    }
  });
  const setTranslate2 = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate2 = params.depth;
    for (let i = 0, length = slides.length; i < length; i += 1) {
      const slideEl = slides[i];
      const slideSize = slidesSizesGrid[i];
      const slideOffset = slideEl.swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      let translateZ = -translate2 * Math.abs(offsetMultiplier);
      let stretch = params.stretch;
      if (typeof stretch === "string" && stretch.indexOf("%") !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }
      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
      if (Math.abs(translateX) < 1e-3)
        translateX = 0;
      if (Math.abs(translateY) < 1e-3)
        translateY = 0;
      if (Math.abs(translateZ) < 1e-3)
        translateZ = 0;
      if (Math.abs(rotateY) < 1e-3)
        rotateY = 0;
      if (Math.abs(rotateX) < 1e-3)
        rotateX = 0;
      if (Math.abs(scale) < 1e-3)
        scale = 0;
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = slideTransform;
      slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBeforeEl) {
          shadowBeforeEl = createShadow("coverflow", slideEl, isHorizontal ? "left" : "top");
        }
        if (!shadowAfterEl) {
          shadowAfterEl = createShadow("coverflow", slideEl, isHorizontal ? "right" : "bottom");
        }
        if (shadowBeforeEl)
          shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if (shadowAfterEl)
          shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };
  const setTransition2 = (duration) => {
    const transformElements = swiper.slides.map((slideEl) => getSlideTransformEl(slideEl));
    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl) => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
  };
  effectInit({
    effect: "coverflow",
    swiper,
    on: on3,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}

// node_modules/swiper/modules/effect-creative.mjs
function EffectCreative(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const getTranslateValue = (value) => {
    if (typeof value === "string")
      return value;
    return `${value}px`;
  };
  const setTranslate2 = () => {
    const {
      slides,
      wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;
    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;
      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
      }
      const offset = slideEl.swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;
      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }
      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };
      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      }
      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      });
      r.forEach((value, index) => {
        r[index] = data.rotate[index] * Math.abs(progress * multiplier);
      });
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(", ");
      const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
      if (custom && data.shadow || !custom) {
        let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
        if (!shadowEl && data.shadow) {
          shadowEl = createShadow("creative", slideEl);
        }
        if (shadowEl) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
      targetEl.style.opacity = opacityString;
      if (data.origin) {
        targetEl.style.transformOrigin = data.origin;
      }
    }
  };
  const setTransition2 = (duration) => {
    const transformElements = swiper.slides.map((slideEl) => getSlideTransformEl(slideEl));
    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl) => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effectInit({
    effect: "creative",
    swiper,
    on: on3,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

// node_modules/swiper/modules/effect-cards.mjs
function EffectCards(_ref) {
  let {
    swiper,
    extendParams,
    on: on3
  } = _ref;
  extendParams({
    cardsEffect: {
      slideShadows: true,
      rotate: true,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });
  const setTranslate2 = () => {
    const {
      slides,
      activeIndex,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = rtl ? -swiper.translate : swiper.translate;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = slideEl.swiperSlideOffset;
      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
      }
      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }
      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -params.perSlideRotate * progress;
      let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${-25 * subProgress * Math.abs(progress)}%`;
      }
      if (progress < 0) {
        tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }
      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }
      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
      if (params.slideShadows) {
        let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
        if (!shadowEl) {
          shadowEl = createShadow("cards", slideEl);
        }
        if (shadowEl)
          shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
    }
  };
  const setTransition2 = (duration) => {
    const transformElements = swiper.slides.map((slideEl) => getSlideTransformEl(slideEl));
    transformElements.forEach((el) => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl) => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements
    });
  };
  effectInit({
    effect: "cards",
    swiper,
    on: on3,
    setTranslate: setTranslate2,
    setTransition: setTransition2,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

// node_modules/swiper/shared/swiper-core.mjs
var support;
function calcSupport() {
  const window2 = getWindow();
  const document2 = getDocument();
  return {
    smoothScroll: document2.documentElement && document2.documentElement.style && "scrollBehavior" in document2.documentElement.style,
    touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}
var deviceCached;
function calcDevice(_temp) {
  let {
    userAgent
  } = _temp === void 0 ? {} : _temp;
  const support2 = getSupport();
  const window2 = getWindow();
  const platform = window2.navigator.platform;
  const ua = userAgent || window2.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window2.screen.width;
  const screenHeight = window2.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === "Win32";
  let macos = platform === "MacIntel";
  const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad)
      ipad = [0, 1, "13_0_0"];
    macos = false;
  }
  if (android && !windows) {
    device.os = "android";
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = "ios";
    device.ios = true;
  }
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}
var browser;
function calcBrowser() {
  const window2 = getWindow();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window2.navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
  }
  if (isSafari()) {
    const ua = String(window2.navigator.userAgent);
    if (ua.includes("Version/")) {
      const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  return {
    isSafari: needPerspectiveFix || isSafari(),
    needPerspectiveFix,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent)
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}
function Resize(_ref) {
  let {
    swiper,
    on: on3,
    emit
  } = _ref;
  const window2 = getWindow();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    emit("beforeResize");
    emit("resize");
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    observer = new ResizeObserver((entries) => {
      animationFrame = window2.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach((_ref2) => {
          let {
            contentBoxSize,
            contentRect,
            target
          } = _ref2;
          if (target && target !== swiper.el)
            return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window2.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized)
      return;
    emit("orientationchange");
  };
  on3("init", () => {
    if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
      createObserver();
      return;
    }
    window2.addEventListener("resize", resizeHandler);
    window2.addEventListener("orientationchange", orientationChangeHandler);
  });
  on3("destroy", () => {
    removeObserver();
    window2.removeEventListener("resize", resizeHandler);
    window2.removeEventListener("orientationchange", orientationChangeHandler);
  });
}
function Observer(_ref) {
  let {
    swiper,
    extendParams,
    on: on3,
    emit
  } = _ref;
  const observers = [];
  const window2 = getWindow();
  const attach = function(target, options) {
    if (options === void 0) {
      options = {};
    }
    const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
    const observer = new ObserverFunc((mutations) => {
      if (swiper.__preventObserver__)
        return;
      if (mutations.length === 1) {
        emit("observerUpdate", mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate2() {
        emit("observerUpdate", mutations[0]);
      };
      if (window2.requestAnimationFrame) {
        window2.requestAnimationFrame(observerUpdate);
      } else {
        window2.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === "undefined" ? true : options.attributes,
      childList: typeof options.childList === "undefined" ? true : options.childList,
      characterData: typeof options.characterData === "undefined" ? true : options.characterData
    });
    observers.push(observer);
  };
  const init2 = () => {
    if (!swiper.params.observer)
      return;
    if (swiper.params.observeParents) {
      const containerParents = elementParents(swiper.hostEl);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach((observer) => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on3("init", init2);
  on3("destroy", destroy);
}
var eventsEmitter = {
  on(events2, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (typeof handler !== "function")
      return self;
    const method = priority ? "unshift" : "push";
    events2.split(" ").forEach((event2) => {
      if (!self.eventsListeners[event2])
        self.eventsListeners[event2] = [];
      self.eventsListeners[event2][method](handler);
    });
    return self;
  },
  once(events2, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (typeof handler !== "function")
      return self;
    function onceHandler() {
      self.off(events2, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events2, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (typeof handler !== "function")
      return self;
    const method = priority ? "unshift" : "push";
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (!self.eventsAnyListeners)
      return self;
    const index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off(events2, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (!self.eventsListeners)
      return self;
    events2.split(" ").forEach((event2) => {
      if (typeof handler === "undefined") {
        self.eventsListeners[event2] = [];
      } else if (self.eventsListeners[event2]) {
        self.eventsListeners[event2].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event2].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit() {
    const self = this;
    if (!self.eventsListeners || self.destroyed)
      return self;
    if (!self.eventsListeners)
      return self;
    let events2;
    let data;
    let context;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === "string" || Array.isArray(args[0])) {
      events2 = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events2 = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
    eventsArray.forEach((event2) => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach((eventHandler) => {
          eventHandler.apply(context, [event2, ...data]);
        });
      }
      if (self.eventsListeners && self.eventsListeners[event2]) {
        self.eventsListeners[event2].forEach((eventHandler) => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};
function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }
  width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
  height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
  if (Number.isNaN(width))
    width = 0;
  if (Number.isNaN(height))
    height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}
function updateSlides() {
  const swiper = this;
  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    }
    return {
      "width": "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      "marginRight": "marginBottom"
    }[property];
  }
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === "function") {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === "function") {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === "undefined") {
    return;
  }
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween;
  slides.forEach((slideEl) => {
    if (rtl) {
      slideEl.style.marginLeft = "";
    } else {
      slideEl.style.marginRight = "";
    }
    slideEl.style.marginBottom = "";
    slideEl.style.marginTop = "";
  });
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  }
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
    return typeof params.breakpoints[key].slidesPerView !== "undefined";
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    let slide2;
    if (slides[i])
      slide2 = slides[i];
    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide2, slidesLength, getDirectionLabel);
    }
    if (slides[i] && elementStyle(slide2, "display") === "none")
      continue;
    if (params.slidesPerView === "auto") {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel("width")] = ``;
      }
      const slideStyles = getComputedStyle(slide2);
      const currentTransform = slide2.style.transform;
      const currentWebKitTransform = slide2.style.webkitTransform;
      if (currentTransform) {
        slide2.style.transform = "none";
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = "none";
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? elementOuterSize(slide2, "width", true) : elementOuterSize(slide2, "height", true);
      } else {
        const width = getDirectionPropertyValue(slideStyles, "width");
        const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
        const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
        const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
        const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
        const boxSizing = slideStyles.getPropertyValue("box-sizing");
        if (boxSizing && boxSizing === "border-box") {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide2;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide2.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide2.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths)
        slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0)
        slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1e3)
        slidePosition = 0;
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths)
        slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0)
        snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  }
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths)
        slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0)
    snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop)
        return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach((slideEl) => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map((snap) => {
      if (snap <= 0)
        return -offsetBefore;
      if (snap > maxSnap)
        return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach((slideSizeValue) => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
    setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit("slidesLengthChange");
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow)
      swiper.checkOverflow();
    swiper.emit("snapGridLengthChange");
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit("slidesGridLengthChange");
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded)
        swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}
function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === "number") {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = (index) => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach((slide2) => {
        activeSlides.push(slide2);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual)
          break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== "undefined") {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }
  if (newHeight || newHeight === 0)
    swiper.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}
function updateSlidesProgress(translate2) {
  if (translate2 === void 0) {
    translate2 = this && this.translate || 0;
  }
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0)
    return;
  if (typeof slides[0].swiperSlideOffset === "undefined")
    swiper.updateSlidesOffset();
  let offsetCenter = -translate2;
  if (rtl)
    offsetCenter = translate2;
  slides.forEach((slideEl) => {
    slideEl.classList.remove(params.slideVisibleClass);
  });
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
  } else if (typeof spaceBetween === "string") {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide2 = slides[i];
    let slideOffset = slide2.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide2);
      swiper.visibleSlidesIndexes.push(i);
      slides[i].classList.add(params.slideVisibleClass);
    }
    slide2.progress = rtl ? -slideProgress : slideProgress;
    slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}
function updateProgress(translate2) {
  const swiper = this;
  if (typeof translate2 === "undefined") {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate2 - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate2 - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate2 - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded)
      progress = 0;
    if (isEndRounded)
      progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate2);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1)
      progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight)
    swiper.updateSlidesProgress(translate2);
  if (isBeginning && !wasBeginning) {
    swiper.emit("reachBeginning toEdge");
  }
  if (isEnd && !wasEnd) {
    swiper.emit("reachEnd toEdge");
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit("fromEdge");
  }
  swiper.emit("progress", progress);
}
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const getFilteredSlide = (selector) => {
    return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  slides.forEach((slideEl) => {
    slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
  });
  let activeSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0)
        slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length)
        slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    activeSlide = slides[activeIndex];
  }
  if (activeSlide) {
    activeSlide.classList.add(params.slideActiveClass);
    let nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
    if (params.loop && !nextSlide) {
      nextSlide = slides[0];
    }
    if (nextSlide) {
      nextSlide.classList.add(params.slideNextClass);
    }
    let prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
    if (params.loop && !prevSlide === 0) {
      prevSlide = slides[slides.length - 1];
    }
    if (prevSlide) {
      prevSlide.classList.add(params.slidePrevClass);
    }
  }
  swiper.emitSlidesClasses();
}
var processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params)
    return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl)
              lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl)
      lazyEl.remove();
  }
};
var unlazy = (swiper, index) => {
  if (!swiper.slides[index])
    return;
  const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl)
    imageEl.removeAttribute("loading");
};
var preload = (swiper) => {
  if (!swiper || swiper.destroyed || !swiper.params)
    return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0)
    return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column))
        unlazy(swiper, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView)
        unlazy(swiper, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper, i);
      }
    }
  }
};
function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== "undefined") {
      if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate2 >= slidesGrid[i] && translate2 < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate2 >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === "undefined")
      activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = (aIndex) => {
    let realIndex2 = aIndex - swiper.virtual.slidesBefore;
    if (realIndex2 < 0) {
      realIndex2 = swiper.virtual.slides.length + realIndex2;
    }
    if (realIndex2 >= swiper.virtual.slides.length) {
      realIndex2 -= swiper.virtual.slides.length;
    }
    return realIndex2;
  };
  if (typeof activeIndex === "undefined") {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate2) >= 0) {
    snapIndex = snapGrid.indexOf(translate2);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit("snapIndexChange");
    }
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.realIndex = getVirtualRealIndex(activeIndex);
    }
    return;
  }
  let realIndex;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (swiper.slides[activeIndex]) {
    realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit("activeIndexChange");
  swiper.emit("snapIndexChange");
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit("realIndexChange");
    }
    swiper.emit("slideChange");
  }
}
function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide2 = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide2 && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach((pathEl) => {
      if (!slide2 && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide2 = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide2) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide2) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide2 && slideFound) {
    swiper.clickedSlide = slide2;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = void 0;
    swiper.clickedIndex = void 0;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}
var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};
function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? "x" : "y";
  }
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate: translate2,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate2 : translate2;
  }
  if (params.cssMode) {
    return translate2;
  }
  let currentTranslate = getTranslate(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl)
    currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}
function setTranslate(translate2, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate2 : translate2;
  } else {
    y = translate2;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
  }
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate2);
  }
  swiper.emit("setTranslate", swiper.translate, byController);
}
function minTranslate() {
  return -this.snapGrid[0];
}
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate2, speed, runCallbacks, translateBounds, internal) {
  if (translate2 === void 0) {
    translate2 = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate2 = swiper.minTranslate();
  const maxTranslate2 = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate2 > minTranslate2)
    newTranslate = minTranslate2;
  else if (translateBounds && translate2 < maxTranslate2)
    newTranslate = maxTranslate2;
  else
    newTranslate = translate2;
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: -newTranslate,
        behavior: "smooth"
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionEnd");
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.emit("transitionStart");
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e) {
          if (!swiper || swiper.destroyed)
            return;
          if (e.target !== this)
            return;
          swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit("transitionEnd");
          }
        };
      }
      swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}
var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};
function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
  }
  swiper.emit("setTransition", duration, byController);
}
function transitionEmit(_ref) {
  let {
    swiper,
    runCallbacks,
    direction,
    step
  } = _ref;
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex)
      dir = "next";
    else if (activeIndex < previousIndex)
      dir = "prev";
    else
      dir = "reset";
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === "next") {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode)
    return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "Start"
  });
}
function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode)
    return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: "End"
  });
}
var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};
function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === "string") {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0)
    slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length)
    snapIndex = snapGrid.length - 1;
  const translate2 = -snapGrid[snapIndex];
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate2 * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== "undefined") {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate2 > swiper.translate && translate2 > swiper.minTranslate() : translate2 < swiper.translate && translate2 < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit("beforeSlideChangeStart");
  }
  swiper.updateProgress(translate2);
  let direction;
  if (slideIndex > activeIndex)
    direction = "next";
  else if (slideIndex < activeIndex)
    direction = "prev";
  else
    direction = "reset";
  if (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== "slide") {
      swiper.setTranslate(translate2);
    }
    if (direction !== "reset") {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate2 : -translate2;
    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = "none";
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
        });
      } else {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = "";
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? "left" : "top"
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? "left" : "top"]: t,
        behavior: "smooth"
      });
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate2);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit("beforeTransitionStart", speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e) {
        if (!swiper || swiper.destroyed)
          return;
        if (e.target !== this)
          return;
        swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}
function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === "string") {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      newIndex = swiper.getSlideIndexByData(newIndex);
    }
  }
  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled)
    return swiper;
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding)
      return false;
    swiper.loopFix({
      direction: "next"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled)
    return swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding)
      return false;
    swiper.loopFix({
      direction: "prev"
    });
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0)
      return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate2);
  const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === "undefined" && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== "undefined") {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== "undefined") {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0)
      prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate2 >= swiper.snapGrid[snapIndex]) {
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  if (params.loop) {
    if (swiper.animating)
      return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}
var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};
function loopCreate(slideRealIndex) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled)
    return;
  const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  slides.forEach((el, index) => {
    el.setAttribute("data-swiper-slide-index", index);
  });
  swiper.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? void 0 : "next"
  });
}
function loopFix(_temp) {
  let {
    slideRealIndex,
    slideTo: slideTo2 = true,
    direction,
    setTranslate: setTranslate2,
    activeSlideIndex,
    byController,
    byMousewheel
  } = _temp === void 0 ? {} : _temp;
  const swiper = this;
  if (!swiper.params.loop)
    return;
  swiper.emit("beforeLoopFix");
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo2) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit("loopFix");
    return;
  }
  const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
  let loopedSlides = params.loopedSlides || slidesPerView;
  if (loopedSlides % params.slidesPerGroup !== 0) {
    loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
  }
  swiper.loopedSlides = loopedSlides;
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  let activeIndex = swiper.activeIndex;
  if (typeof activeSlideIndex === "undefined") {
    activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter((el) => el.classList.contains(params.slideActiveClass))[0]);
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === "next" || !direction;
  const isPrev = direction === "prev" || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  if (activeSlideIndex < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeSlideIndex; i += 1) {
      const index = i - Math.floor(i / slides.length) * slides.length;
      prependSlidesIndexes.push(slides.length - index - 1);
    }
  } else if (activeSlideIndex > swiper.slides.length - loopedSlides * 2) {
    slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
    for (let i = 0; i < slidesAppended; i += 1) {
      const index = i - Math.floor(i / slides.length) * slides.length;
      appendSlidesIndexes.push(index);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach((index) => {
      swiper.slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(swiper.slides[index]);
      swiper.slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach((index) => {
      swiper.slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(swiper.slides[index]);
      swiper.slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === "auto") {
    swiper.updateSlides();
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo2) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
          if (setTranslate2) {
            swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
            swiper.touchEventsData.currentTranslate = swiper.translate;
          }
        }
      } else {
        if (setTranslate2) {
          swiper.slideToLoop(slideRealIndex, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === "undefined") {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate2) {
            swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
            swiper.touchEventsData.currentTranslate = swiper.translate;
          }
        }
      } else {
        swiper.slideToLoop(slideRealIndex, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate: setTranslate2,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach((c) => {
        if (!c.destroyed && c.params.loop)
          c.loopFix({
            ...loopParams,
            slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo2 : false
          });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo2 : false
      });
    }
  }
  swiper.emit("loopFix");
}
function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled)
    return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach((slideEl) => {
    const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach((slideEl) => {
    slideEl.removeAttribute("data-swiper-slide-index");
  });
  newSlidesOrder.forEach((slideEl) => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}
var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};
function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode)
    return;
  const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = "move";
  el.style.cursor = moving ? "grabbing" : "grab";
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}
function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}
var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow())
      return null;
    if (el.assignedSlot)
      el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function onTouchStart(event2) {
  const swiper = this;
  const document2 = getDocument();
  const window2 = getWindow();
  const data = swiper.touchEventsData;
  data.evCache.push(event2);
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled)
    return;
  if (!params.simulateTouch && event2.pointerType === "mouse")
    return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let e = event2;
  if (e.originalEvent)
    e = e.originalEvent;
  let targetEl = e.target;
  if (params.touchEventsTarget === "wrapper") {
    if (!swiper.wrapperEl.contains(targetEl))
      return;
  }
  if ("which" in e && e.which === 3)
    return;
  if ("button" in e && e.button > 0)
    return;
  if (data.isTouched && data.isMoved)
    return;
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
  const eventPath = event2.composedPath ? event2.composedPath() : event2.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler))
      return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;
  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === "prevent") {
      event2.preventDefault();
    } else {
      return;
    }
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: void 0,
    startMoving: void 0
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = void 0;
  if (params.threshold > 0)
    data.allowThresholdMove = false;
  let preventDefault3 = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault3 = false;
    if (targetEl.nodeName === "SELECT") {
      data.isTouched = false;
    }
  }
  if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== targetEl) {
    document2.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault3 && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit("touchStart", e);
}
function onTouchMove(event2) {
  const document2 = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled)
    return;
  if (!params.simulateTouch && event2.pointerType === "mouse")
    return;
  let e = event2;
  if (e.originalEvent)
    e = e.originalEvent;
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit("touchMoveOpposite", e);
    }
    return;
  }
  const pointerIndex = data.evCache.findIndex((cachedEv) => cachedEv.pointerId === e.pointerId);
  if (pointerIndex >= 0)
    data.evCache[pointerIndex] = e;
  const targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        prevX: swiper.touches.currentX,
        prevY: swiper.touches.currentY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (document2.activeElement) {
    if (e.target === document2.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit("touchMove", e);
  }
  if (e.targetTouches && e.targetTouches.length > 1)
    return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold)
    return;
  if (typeof data.isScrolling === "undefined") {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit("touchMoveOpposite", e);
  }
  if (typeof data.startMoving === "undefined") {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? "prev" : "next";
  swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.swipeDirection === "next" && swiper.allowSlideNext || swiper.swipeDirection === "prev" && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent("transitionend", {
        bubbles: true,
        cancelable: true
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit("sliderFirstMove", e);
  }
  let loopFixed;
  if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    swiper.loopFix({
      direction: swiper.swipeDirection,
      setTranslate: true
    });
    loopFixed = true;
  }
  swiper.emit("sliderMove", e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) {
      swiper.loopFix({
        direction: "prev",
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: "next",
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }
  if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode)
    return;
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  swiper.updateProgress(data.currentTranslate);
  swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event2) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const pointerIndex = data.evCache.findIndex((cachedEv) => cachedEv.pointerId === event2.pointerId);
  if (pointerIndex >= 0) {
    data.evCache.splice(pointerIndex, 1);
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(event2.type)) {
    const proceed = ["pointercancel", "contextmenu"].includes(event2.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled)
    return;
  if (!params.simulateTouch && event2.pointerType === "mouse")
    return;
  let e = event2;
  if (e.originalEvent)
    e = e.originalEvent;
  if (data.allowTouchCallbacks) {
    swiper.emit("touchEnd", e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }
  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime;
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit("tap click", e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit("doubleTap doubleClick", e);
    }
  }
  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed)
      swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment2 = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment2] !== "undefined") {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment2]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment2] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === "next") {
      if (ratio >= params.longSwipesRatio)
        swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
      else
        swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === "prev") {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === "next") {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === "prev") {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}
function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0)
    return;
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}
function onClick(e) {
  const swiper = this;
  if (!swiper.enabled)
    return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks)
      e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}
function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled)
    return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  if (swiper.translate === 0)
    swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit("setTranslate", swiper.translate, false);
}
function onLoad(e) {
  const swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}
var dummyEventAttached = false;
function dummyEventListener() {
}
var events = (swiper, method) => {
  const document2 = getDocument();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
  const swiperMethod = method;
  el[domMethod]("pointerdown", swiper.onTouchStart, {
    passive: false
  });
  document2[domMethod]("pointermove", swiper.onTouchMove, {
    passive: false,
    capture
  });
  document2[domMethod]("pointerup", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointercancel", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerout", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("pointerleave", swiper.onTouchEnd, {
    passive: true
  });
  document2[domMethod]("contextmenu", swiper.onTouchEnd, {
    passive: true
  });
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]("click", swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]("scroll", swiper.onScroll);
  }
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
  } else {
    swiper[swiperMethod]("observerUpdate", onResize, true);
  }
  el[domMethod]("load", swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const document2 = getDocument();
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  if (!dummyEventAttached) {
    document2.addEventListener("touchstart", dummyEventListener);
    dummyEventAttached = true;
  }
  events(swiper, "on");
}
function detachEvents() {
  const swiper = this;
  events(swiper, "off");
}
var events$1 = {
  attachEvents,
  detachEvents
};
var isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints2 = params.breakpoints;
  if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0)
    return;
  const breakpoint = swiper.getBreakpoint(breakpoints2, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint)
    return;
  const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  ["navigation", "pagination", "scrollbar"].forEach((prop) => {
    if (typeof breakpointParams[prop] === "undefined")
      return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend2(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit("_beforeBreakpoint", breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit("breakpoint", breakpointParams);
}
function getBreakpoint(breakpoints2, base, containerEl) {
  if (base === void 0) {
    base = "window";
  }
  if (!breakpoints2 || base === "container" && !containerEl)
    return void 0;
  let breakpoint = false;
  const window2 = getWindow();
  const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints2).map((point) => {
    if (typeof point === "string" && point.indexOf("@") === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === "window") {
      if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || "max";
}
var breakpoints = {
  setBreakpoint,
  getBreakpoint
};
function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach((item) => {
    if (typeof item === "object") {
      Object.keys(item).forEach((classNames) => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === "string") {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  const suffixes = prepareClasses(["initialized", params.direction, {
    "free-mode": swiper.params.freeMode && params.freeMode.enabled
  }, {
    "autoheight": params.autoHeight
  }, {
    "rtl": rtl
  }, {
    "grid": params.grid && params.grid.rows > 1
  }, {
    "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
  }, {
    "android": device.android
  }, {
    "ios": device.ios
  }, {
    "css-mode": params.cssMode
  }, {
    "centered": params.cssMode && params.centeredSlides
  }, {
    "watch-progress": params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}
function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}
var classes = {
  addClasses,
  removeClasses
};
function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? "lock" : "unlock");
  }
}
var checkOverflow$1 = {
  checkOverflow
};
var defaults = {
  init: true,
  direction: "horizontal",
  oneWayMovement: false,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopedSlides: null,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== "object" || moduleParams === null) {
      extend2(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (["pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && "enabled" in moduleParams)) {
      extend2(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName])
      params[moduleParamName] = {
        enabled: false
      };
    extend2(allModulesParams, obj);
  };
}
var prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
var extendedDefaults = {};
var Swiper = class _Swiper {
  constructor() {
    let el;
    let params;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params)
      params = {};
    params = extend2({}, params);
    if (el && !params.el)
      params.el = el;
    const document2 = getDocument();
    if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document2.querySelectorAll(params.el).forEach((containerEl) => {
        const newParams = extend2({}, params, {
          el: containerEl
        });
        swipers.push(new _Swiper(newParams));
      });
      return swipers;
    }
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach((mod) => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });
    const swiperParams = extend2({}, defaults, allModulesParams);
    swiper.params = extend2({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend2({}, swiper.params);
    swiper.passedParams = extend2({}, params);
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach((eventName) => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === "horizontal";
      },
      isVertical() {
        return swiper.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit("_swiper");
    if (swiper.params.init) {
      swiper.init();
    }
    return swiper;
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = elementIndex(slides[0]);
    return elementIndex(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.filter((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled)
      return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit("enable");
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled)
      return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit("disable");
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el)
      return;
    const cls = swiper.el.className.split(" ").filter((className) => {
      return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit("_containerClasses", cls.join(" "));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed)
      return "";
    return slideEl.className.split(" ").filter((className) => {
      return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(" ");
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el)
      return;
    const updates = [];
    swiper.slides.forEach((slideEl) => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit("_slideClass", slideEl, classNames);
    });
    swiper.emit("_slideClasses", updates);
  }
  slidesPerViewDynamic(view, exact) {
    if (view === void 0) {
      view = "current";
    }
    if (exact === void 0) {
      exact = false;
    }
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === "number")
      return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize)
            breakLoop = true;
        }
      }
    } else {
      if (view === "current") {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed)
      return;
    const {
      snapGrid,
      params
    } = swiper;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate2() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate2();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate2();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit("update");
  }
  changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
    }
    if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach((slideEl) => {
      if (newDirection === "vertical") {
        slideEl.style.width = "";
      } else {
        slideEl.style.height = "";
      }
    });
    swiper.emit("changeDirection");
    if (needUpdate)
      swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr")
      return;
    swiper.rtl = direction === "rtl";
    swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "rtl";
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = "ltr";
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted)
      return true;
    let el = element || swiper.params.el;
    if (typeof el === "string") {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === "SWIPER-CONTAINER") {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        return res;
      }
      return elementChildren(el, getWrapperSelector())[0];
    };
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = createElement("div", swiper.params.wrapperClass);
      el.append(wrapperEl);
      elementChildren(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
      rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
      wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized)
      return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false)
      return swiper;
    swiper.emit("beforeInit");
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.addClasses();
    swiper.updateSize();
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }
    if (swiper.params.loop) {
      swiper.loopCreate();
    }
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach((imageEl) => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener("load", (e) => {
          processLazyPreloader(swiper, e.target);
        });
      }
    });
    preload(swiper);
    swiper.initialized = true;
    preload(swiper);
    swiper.emit("init");
    swiper.emit("afterInit");
    return swiper;
  }
  destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }
    if (cleanStyles === void 0) {
      cleanStyles = true;
    }
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === "undefined" || swiper.destroyed) {
      return null;
    }
    swiper.emit("beforeDestroy");
    swiper.initialized = false;
    swiper.detachEvents();
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (cleanStyles) {
      swiper.removeClasses();
      el.removeAttribute("style");
      wrapperEl.removeAttribute("style");
      if (slides && slides.length) {
        slides.forEach((slideEl) => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute("style");
          slideEl.removeAttribute("data-swiper-slide-index");
        });
      }
    }
    swiper.emit("destroy");
    Object.keys(swiper.eventsListeners).forEach((eventName) => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      swiper.el.swiper = null;
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend2(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!_Swiper.prototype.__modules__)
      _Swiper.prototype.__modules__ = [];
    const modules = _Swiper.prototype.__modules__;
    if (typeof mod === "function" && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach((m) => _Swiper.installModule(m));
      return _Swiper;
    }
    _Swiper.installModule(module);
    return _Swiper;
  }
};
Object.keys(prototypes).forEach((prototypeGroup) => {
  Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);

// src/extenders/swiper-upsell.js
var SwiperUpsell = class extends HTMLElement {
  constructor() {
    super();
    const productSliderElement = this;
    const swiperHolder = productSliderElement.querySelector(".swiper");
    const swiperConfig = {
      modules: [Mousewheel],
      mousewheel: {
        forceToAxis: true
      },
      direction: "horizontal",
      spaceBetween: 8,
      slidesPerView: 2.25
    };
    new Swiper(swiperHolder, swiperConfig);
    window.addEventListener("shopify:section:load", () => new Swiper(swiperHolder, swiperConfig));
  }
};
if (customElements.get("swiper-upsell") === void 0) {
  customElements.define("swiper-upsell", SwiperUpsell);
}

// src/extenders/gifting-options-form.js
var GiftingOptionsForm = class extends HTMLElement {
  constructor() {
    super();
    const giftingOptionsFormElement = this;
    const allGiftingOptions = giftingOptionsFormElement.querySelectorAll(".gifting-option");
    const handleGiftingOption = debounce2((variantId, message, line) => {
      if (line) {
        shopifyCart.updateProduct(line, {
          _gifting_option: "true",
          message: message.value
        });
      } else {
        shopifyCart.quickBuyWithProperties(variantId, 1, {
          _gifting_option: "true",
          message: message.value
        });
      }
    }, 1e3);
    allGiftingOptions.forEach((giftingOptionElement) => {
      giftingOptionElement.addEventListener("input", () => {
        var _a;
        const inputElement = giftingOptionElement.querySelector("input");
        const giftingOptionNoteElement = giftingOptionElement.querySelector(
          ".gifting-option-note"
        );
        const textareaElement = giftingOptionElement.querySelector("textarea");
        const variantId = (_a = giftingOptionElement.querySelector(
          ".gifting-option-variant-id"
        )) == null ? void 0 : _a.value;
        const line = giftingOptionElement.getAttribute("data-key-id");
        if (inputElement.checked === true) {
          if (giftingOptionNoteElement) {
            giftingOptionNoteElement.removeAttribute("hidden");
          }
        } else {
          if (giftingOptionNoteElement) {
            giftingOptionNoteElement.setAttribute("hidden", "");
          }
        }
        if (giftingOptionNoteElement) {
          if (inputElement.checked === true) {
            giftingOptionNoteElement.addEventListener(
              "input",
              () => handleGiftingOption(variantId, textareaElement, line)
            );
          } else {
            shopifyCart.remove(line);
          }
        } else {
          if (inputElement.checked === true) {
            shopifyCart.quickBuyWithProperties(variantId, 1, {
              _gifting_option: "true"
            });
          } else {
            shopifyCart.remove(line);
          }
        }
      });
    });
  }
};
customElements.define("gifting-options-form", GiftingOptionsForm);

// src/extenders/cart-gifts.js
var CartGifts = class extends HTMLElement {
  constructor() {
    super();
    const cartGiftsElement = document.querySelector(".cart-drawer__gifts");
    const allGiftElement = cartGiftsElement.querySelectorAll(".gift-holder__gift");
    const giftHolderElement = cartGiftsElement.querySelector(
      ".gifts__gift-holder"
    );
    const totalItemsInCart = giftHolderElement == null ? void 0 : giftHolderElement.getAttribute("data-items-in-cart");
    const areGiftsInCartAttributes = giftHolderElement == null ? void 0 : giftHolderElement.getAttribute(
      "data-in-cart-attributes"
    );
    const updateAttributes = debounce2((currentGiftInCartAttributes) => {
      if (currentGiftInCartAttributes) {
        shopifyCart.updateAttributes(
          "gifts",
          currentGiftInCartAttributes.join(",")
        );
      } else {
        shopifyCart.updateAttributes("gifts", "");
      }
    }, 100);
    allGiftElement.forEach((giftElement) => {
      const giftVariantId = giftElement.getAttribute("data-variant-id");
      const giftInCartStatus = giftElement.getAttribute("data-in-cart");
      const giftUnlockedStatus = giftElement.getAttribute("data-unlocked");
      const giftTitle = giftElement.getAttribute("data-product-title");
      const giftHandle = giftElement.getAttribute("data-product-handle");
      const currentGiftInCartAttributes = giftElement.getAttribute(
        "data-attributes"
      ) ? giftElement.getAttribute("data-attributes").split(",") : [];
      if (giftUnlockedStatus === "true" && giftInCartStatus === "false") {
        const giftInfo = `${giftHandle} | ${giftTitle} | ${giftVariantId}`;
        currentGiftInCartAttributes.push(giftInfo);
        updateAttributes(currentGiftInCartAttributes);
      } else if (giftUnlockedStatus === "false" && giftInCartStatus === "true") {
        if (currentGiftInCartAttributes.length > 0) {
          const giftInfo = `${giftHandle} | ${giftTitle} | ${giftVariantId}`;
          const index = currentGiftInCartAttributes.indexOf(giftInfo);
          currentGiftInCartAttributes.splice(index, 1);
          updateAttributes(currentGiftInCartAttributes);
        }
      }
    });
    if (totalItemsInCart && Number(totalItemsInCart) === 0) {
      if (areGiftsInCartAttributes === "true") {
        updateAttributes(null);
      }
    }
  }
};
if (customElements.get("cart-gifts") === void 0) {
  customElements.define("cart-gifts", CartGifts);
}

// src/extenders/cart-goodie-selector.js
var CartGoodieSelector = class extends HTMLElement {
  constructor() {
    super();
    const cartGiftsElement = document.querySelector(".selectable-gifts");
    const selectableState = cartGiftsElement == null ? void 0 : cartGiftsElement.getAttribute("data-state");
    const isThereAGoodieInCartAttributes = cartGiftsElement == null ? void 0 : cartGiftsElement.getAttribute(
      "data-in-cart-attributes"
    );
    const updateAttributes = debounce2((currentGiftInCartAttributes) => {
      if (currentGiftInCartAttributes) {
        shopifyCart.updateAttributes(
          "goodies",
          currentGiftInCartAttributes.join(",")
        );
      } else {
        shopifyCart.updateAttributes("goodies", "");
      }
    }, 100);
    cartGiftsElement == null ? void 0 : cartGiftsElement.addEventListener("change", () => {
      const checkedInput = cartGiftsElement == null ? void 0 : cartGiftsElement.querySelector("input:checked");
      const giftElement = checkedInput.closest(".gift-button");
      const giftVariantId = giftElement.getAttribute("data-variant-id");
      const giftInCartStatus = giftElement.getAttribute("data-in-cart");
      const giftUnlockedStatus = giftElement.getAttribute("data-unlocked");
      const giftTitle = giftElement.getAttribute("data-product-title");
      const giftHandle = giftElement.getAttribute("data-product-handle");
      let currentGiftInCartAttributes = giftElement.getAttribute(
        "data-attributes"
      ) ? giftElement.getAttribute("data-attributes").split(",") : [];
      if (giftUnlockedStatus === "true" && giftInCartStatus === "false") {
        const giftInfo = `${giftHandle} | ${giftTitle} | ${giftVariantId}`;
        currentGiftInCartAttributes = [];
        currentGiftInCartAttributes.push(giftInfo);
        updateAttributes(currentGiftInCartAttributes);
      } else if (giftUnlockedStatus === "false" && giftInCartStatus === "true") {
        const giftInfo = `${giftHandle} | ${giftTitle} | ${giftVariantId}`;
        currentGiftInCartAttributes = [];
        currentGiftInCartAttributes.push(giftInfo);
        updateAttributes(currentGiftInCartAttributes);
      }
    });
    if (selectableState === "disabled") {
      if (isThereAGoodieInCartAttributes === "true") {
        updateAttributes(null);
      }
    }
  }
};
if (customElements.get("cart-goodie-selector") === void 0) {
  customElements.define("cart-goodie-selector", CartGoodieSelector);
}

// src/config/base.js
var loadPage = () => {
  addToCart();
  header();
  collection();
  footer();
  productHelpers();
  relatedProducts();
  productEngraving();
  cookie();
  search2();
  predictiveSearch();
  breadcrumbs();
  forgotPassword();
  address();
  faq();
  mainCart();
  earparty();
  console.log("Page loaded");
};
enableBFCacheSupport();
document.addEventListener("DOMContentLoaded", loadPage);
/*! Bundled license information:

get-size/get-size.js:
  (*!
   * getSize v2.0.3
   * measure size of elements
   * MIT license
   *)

unipointer/unipointer.js:
  (*!
   * Unipointer v2.4.0
   * base class for doing one thing with pointer event
   * MIT license
   *)

unidragger/unidragger.js:
  (*!
   * Unidragger v2.4.0
   * Draggable base class
   * MIT license
   *)

flickity/js/index.js:
  (*!
   * Flickity v2.3.0
   * Touch, responsive, flickable carousels
   *
   * Licensed GPLv3 for open source use
   * or Flickity Commercial License for commercial use
   *
   * https://flickity.metafizzy.co
   * Copyright 2015-2021 Metafizzy
   *)

js-cookie/src/js.cookie.js:
  (*!
   * JavaScript Cookie v2.2.1
   * https://github.com/js-cookie/js-cookie
   *
   * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
   * Released under the MIT license
   *)
*/
